export const postalCodes = [
  {
    "region": "Uusimaa",
    "city": "Askola",
    "area": "Monninkylä",
    "postalCode": 7230,
    "postalCodeMin": 7230,
    "postalCodeMax": 7239,
    "lat": 60.4961,
    "lng": 25.536,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Askola",
    "area": "Askola",
    "postalCode": 7500,
    "postalCodeMin": 7500,
    "postalCodeMax": 7509,
    "lat": 60.5305,
    "lng": 25.5979,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Askola",
    "area": "Vakkola",
    "postalCode": 7510,
    "postalCodeMin": 7510,
    "postalCodeMax": 7519,
    "lat": 60.5177,
    "lng": 25.5867,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Askola",
    "area": "Onkimaa",
    "postalCode": 7530,
    "postalCodeMin": 7530,
    "postalCodeMax": 7539,
    "lat": 60.552,
    "lng": 25.5639,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Askola",
    "area": "Tiilää",
    "postalCode": 7580,
    "postalCodeMin": 7580,
    "postalCodeMax": 7589,
    "lat": 60.5473,
    "lng": 25.6891,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Askola",
    "area": "Huuvari",
    "postalCode": 7590,
    "postalCodeMin": 7590,
    "postalCodeMax": 7599,
    "lat": 60.5285,
    "lng": 25.7135,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Askola",
    "area": "Juornaankylä",
    "postalCode": 7680,
    "postalCodeMin": 7680,
    "postalCodeMax": 7689,
    "lat": 60.5685,
    "lng": 25.7584,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Tapiola – Heikintori, U-talo",
    "postalCode": 2100,
    "postalCodeMin": 2100,
    "postalCodeMax": 2109,
    "lat": 60.1766,
    "lng": 24.8018,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Tapiola – Itäranta",
    "postalCode": 2110,
    "postalCodeMin": 2110,
    "postalCodeMax": 2119,
    "lat": 60.175,
    "lng": 24.8237,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Tapiola – Suvikumpu, Hakalehto",
    "postalCode": 2120,
    "postalCodeMin": 2120,
    "postalCodeMax": 2129,
    "lat": 60.1769,
    "lng": 24.8058,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Pohjois-Tapiola – Koivumankkaa, Pyhäristi",
    "postalCode": 2130,
    "postalCodeMin": 2130,
    "postalCodeMax": 2139,
    "lat": 60.1937,
    "lng": 24.7963,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Laajalahti – Friisinmäki, Laajaranta",
    "postalCode": 2140,
    "postalCodeMin": 2140,
    "postalCodeMax": 2149,
    "lat": 60.2055,
    "lng": 24.8086,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Otaniemi – Keilaniemi, Servinniemi, Teekkarikylä, Maari",
    "postalCode": 2150,
    "postalCodeMin": 2150,
    "postalCodeMax": 2159,
    "lat": 60.1906,
    "lng": 24.8356,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Westend",
    "postalCode": 2160,
    "postalCodeMin": 2160,
    "postalCodeMax": 2169,
    "lat": 60.1635,
    "lng": 24.7972,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Haukilahti",
    "postalCode": 2170,
    "postalCodeMin": 2170,
    "postalCodeMax": 2179,
    "lat": 60.1597,
    "lng": 24.7706,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Mankkaa – Seilimäki, Klovi, Taavinkylä",
    "postalCode": 2180,
    "postalCodeMin": 2180,
    "postalCodeMax": 2189,
    "lat": 60.1886,
    "lng": 24.7725,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Henttaa, Niittykumpu – Piispankylä, Olarinluoma, Tontunmäki, Lystimäki, Kokinkylä, Lukupuro",
    "postalCode": 2200,
    "postalCodeMin": 2200,
    "postalCodeMax": 2209,
    "lat": 60.1769,
    "lng": 24.7588,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Olari – Olarinmäki, Kuitinmäki, Puolarmaari",
    "postalCode": 2210,
    "postalCodeMin": 2210,
    "postalCodeMax": 2219,
    "lat": 60.1725,
    "lng": 24.7255,
    "radiusKm": 13.2
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Matinkylä – Iirislahti, Koukkuniemi, Nokkala, Nuottaniemi, Nuottalahti, Tiistilä, Piispansilta",
    "postalCode": 2230,
    "postalCodeMin": 2230,
    "postalCodeMax": 2239,
    "lat": 60.1624,
    "lng": 24.7388,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Olari – Friisilä",
    "postalCode": 2240,
    "postalCodeMin": 2240,
    "postalCodeMax": 2249,
    "lat": 60.1663,
    "lng": 24.7183,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Henttaa – Suurpelto",
    "postalCode": 2250,
    "postalCodeMin": 2250,
    "postalCodeMax": 2259,
    "lat": 60.1904,
    "lng": 24.7268,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Kaitaa – Hyljelahti, Kaitamäki, Iivisniemi, Riilahti",
    "postalCode": 2260,
    "postalCodeMin": 2260,
    "postalCodeMax": 2269,
    "lat": 60.1494,
    "lng": 24.6905,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Kaitaa, Nöykkiö – Hannus, Suomenoja, Eestinmalmi",
    "postalCode": 2270,
    "postalCodeMin": 2270,
    "postalCodeMax": 2279,
    "lat": 60.1494,
    "lng": 24.6905,
    "radiusKm": 12.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Latokaski, Nöykkiö – Pisa, Kukkumäki, Malminmäki, Puolarmetsä, Eestinlaakso",
    "postalCode": 2280,
    "postalCodeMin": 2280,
    "postalCodeMax": 2289,
    "lat": 60.1686,
    "lng": 24.6767,
    "radiusKm": 15.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Olari – Puolarmetsän sairaala",
    "postalCode": 2290,
    "postalCodeMin": 2290,
    "postalCodeMax": 2299,
    "lat": 60.1738,
    "lng": 24.7381,
    "radiusKm": 15.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Nöykkiö",
    "postalCode": 2300,
    "postalCodeMin": 2300,
    "postalCodeMax": 2309,
    "lat": 60.1603,
    "lng": 24.6678,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Espoonlahti – Laurinlahti, Maininki, Kivenlahti, Marinsatama",
    "postalCode": 2320,
    "postalCodeMin": 2320,
    "postalCodeMax": 2329,
    "lat": 60.1576,
    "lng": 24.6219,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Saunalahti – Kiviruukki, Kummelivuori, Tillinmäki, Kattilalaakso",
    "postalCode": 2330,
    "postalCodeMin": 2330,
    "postalCodeMax": 2339,
    "lat": 60.1645,
    "lng": 24.6173,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Latokaski",
    "postalCode": 2340,
    "postalCodeMin": 2340,
    "postalCodeMax": 2349,
    "lat": 60.1772,
    "lng": 24.6596,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Soukka, Kaitaa – Soukanpohja, Soukanranta, Soukansalmi, Soukanniemi, Hanikka, Munkkiranta, Hannusjärvi",
    "postalCode": 2360,
    "postalCodeMin": 2360,
    "postalCodeMax": 2369,
    "lat": 60.1412,
    "lng": 24.6581,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Suvisaaristo",
    "postalCode": 2380,
    "postalCodeMin": 2380,
    "postalCodeMax": 2389,
    "lat": 60.1204,
    "lng": 24.7171,
    "radiusKm": 12.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Leppävaara, Laajalahti – Ruusutorppa, Säteri, Perkkaa, Vermo, Yhdyskunnanmäki, Ruukinranta",
    "postalCode": 2600,
    "postalCodeMin": 2600,
    "postalCodeMax": 2609,
    "lat": 60.2148,
    "lng": 24.821,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Kilo – Kilonkartano, Kuninkainen, Karamalmi",
    "postalCode": 2610,
    "postalCodeMin": 2610,
    "postalCodeMax": 2619,
    "lat": 60.2197,
    "lng": 24.7574,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Karakallio – Leppäsilta, Rastaspuisto, Rastaala",
    "postalCode": 2620,
    "postalCodeMin": 2620,
    "postalCodeMax": 2629,
    "lat": 60.2377,
    "lng": 24.7658,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Kilo – Nihtisilta, Lansa, Nuijala, Sinimäki",
    "postalCode": 2630,
    "postalCodeMin": 2630,
    "postalCodeMax": 2639,
    "lat": 60.2071,
    "lng": 24.7529,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Leppävaara – Vallikallio, Puustellinmäki, Mäkkylä, Mäkkylänmetsä",
    "postalCode": 2650,
    "postalCodeMin": 2650,
    "postalCodeMax": 2659,
    "lat": 60.2194,
    "lng": 24.8136,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Lintuvaara",
    "postalCode": 2660,
    "postalCodeMin": 2660,
    "postalCodeMax": 2669,
    "lat": 60.2344,
    "lng": 24.8136,
    "radiusKm": 13.2
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Lintuvaara – Uusmäki",
    "postalCode": 2680,
    "postalCodeMin": 2680,
    "postalCodeMax": 2689,
    "lat": 60.2405,
    "lng": 24.829,
    "radiusKm": 13.2
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Viherlaakso – Kavallinmäki",
    "postalCode": 2710,
    "postalCodeMin": 2710,
    "postalCodeMax": 2719,
    "lat": 60.2233,
    "lng": 24.7378,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Lippajärvi, Laaksolahti – Lähderanta, Kolkekannas",
    "postalCode": 2720,
    "postalCodeMin": 2720,
    "postalCodeMax": 2729,
    "lat": 60.245,
    "lng": 24.7348,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Laaksolahti – Jupperi, Veini",
    "postalCode": 2730,
    "postalCodeMin": 2730,
    "postalCodeMax": 2739,
    "lat": 60.244,
    "lng": 24.7679,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Kunnarla, Karhusuo, Röylä, Bodom, Karvasmäki, Högnäs – Lommila, Bemböle, Miilukorpi, Tollinmäki, Ristimäki, Oittaa, Pakankylä, Sorvalampi",
    "postalCode": 2740,
    "postalCodeMin": 2740,
    "postalCodeMax": 2749,
    "lat": 61.504,
    "lng": 23.6377,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Sepänkylä, Kuurinniitty, Henttaa – Ymmersta, Gerk, Taavinkylä",
    "postalCode": 2750,
    "postalCodeMin": 2750,
    "postalCodeMax": 2759,
    "lat": 60.2045,
    "lng": 24.7343,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Espoon keskus – Tuomarila, Kulotorppa, Suvela, Suna, Saarniraivio",
    "postalCode": 2760,
    "postalCodeMin": 2760,
    "postalCodeMax": 2769,
    "lat": 60.2076,
    "lng": 24.6809,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Espoon keskus, Muurala, Kaupunginkallio – Nimismiehenpelto, Lehtimäki, Pappilanmäki, Kirkkojärvi, Mikkelä, Kiltakallio, Saarniraivio",
    "postalCode": 2770,
    "postalCodeMin": 2770,
    "postalCodeMax": 2779,
    "lat": 60.2158,
    "lng": 24.6529,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Espoonkartano, Kauklahti, Kurttila, Vanttila",
    "postalCode": 2780,
    "postalCodeMin": 2780,
    "postalCodeMax": 2789,
    "lat": 60.1774,
    "lng": 24.6035,
    "radiusKm": 9.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Espoonkartano, Gumböle, Karhusuo – Myllärinmäki, Hirvisuo, Pitkäniitty, Karhuniitty",
    "postalCode": 2810,
    "postalCodeMin": 2810,
    "postalCodeMax": 2819,
    "lat": 60.2179,
    "lng": 24.6037,
    "radiusKm": 12.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Nuuksio, Vanha-Nuuksio, Nupuri, Kolmperä, Ämmässuo, Siikajärvi",
    "postalCode": 2820,
    "postalCodeMin": 2820,
    "postalCodeMax": 2829,
    "lat": 60.294,
    "lng": 24.5947,
    "radiusKm": 12.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Siikajärvi – Siikaranta, Soittila, Suolaakso, Uusipelto, Kotimäki, Heinäs",
    "postalCode": 2860,
    "postalCodeMin": 2860,
    "postalCodeMax": 2869,
    "lat": 60.289,
    "lng": 24.5233,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Vanhakartano, Niipperi, Perusmäki",
    "postalCode": 2920,
    "postalCodeMin": 2920,
    "postalCodeMax": 2929,
    "lat": 60.2863,
    "lng": 24.7391,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Röylä, Bodom, Högnäs, Järvenperä, Lippajärvi",
    "postalCode": 2940,
    "postalCodeMin": 2940,
    "postalCodeMax": 2949,
    "lat": 60.2969,
    "lng": 24.6977,
    "radiusKm": 12.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Luukki, Kalajärvi, Lahnus",
    "postalCode": 2970,
    "postalCodeMin": 2970,
    "postalCodeMax": 2979,
    "lat": 60.3069,
    "lng": 24.7234,
    "radiusKm": 12.0
  },
  {
    "region": "Uusimaa",
    "city": "Espoo",
    "area": "Velskola, Lakisto",
    "postalCode": 2980,
    "postalCodeMin": 2980,
    "postalCodeMax": 2989,
    "lat": 60.3134,
    "lng": 24.6392,
    "radiusKm": 13.8
  },
  {
    "region": "Uusimaa",
    "city": "Hanko",
    "area": "Lappohja / Lappvik",
    "postalCode": 10820,
    "postalCodeMin": 10820,
    "postalCodeMax": 10829,
    "lat": 59.9029,
    "lng": 23.242,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hanko",
    "area": "Hanko / Hangö",
    "postalCode": 10900,
    "postalCodeMin": 10900,
    "postalCodeMax": 10909,
    "lat": 59.8283,
    "lng": 22.9659,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hanko",
    "area": "Hangonkylä / Hangöby",
    "postalCode": 10940,
    "postalCodeMin": 10940,
    "postalCodeMax": 10949,
    "lat": 59.8357,
    "lng": 22.9438,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Hanko",
    "area": "Hanko Pohjoinen / Hangö Norra",
    "postalCode": 10960,
    "postalCodeMin": 10960,
    "postalCodeMax": 10969,
    "lat": 59.83,
    "lng": 22.9879,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Helsinki / Helsingfors",
    "postalCode": 2,
    "postalCodeMin": 0,
    "postalCodeMax": 9,
    "lat": 60.1874,
    "lng": 24.9606,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Postitalo, Kamppi, Leppäsuo, Etu-Töölö",
    "postalCode": 100,
    "postalCodeMin": 100,
    "postalCodeMax": 109,
    "lat": 60.1694,
    "lng": 24.9233,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Eduskunta / Riksdagen",
    "postalCode": 102,
    "postalCodeMin": 100,
    "postalCodeMax": 109,
    "lat": 60.1945,
    "lng": 24.7436,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Punavuori",
    "postalCode": 120,
    "postalCodeMin": 120,
    "postalCodeMax": 129,
    "lat": 60.1629,
    "lng": 24.9421,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Kaartinkaupunki",
    "postalCode": 130,
    "postalCodeMin": 130,
    "postalCodeMax": 139,
    "lat": 60.1654,
    "lng": 24.9492,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Ullanlinna, Kaivopuisto",
    "postalCode": 140,
    "postalCodeMin": 140,
    "postalCodeMax": 149,
    "lat": 60.1557,
    "lng": 24.9557,
    "radiusKm": 5.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Eira",
    "postalCode": 150,
    "postalCodeMin": 150,
    "postalCodeMax": 159,
    "lat": 60.1552,
    "lng": 24.9382,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Katajanokka",
    "postalCode": 160,
    "postalCodeMin": 160,
    "postalCodeMax": 169,
    "lat": 60.1666,
    "lng": 24.9697,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Kruununhaka",
    "postalCode": 170,
    "postalCodeMin": 170,
    "postalCodeMax": 179,
    "lat": 60.1731,
    "lng": 24.9531,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Ruoholahti, Jätkäsaari",
    "postalCode": 180,
    "postalCodeMin": 180,
    "postalCodeMax": 189,
    "lat": 60.1636,
    "lng": 24.9076,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Suomenlinna",
    "postalCode": 190,
    "postalCodeMin": 190,
    "postalCodeMax": 199,
    "lat": 60.1455,
    "lng": 24.9823,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Lauttasaari",
    "postalCode": 200,
    "postalCodeMin": 200,
    "postalCodeMax": 209,
    "lat": 60.1601,
    "lng": 24.8714,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Lauttasaari, Vattuniemi",
    "postalCode": 210,
    "postalCodeMin": 210,
    "postalCodeMax": 219,
    "lat": 60.1506,
    "lng": 24.8827,
    "radiusKm": 13.0
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Jätkäsaari",
    "postalCode": 220,
    "postalCodeMin": 220,
    "postalCodeMax": 229,
    "lat": 60.1556,
    "lng": 24.9166,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Pasila postikeskus",
    "postalCode": 230,
    "postalCodeMin": 230,
    "postalCodeMax": 239,
    "lat": 60.2151,
    "lng": 24.9205,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Länsi-Pasila",
    "postalCode": 240,
    "postalCodeMin": 240,
    "postalCodeMax": 249,
    "lat": 60.1984,
    "lng": 24.9255,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Laakso, Meilahti, Taka-Töölö",
    "postalCode": 250,
    "postalCodeMin": 250,
    "postalCodeMax": 259,
    "lat": 60.1816,
    "lng": 24.9181,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Taka-Töölö",
    "postalCode": 260,
    "postalCodeMin": 260,
    "postalCodeMax": 269,
    "lat": 60.1816,
    "lng": 24.9181,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Laakso, Meilahti",
    "postalCode": 270,
    "postalCodeMin": 270,
    "postalCodeMax": 279,
    "lat": 60.1927,
    "lng": 24.8947,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Ruskeasuo",
    "postalCode": 280,
    "postalCodeMin": 280,
    "postalCodeMax": 289,
    "lat": 60.201,
    "lng": 24.9065,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Meilahden sairaala-alue",
    "postalCode": 290,
    "postalCodeMin": 290,
    "postalCodeMax": 299,
    "lat": 60.1889,
    "lng": 24.9057,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Pikku Huopalahti, Ruskeasuo",
    "postalCode": 300,
    "postalCodeMin": 300,
    "postalCodeMax": 309,
    "lat": 60.2046,
    "lng": 24.8955,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Kivihaka",
    "postalCode": 310,
    "postalCodeMin": 310,
    "postalCodeMax": 319,
    "lat": 60.2108,
    "lng": 24.9038,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Etelä-Haaga",
    "postalCode": 320,
    "postalCodeMin": 320,
    "postalCodeMax": 329,
    "lat": 60.2125,
    "lng": 24.8984,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Munkkiniemi",
    "postalCode": 330,
    "postalCodeMin": 330,
    "postalCodeMax": 339,
    "lat": 60.1983,
    "lng": 24.876,
    "radiusKm": 13.0
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Lehtisaari, Kaskisaari, Kuusisaari",
    "postalCode": 340,
    "postalCodeMin": 340,
    "postalCodeMax": 349,
    "lat": 60.1855,
    "lng": 24.8606,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Munkkivuori, Niemenmäki",
    "postalCode": 350,
    "postalCodeMin": 350,
    "postalCodeMax": 359,
    "lat": 60.198,
    "lng": 24.8752,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Pajamäki",
    "postalCode": 360,
    "postalCodeMin": 360,
    "postalCodeMax": 369,
    "lat": 60.2184,
    "lng": 24.8556,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Pitäjänmäki, Reimarla",
    "postalCode": 370,
    "postalCodeMin": 370,
    "postalCodeMax": 379,
    "lat": 60.2234,
    "lng": 24.8593,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Pitäjänmäen yritysalue",
    "postalCode": 380,
    "postalCodeMin": 380,
    "postalCodeMax": 389,
    "lat": 60.223,
    "lng": 24.8621,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Konala",
    "postalCode": 390,
    "postalCodeMin": 390,
    "postalCodeMax": 399,
    "lat": 60.237,
    "lng": 24.845,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Pohjois-Haaga",
    "postalCode": 400,
    "postalCodeMin": 400,
    "postalCodeMax": 409,
    "lat": 60.2245,
    "lng": 24.8978,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Malminkartano, Honkasuo",
    "postalCode": 410,
    "postalCodeMin": 410,
    "postalCodeMax": 419,
    "lat": 60.2493,
    "lng": 24.8613,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Kannelmäki",
    "postalCode": 420,
    "postalCodeMin": 420,
    "postalCodeMax": 429,
    "lat": 60.2417,
    "lng": 24.8854,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Hakuninmaa, Maununneva, Kuninkaantammi",
    "postalCode": 430,
    "postalCodeMin": 430,
    "postalCodeMax": 439,
    "lat": 60.2448,
    "lng": 24.8988,
    "radiusKm": 15.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Lassila",
    "postalCode": 440,
    "postalCodeMin": 440,
    "postalCodeMax": 449,
    "lat": 60.2314,
    "lng": 24.8796,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Sörnäinen",
    "postalCode": 500,
    "postalCodeMin": 500,
    "postalCodeMax": 509,
    "lat": 60.1868,
    "lng": 24.962,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Alppila, Vallila",
    "postalCode": 510,
    "postalCodeMin": 510,
    "postalCodeMax": 519,
    "lat": 60.1908,
    "lng": 24.9454,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Itä-Pasila",
    "postalCode": 520,
    "postalCodeMin": 520,
    "postalCodeMax": 529,
    "lat": 60.1992,
    "lng": 24.9373,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Hakaniemi, Kallio, Siltasaari, Merihaka",
    "postalCode": 530,
    "postalCodeMin": 530,
    "postalCodeMax": 539,
    "lat": 60.1794,
    "lng": 24.9502,
    "radiusKm": 13.0
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Hanasaari, Kalasatama, Sompasaari, Sörnäinen",
    "postalCode": 540,
    "postalCodeMin": 540,
    "postalCodeMax": 549,
    "lat": 60.1875,
    "lng": 24.9773,
    "radiusKm": 5.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Hermanni, Toukola, Vallila",
    "postalCode": 550,
    "postalCodeMin": 550,
    "postalCodeMax": 559,
    "lat": 60.1944,
    "lng": 24.957,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Kumpula, Toukola, Vanhakaupunki, Viikki",
    "postalCode": 560,
    "postalCodeMin": 560,
    "postalCodeMax": 569,
    "lat": 60.2251,
    "lng": 25.0201,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Kulosaari, Mustikkamaa–Korkeasaari",
    "postalCode": 570,
    "postalCodeMin": 570,
    "postalCodeMax": 579,
    "lat": 60.1866,
    "lng": 25.009,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Hermanni, Sörnäinen",
    "postalCode": 580,
    "postalCodeMin": 580,
    "postalCodeMax": 589,
    "lat": 60.1942,
    "lng": 24.9788,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Laajasalo, Kruunuvuorenranta",
    "postalCode": 590,
    "postalCodeMin": 590,
    "postalCodeMax": 599,
    "lat": 60.1666,
    "lng": 25.0223,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Käpylä, Koskela",
    "postalCode": 600,
    "postalCodeMin": 600,
    "postalCodeMax": 609,
    "lat": 60.2183,
    "lng": 24.9663,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Käpylä",
    "postalCode": 610,
    "postalCodeMin": 610,
    "postalCodeMax": 619,
    "lat": 60.2142,
    "lng": 24.9508,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Metsälä",
    "postalCode": 620,
    "postalCodeMin": 620,
    "postalCodeMax": 629,
    "lat": 60.2211,
    "lng": 24.9392,
    "radiusKm": 18.0
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Maunula",
    "postalCode": 630,
    "postalCodeMin": 630,
    "postalCodeMax": 639,
    "lat": 60.2298,
    "lng": 24.9306,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Oulunkylä, Patola",
    "postalCode": 640,
    "postalCodeMin": 640,
    "postalCodeMax": 649,
    "lat": 60.2275,
    "lng": 24.9653,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Oulunkylä, Veräjämäki",
    "postalCode": 650,
    "postalCodeMin": 650,
    "postalCodeMax": 659,
    "lat": 60.2283,
    "lng": 24.9666,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Länsi-Pakila",
    "postalCode": 660,
    "postalCodeMin": 660,
    "postalCodeMax": 669,
    "lat": 60.2411,
    "lng": 24.9271,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Paloheinä",
    "postalCode": 670,
    "postalCodeMin": 670,
    "postalCodeMax": 679,
    "lat": 60.2538,
    "lng": 24.9281,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Itä-Pakila",
    "postalCode": 680,
    "postalCodeMin": 680,
    "postalCodeMax": 689,
    "lat": 60.2435,
    "lng": 24.9588,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Torpparinmäki, Tuomarinkylä",
    "postalCode": 690,
    "postalCodeMin": 690,
    "postalCodeMax": 699,
    "lat": 60.2564,
    "lng": 24.9668,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Malmi",
    "postalCode": 700,
    "postalCodeMin": 700,
    "postalCodeMax": 709,
    "lat": 60.251,
    "lng": 25.0106,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Pihlajisto, Pihlajamäki",
    "postalCode": 710,
    "postalCodeMin": 710,
    "postalCodeMax": 719,
    "lat": 60.2308,
    "lng": 24.9995,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Pukinmäki, Savela",
    "postalCode": 720,
    "postalCodeMin": 720,
    "postalCodeMax": 729,
    "lat": 60.2427,
    "lng": 24.9941,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Malmi, Tapaninkylä, Tapanila",
    "postalCode": 730,
    "postalCodeMin": 730,
    "postalCodeMax": 739,
    "lat": 60.251,
    "lng": 25.0106,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Siltamäki, Suutarila, Töyrynummi",
    "postalCode": 740,
    "postalCodeMin": 740,
    "postalCodeMax": 749,
    "lat": 60.2701,
    "lng": 24.9997,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Puistola, Tapulikaupunki, Ala-Tikkurila",
    "postalCode": 750,
    "postalCodeMin": 750,
    "postalCodeMax": 759,
    "lat": 60.2755,
    "lng": 25.0365,
    "radiusKm": 5.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Puistola, Sirkkalanmäki, Heikinlaakso",
    "postalCode": 760,
    "postalCodeMin": 760,
    "postalCodeMax": 769,
    "lat": 60.2756,
    "lng": 25.0513,
    "radiusKm": 5.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Tattarisuo, Alppikylä, Jakomäki",
    "postalCode": 770,
    "postalCodeMin": 770,
    "postalCodeMax": 779,
    "lat": 60.2601,
    "lng": 25.078,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Tapaninvainio",
    "postalCode": 780,
    "postalCodeMin": 780,
    "postalCodeMax": 789,
    "lat": 60.2585,
    "lng": 24.9851,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Viikki, Latokartano",
    "postalCode": 790,
    "postalCodeMin": 790,
    "postalCodeMax": 799,
    "lat": 60.2276,
    "lng": 25.0275,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Herttoniemi",
    "postalCode": 800,
    "postalCodeMin": 800,
    "postalCodeMax": 809,
    "lat": 60.2087,
    "lng": 25.0299,
    "radiusKm": 13.0
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Herttoniemenranta",
    "postalCode": 810,
    "postalCodeMin": 810,
    "postalCodeMax": 819,
    "lat": 60.1909,
    "lng": 25.034,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Roihuvuori",
    "postalCode": 820,
    "postalCodeMin": 820,
    "postalCodeMax": 829,
    "lat": 60.1953,
    "lng": 25.0486,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Tammisalo",
    "postalCode": 830,
    "postalCodeMin": 830,
    "postalCodeMax": 839,
    "lat": 60.1906,
    "lng": 25.0663,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Laajasalo, Yliskylä",
    "postalCode": 840,
    "postalCodeMin": 840,
    "postalCodeMax": 849,
    "lat": 60.1797,
    "lng": 25.0548,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Laajasalo, Jollas, Villinki",
    "postalCode": 850,
    "postalCodeMin": 850,
    "postalCodeMax": 859,
    "lat": 60.1638,
    "lng": 25.072,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Santahamina, Vallisaari",
    "postalCode": 860,
    "postalCodeMin": 860,
    "postalCodeMax": 869,
    "lat": 60.1381,
    "lng": 25.0037,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Laajasalo, Yliskylä",
    "postalCode": 870,
    "postalCodeMin": 870,
    "postalCodeMax": 879,
    "lat": 60.1797,
    "lng": 25.0548,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Herttoniemi, Roihupelto",
    "postalCode": 880,
    "postalCodeMin": 880,
    "postalCodeMax": 889,
    "lat": 60.2122,
    "lng": 25.0578,
    "radiusKm": 13.0
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Östersundom, Karhusaari, Talosaari",
    "postalCode": 890,
    "postalCodeMin": 890,
    "postalCodeMax": 899,
    "lat": 60.2503,
    "lng": 25.2137,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Puotinharju, Itäkeskus, Vartiokylä",
    "postalCode": 900,
    "postalCodeMin": 900,
    "postalCodeMax": 909,
    "lat": 60.2108,
    "lng": 25.0805,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Puotila",
    "postalCode": 910,
    "postalCodeMin": 910,
    "postalCodeMax": 919,
    "lat": 60.2122,
    "lng": 25.0961,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Myllypuro",
    "postalCode": 920,
    "postalCodeMin": 920,
    "postalCodeMax": 929,
    "lat": 60.2236,
    "lng": 25.0678,
    "radiusKm": 7.2
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Itäkeskus, Marjaniemi",
    "postalCode": 930,
    "postalCodeMin": 930,
    "postalCodeMax": 939,
    "lat": 60.2108,
    "lng": 25.0805,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Kontula, Kivikko, Mellunkylä",
    "postalCode": 940,
    "postalCodeMin": 940,
    "postalCodeMax": 949,
    "lat": 60.2345,
    "lng": 25.0612,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Vartioharju",
    "postalCode": 950,
    "postalCodeMin": 950,
    "postalCodeMax": 959,
    "lat": 60.2244,
    "lng": 25.1111,
    "radiusKm": 6.5
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Vuosaari, Porslahti",
    "postalCode": 960,
    "postalCodeMin": 960,
    "postalCodeMax": 969,
    "lat": 60.2191,
    "lng": 25.1478,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Mellunmäki, Mellunkylä, Uutela",
    "postalCode": 970,
    "postalCodeMin": 970,
    "postalCodeMax": 979,
    "lat": 60.2,
    "lng": 25.1772,
    "radiusKm": 10.8
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Vuosaari, Meri-Rastila",
    "postalCode": 980,
    "postalCodeMin": 980,
    "postalCodeMax": 989,
    "lat": 60.2038,
    "lng": 25.1166,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Helsinki",
    "area": "Vuosaari, Aurinkolahti",
    "postalCode": 990,
    "postalCodeMin": 990,
    "postalCodeMax": 999,
    "lat": 60.2022,
    "lng": 25.1538,
    "radiusKm": 14.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Hyvinkää",
    "postalCode": 5440,
    "postalCodeMin": 5440,
    "postalCodeMax": 5449,
    "lat": 60.5978,
    "lng": 24.8798,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Hyvinkää",
    "postalCode": 5460,
    "postalCodeMin": 5460,
    "postalCodeMax": 5469,
    "lat": 60.6122,
    "lng": 24.8735,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Palopuro",
    "postalCode": 5470,
    "postalCodeMin": 5470,
    "postalCodeMax": 5479,
    "lat": 60.5868,
    "lng": 24.9243,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Päivärinta",
    "postalCode": 5510,
    "postalCodeMin": 5510,
    "postalCodeMax": 5519,
    "lat": 60.5966,
    "lng": 25.0298,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Noppo",
    "postalCode": 5620,
    "postalCodeMin": 5620,
    "postalCodeMax": 5629,
    "lat": 60.5703,
    "lng": 24.7914,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Kytäjä",
    "postalCode": 5720,
    "postalCodeMin": 5720,
    "postalCodeMax": 5729,
    "lat": 60.6013,
    "lng": 24.683,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Hyvinkää",
    "postalCode": 5800,
    "postalCodeMin": 5800,
    "postalCodeMax": 5809,
    "lat": 60.6434,
    "lng": 24.7939,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Martti",
    "postalCode": 5810,
    "postalCodeMin": 5810,
    "postalCodeMax": 5819,
    "lat": 60.6203,
    "lng": 24.8854,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Hyvinkää",
    "postalCode": 5820,
    "postalCodeMin": 5820,
    "postalCodeMax": 5829,
    "lat": 60.6515,
    "lng": 24.9102,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Hyvinkää",
    "postalCode": 5830,
    "postalCodeMin": 5830,
    "postalCodeMax": 5839,
    "lat": 60.6129,
    "lng": 24.8385,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Hyvinkää",
    "postalCode": 5840,
    "postalCodeMin": 5840,
    "postalCodeMax": 5849,
    "lat": 60.6011,
    "lng": 24.8197,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Hyvinkää",
    "postalCode": 5850,
    "postalCodeMin": 5850,
    "postalCodeMax": 5859,
    "lat": 60.6097,
    "lng": 24.8275,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Talvisilta",
    "postalCode": 5860,
    "postalCodeMin": 5860,
    "postalCodeMax": 5869,
    "lat": 60.6272,
    "lng": 24.8206,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Hyvinkää",
    "postalCode": 5880,
    "postalCodeMin": 5880,
    "postalCodeMax": 5889,
    "lat": 60.6553,
    "lng": 24.8127,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Hyvinkää",
    "postalCode": 5900,
    "postalCodeMin": 5900,
    "postalCodeMax": 5909,
    "lat": 60.6338,
    "lng": 24.8492,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Hyvinkää",
    "area": "Ridasjärvi",
    "postalCode": 5950,
    "postalCodeMin": 5950,
    "postalCodeMax": 5959,
    "lat": 60.6428,
    "lng": 24.9838,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Inkoo",
    "area": "Tähtelä / Täkter",
    "postalCode": 10120,
    "postalCodeMin": 10120,
    "postalCodeMax": 10129,
    "lat": 60.0882,
    "lng": 24.0243,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Inkoo",
    "area": "Päivölä / Solberg",
    "postalCode": 10140,
    "postalCodeMin": 10140,
    "postalCodeMax": 10149,
    "lat": 60.0459,
    "lng": 24.0046,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Inkoo",
    "area": "Degerby",
    "postalCode": 10160,
    "postalCodeMin": 10160,
    "postalCodeMax": 10169,
    "lat": 60.0844,
    "lng": 24.1776,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Inkoo",
    "area": "Inkoo / Ingå",
    "postalCode": 10210,
    "postalCodeMin": 10210,
    "postalCodeMax": 10219,
    "lat": 60.0459,
    "lng": 24.0046,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Inkoo",
    "area": "Inkoo as / Ingå st",
    "postalCode": 10230,
    "postalCodeMin": 10230,
    "postalCodeMax": 10239,
    "lat": 60.0616,
    "lng": 23.9379,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Inkoo",
    "area": "Fagervik",
    "postalCode": 10250,
    "postalCodeMin": 10250,
    "postalCodeMax": 10259,
    "lat": 60.0221,
    "lng": 23.8155,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Inkoo",
    "area": "Barösund",
    "postalCode": 10270,
    "postalCodeMin": 10270,
    "postalCodeMax": 10279,
    "lat": 59.977,
    "lng": 23.8819,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Järvenpää",
    "area": "Järvenpää",
    "postalCode": 4400,
    "postalCodeMin": 4400,
    "postalCodeMax": 4409,
    "lat": 60.4633,
    "lng": 25.0753,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Järvenpää",
    "area": "Järvenpää",
    "postalCode": 4410,
    "postalCodeMin": 4410,
    "postalCodeMax": 4419,
    "lat": 60.4923,
    "lng": 25.101,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Järvenpää",
    "area": "Järvenpää",
    "postalCode": 4420,
    "postalCodeMin": 4420,
    "postalCodeMax": 4429,
    "lat": 60.4538,
    "lng": 25.1067,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Järvenpää",
    "area": "Järvenpää",
    "postalCode": 4430,
    "postalCodeMin": 4430,
    "postalCodeMax": 4439,
    "lat": 60.4718,
    "lng": 25.1562,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Järvenpää",
    "area": "Järvenpää",
    "postalCode": 4440,
    "postalCodeMin": 4440,
    "postalCodeMax": 4449,
    "lat": 60.5001,
    "lng": 25.0618,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Järvenpää",
    "area": "Nummenkylä",
    "postalCode": 4460,
    "postalCodeMin": 4460,
    "postalCodeMax": 4469,
    "lat": 60.5081,
    "lng": 25.0932,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Järvenpää",
    "area": "Haarajoki",
    "postalCode": 4480,
    "postalCodeMin": 4480,
    "postalCodeMax": 4489,
    "lat": 60.5028,
    "lng": 25.1594,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Karkkila",
    "area": "Karkkila",
    "postalCode": 3600,
    "postalCodeMin": 3600,
    "postalCodeMax": 3609,
    "lat": 60.5351,
    "lng": 24.2092,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Karkkila",
    "area": "Karkkila",
    "postalCode": 3620,
    "postalCodeMin": 3620,
    "postalCodeMax": 3629,
    "lat": 60.5351,
    "lng": 24.2092,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Karkkila",
    "area": "Uusitalo",
    "postalCode": 3710,
    "postalCodeMin": 3710,
    "postalCodeMax": 3719,
    "lat": 60.5259,
    "lng": 24.2415,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kauniainen",
    "area": "Kauniainen / Grankulla",
    "postalCode": 2700,
    "postalCodeMin": 2700,
    "postalCodeMax": 2709,
    "lat": 60.2117,
    "lng": 24.7289,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kerava",
    "area": "Kerava",
    "postalCode": 4200,
    "postalCodeMin": 4200,
    "postalCodeMax": 4209,
    "lat": 60.4084,
    "lng": 25.1166,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kerava",
    "area": "Kerava",
    "postalCode": 4220,
    "postalCodeMin": 4220,
    "postalCodeMax": 4229,
    "lat": 60.4095,
    "lng": 25.1417,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kerava",
    "area": "Kerava",
    "postalCode": 4230,
    "postalCodeMin": 4230,
    "postalCodeMax": 4239,
    "lat": 60.4194,
    "lng": 25.0929,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kerava",
    "area": "Kerava",
    "postalCode": 4250,
    "postalCodeMin": 4250,
    "postalCodeMax": 4259,
    "lat": 60.3786,
    "lng": 25.1257,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kerava",
    "area": "Savio",
    "postalCode": 4260,
    "postalCodeMin": 4260,
    "postalCodeMax": 4269,
    "lat": 60.3804,
    "lng": 25.0974,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Sarvvik",
    "postalCode": 2390,
    "postalCodeMin": 2390,
    "postalCodeMax": 2399,
    "lat": 60.1522,
    "lng": 24.6048,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Kirkkonummi / Kyrkslätt",
    "postalCode": 2400,
    "postalCodeMin": 2400,
    "postalCodeMax": 2409,
    "lat": 60.1267,
    "lng": 24.4411,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Kirkkonummi / Kyrkslätt",
    "postalCode": 2410,
    "postalCodeMin": 2410,
    "postalCodeMax": 2419,
    "lat": 60.1367,
    "lng": 24.451,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Jorvas",
    "postalCode": 2420,
    "postalCodeMin": 2420,
    "postalCodeMax": 2429,
    "lat": 60.1362,
    "lng": 24.5104,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Masala / Masaby",
    "postalCode": 2430,
    "postalCodeMin": 2430,
    "postalCodeMax": 2439,
    "lat": 60.1579,
    "lng": 24.5385,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Luoma / Bobäck",
    "postalCode": 2440,
    "postalCodeMin": 2440,
    "postalCodeMax": 2449,
    "lat": 60.1792,
    "lng": 24.5479,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Sundsberg",
    "postalCode": 2450,
    "postalCodeMin": 2450,
    "postalCodeMax": 2459,
    "lat": 60.1555,
    "lng": 24.5717,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Kantvik",
    "postalCode": 2460,
    "postalCodeMin": 2460,
    "postalCodeMax": 2469,
    "lat": 60.0908,
    "lng": 24.3941,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Upinniemi / Obbnäs",
    "postalCode": 2470,
    "postalCodeMin": 2470,
    "postalCodeMax": 2479,
    "lat": 60.0317,
    "lng": 24.3646,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Porkkala",
    "postalCode": 2480,
    "postalCodeMin": 2480,
    "postalCodeMax": 2489,
    "lat": 59.9814,
    "lng": 24.4001,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Pikkala / Pickala",
    "postalCode": 2490,
    "postalCodeMin": 2490,
    "postalCodeMax": 2499,
    "lat": 60.0972,
    "lng": 24.3018,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Oitmäki / Oitbacka",
    "postalCode": 2510,
    "postalCodeMin": 2510,
    "postalCodeMax": 2519,
    "lat": 60.2042,
    "lng": 24.5019,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Lapinkylä / Lappböle",
    "postalCode": 2520,
    "postalCodeMin": 2520,
    "postalCodeMax": 2529,
    "lat": 60.2247,
    "lng": 24.4648,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Kylmälä",
    "postalCode": 2540,
    "postalCodeMin": 2540,
    "postalCodeMax": 2549,
    "lat": 60.237,
    "lng": 24.397,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Evitskog",
    "postalCode": 2550,
    "postalCodeMin": 2550,
    "postalCodeMax": 2559,
    "lat": 60.2005,
    "lng": 24.339,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Kirkkonummi",
    "area": "Veikkola",
    "postalCode": 2880,
    "postalCodeMin": 2880,
    "postalCodeMax": 2889,
    "lat": 60.2695,
    "lng": 24.4457,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lapinjärvi",
    "area": "Lapinjärvi / Lappträsk",
    "postalCode": 7800,
    "postalCodeMin": 7800,
    "postalCodeMax": 7809,
    "lat": 60.6245,
    "lng": 26.1973,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Lapinjärvi",
    "area": "Ingermaninkylä / Ingermansby",
    "postalCode": 7810,
    "postalCodeMin": 7810,
    "postalCodeMax": 7819,
    "lat": 60.6157,
    "lng": 26.1518,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Lapinjärvi",
    "area": "Porlammi / Porlom",
    "postalCode": 7820,
    "postalCodeMin": 7820,
    "postalCodeMax": 7829,
    "lat": 60.6824,
    "lng": 26.032,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lapinjärvi",
    "area": "Pukaro / Pockar",
    "postalCode": 7830,
    "postalCodeMin": 7830,
    "postalCodeMax": 7839,
    "lat": 60.6729,
    "lng": 26.2261,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lapinjärvi",
    "area": "Lindkoski",
    "postalCode": 7840,
    "postalCodeMin": 7840,
    "postalCodeMax": 7849,
    "lat": 60.6353,
    "lng": 26.2622,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lapinjärvi",
    "area": "Heikinkylä / Hindersby",
    "postalCode": 7850,
    "postalCodeMin": 7850,
    "postalCodeMax": 7859,
    "lat": 60.5868,
    "lng": 26.2519,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Lapinjärvi",
    "area": "Kimonkylä",
    "postalCode": 47350,
    "postalCodeMin": 47350,
    "postalCodeMax": 47359,
    "lat": 60.7058,
    "lng": 26.3001,
    "radiusKm": 4.5
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Ikkala",
    "postalCode": 3810,
    "postalCodeMin": 3810,
    "postalCodeMax": 3819,
    "lat": 60.4904,
    "lng": 24.1243,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Pusula",
    "postalCode": 3850,
    "postalCodeMin": 3850,
    "postalCodeMax": 3859,
    "lat": 60.473,
    "lng": 23.9828,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Hyönölä",
    "postalCode": 3870,
    "postalCodeMin": 3870,
    "postalCodeMax": 3879,
    "lat": 60.4636,
    "lng": 23.9359,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Lohja / Lojo",
    "postalCode": 8100,
    "postalCodeMin": 8100,
    "postalCodeMax": 8109,
    "lat": 60.2454,
    "lng": 24.0428,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Lohja / Lojo",
    "postalCode": 8150,
    "postalCodeMin": 8150,
    "postalCodeMax": 8159,
    "lat": 60.2379,
    "lng": 24.0816,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Lohja / Lojo",
    "postalCode": 8200,
    "postalCodeMin": 8200,
    "postalCodeMax": 8209,
    "lat": 60.2316,
    "lng": 24.0343,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Routio",
    "postalCode": 8350,
    "postalCodeMin": 8350,
    "postalCodeMax": 8359,
    "lat": 60.2737,
    "lng": 24.0579,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Kisakallio",
    "postalCode": 8360,
    "postalCodeMin": 8360,
    "postalCodeMax": 8369,
    "lat": 60.321,
    "lng": 24.0424,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Hormajärvi",
    "postalCode": 8450,
    "postalCodeMin": 8450,
    "postalCodeMax": 8459,
    "lat": 60.287,
    "lng": 24.0051,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Karstu",
    "postalCode": 8480,
    "postalCodeMin": 8480,
    "postalCodeMax": 8489,
    "lat": 60.3006,
    "lng": 23.9286,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Ventelä",
    "postalCode": 8500,
    "postalCodeMin": 8500,
    "postalCodeMax": 8509,
    "lat": 60.2722,
    "lng": 24.1298,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Muijala",
    "postalCode": 8680,
    "postalCodeMin": 8680,
    "postalCodeMax": 8689,
    "lat": 60.2805,
    "lng": 24.19,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Virkkala",
    "postalCode": 8700,
    "postalCodeMin": 8700,
    "postalCodeMax": 8709,
    "lat": 60.1913,
    "lng": 23.999,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Kirkniemi",
    "postalCode": 8800,
    "postalCodeMin": 8800,
    "postalCodeMax": 8809,
    "lat": 60.182,
    "lng": 23.9496,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Karjalohja",
    "postalCode": 9120,
    "postalCodeMin": 9120,
    "postalCodeMax": 9129,
    "lat": 60.2402,
    "lng": 23.7179,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Sammatti",
    "postalCode": 9220,
    "postalCodeMin": 9220,
    "postalCodeMax": 9229,
    "lat": 60.3242,
    "lng": 23.8169,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Saukkola",
    "postalCode": 9430,
    "postalCodeMin": 9430,
    "postalCodeMax": 9439,
    "lat": 60.3818,
    "lng": 23.9714,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Millola",
    "postalCode": 9520,
    "postalCodeMin": 9520,
    "postalCodeMax": 9529,
    "lat": 60.3526,
    "lng": 24.0247,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Koisjärvi",
    "postalCode": 9630,
    "postalCodeMin": 9630,
    "postalCodeMax": 9639,
    "lat": 60.4006,
    "lng": 24.0655,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Nummi",
    "postalCode": 9810,
    "postalCodeMin": 9810,
    "postalCodeMax": 9819,
    "lat": 60.3928,
    "lng": 23.8853,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Lohja",
    "area": "Leppäkorpi",
    "postalCode": 9930,
    "postalCodeMin": 9930,
    "postalCodeMax": 9939,
    "lat": 60.4759,
    "lng": 23.8226,
    "radiusKm": 6.0
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Koskenkylän Saha / Forsby Såg",
    "postalCode": 7700,
    "postalCodeMin": 7700,
    "postalCodeMax": 7709,
    "lat": 60.4997,
    "lng": 25.9422,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Malmgård",
    "postalCode": 7720,
    "postalCodeMin": 7720,
    "postalCodeMax": 7729,
    "lat": 60.5467,
    "lng": 25.9247,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Pernajan vanhakylä / Gammelby",
    "postalCode": 7740,
    "postalCodeMin": 7740,
    "postalCodeMax": 7749,
    "lat": 60.4892,
    "lng": 25.8764,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Isnäs",
    "postalCode": 7750,
    "postalCodeMin": 7750,
    "postalCodeMax": 7759,
    "lat": 60.3927,
    "lng": 25.9954,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Härkäpää / Härpe",
    "postalCode": 7780,
    "postalCodeMin": 7780,
    "postalCodeMax": 7789,
    "lat": 60.3073,
    "lng": 25.9631,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Skinnarby",
    "postalCode": 7870,
    "postalCodeMin": 7870,
    "postalCodeMax": 7879,
    "lat": 60.5315,
    "lng": 26.1716,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Liljendal",
    "postalCode": 7880,
    "postalCodeMin": 7880,
    "postalCodeMax": 7889,
    "lat": 60.5732,
    "lng": 26.0543,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Mickelspiltom",
    "postalCode": 7890,
    "postalCodeMin": 7890,
    "postalCodeMax": 7899,
    "lat": 60.6183,
    "lng": 26.0084,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Loviisa / Lovisa",
    "postalCode": 7900,
    "postalCodeMin": 7900,
    "postalCodeMax": 7909,
    "lat": 60.4579,
    "lng": 26.2278,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Valko / Valkom",
    "postalCode": 7910,
    "postalCodeMin": 7910,
    "postalCodeMax": 7919,
    "lat": 60.4029,
    "lng": 26.2545,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Loviisa / Lovisa",
    "postalCode": 7920,
    "postalCodeMin": 7920,
    "postalCodeMax": 7929,
    "lat": 60.4424,
    "lng": 26.2272,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Pernaja / Pernå",
    "postalCode": 7930,
    "postalCodeMin": 7930,
    "postalCodeMax": 7939,
    "lat": 60.4491,
    "lng": 26.032,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Loviisa / Lovisa",
    "postalCode": 7940,
    "postalCodeMin": 7940,
    "postalCodeMax": 7949,
    "lat": 60.4683,
    "lng": 26.26,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Kuggom",
    "postalCode": 7945,
    "postalCodeMin": 7940,
    "postalCodeMax": 7949,
    "lat": 60.4979,
    "lng": 26.1771,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Tesjoki / Tessjö",
    "postalCode": 7955,
    "postalCodeMin": 7950,
    "postalCodeMax": 7959,
    "lat": 60.4713,
    "lng": 26.2928,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Ahvenkoski / Abborfors",
    "postalCode": 7960,
    "postalCodeMin": 7960,
    "postalCodeMax": 7969,
    "lat": 60.4921,
    "lng": 26.4541,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Ruotsinpyhtää / Strömfors",
    "postalCode": 7970,
    "postalCodeMin": 7970,
    "postalCodeMax": 7979,
    "lat": 60.5261,
    "lng": 26.4637,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Kuninkaankylä / Kungsböle",
    "postalCode": 7980,
    "postalCodeMin": 7980,
    "postalCodeMax": 7989,
    "lat": 60.5871,
    "lng": 26.4421,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Loviisa",
    "area": "Ruotsinkylä / Svenskby",
    "postalCode": 7990,
    "postalCodeMin": 7990,
    "postalCodeMax": 7999,
    "lat": 60.6129,
    "lng": 26.4617,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Myrskylä",
    "area": "Myrskylä / Mörskom",
    "postalCode": 7600,
    "postalCodeMin": 7600,
    "postalCodeMax": 7609,
    "lat": 60.6697,
    "lng": 25.8538,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Myrskylä",
    "area": "Kankkila / Kankböle",
    "postalCode": 7690,
    "postalCodeMin": 7690,
    "postalCodeMax": 7699,
    "lat": 60.6104,
    "lng": 25.7566,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Ohkola",
    "postalCode": 4530,
    "postalCodeMin": 4530,
    "postalCodeMax": 4539,
    "lat": 60.5711,
    "lng": 25.1481,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Mäntsälä",
    "postalCode": 4600,
    "postalCodeMin": 4600,
    "postalCodeMax": 4609,
    "lat": 60.6418,
    "lng": 25.3314,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Mäntsälä",
    "postalCode": 4620,
    "postalCodeMin": 4620,
    "postalCodeMax": 4629,
    "lat": 60.6568,
    "lng": 25.2878,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Sääksjärvi",
    "postalCode": 4630,
    "postalCodeMin": 4630,
    "postalCodeMax": 4639,
    "lat": 60.5963,
    "lng": 25.3843,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Numminen",
    "postalCode": 4660,
    "postalCodeMin": 4660,
    "postalCodeMax": 4669,
    "lat": 60.5591,
    "lng": 25.2826,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Hirvihaara",
    "postalCode": 4680,
    "postalCodeMin": 4680,
    "postalCodeMax": 4689,
    "lat": 60.619,
    "lng": 25.2467,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Sälinkää",
    "postalCode": 4740,
    "postalCodeMin": 4740,
    "postalCodeMax": 4749,
    "lat": 60.7116,
    "lng": 25.2315,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Sahakylä",
    "postalCode": 4770,
    "postalCodeMin": 4770,
    "postalCodeMax": 4779,
    "lat": 60.7629,
    "lng": 25.2245,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Kaukalampi",
    "postalCode": 4820,
    "postalCodeMin": 4820,
    "postalCodeMax": 4829,
    "lat": 60.7015,
    "lng": 25.3862,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Hautjärvi",
    "postalCode": 4840,
    "postalCodeMin": 4840,
    "postalCodeMax": 4849,
    "lat": 60.7131,
    "lng": 25.4828,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Saarentaus",
    "postalCode": 4920,
    "postalCodeMin": 4920,
    "postalCodeMax": 4929,
    "lat": 60.7286,
    "lng": 25.4182,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Mäntsälä",
    "area": "Levanto",
    "postalCode": 4940,
    "postalCodeMin": 4940,
    "postalCodeMax": 4949,
    "lat": 60.7633,
    "lng": 25.433,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Klaukkala",
    "postalCode": 1800,
    "postalCodeMin": 1800,
    "postalCodeMax": 1809,
    "lat": 60.3819,
    "lng": 24.7485,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Luhtajoki",
    "postalCode": 1810,
    "postalCodeMin": 1810,
    "postalCodeMax": 1819,
    "lat": 60.4655,
    "lng": 24.8072,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Klaukkala",
    "postalCode": 1820,
    "postalCodeMin": 1820,
    "postalCodeMax": 1829,
    "lat": 60.3986,
    "lng": 24.7618,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Lepsämä",
    "postalCode": 1830,
    "postalCodeMin": 1830,
    "postalCodeMax": 1839,
    "lat": 60.3892,
    "lng": 24.6452,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Klaukkala",
    "postalCode": 1840,
    "postalCodeMin": 1840,
    "postalCodeMax": 1849,
    "lat": 60.3555,
    "lng": 24.7451,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Perttula",
    "postalCode": 1860,
    "postalCodeMin": 1860,
    "postalCodeMax": 1869,
    "lat": 60.4427,
    "lng": 24.7036,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Nurmijärvi",
    "postalCode": 1900,
    "postalCodeMin": 1900,
    "postalCodeMax": 1909,
    "lat": 60.4655,
    "lng": 24.8072,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Palojoki",
    "postalCode": 1940,
    "postalCodeMin": 1940,
    "postalCodeMax": 1949,
    "lat": 60.4211,
    "lng": 24.8681,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Röykkä",
    "postalCode": 5100,
    "postalCodeMin": 5100,
    "postalCodeMax": 5109,
    "lat": 60.4845,
    "lng": 24.6536,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Rajamäki",
    "postalCode": 5200,
    "postalCodeMin": 5200,
    "postalCodeMax": 5209,
    "lat": 60.5255,
    "lng": 24.7616,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Kiljava",
    "postalCode": 5250,
    "postalCodeMin": 5250,
    "postalCodeMax": 5259,
    "lat": 60.5066,
    "lng": 24.6928,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Nurmijärvi",
    "area": "Nukari",
    "postalCode": 5450,
    "postalCodeMin": 5450,
    "postalCodeMax": 5459,
    "lat": 60.5296,
    "lng": 24.9145,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Pornainen",
    "area": "Laukkoski",
    "postalCode": 7150,
    "postalCodeMin": 7150,
    "postalCodeMax": 7159,
    "lat": 60.4322,
    "lng": 25.3996,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Pornainen",
    "area": "Pornainen",
    "postalCode": 7170,
    "postalCodeMin": 7170,
    "postalCodeMax": 7179,
    "lat": 60.4759,
    "lng": 25.3751,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Pornainen",
    "area": "Halkia",
    "postalCode": 7190,
    "postalCodeMin": 7190,
    "postalCodeMax": 7199,
    "lat": 60.5279,
    "lng": 25.2905,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Porvoo / Borgå",
    "postalCode": 6100,
    "postalCodeMin": 6100,
    "postalCodeMax": 6109,
    "lat": 60.3926,
    "lng": 25.6669,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Porvoo / Borgå",
    "postalCode": 6150,
    "postalCodeMin": 6150,
    "postalCodeMax": 6159,
    "lat": 60.4022,
    "lng": 25.6957,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Porvoo / Borgå",
    "postalCode": 6200,
    "postalCodeMin": 6200,
    "postalCodeMax": 6209,
    "lat": 60.335,
    "lng": 25.8545,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Porvoo / Borgå",
    "postalCode": 6400,
    "postalCodeMin": 6400,
    "postalCodeMax": 6409,
    "lat": 60.3627,
    "lng": 25.6155,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Porvoo / Borgå",
    "postalCode": 6450,
    "postalCodeMin": 6450,
    "postalCodeMax": 6459,
    "lat": 60.3718,
    "lng": 25.6017,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Porvoo / Borgå",
    "postalCode": 6500,
    "postalCodeMin": 6500,
    "postalCodeMax": 6509,
    "lat": 60.4197,
    "lng": 25.5652,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Kerkkoo / Kerko",
    "postalCode": 6530,
    "postalCodeMin": 6530,
    "postalCodeMax": 6539,
    "lat": 60.4547,
    "lng": 25.6258,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Hamari / Hammars",
    "postalCode": 6650,
    "postalCodeMin": 6650,
    "postalCodeMax": 6659,
    "lat": 60.3633,
    "lng": 25.6398,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Tolkkinen / Tolkis",
    "postalCode": 6750,
    "postalCodeMin": 6750,
    "postalCodeMax": 6759,
    "lat": 60.34,
    "lng": 25.5872,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Kulloonkylä / Kulloby",
    "postalCode": 6830,
    "postalCodeMin": 6830,
    "postalCodeMax": 6839,
    "lat": 60.341,
    "lng": 25.4819,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Kulloo / Kullo",
    "postalCode": 6850,
    "postalCodeMin": 6850,
    "postalCodeMax": 6859,
    "lat": 60.341,
    "lng": 25.4819,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Kärrby",
    "postalCode": 6880,
    "postalCodeMin": 6880,
    "postalCodeMax": 6889,
    "lat": 60.2864,
    "lng": 25.4751,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Emäsalo / Emsalö",
    "postalCode": 6950,
    "postalCodeMin": 6950,
    "postalCodeMax": 6959,
    "lat": 60.2511,
    "lng": 25.6287,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Hinthaara / Hindhår",
    "postalCode": 7110,
    "postalCodeMin": 7110,
    "postalCodeMax": 7119,
    "lat": 60.4029,
    "lng": 25.4753,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Anttila / Andersböle",
    "postalCode": 7130,
    "postalCodeMin": 7130,
    "postalCodeMax": 7139,
    "lat": 60.3821,
    "lng": 25.3955,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Kaarenkylä / Karsby",
    "postalCode": 7220,
    "postalCodeMin": 7220,
    "postalCodeMax": 7229,
    "lat": 60.47,
    "lng": 25.5523,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Ilola / Illby",
    "postalCode": 7280,
    "postalCodeMin": 7280,
    "postalCodeMax": 7289,
    "lat": 60.4559,
    "lng": 25.7522,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Sannainen / Sannäs",
    "postalCode": 7310,
    "postalCodeMin": 7310,
    "postalCodeMax": 7319,
    "lat": 60.4157,
    "lng": 25.7975,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Jakari / Jackarby",
    "postalCode": 7320,
    "postalCodeMin": 7320,
    "postalCodeMax": 7329,
    "lat": 60.4131,
    "lng": 25.8757,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Gäddrag",
    "postalCode": 7350,
    "postalCodeMin": 7350,
    "postalCodeMax": 7359,
    "lat": 60.3011,
    "lng": 25.8824,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Tirmo",
    "postalCode": 7360,
    "postalCodeMin": 7360,
    "postalCodeMax": 7369,
    "lat": 60.2578,
    "lng": 25.896,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Pellinki / Pellinge",
    "postalCode": 7370,
    "postalCodeMin": 7370,
    "postalCodeMax": 7379,
    "lat": 60.2194,
    "lng": 25.8793,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Suurpellinki / Storpellinge",
    "postalCode": 7390,
    "postalCodeMin": 7390,
    "postalCodeMax": 7399,
    "lat": 60.2068,
    "lng": 25.8421,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Kråkö",
    "postalCode": 7410,
    "postalCodeMin": 7410,
    "postalCodeMax": 7419,
    "lat": 60.3441,
    "lng": 25.6606,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Porvoo",
    "area": "Voolahti / Vålax",
    "postalCode": 7450,
    "postalCodeMin": 7450,
    "postalCodeMax": 7459,
    "lat": 60.294,
    "lng": 25.8502,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Pukkila",
    "area": "Torppi",
    "postalCode": 7550,
    "postalCodeMin": 7550,
    "postalCodeMax": 7559,
    "lat": 60.6219,
    "lng": 25.5173,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Pukkila",
    "area": "Pukkila",
    "postalCode": 7560,
    "postalCodeMin": 7560,
    "postalCodeMax": 7569,
    "lat": 60.6505,
    "lng": 25.5339,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Pukkila",
    "area": "Kantele",
    "postalCode": 7565,
    "postalCodeMin": 7560,
    "postalCodeMax": 7569,
    "lat": 60.6587,
    "lng": 25.6673,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Karjaa / Karis",
    "postalCode": 10300,
    "postalCodeMin": 10300,
    "postalCodeMax": 10309,
    "lat": 60.0715,
    "lng": 23.662,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Karjaa / Karis",
    "postalCode": 10320,
    "postalCodeMin": 10320,
    "postalCodeMax": 10329,
    "lat": 60.0589,
    "lng": 23.6494,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Pinjainen / Billnäs",
    "postalCode": 10330,
    "postalCodeMin": 10330,
    "postalCodeMax": 10339,
    "lat": 60.0855,
    "lng": 23.641,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Meltola / Mjölbolsta",
    "postalCode": 10350,
    "postalCodeMin": 10350,
    "postalCodeMax": 10359,
    "lat": 60.1137,
    "lng": 23.7804,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Mustio / Svartå",
    "postalCode": 10360,
    "postalCodeMin": 10360,
    "postalCodeMax": 10369,
    "lat": 60.1403,
    "lng": 23.8686,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Kaunislahti / Grundsjö",
    "postalCode": 10380,
    "postalCodeMin": 10380,
    "postalCodeMax": 10389,
    "lat": 60.0676,
    "lng": 23.8114,
    "radiusKm": 4.7
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Åminnefors",
    "postalCode": 10410,
    "postalCodeMin": 10410,
    "postalCodeMax": 10419,
    "lat": 60.0948,
    "lng": 23.588,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Pohjankuru / Skuru",
    "postalCode": 10420,
    "postalCodeMin": 10420,
    "postalCodeMax": 10429,
    "lat": 60.0998,
    "lng": 23.5506,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Bollsta",
    "postalCode": 10440,
    "postalCodeMin": 10440,
    "postalCodeMax": 10449,
    "lat": 60.1157,
    "lng": 23.5112,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Fiskari / Fiskars",
    "postalCode": 10470,
    "postalCodeMin": 10470,
    "postalCodeMax": 10479,
    "lat": 60.1239,
    "lng": 23.5384,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Antskog",
    "postalCode": 10480,
    "postalCodeMin": 10480,
    "postalCodeMax": 10489,
    "lat": 60.1719,
    "lng": 23.5924,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Tenhola / Tenala",
    "postalCode": 10520,
    "postalCodeMin": 10520,
    "postalCodeMax": 10529,
    "lat": 60.0584,
    "lng": 23.2981,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Bromarv",
    "postalCode": 10570,
    "postalCodeMin": 10570,
    "postalCodeMax": 10579,
    "lat": 59.9883,
    "lng": 23.0316,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Tammisaari / Ekenäs",
    "postalCode": 10600,
    "postalCodeMin": 10600,
    "postalCodeMax": 10609,
    "lat": 59.9742,
    "lng": 23.4376,
    "radiusKm": 6.2
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Högbacka",
    "postalCode": 10620,
    "postalCodeMin": 10620,
    "postalCodeMax": 10629,
    "lat": 60.0125,
    "lng": 23.3906,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Dragsvik",
    "postalCode": 10640,
    "postalCodeMin": 10640,
    "postalCodeMax": 10649,
    "lat": 59.9842,
    "lng": 23.4745,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Tammisaari / Ekenäs",
    "postalCode": 10650,
    "postalCodeMin": 10650,
    "postalCodeMax": 10659,
    "lat": 59.9773,
    "lng": 23.4639,
    "radiusKm": 6.2
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Tammisaari / Ekenäs",
    "postalCode": 10660,
    "postalCodeMin": 10660,
    "postalCodeMax": 10669,
    "lat": 59.9742,
    "lng": 23.4376,
    "radiusKm": 6.2
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Skogby",
    "postalCode": 10680,
    "postalCodeMin": 10680,
    "postalCodeMax": 10689,
    "lat": 59.9235,
    "lng": 23.3132,
    "radiusKm": 4.7
  },
  {
    "region": "Uusimaa",
    "city": "Raasepori",
    "area": "Snappertuna",
    "postalCode": 10710,
    "postalCodeMin": 10710,
    "postalCodeMax": 10719,
    "lat": 59.9972,
    "lng": 23.6514,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Sipoo",
    "area": "Västerskog",
    "postalCode": 1120,
    "postalCodeMin": 1120,
    "postalCodeMax": 1129,
    "lat": 60.2904,
    "lng": 25.2793,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Sipoo",
    "area": "Söderkulla",
    "postalCode": 1150,
    "postalCodeMin": 1150,
    "postalCodeMax": 1159,
    "lat": 60.3006,
    "lng": 25.3302,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Sipoo",
    "area": "Kalkkiranta / Kalkstrand",
    "postalCode": 1180,
    "postalCodeMin": 1180,
    "postalCodeMax": 1189,
    "lat": 60.2533,
    "lng": 25.3915,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Sipoo",
    "area": "Box",
    "postalCode": 1190,
    "postalCodeMin": 1190,
    "postalCodeMax": 1199,
    "lat": 60.3343,
    "lng": 25.3749,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Sipoo",
    "area": "Nikkilä",
    "postalCode": 4130,
    "postalCodeMin": 4130,
    "postalCodeMax": 4139,
    "lat": 60.3766,
    "lng": 25.2686,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Sipoo",
    "area": "Martinkylä / Mårtensby",
    "postalCode": 4150,
    "postalCodeMin": 4150,
    "postalCodeMax": 4159,
    "lat": 60.3899,
    "lng": 25.236,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Sipoo",
    "area": "Paippinen / Paipis",
    "postalCode": 4170,
    "postalCodeMin": 4170,
    "postalCodeMax": 4179,
    "lat": 60.4717,
    "lng": 25.2132,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Sipoo",
    "area": "Talma / Tallmo",
    "postalCode": 4240,
    "postalCodeMin": 4240,
    "postalCodeMax": 4249,
    "lat": 60.4105,
    "lng": 25.1744,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Siuntio",
    "area": "Siuntio kk / Sjundeå kby",
    "postalCode": 2570,
    "postalCodeMin": 2570,
    "postalCodeMax": 2579,
    "lat": 60.1793,
    "lng": 24.2027,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Siuntio",
    "area": "Siuntio / Sjundeå",
    "postalCode": 2580,
    "postalCodeMin": 2580,
    "postalCodeMax": 2589,
    "lat": 60.1387,
    "lng": 24.227,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Siuntio",
    "area": "Lappers",
    "postalCode": 2590,
    "postalCodeMin": 2590,
    "postalCodeMax": 2599,
    "lat": 60.1744,
    "lng": 24.115,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Hyrylä",
    "postalCode": 4300,
    "postalCodeMin": 4300,
    "postalCodeMax": 4309,
    "lat": 60.4264,
    "lng": 25.0113,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Kirkonkylä",
    "postalCode": 4310,
    "postalCodeMin": 4310,
    "postalCodeMax": 4319,
    "lat": 60.414,
    "lng": 25.0497,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Riihikallio",
    "postalCode": 4320,
    "postalCodeMin": 4320,
    "postalCodeMax": 4329,
    "lat": 60.3759,
    "lng": 25.0155,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Lahela",
    "postalCode": 4330,
    "postalCodeMin": 4330,
    "postalCodeMax": 4339,
    "lat": 60.3857,
    "lng": 24.9853,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Tuusula",
    "postalCode": 4340,
    "postalCodeMin": 4340,
    "postalCodeMax": 4349,
    "lat": 60.399,
    "lng": 25.0707,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Nahkela",
    "postalCode": 4350,
    "postalCodeMin": 4350,
    "postalCodeMax": 4359,
    "lat": 60.4002,
    "lng": 24.9266,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Ruotsinkylä",
    "postalCode": 4360,
    "postalCodeMin": 4360,
    "postalCodeMax": 4369,
    "lat": 60.369,
    "lng": 24.9726,
    "radiusKm": 3.6
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Rusutjärvi",
    "postalCode": 4370,
    "postalCodeMin": 4370,
    "postalCodeMax": 4379,
    "lat": 60.4271,
    "lng": 24.9751,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Tuusula",
    "postalCode": 4380,
    "postalCodeMin": 4380,
    "postalCodeMax": 4389,
    "lat": 60.4609,
    "lng": 25.025,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Jäniksenlinna",
    "postalCode": 4390,
    "postalCodeMin": 4390,
    "postalCodeMax": 4399,
    "lat": 60.491,
    "lng": 24.9671,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Kellokoski",
    "postalCode": 4500,
    "postalCodeMin": 4500,
    "postalCodeMax": 4509,
    "lat": 60.5306,
    "lng": 25.1061,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Jokela",
    "postalCode": 5400,
    "postalCodeMin": 5400,
    "postalCodeMax": 5409,
    "lat": 60.5533,
    "lng": 24.9685,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Tuusula",
    "area": "Nuppulinna",
    "postalCode": 5430,
    "postalCodeMin": 5430,
    "postalCodeMax": 5439,
    "lat": 60.5285,
    "lng": 25.0178,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Hakunila, Länsisalmi, Ojanko, Sotunki",
    "postalCode": 1200,
    "postalCodeMin": 1200,
    "postalCodeMax": 1209,
    "lat": 60.2563,
    "lng": 25.1417,
    "radiusKm": 6.9
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Vaarala",
    "postalCode": 1230,
    "postalCodeMin": 1230,
    "postalCodeMax": 1239,
    "lat": 60.2624,
    "lng": 25.093,
    "radiusKm": 11.6
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Itä-Hakkila, Kuninkaanmäki",
    "postalCode": 1260,
    "postalCodeMin": 1260,
    "postalCodeMax": 1269,
    "lat": 60.2937,
    "lng": 25.1103,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Länsimäki, Rajakylä",
    "postalCode": 1280,
    "postalCodeMin": 1280,
    "postalCodeMax": 1289,
    "lat": 60.2439,
    "lng": 25.1052,
    "radiusKm": 7.9
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Koivuhaka, Kuninkaala, Tikkurila, Viertola",
    "postalCode": 1300,
    "postalCodeMin": 1300,
    "postalCodeMax": 1309,
    "lat": 60.2854,
    "lng": 25.0455,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Leinelä",
    "postalCode": 1340,
    "postalCodeMin": 1340,
    "postalCodeMax": 1349,
    "lat": 60.3228,
    "lng": 25.0386,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Hiekkaharju, Simonkylä",
    "postalCode": 1350,
    "postalCodeMin": 1350,
    "postalCodeMax": 1359,
    "lat": 60.3103,
    "lng": 25.0304,
    "radiusKm": 4.8
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Havukoski, Koivukylä",
    "postalCode": 1360,
    "postalCodeMin": 1360,
    "postalCodeMax": 1369,
    "lat": 60.3214,
    "lng": 25.0713,
    "radiusKm": 7.9
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Jokiniemi",
    "postalCode": 1370,
    "postalCodeMin": 1370,
    "postalCodeMax": 1379,
    "lat": 60.2989,
    "lng": 25.0548,
    "radiusKm": 9.5
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Hakkila, Kuninkaala",
    "postalCode": 1380,
    "postalCodeMin": 1380,
    "postalCodeMax": 1389,
    "lat": 60.2924,
    "lng": 25.0734,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Ilola, Ruskeasanta",
    "postalCode": 1390,
    "postalCodeMin": 1390,
    "postalCodeMax": 1399,
    "lat": 60.3264,
    "lng": 25.021,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Asola, Matari, Rekola",
    "postalCode": 1400,
    "postalCodeMin": 1400,
    "postalCodeMax": 1409,
    "lat": 60.3302,
    "lng": 25.0728,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Päiväkumpu",
    "postalCode": 1420,
    "postalCodeMin": 1420,
    "postalCodeMax": 1429,
    "lat": 60.3272,
    "lng": 25.1034,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Korso, Leppäkorpi, Metsola, Vallinoja, Vierumäki",
    "postalCode": 1450,
    "postalCodeMin": 1450,
    "postalCodeMax": 1459,
    "lat": 60.3693,
    "lng": 25.0747,
    "radiusKm": 6.9
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Jokivarsi, Metsola, Mikkola",
    "postalCode": 1480,
    "postalCodeMin": 1480,
    "postalCodeMax": 1489,
    "lat": 60.3508,
    "lng": 25.1155,
    "radiusKm": 9.5
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Nikinmäki",
    "postalCode": 1490,
    "postalCodeMin": 1490,
    "postalCodeMax": 1499,
    "lat": 60.3397,
    "lng": 25.1334,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Helsingin pitäjän kirkonkylä, Koivuhaka, Pakkala, Veromies",
    "postalCode": 1510,
    "postalCodeMin": 1510,
    "postalCodeMax": 1519,
    "lat": 60.2836,
    "lng": 24.9831,
    "radiusKm": 7.9
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Pakkala, Tammisto",
    "postalCode": 1520,
    "postalCodeMin": 1520,
    "postalCodeMax": 1529,
    "lat": 60.2742,
    "lng": 24.9703,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Lentokenttä, Veromies",
    "postalCode": 1530,
    "postalCodeMin": 1530,
    "postalCodeMax": 1539,
    "lat": 60.2983,
    "lng": 24.9633,
    "radiusKm": 7.9
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Myyrmäki",
    "postalCode": 1600,
    "postalCodeMin": 1600,
    "postalCodeMax": 1609,
    "lat": 60.2661,
    "lng": 24.8517,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Kaivoksela",
    "postalCode": 1610,
    "postalCodeMin": 1610,
    "postalCodeMax": 1619,
    "lat": 60.2704,
    "lng": 24.8692,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Martinlaakso",
    "postalCode": 1620,
    "postalCodeMin": 1620,
    "postalCodeMax": 1629,
    "lat": 60.2785,
    "lng": 24.8514,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Hämeenkylä",
    "postalCode": 1630,
    "postalCodeMin": 1630,
    "postalCodeMax": 1639,
    "lat": 60.2691,
    "lng": 24.7991,
    "radiusKm": 7.9
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Hämevaara, Linnainen",
    "postalCode": 1640,
    "postalCodeMin": 1640,
    "postalCodeMax": 1649,
    "lat": 60.2497,
    "lng": 24.806,
    "radiusKm": 11.6
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Vapaala",
    "postalCode": 1650,
    "postalCodeMin": 1650,
    "postalCodeMax": 1659,
    "lat": 60.2628,
    "lng": 24.8247,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Varisto",
    "postalCode": 1660,
    "postalCodeMin": 1660,
    "postalCodeMax": 1669,
    "lat": 60.27,
    "lng": 24.8172,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Vantaanlaakso",
    "postalCode": 1670,
    "postalCodeMin": 1670,
    "postalCodeMax": 1679,
    "lat": 60.2837,
    "lng": 24.872,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Askisto",
    "postalCode": 1680,
    "postalCodeMin": 1680,
    "postalCodeMax": 1689,
    "lat": 60.2812,
    "lng": 24.7838,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Ylästö",
    "postalCode": 1690,
    "postalCodeMin": 1690,
    "postalCodeMax": 1699,
    "lat": 60.2841,
    "lng": 24.9145,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Kivistö",
    "postalCode": 1700,
    "postalCodeMin": 1700,
    "postalCodeMax": 1709,
    "lat": 60.3228,
    "lng": 24.8408,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Pähkinärinne",
    "postalCode": 1710,
    "postalCodeMin": 1710,
    "postalCodeMax": 1719,
    "lat": 60.2597,
    "lng": 24.8064,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Petikko, Varisto",
    "postalCode": 1720,
    "postalCodeMin": 1720,
    "postalCodeMax": 1729,
    "lat": 60.2806,
    "lng": 24.8148,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Lapinkylä, Myllymäki, Piispankylä",
    "postalCode": 1730,
    "postalCodeMin": 1730,
    "postalCodeMax": 1739,
    "lat": 60.3278,
    "lng": 24.8659,
    "radiusKm": 7.9
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Viinikkala",
    "postalCode": 1740,
    "postalCodeMin": 1740,
    "postalCodeMax": 1749,
    "lat": 60.2961,
    "lng": 24.879,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Keimola, Luhtaanmäki, Vestra",
    "postalCode": 1750,
    "postalCodeMin": 1750,
    "postalCodeMax": 1759,
    "lat": 60.3515,
    "lng": 24.7934,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Kiila, Riipilä, Seutula",
    "postalCode": 1760,
    "postalCodeMin": 1760,
    "postalCodeMax": 1769,
    "lat": 60.3477,
    "lng": 24.8655,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vantaa",
    "area": "Sanomala",
    "postalCode": 1770,
    "postalCodeMin": 1770,
    "postalCodeMax": 1779,
    "lat": 60.2874,
    "lng": 24.8541,
    "radiusKm": 5.3
  },
  {
    "region": "Uusimaa",
    "city": "Vihti",
    "area": "Nummela",
    "postalCode": 3100,
    "postalCodeMin": 3100,
    "postalCodeMax": 3109,
    "lat": 60.334,
    "lng": 24.3205,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Vihti",
    "area": "Huhmari",
    "postalCode": 3150,
    "postalCodeMin": 3150,
    "postalCodeMax": 3159,
    "lat": 60.3016,
    "lng": 24.3612,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Vihti",
    "area": "Tervalampi",
    "postalCode": 3220,
    "postalCodeMin": 3220,
    "postalCodeMax": 3229,
    "lat": 60.319,
    "lng": 24.4117,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Vihti",
    "area": "Ojakkala",
    "postalCode": 3250,
    "postalCodeMin": 3250,
    "postalCodeMax": 3259,
    "lat": 60.3691,
    "lng": 24.3836,
    "radiusKm": 3.1
  },
  {
    "region": "Uusimaa",
    "city": "Vihti",
    "area": "Otalampi",
    "postalCode": 3300,
    "postalCodeMin": 3300,
    "postalCodeMax": 3309,
    "lat": 60.4009,
    "lng": 24.4941,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Vihti",
    "area": "Selki",
    "postalCode": 3320,
    "postalCodeMin": 3320,
    "postalCodeMax": 3329,
    "lat": 60.432,
    "lng": 24.5216,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Vihti",
    "area": "Vihti",
    "postalCode": 3400,
    "postalCodeMin": 3400,
    "postalCodeMax": 3409,
    "lat": 60.4158,
    "lng": 24.3269,
    "radiusKm": 2.4
  },
  {
    "region": "Uusimaa",
    "city": "Vihti",
    "area": "Jokikunta",
    "postalCode": 3430,
    "postalCodeMin": 3430,
    "postalCodeMax": 3439,
    "lat": 60.4387,
    "lng": 24.1961,
    "radiusKm": 4.3
  },
  {
    "region": "Uusimaa",
    "city": "Vihti",
    "area": "Vihtijärvi",
    "postalCode": 3790,
    "postalCodeMin": 3790,
    "postalCodeMax": 3799,
    "lat": 60.5248,
    "lng": 24.6037,
    "radiusKm": 4.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Forssa",
    "area": "Forssa",
    "postalCode": 30100,
    "postalCodeMin": 30100,
    "postalCodeMax": 30109,
    "lat": 60.8146,
    "lng": 23.6339,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Forssa",
    "area": "Forssa",
    "postalCode": 30300,
    "postalCodeMin": 30300,
    "postalCodeMax": 30309,
    "lat": 60.7951,
    "lng": 23.6322,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Forssa",
    "area": "Forssa",
    "postalCode": 30420,
    "postalCodeMin": 30420,
    "postalCodeMax": 30429,
    "lat": 60.8008,
    "lng": 23.5851,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Forssa",
    "area": "Matku",
    "postalCode": 31110,
    "postalCodeMin": 31110,
    "postalCodeMax": 31119,
    "lat": 60.9589,
    "lng": 23.512,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Forssa",
    "area": "Koijärvi",
    "postalCode": 31130,
    "postalCodeMin": 31130,
    "postalCodeMax": 31139,
    "lat": 60.9467,
    "lng": 23.6633,
    "radiusKm": 4.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Forssa",
    "area": "Savijoki",
    "postalCode": 31170,
    "postalCodeMin": 31170,
    "postalCodeMax": 31179,
    "lat": 60.9774,
    "lng": 23.7317,
    "radiusKm": 3.6
  },
  {
    "region": "Kanta-Häme",
    "city": "Hattula",
    "area": "Parolannummi",
    "postalCode": 13700,
    "postalCodeMin": 13700,
    "postalCodeMax": 13709,
    "lat": 61.0248,
    "lng": 24.3662,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hattula",
    "area": "Parola",
    "postalCode": 13720,
    "postalCodeMin": 13720,
    "postalCodeMax": 13729,
    "lat": 61.0555,
    "lng": 24.3712,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hattula",
    "area": "Katinala",
    "postalCode": 13800,
    "postalCodeMin": 13800,
    "postalCodeMax": 13809,
    "lat": 61.0357,
    "lng": 24.4061,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hattula",
    "area": "Hattula",
    "postalCode": 13880,
    "postalCodeMin": 13880,
    "postalCodeMax": 13889,
    "lat": 61.0937,
    "lng": 24.428,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hattula",
    "area": "Pekola",
    "postalCode": 13900,
    "postalCodeMin": 13900,
    "postalCodeMax": 13909,
    "lat": 61.047,
    "lng": 24.4448,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hattula",
    "area": "Vuohiniemi",
    "postalCode": 14430,
    "postalCodeMin": 14430,
    "postalCodeMax": 14439,
    "lat": 60.9465,
    "lng": 24.1258,
    "radiusKm": 3.2
  },
  {
    "region": "Kanta-Häme",
    "city": "Hattula",
    "area": "Leteensuo",
    "postalCode": 14530,
    "postalCodeMin": 14530,
    "postalCodeMax": 14539,
    "lat": 61.0645,
    "lng": 24.2401,
    "radiusKm": 3.5
  },
  {
    "region": "Kanta-Häme",
    "city": "Hattula",
    "area": "Lepaa",
    "postalCode": 14610,
    "postalCodeMin": 14610,
    "postalCodeMax": 14619,
    "lat": 61.1184,
    "lng": 24.3382,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hattula",
    "area": "Tyrväntö",
    "postalCode": 14620,
    "postalCodeMin": 14620,
    "postalCodeMax": 14629,
    "lat": 61.1548,
    "lng": 24.336,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hausjärvi",
    "area": "Oitti",
    "postalCode": 12100,
    "postalCodeMin": 12100,
    "postalCodeMax": 12109,
    "lat": 60.7865,
    "lng": 25.0272,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hausjärvi",
    "area": "Mommila",
    "postalCode": 12130,
    "postalCodeMin": 12130,
    "postalCodeMax": 12139,
    "lat": 60.8225,
    "lng": 25.0785,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hausjärvi",
    "area": "Hietoinen",
    "postalCode": 12170,
    "postalCodeMin": 12170,
    "postalCodeMax": 12179,
    "lat": 60.9052,
    "lng": 25.0416,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hausjärvi",
    "area": "Hausjärvi",
    "postalCode": 12210,
    "postalCodeMin": 12210,
    "postalCodeMax": 12219,
    "lat": 60.7906,
    "lng": 24.9298,
    "radiusKm": 3.5
  },
  {
    "region": "Kanta-Häme",
    "city": "Hausjärvi",
    "area": "Hikiä",
    "postalCode": 12240,
    "postalCodeMin": 12240,
    "postalCodeMax": 12249,
    "lat": 60.7574,
    "lng": 24.9191,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hausjärvi",
    "area": "Ryttylä",
    "postalCode": 12310,
    "postalCodeMin": 12310,
    "postalCodeMax": 12319,
    "lat": 60.8196,
    "lng": 24.7611,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hausjärvi",
    "area": "Turkhauta",
    "postalCode": 12350,
    "postalCodeMin": 12350,
    "postalCodeMax": 12359,
    "lat": 60.82,
    "lng": 24.8112,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Humppila",
    "area": "Humppila",
    "postalCode": 31640,
    "postalCodeMin": 31640,
    "postalCodeMax": 31649,
    "lat": 60.9242,
    "lng": 23.3711,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Humppila",
    "area": "Venäjänkangas",
    "postalCode": 31650,
    "postalCodeMin": 31650,
    "postalCodeMax": 31659,
    "lat": 60.9812,
    "lng": 23.3099,
    "radiusKm": 4.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Keskus",
    "postalCode": 13100,
    "postalCodeMin": 13100,
    "postalCodeMax": 13109,
    "lat": 60.9847,
    "lng": 24.4613,
    "radiusKm": 1.2
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Kantola, Vanaja",
    "postalCode": 13110,
    "postalCodeMin": 13110,
    "postalCodeMax": 13119,
    "lat": 60.9881,
    "lng": 24.4814,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Kauriala",
    "postalCode": 13130,
    "postalCodeMin": 13130,
    "postalCodeMax": 13139,
    "lat": 60.9961,
    "lng": 24.4409,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Keinusaari",
    "postalCode": 13200,
    "postalCodeMin": 13200,
    "postalCodeMax": 13209,
    "lat": 60.9969,
    "lng": 24.4793,
    "radiusKm": 3.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Hätilä",
    "postalCode": 13210,
    "postalCodeMin": 13210,
    "postalCodeMax": 13219,
    "lat": 61.0043,
    "lng": 24.4838,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Aulanko, Sairio",
    "postalCode": 13220,
    "postalCodeMin": 13220,
    "postalCodeMax": 13229,
    "lat": 61.0125,
    "lng": 24.4761,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Katumajärvi",
    "postalCode": 13250,
    "postalCodeMin": 13250,
    "postalCodeMax": 13259,
    "lat": 60.9846,
    "lng": 24.5182,
    "radiusKm": 0.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Ruununmylly",
    "postalCode": 13270,
    "postalCodeMin": 13270,
    "postalCodeMax": 13279,
    "lat": 61.0124,
    "lng": 24.5323,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Käikälä",
    "postalCode": 13300,
    "postalCodeMin": 13300,
    "postalCodeMax": 13309,
    "lat": 60.9657,
    "lng": 24.5491,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Hattelmala",
    "postalCode": 13430,
    "postalCodeMin": 13430,
    "postalCodeMax": 13439,
    "lat": 60.9663,
    "lng": 24.4725,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Jukola",
    "postalCode": 13500,
    "postalCodeMin": 13500,
    "postalCodeMax": 13509,
    "lat": 60.9845,
    "lng": 24.4174,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Ahvenisto",
    "postalCode": 13530,
    "postalCodeMin": 13530,
    "postalCodeMax": 13539,
    "lat": 60.989,
    "lng": 24.4149,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Ojoinen",
    "postalCode": 13600,
    "postalCodeMin": 13600,
    "postalCodeMax": 13609,
    "lat": 61.0076,
    "lng": 24.4427,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Renko",
    "postalCode": 14300,
    "postalCodeMin": 14300,
    "postalCodeMax": 14309,
    "lat": 60.8937,
    "lng": 24.2869,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Rimmilä",
    "postalCode": 14450,
    "postalCodeMin": 14450,
    "postalCodeMax": 14459,
    "lat": 60.9882,
    "lng": 24.0588,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Iittala",
    "postalCode": 14500,
    "postalCodeMin": 14500,
    "postalCodeMax": 14509,
    "lat": 61.0913,
    "lng": 24.1348,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Leteensuo",
    "postalCode": 14530,
    "postalCodeMin": 14530,
    "postalCodeMax": 14539,
    "lat": 61.0678,
    "lng": 24.2583,
    "radiusKm": 3.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Alvettula",
    "postalCode": 14680,
    "postalCodeMin": 14680,
    "postalCodeMax": 14689,
    "lat": 61.2002,
    "lng": 24.4845,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Torvoila",
    "postalCode": 14690,
    "postalCodeMin": 14690,
    "postalCodeMax": 14699,
    "lat": 61.2552,
    "lng": 24.5589,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Hauho",
    "postalCode": 14700,
    "postalCodeMin": 14700,
    "postalCodeMax": 14709,
    "lat": 61.1716,
    "lng": 24.5634,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Eteläinen",
    "postalCode": 14770,
    "postalCodeMin": 14770,
    "postalCodeMax": 14779,
    "lat": 61.0704,
    "lng": 24.6792,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Pohjoinen",
    "postalCode": 14810,
    "postalCodeMin": 14810,
    "postalCodeMax": 14819,
    "lat": 61.1022,
    "lng": 24.8722,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Syrjäntaka",
    "postalCode": 14820,
    "postalCodeMin": 14820,
    "postalCodeMax": 14829,
    "lat": 61.1162,
    "lng": 24.8316,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Sairiala",
    "postalCode": 14840,
    "postalCodeMin": 14840,
    "postalCodeMax": 14849,
    "lat": 61.1438,
    "lng": 24.7932,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Juttila",
    "postalCode": 14870,
    "postalCodeMin": 14870,
    "postalCodeMax": 14879,
    "lat": 61.1668,
    "lng": 24.7776,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Sappee",
    "postalCode": 14930,
    "postalCodeMin": 14930,
    "postalCodeMax": 14939,
    "lat": 61.2571,
    "lng": 24.707,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Lammi",
    "postalCode": 16900,
    "postalCodeMin": 16900,
    "postalCodeMax": 16909,
    "lat": 61.0775,
    "lng": 25.011,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Iso-Evo",
    "postalCode": 16960,
    "postalCodeMin": 16960,
    "postalCodeMax": 16969,
    "lat": 61.1764,
    "lng": 25.0484,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Hämeenlinna",
    "area": "Evo",
    "postalCode": 16970,
    "postalCodeMin": 16970,
    "postalCodeMax": 16979,
    "lat": 61.1927,
    "lng": 25.1082,
    "radiusKm": 1.9
  },
  {
    "region": "Kanta-Häme",
    "city": "Janakkala",
    "area": "Leppäkoski",
    "postalCode": 12380,
    "postalCodeMin": 12380,
    "postalCodeMax": 12389,
    "lat": 60.8635,
    "lng": 24.7069,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Janakkala",
    "area": "Tervakoski",
    "postalCode": 12400,
    "postalCodeMin": 12400,
    "postalCodeMax": 12409,
    "lat": 60.8145,
    "lng": 24.6258,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Janakkala",
    "area": "Vähikkälä",
    "postalCode": 12450,
    "postalCodeMin": 12450,
    "postalCodeMax": 12459,
    "lat": 60.7849,
    "lng": 24.5318,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Janakkala",
    "area": "Harviala",
    "postalCode": 13330,
    "postalCodeMin": 13330,
    "postalCodeMax": 13339,
    "lat": 60.9503,
    "lng": 24.5727,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Janakkala",
    "area": "Jokimaa",
    "postalCode": 14140,
    "postalCodeMin": 14140,
    "postalCodeMax": 14149,
    "lat": 60.877,
    "lng": 24.8709,
    "radiusKm": 3.2
  },
  {
    "region": "Kanta-Häme",
    "city": "Janakkala",
    "area": "Turenki",
    "postalCode": 14200,
    "postalCodeMin": 14200,
    "postalCodeMax": 14209,
    "lat": 60.9201,
    "lng": 24.646,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Janakkala",
    "area": "Janakkala",
    "postalCode": 14240,
    "postalCodeMin": 14240,
    "postalCodeMax": 14249,
    "lat": 60.8893,
    "lng": 24.5209,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Jokioinen",
    "area": "Jokioinen",
    "postalCode": 31600,
    "postalCodeMin": 31600,
    "postalCodeMax": 31609,
    "lat": 60.8038,
    "lng": 23.4858,
    "radiusKm": 3.6
  },
  {
    "region": "Kanta-Häme",
    "city": "Jokioinen",
    "area": "Vaulammi",
    "postalCode": 31610,
    "postalCodeMin": 31610,
    "postalCodeMax": 31619,
    "lat": 60.7887,
    "lng": 23.421,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Jokioinen",
    "area": "Latovainio",
    "postalCode": 31620,
    "postalCodeMin": 31620,
    "postalCodeMax": 31629,
    "lat": 60.8772,
    "lng": 23.4929,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Jokioinen",
    "area": "Minkiö",
    "postalCode": 31630,
    "postalCodeMin": 31630,
    "postalCodeMax": 31639,
    "lat": 60.8407,
    "lng": 23.4025,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Kormu",
    "postalCode": 12520,
    "postalCodeMin": 12520,
    "postalCodeMax": 12529,
    "lat": 60.7434,
    "lng": 24.6492,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Launonen",
    "postalCode": 12540,
    "postalCodeMin": 12540,
    "postalCodeMax": 12549,
    "lat": 60.7495,
    "lng": 24.5855,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Läyliäinen",
    "postalCode": 12600,
    "postalCodeMin": 12600,
    "postalCodeMax": 12609,
    "lat": 60.626,
    "lng": 24.4597,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Sajaniemi",
    "postalCode": 12630,
    "postalCodeMin": 12630,
    "postalCodeMax": 12639,
    "lat": 60.6857,
    "lng": 24.4793,
    "radiusKm": 3.2
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Jokiniemi",
    "postalCode": 12640,
    "postalCodeMin": 12640,
    "postalCodeMax": 12649,
    "lat": 60.7104,
    "lng": 24.4816,
    "radiusKm": 3.2
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Loppi",
    "postalCode": 12700,
    "postalCodeMin": 12700,
    "postalCodeMax": 12709,
    "lat": 60.7178,
    "lng": 24.4417,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Pilpala",
    "postalCode": 12750,
    "postalCodeMin": 12750,
    "postalCodeMax": 12759,
    "lat": 60.6231,
    "lng": 24.2872,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Räyskälä",
    "postalCode": 12820,
    "postalCodeMin": 12820,
    "postalCodeMax": 12829,
    "lat": 60.742,
    "lng": 24.1507,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Topeno",
    "postalCode": 12920,
    "postalCodeMin": 12920,
    "postalCodeMax": 12929,
    "lat": 60.7672,
    "lng": 24.2955,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Loppi",
    "area": "Vojakkala",
    "postalCode": 12950,
    "postalCodeMin": 12950,
    "postalCodeMax": 12959,
    "lat": 60.78,
    "lng": 24.1568,
    "radiusKm": 2.3
  },
  {
    "region": "Kanta-Häme",
    "city": "Riihimäki",
    "area": "Riihimäki",
    "postalCode": 11100,
    "postalCodeMin": 11100,
    "postalCodeMax": 11109,
    "lat": 60.7329,
    "lng": 24.7653,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Riihimäki",
    "area": "Riihimäki",
    "postalCode": 11120,
    "postalCodeMin": 11120,
    "postalCodeMax": 11129,
    "lat": 60.7794,
    "lng": 24.7976,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Riihimäki",
    "area": "Riihimäki",
    "postalCode": 11130,
    "postalCodeMin": 11130,
    "postalCodeMax": 11139,
    "lat": 60.7158,
    "lng": 24.8364,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Riihimäki",
    "area": "Riihimäki",
    "postalCode": 11310,
    "postalCodeMin": 11310,
    "postalCodeMax": 11319,
    "lat": 60.7637,
    "lng": 24.7985,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Riihimäki",
    "area": "Riihimäki",
    "postalCode": 11710,
    "postalCodeMin": 11710,
    "postalCodeMax": 11719,
    "lat": 60.7408,
    "lng": 24.7511,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Riihimäki",
    "area": "Riihimäki",
    "postalCode": 11910,
    "postalCodeMin": 11910,
    "postalCodeMax": 11919,
    "lat": 60.7603,
    "lng": 24.7051,
    "radiusKm": 1.8
  },
  {
    "region": "Kanta-Häme",
    "city": "Tammela",
    "area": "Susikas",
    "postalCode": 31230,
    "postalCodeMin": 31230,
    "postalCodeMax": 31239,
    "lat": 60.8789,
    "lng": 23.8472,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Tammela",
    "area": "Teuro",
    "postalCode": 31250,
    "postalCodeMin": 31250,
    "postalCodeMax": 31259,
    "lat": 60.863,
    "lng": 23.9299,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Tammela",
    "area": "Tammela",
    "postalCode": 31300,
    "postalCodeMin": 31300,
    "postalCodeMax": 31309,
    "lat": 60.8091,
    "lng": 23.769,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Tammela",
    "area": "Mustiala",
    "postalCode": 31310,
    "postalCodeMin": 31310,
    "postalCodeMax": 31319,
    "lat": 60.8184,
    "lng": 23.7698,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Tammela",
    "area": "Porras",
    "postalCode": 31340,
    "postalCodeMin": 31340,
    "postalCodeMax": 31349,
    "lat": 60.7536,
    "lng": 23.9092,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Tammela",
    "area": "Liesjärvi",
    "postalCode": 31350,
    "postalCodeMin": 31350,
    "postalCodeMax": 31359,
    "lat": 60.7004,
    "lng": 23.9387,
    "radiusKm": 4.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Tammela",
    "area": "Eerikkilän urheiluopisto",
    "postalCode": 31370,
    "postalCodeMin": 31370,
    "postalCodeMax": 31379,
    "lat": 60.723,
    "lng": 23.7893,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Tammela",
    "area": "Letku",
    "postalCode": 31380,
    "postalCodeMin": 31380,
    "postalCodeMax": 31389,
    "lat": 60.6982,
    "lng": 23.7218,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Ypäjä",
    "area": "Ypäjä",
    "postalCode": 32100,
    "postalCodeMin": 32100,
    "postalCodeMax": 32109,
    "lat": 60.8038,
    "lng": 23.2819,
    "radiusKm": 2.0
  },
  {
    "region": "Kanta-Häme",
    "city": "Ypäjä",
    "area": "Ypäjä as",
    "postalCode": 32140,
    "postalCodeMin": 32140,
    "postalCodeMax": 32149,
    "lat": 60.849,
    "lng": 23.2231,
    "radiusKm": 2.0
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Vesivehmaa",
    "postalCode": 17130,
    "postalCodeMin": 17130,
    "postalCodeMax": 17139,
    "lat": 61.14,
    "lng": 25.6631,
    "radiusKm": 4.2
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Urajärvi",
    "postalCode": 17150,
    "postalCodeMin": 17150,
    "postalCodeMax": 17159,
    "lat": 61.1322,
    "lng": 25.7712,
    "radiusKm": 3.8
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Vääksy",
    "postalCode": 17200,
    "postalCodeMin": 17200,
    "postalCodeMax": 17209,
    "lat": 61.1721,
    "lng": 25.547,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Pietilä",
    "postalCode": 17220,
    "postalCodeMin": 17220,
    "postalCodeMax": 17229,
    "lat": 61.2395,
    "lng": 25.711,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Kalkkinen",
    "postalCode": 17240,
    "postalCodeMin": 17240,
    "postalCodeMax": 17249,
    "lat": 61.2992,
    "lng": 25.684,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Asikkala",
    "postalCode": 17320,
    "postalCodeMin": 17320,
    "postalCodeMax": 17329,
    "lat": 61.2154,
    "lng": 25.4895,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Viitaila",
    "postalCode": 17410,
    "postalCodeMin": 17410,
    "postalCodeMax": 17419,
    "lat": 61.1434,
    "lng": 25.3519,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Kurhila",
    "postalCode": 17430,
    "postalCodeMin": 17430,
    "postalCodeMax": 17439,
    "lat": 61.19,
    "lng": 25.3877,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Vähimaa",
    "postalCode": 17440,
    "postalCodeMin": 17440,
    "postalCodeMax": 17449,
    "lat": 61.2102,
    "lng": 25.382,
    "radiusKm": 4.2
  },
  {
    "region": "Päijät-Häme",
    "city": "Asikkala",
    "area": "Iso-Äiniö",
    "postalCode": 17450,
    "postalCodeMin": 17450,
    "postalCodeMax": 17459,
    "lat": 61.2253,
    "lng": 25.3501,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hartola",
    "area": "Lepsala",
    "postalCode": 19510,
    "postalCodeMin": 19510,
    "postalCodeMax": 19519,
    "lat": 61.4307,
    "lng": 26.2009,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hartola",
    "area": "Koitti",
    "postalCode": 19540,
    "postalCodeMin": 19540,
    "postalCodeMax": 19549,
    "lat": 61.5048,
    "lng": 26.2244,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hartola",
    "area": "Hartola",
    "postalCode": 19600,
    "postalCodeMin": 19600,
    "postalCodeMax": 19609,
    "lat": 61.5798,
    "lng": 26.0202,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hartola",
    "area": "Murakka",
    "postalCode": 19610,
    "postalCodeMin": 19610,
    "postalCodeMax": 19619,
    "lat": 61.5343,
    "lng": 26.0899,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hartola",
    "area": "Pohela",
    "postalCode": 19620,
    "postalCodeMin": 19620,
    "postalCodeMax": 19629,
    "lat": 61.5039,
    "lng": 26.0158,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hartola",
    "area": "Kalhonkylä",
    "postalCode": 19630,
    "postalCodeMin": 19630,
    "postalCodeMax": 19639,
    "lat": 61.4715,
    "lng": 25.9281,
    "radiusKm": 2.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hartola",
    "area": "Putkijärvi",
    "postalCode": 19850,
    "postalCodeMin": 19850,
    "postalCodeMax": 19859,
    "lat": 61.7328,
    "lng": 25.8805,
    "radiusKm": 3.8
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "keskusta, Tähtiniemi, Hevossaari, Sinilähde",
    "postalCode": 18100,
    "postalCodeMin": 18100,
    "postalCodeMax": 18109,
    "lat": 61.183,
    "lng": 25.9923,
    "radiusKm": 1.0
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Rainio",
    "postalCode": 18120,
    "postalCodeMin": 18120,
    "postalCodeMax": 18129,
    "lat": 61.2118,
    "lng": 26.0655,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Tommola, Sahanniemi",
    "postalCode": 18130,
    "postalCodeMin": 18130,
    "postalCodeMax": 18139,
    "lat": 61.1989,
    "lng": 26.0456,
    "radiusKm": 3.5
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Jyränkö",
    "postalCode": 18150,
    "postalCodeMin": 18150,
    "postalCodeMax": 18159,
    "lat": 61.1909,
    "lng": 26.0276,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Veljeskylä, Vuohkallio",
    "postalCode": 18200,
    "postalCodeMin": 18200,
    "postalCodeMax": 18209,
    "lat": 61.2265,
    "lng": 26.0515,
    "radiusKm": 2.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Heinola kk",
    "postalCode": 18300,
    "postalCodeMin": 18300,
    "postalCodeMax": 18309,
    "lat": 61.2477,
    "lng": 26.0616,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Myllyoja",
    "postalCode": 18600,
    "postalCodeMin": 18600,
    "postalCodeMax": 18609,
    "lat": 61.1615,
    "lng": 25.9831,
    "radiusKm": 2.5
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Vierumäki",
    "postalCode": 19110,
    "postalCodeMin": 19110,
    "postalCodeMax": 19119,
    "lat": 61.1046,
    "lng": 25.932,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Vierumäki",
    "postalCode": 19120,
    "postalCodeMin": 19120,
    "postalCodeMax": 19129,
    "lat": 61.1046,
    "lng": 25.932,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Lusi",
    "postalCode": 19210,
    "postalCodeMin": 19210,
    "postalCodeMax": 19219,
    "lat": 61.2982,
    "lng": 26.074,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Syrjäkoski",
    "postalCode": 19250,
    "postalCodeMin": 19250,
    "postalCodeMax": 19259,
    "lat": 61.3562,
    "lng": 26.1769,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Heinola",
    "area": "Paaso",
    "postalCode": 19260,
    "postalCodeMin": 19260,
    "postalCodeMax": 19269,
    "lat": 61.3661,
    "lng": 26.2549,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Kukkila",
    "postalCode": 15270,
    "postalCodeMin": 15270,
    "postalCodeMax": 15279,
    "lat": 61.0411,
    "lng": 25.6546,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Lahti",
    "postalCode": 15820,
    "postalCodeMin": 15820,
    "postalCodeMax": 15829,
    "lat": 60.9395,
    "lng": 25.5549,
    "radiusKm": 2.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Kartano",
    "postalCode": 15860,
    "postalCodeMin": 15860,
    "postalCodeMax": 15869,
    "lat": 60.9824,
    "lng": 25.5432,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Salpakangas",
    "postalCode": 15870,
    "postalCodeMin": 15870,
    "postalCodeMax": 15879,
    "lat": 60.9887,
    "lng": 25.5164,
    "radiusKm": 3.8
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Soramäki",
    "postalCode": 15880,
    "postalCodeMin": 15880,
    "postalCodeMax": 15889,
    "lat": 60.9879,
    "lng": 25.4769,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Messilä",
    "postalCode": 15980,
    "postalCodeMin": 15980,
    "postalCodeMax": 15989,
    "lat": 61.0136,
    "lng": 25.5591,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Herrala",
    "postalCode": 16500,
    "postalCodeMin": 16500,
    "postalCodeMax": 16509,
    "lat": 60.8976,
    "lng": 25.4694,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Tennilä",
    "postalCode": 16630,
    "postalCodeMin": 16630,
    "postalCodeMax": 16639,
    "lat": 60.9566,
    "lng": 25.347,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Hollola kk",
    "postalCode": 16710,
    "postalCodeMin": 16710,
    "postalCodeMax": 16719,
    "lat": 61.052,
    "lng": 25.4006,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Kutajärvi",
    "postalCode": 16730,
    "postalCodeMin": 16730,
    "postalCodeMax": 16739,
    "lat": 61.0381,
    "lng": 25.479,
    "radiusKm": 3.8
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Manskivi",
    "postalCode": 16790,
    "postalCodeMin": 16790,
    "postalCodeMax": 16799,
    "lat": 61.104,
    "lng": 25.3552,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Hämeenkoski",
    "postalCode": 16800,
    "postalCodeMin": 16800,
    "postalCodeMax": 16809,
    "lat": 61.0215,
    "lng": 25.1553,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Kalliola",
    "postalCode": 17110,
    "postalCodeMin": 17110,
    "postalCodeMax": 17119,
    "lat": 61.0653,
    "lng": 25.6641,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Hollola",
    "area": "Paimela",
    "postalCode": 17120,
    "postalCodeMin": 17120,
    "postalCodeMax": 17129,
    "lat": 61.0905,
    "lng": 25.64,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Kärkölä",
    "area": "Mertie",
    "postalCode": 16540,
    "postalCodeMin": 16540,
    "postalCodeMax": 16549,
    "lat": 60.7991,
    "lng": 25.3835,
    "radiusKm": 1.2
  },
  {
    "region": "Päijät-Häme",
    "city": "Kärkölä",
    "area": "Järvelä",
    "postalCode": 16600,
    "postalCodeMin": 16600,
    "postalCodeMax": 16609,
    "lat": 60.8689,
    "lng": 25.2774,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Kärkölä",
    "area": "Kärkölä",
    "postalCode": 16610,
    "postalCodeMin": 16610,
    "postalCodeMax": 16619,
    "lat": 60.9171,
    "lng": 25.2016,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Kärkölä",
    "area": "Lappila",
    "postalCode": 16670,
    "postalCodeMin": 16670,
    "postalCodeMax": 16679,
    "lat": 60.8458,
    "lng": 25.1686,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "keskustan eteläinen osa, Asemantausta",
    "postalCode": 15100,
    "postalCodeMin": 15100,
    "postalCodeMax": 15109,
    "lat": 60.974,
    "lng": 25.658,
    "radiusKm": 1.3
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "keskustan läntinen osa",
    "postalCode": 15110,
    "postalCodeMin": 15110,
    "postalCodeMax": 15119,
    "lat": 60.9799,
    "lng": 25.6122,
    "radiusKm": 1.3
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "keskustan pohjoinen osa, Ankkuri, Ruoriniemi",
    "postalCode": 15140,
    "postalCodeMin": 15140,
    "postalCodeMax": 15149,
    "lat": 61.0044,
    "lng": 25.6416,
    "radiusKm": 1.3
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Kujala, Pyhätön",
    "postalCode": 15150,
    "postalCodeMin": 15150,
    "postalCodeMax": 15159,
    "lat": 60.9832,
    "lng": 25.6853,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Karisto",
    "postalCode": 15160,
    "postalCodeMin": 15160,
    "postalCodeMax": 15169,
    "lat": 60.9745,
    "lng": 25.7719,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Möysä",
    "postalCode": 15170,
    "postalCodeMin": 15170,
    "postalCodeMax": 15179,
    "lat": 60.9805,
    "lng": 25.701,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Kiveriö",
    "postalCode": 15200,
    "postalCodeMin": 15200,
    "postalCodeMax": 15209,
    "lat": 60.9895,
    "lng": 25.6808,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Kivimaa, Niemi",
    "postalCode": 15210,
    "postalCodeMin": 15210,
    "postalCodeMax": 15219,
    "lat": 61.0049,
    "lng": 25.6515,
    "radiusKm": 4.8
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Holma, Metsämaa",
    "postalCode": 15230,
    "postalCodeMin": 15230,
    "postalCodeMax": 15239,
    "lat": 61.0069,
    "lng": 25.6827,
    "radiusKm": 6.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Kilpiäinen, Mukkula",
    "postalCode": 15240,
    "postalCodeMin": 15240,
    "postalCodeMax": 15249,
    "lat": 61.0206,
    "lng": 25.6619,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Myllypohja",
    "postalCode": 15300,
    "postalCodeMin": 15300,
    "postalCodeMax": 15309,
    "lat": 60.9956,
    "lng": 25.7593,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Ahtiala",
    "postalCode": 15320,
    "postalCodeMin": 15320,
    "postalCodeMax": 15329,
    "lat": 61.0025,
    "lng": 25.7756,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Kunnas",
    "postalCode": 15340,
    "postalCodeMin": 15340,
    "postalCodeMax": 15349,
    "lat": 61.0084,
    "lng": 25.8027,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Mäkelä",
    "postalCode": 15460,
    "postalCodeMin": 15460,
    "postalCodeMax": 15469,
    "lat": 61.0597,
    "lng": 25.8523,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Liipola",
    "postalCode": 15500,
    "postalCodeMin": 15500,
    "postalCodeMax": 15509,
    "lat": 60.9627,
    "lng": 25.668,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Saksala",
    "postalCode": 15520,
    "postalCodeMin": 15520,
    "postalCodeMax": 15529,
    "lat": 60.9695,
    "lng": 25.6815,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Villähde",
    "postalCode": 15540,
    "postalCodeMin": 15540,
    "postalCodeMax": 15549,
    "lat": 60.951,
    "lng": 25.8109,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Rakokivi",
    "postalCode": 15550,
    "postalCodeMin": 15550,
    "postalCodeMax": 15559,
    "lat": 60.9365,
    "lng": 25.9611,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Kirkonkylä",
    "postalCode": 15560,
    "postalCodeMin": 15560,
    "postalCodeMax": 15569,
    "lat": 60.948,
    "lng": 25.9211,
    "radiusKm": 4.0
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Ruuhijärvi",
    "postalCode": 15580,
    "postalCodeMin": 15580,
    "postalCodeMax": 15589,
    "lat": 61.0491,
    "lng": 26.0172,
    "radiusKm": 5.4
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Laune, Nikkilä",
    "postalCode": 15610,
    "postalCodeMin": 15610,
    "postalCodeMax": 15619,
    "lat": 60.9613,
    "lng": 25.6517,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Renkomäki",
    "postalCode": 15680,
    "postalCodeMin": 15680,
    "postalCodeMax": 15689,
    "lat": 60.9314,
    "lng": 25.6529,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Ala-Okeroinen, Hennala",
    "postalCode": 15700,
    "postalCodeMin": 15700,
    "postalCodeMax": 15709,
    "lat": 60.9458,
    "lng": 25.6054,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Kärpänen",
    "postalCode": 15800,
    "postalCodeMin": 15800,
    "postalCodeMax": 15809,
    "lat": 60.9724,
    "lng": 25.6047,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Kasakkamäki",
    "postalCode": 15810,
    "postalCodeMin": 15810,
    "postalCodeMax": 15819,
    "lat": 60.9764,
    "lng": 25.5706,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Okeroinen",
    "postalCode": 15820,
    "postalCodeMin": 15820,
    "postalCodeMax": 15829,
    "lat": 60.9657,
    "lng": 25.5432,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Metsäkangas",
    "postalCode": 15830,
    "postalCodeMin": 15830,
    "postalCodeMax": 15839,
    "lat": 60.9791,
    "lng": 25.5951,
    "radiusKm": 6.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Pirttiharju, Riihelä",
    "postalCode": 15840,
    "postalCodeMin": 15840,
    "postalCodeMax": 15849,
    "lat": 60.9821,
    "lng": 25.5565,
    "radiusKm": 2.4
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Likolampi",
    "postalCode": 15850,
    "postalCodeMin": 15850,
    "postalCodeMax": 15859,
    "lat": 60.9902,
    "lng": 25.5641,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Tapanila",
    "postalCode": 15900,
    "postalCodeMin": 15900,
    "postalCodeMax": 15909,
    "lat": 60.99,
    "lng": 25.6075,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Jalkaranta",
    "postalCode": 15950,
    "postalCodeMin": 15950,
    "postalCodeMax": 15959,
    "lat": 60.9968,
    "lng": 25.5908,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Uusikylä",
    "postalCode": 16100,
    "postalCodeMin": 16100,
    "postalCodeMax": 16109,
    "lat": 60.9277,
    "lng": 26.0237,
    "radiusKm": 4.0
  },
  {
    "region": "Päijät-Häme",
    "city": "Lahti",
    "area": "Okkeri",
    "postalCode": 16160,
    "postalCodeMin": 16160,
    "postalCodeMax": 16169,
    "lat": 61.0112,
    "lng": 26.0903,
    "radiusKm": 2.7
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Artjärvi",
    "postalCode": 16200,
    "postalCodeMin": 16200,
    "postalCodeMax": 16209,
    "lat": 60.7437,
    "lng": 26.0551,
    "radiusKm": 3.8
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Artjärvi kk",
    "postalCode": 16230,
    "postalCodeMin": 16230,
    "postalCodeMax": 16239,
    "lat": 60.7229,
    "lng": 26.1507,
    "radiusKm": 3.8
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Hietana",
    "postalCode": 16260,
    "postalCodeMin": 16260,
    "postalCodeMax": 16269,
    "lat": 60.8016,
    "lng": 26.1336,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Villikkala",
    "postalCode": 16270,
    "postalCodeMin": 16270,
    "postalCodeMax": 16279,
    "lat": 60.7792,
    "lng": 26.0186,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Kuivanto",
    "postalCode": 16280,
    "postalCodeMin": 16280,
    "postalCodeMax": 16289,
    "lat": 60.8737,
    "lng": 26.006,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Orimattila",
    "postalCode": 16300,
    "postalCodeMin": 16300,
    "postalCodeMax": 16309,
    "lat": 60.8017,
    "lng": 25.7288,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Virenoja",
    "postalCode": 16310,
    "postalCodeMin": 16310,
    "postalCodeMax": 16319,
    "lat": 60.8491,
    "lng": 25.717,
    "radiusKm": 2.5
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Pennala",
    "postalCode": 16320,
    "postalCodeMin": 16320,
    "postalCodeMax": 16329,
    "lat": 60.8935,
    "lng": 25.7057,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Heinämaa",
    "postalCode": 16330,
    "postalCodeMin": 16330,
    "postalCodeMax": 16339,
    "lat": 60.87,
    "lng": 25.8208,
    "radiusKm": 4.2
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Niinikoski",
    "postalCode": 16350,
    "postalCodeMin": 16350,
    "postalCodeMax": 16359,
    "lat": 60.781,
    "lng": 25.9071,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Pakaa",
    "postalCode": 16390,
    "postalCodeMin": 16390,
    "postalCodeMax": 16399,
    "lat": 60.7325,
    "lng": 25.778,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Mallusjoki",
    "postalCode": 16450,
    "postalCodeMin": 16450,
    "postalCodeMax": 16459,
    "lat": 60.7338,
    "lng": 25.6248,
    "radiusKm": 3.5
  },
  {
    "region": "Päijät-Häme",
    "city": "Orimattila",
    "area": "Luhtikylä",
    "postalCode": 16510,
    "postalCodeMin": 16510,
    "postalCodeMax": 16519,
    "lat": 60.8619,
    "lng": 25.4864,
    "radiusKm": 2.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Padasjoki",
    "area": "Maakeski",
    "postalCode": 17470,
    "postalCodeMin": 17470,
    "postalCodeMax": 17479,
    "lat": 61.2865,
    "lng": 25.3409,
    "radiusKm": 4.2
  },
  {
    "region": "Päijät-Häme",
    "city": "Padasjoki",
    "area": "Padasjoki",
    "postalCode": 17500,
    "postalCodeMin": 17500,
    "postalCodeMax": 17509,
    "lat": 61.3509,
    "lng": 25.2781,
    "radiusKm": 3.5
  },
  {
    "region": "Päijät-Häme",
    "city": "Padasjoki",
    "area": "Nyystölä",
    "postalCode": 17510,
    "postalCodeMin": 17510,
    "postalCodeMax": 17519,
    "lat": 61.3279,
    "lng": 25.2971,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Padasjoki",
    "area": "Arrakoski",
    "postalCode": 17530,
    "postalCodeMin": 17530,
    "postalCodeMax": 17539,
    "lat": 61.3855,
    "lng": 25.1868,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Padasjoki",
    "area": "Auttoinen",
    "postalCode": 17610,
    "postalCodeMin": 17610,
    "postalCodeMax": 17619,
    "lat": 61.3016,
    "lng": 25.0872,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Padasjoki",
    "area": "Vesijako",
    "postalCode": 17630,
    "postalCodeMin": 17630,
    "postalCodeMax": 17639,
    "lat": 61.3505,
    "lng": 25.0389,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Padasjoki",
    "area": "Torittu",
    "postalCode": 17710,
    "postalCodeMin": 17710,
    "postalCodeMax": 17719,
    "lat": 61.4455,
    "lng": 25.0559,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Padasjoki",
    "area": "Kasiniemi",
    "postalCode": 17740,
    "postalCodeMin": 17740,
    "postalCodeMax": 17749,
    "lat": 61.44,
    "lng": 24.9175,
    "radiusKm": 3.5
  },
  {
    "region": "Päijät-Häme",
    "city": "Sysmä",
    "area": "Onkiniemi",
    "postalCode": 19230,
    "postalCodeMin": 19230,
    "postalCodeMax": 19239,
    "lat": 61.4129,
    "lng": 26.0437,
    "radiusKm": 3.5
  },
  {
    "region": "Päijät-Häme",
    "city": "Sysmä",
    "area": "Karilanmaa",
    "postalCode": 19310,
    "postalCodeMin": 19310,
    "postalCodeMax": 19319,
    "lat": 61.3533,
    "lng": 25.6279,
    "radiusKm": 4.2
  },
  {
    "region": "Päijät-Häme",
    "city": "Sysmä",
    "area": "Nikkaroinen",
    "postalCode": 19320,
    "postalCodeMin": 19320,
    "postalCodeMax": 19329,
    "lat": 61.4065,
    "lng": 25.6567,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Sysmä",
    "area": "Nuoramoinen",
    "postalCode": 19370,
    "postalCodeMin": 19370,
    "postalCodeMax": 19379,
    "lat": 61.4395,
    "lng": 25.8581,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Sysmä",
    "area": "Sysmä",
    "postalCode": 19700,
    "postalCodeMin": 19700,
    "postalCodeMax": 19709,
    "lat": 61.5039,
    "lng": 25.6832,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Sysmä",
    "area": "Särkilampi",
    "postalCode": 19730,
    "postalCodeMin": 19730,
    "postalCodeMax": 19739,
    "lat": 61.5948,
    "lng": 25.6634,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Sysmä",
    "area": "Liikola",
    "postalCode": 19740,
    "postalCodeMin": 19740,
    "postalCodeMax": 19749,
    "lat": 61.5839,
    "lng": 25.7519,
    "radiusKm": 1.9
  },
  {
    "region": "Päijät-Häme",
    "city": "Sysmä",
    "area": "Valittula",
    "postalCode": 19770,
    "postalCodeMin": 19770,
    "postalCodeMax": 19779,
    "lat": 61.5349,
    "lng": 25.8525,
    "radiusKm": 1.9
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Hamina",
    "postalCode": 49400,
    "postalCodeMin": 49400,
    "postalCodeMax": 49409,
    "lat": 60.5719,
    "lng": 27.1906,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Poitsila",
    "postalCode": 49410,
    "postalCodeMin": 49410,
    "postalCodeMax": 49419,
    "lat": 60.5744,
    "lng": 27.1506,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Uusi-Summa",
    "postalCode": 49420,
    "postalCodeMin": 49420,
    "postalCodeMax": 49429,
    "lat": 60.5612,
    "lng": 27.1274,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Hillo",
    "postalCode": 49460,
    "postalCodeMin": 49460,
    "postalCodeMax": 49469,
    "lat": 60.5472,
    "lng": 27.1592,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Summa",
    "postalCode": 49480,
    "postalCodeMin": 49480,
    "postalCodeMax": 49489,
    "lat": 60.5719,
    "lng": 27.1906,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Neuvoton",
    "postalCode": 49490,
    "postalCodeMin": 49490,
    "postalCodeMax": 49499,
    "lat": 60.5623,
    "lng": 27.0457,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Husula",
    "postalCode": 49510,
    "postalCodeMin": 49510,
    "postalCodeMax": 49519,
    "lat": 60.5995,
    "lng": 27.1729,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Reitkalli",
    "postalCode": 49520,
    "postalCodeMin": 49520,
    "postalCodeMax": 49529,
    "lat": 60.6118,
    "lng": 27.0906,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Metsäkylä",
    "postalCode": 49540,
    "postalCodeMin": 49540,
    "postalCodeMax": 49549,
    "lat": 60.6514,
    "lng": 27.078,
    "radiusKm": 3.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Kannusjärvi",
    "postalCode": 49570,
    "postalCodeMin": 49570,
    "postalCodeMax": 49579,
    "lat": 60.6874,
    "lng": 27.2058,
    "radiusKm": 4.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Sivatti",
    "postalCode": 49610,
    "postalCodeMin": 49610,
    "postalCodeMax": 49619,
    "lat": 60.5907,
    "lng": 27.2196,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Vehkajoki",
    "postalCode": 49630,
    "postalCodeMin": 49630,
    "postalCodeMax": 49639,
    "lat": 60.6295,
    "lng": 27.2075,
    "radiusKm": 3.6
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Paijärvi",
    "postalCode": 49640,
    "postalCodeMin": 49640,
    "postalCodeMax": 49649,
    "lat": 60.6532,
    "lng": 27.2528,
    "radiusKm": 4.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Pyhältö",
    "postalCode": 49660,
    "postalCodeMin": 49660,
    "postalCodeMax": 49669,
    "lat": 60.7513,
    "lng": 27.3399,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Onkamaa",
    "postalCode": 49780,
    "postalCodeMin": 49780,
    "postalCodeMax": 49789,
    "lat": 60.6584,
    "lng": 27.4076,
    "radiusKm": 4.4
  },
  {
    "region": "Kymenlaakso",
    "city": "Hamina",
    "area": "Mäntlahti",
    "postalCode": 49840,
    "postalCodeMin": 49840,
    "postalCodeMax": 49849,
    "lat": 60.5156,
    "lng": 27.357,
    "radiusKm": 3.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Huutotöyry",
    "postalCode": 19160,
    "postalCodeMin": 19160,
    "postalCodeMax": 19169,
    "lat": 61.0837,
    "lng": 26.182,
    "radiusKm": 1.6
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Haapa-Kimola",
    "postalCode": 47310,
    "postalCodeMin": 47310,
    "postalCodeMax": 47319,
    "lat": 60.7992,
    "lng": 26.3091,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Kausala",
    "postalCode": 47400,
    "postalCodeMin": 47400,
    "postalCodeMax": 47409,
    "lat": 60.8894,
    "lng": 26.3395,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Sääskjärvi",
    "postalCode": 47440,
    "postalCodeMin": 47440,
    "postalCodeMax": 47449,
    "lat": 60.8444,
    "lng": 26.2491,
    "radiusKm": 4.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Perheniemi",
    "postalCode": 47450,
    "postalCodeMin": 47450,
    "postalCodeMax": 47459,
    "lat": 60.8487,
    "lng": 26.2215,
    "radiusKm": 3.6
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Hiisiö",
    "postalCode": 47460,
    "postalCodeMin": 47460,
    "postalCodeMax": 47469,
    "lat": 60.9113,
    "lng": 26.1489,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Mankala",
    "postalCode": 47490,
    "postalCodeMin": 47490,
    "postalCodeMax": 47499,
    "lat": 60.9175,
    "lng": 26.1825,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Iitti",
    "postalCode": 47520,
    "postalCodeMin": 47520,
    "postalCodeMax": 47529,
    "lat": 60.9417,
    "lng": 26.3923,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Lyöttilä",
    "postalCode": 47540,
    "postalCodeMin": 47540,
    "postalCodeMax": 47549,
    "lat": 60.9645,
    "lng": 26.4383,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Iitti",
    "area": "Kymentaka",
    "postalCode": 47610,
    "postalCodeMin": 47610,
    "postalCodeMax": 47619,
    "lat": 60.9807,
    "lng": 26.3404,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Huruksela",
    "postalCode": 46930,
    "postalCodeMin": 46930,
    "postalCodeMax": 46939,
    "lat": 60.6658,
    "lng": 26.7726,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48100,
    "postalCodeMin": 48100,
    "postalCodeMax": 48109,
    "lat": 60.3541,
    "lng": 26.7787,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48130,
    "postalCodeMin": 48130,
    "postalCodeMax": 48139,
    "lat": 60.4522,
    "lng": 26.9403,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48200,
    "postalCodeMin": 48200,
    "postalCodeMax": 48209,
    "lat": 60.4789,
    "lng": 26.9259,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48210,
    "postalCodeMin": 48210,
    "postalCodeMax": 48219,
    "lat": 60.4728,
    "lng": 26.9141,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48220,
    "postalCodeMin": 48220,
    "postalCodeMax": 48229,
    "lat": 60.4832,
    "lng": 26.9064,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48230,
    "postalCodeMin": 48230,
    "postalCodeMax": 48239,
    "lat": 60.4974,
    "lng": 26.8987,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48300,
    "postalCodeMin": 48300,
    "postalCodeMax": 48309,
    "lat": 60.4778,
    "lng": 26.8662,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48310,
    "postalCodeMin": 48310,
    "postalCodeMax": 48319,
    "lat": 60.4454,
    "lng": 26.8924,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48350,
    "postalCodeMin": 48350,
    "postalCodeMax": 48359,
    "lat": 60.4849,
    "lng": 26.8624,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48400,
    "postalCodeMin": 48400,
    "postalCodeMax": 48409,
    "lat": 60.4938,
    "lng": 26.8575,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kotka",
    "postalCode": 48410,
    "postalCodeMin": 48410,
    "postalCodeMax": 48419,
    "lat": 60.545,
    "lng": 26.8382,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Karhula",
    "postalCode": 48600,
    "postalCodeMin": 48600,
    "postalCodeMax": 48609,
    "lat": 60.5151,
    "lng": 26.9351,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kyminlinna",
    "postalCode": 48700,
    "postalCodeMin": 48700,
    "postalCodeMax": 48709,
    "lat": 60.5065,
    "lng": 26.8978,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Karhula",
    "postalCode": 48710,
    "postalCodeMin": 48710,
    "postalCodeMax": 48719,
    "lat": 60.5151,
    "lng": 26.9351,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Kymi",
    "postalCode": 48720,
    "postalCodeMin": 48720,
    "postalCodeMax": 48729,
    "lat": 60.5389,
    "lng": 26.9064,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Nikeli",
    "postalCode": 48750,
    "postalCodeMin": 48750,
    "postalCodeMax": 48759,
    "lat": 60.5665,
    "lng": 26.8448,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Karhula",
    "postalCode": 48770,
    "postalCodeMin": 48770,
    "postalCodeMax": 48779,
    "lat": 60.5151,
    "lng": 26.9351,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Karhula",
    "postalCode": 48800,
    "postalCodeMin": 48800,
    "postalCodeMax": 48809,
    "lat": 60.5253,
    "lng": 26.9871,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Karhula",
    "postalCode": 48810,
    "postalCodeMin": 48810,
    "postalCodeMax": 48819,
    "lat": 60.5151,
    "lng": 26.9351,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Sunila",
    "postalCode": 48900,
    "postalCodeMin": 48900,
    "postalCodeMax": 48909,
    "lat": 60.4961,
    "lng": 26.9588,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Suulisniemi",
    "postalCode": 48910,
    "postalCodeMin": 48910,
    "postalCodeMax": 48919,
    "lat": 60.4957,
    "lng": 26.9779,
    "radiusKm": 3.6
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Tiutinen",
    "postalCode": 48930,
    "postalCodeMin": 48930,
    "postalCodeMax": 48939,
    "lat": 60.4667,
    "lng": 26.9833,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Tavastila",
    "postalCode": 49300,
    "postalCodeMin": 49300,
    "postalCodeMax": 49309,
    "lat": 60.5745,
    "lng": 26.9776,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kotka (kaupunki)",
    "area": "Juurikorpi",
    "postalCode": 49340,
    "postalCodeMin": 49340,
    "postalCodeMax": 49349,
    "lat": 60.6042,
    "lng": 26.9381,
    "radiusKm": 5.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Kouvola",
    "postalCode": 45100,
    "postalCodeMin": 45100,
    "postalCodeMax": 45109,
    "lat": 60.8403,
    "lng": 26.7804,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Kotkankallio, Mielakka, Sarkola",
    "postalCode": 45120,
    "postalCodeMin": 45120,
    "postalCodeMax": 45129,
    "lat": 60.8607,
    "lng": 26.722,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Kasarminmäki, Kaunisnurmi, Korjala",
    "postalCode": 45130,
    "postalCodeMin": 45130,
    "postalCodeMax": 45139,
    "lat": 60.8752,
    "lng": 26.6744,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Eskolanmäki, Kankaro, Vahtero",
    "postalCode": 45150,
    "postalCodeMin": 45150,
    "postalCodeMax": 45159,
    "lat": 60.8533,
    "lng": 26.6948,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Lehtomäki, Ravikylä",
    "postalCode": 45160,
    "postalCodeMin": 45160,
    "postalCodeMax": 45169,
    "lat": 60.8903,
    "lng": 26.7206,
    "radiusKm": 3.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Tornionmäki, Tykkimäki, Viitakumpu",
    "postalCode": 45200,
    "postalCodeMin": 45200,
    "postalCodeMax": 45209,
    "lat": 60.8753,
    "lng": 26.7567,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Harju",
    "postalCode": 45330,
    "postalCodeMin": 45330,
    "postalCodeMax": 45339,
    "lat": 60.937,
    "lng": 26.6766,
    "radiusKm": 1.8
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Jokela",
    "postalCode": 45360,
    "postalCodeMin": 45360,
    "postalCodeMax": 45369,
    "lat": 60.9102,
    "lng": 26.7431,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Kirkonkylä",
    "postalCode": 45370,
    "postalCodeMin": 45370,
    "postalCodeMax": 45379,
    "lat": 60.9451,
    "lng": 26.8047,
    "radiusKm": 3.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Utti",
    "postalCode": 45410,
    "postalCodeMin": 45410,
    "postalCodeMax": 45419,
    "lat": 60.8822,
    "lng": 26.9238,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Savero",
    "postalCode": 45460,
    "postalCodeMin": 45460,
    "postalCodeMax": 45469,
    "lat": 60.8302,
    "lng": 26.9788,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Koria",
    "postalCode": 45610,
    "postalCodeMin": 45610,
    "postalCodeMax": 45619,
    "lat": 60.8465,
    "lng": 26.6064,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Kuusankoski",
    "postalCode": 45700,
    "postalCodeMin": 45700,
    "postalCodeMax": 45709,
    "lat": 60.9069,
    "lng": 26.6244,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Kymintehdas",
    "postalCode": 45720,
    "postalCodeMin": 45720,
    "postalCodeMax": 45729,
    "lat": 60.9008,
    "lng": 26.6487,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Mäkikylä",
    "postalCode": 45740,
    "postalCodeMin": 45740,
    "postalCodeMax": 45749,
    "lat": 60.8994,
    "lng": 26.5883,
    "radiusKm": 3.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Sairaalamäki",
    "postalCode": 45750,
    "postalCodeMin": 45750,
    "postalCodeMax": 45759,
    "lat": 60.9146,
    "lng": 26.6247,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Pilkanmaa",
    "postalCode": 45810,
    "postalCodeMin": 45810,
    "postalCodeMax": 45819,
    "lat": 60.9449,
    "lng": 26.5839,
    "radiusKm": 4.4
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Voikkaa",
    "postalCode": 45910,
    "postalCodeMin": 45910,
    "postalCodeMax": 45919,
    "lat": 60.9413,
    "lng": 26.6195,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Oravala",
    "postalCode": 45940,
    "postalCodeMin": 45940,
    "postalCodeMax": 45949,
    "lat": 60.9727,
    "lng": 26.5957,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Tuohikotti",
    "postalCode": 46110,
    "postalCodeMin": 46110,
    "postalCodeMax": 46119,
    "lat": 61.0896,
    "lng": 27.062,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Vekaranjärvi",
    "postalCode": 46140,
    "postalCodeMin": 46140,
    "postalCodeMax": 46149,
    "lat": 61.1153,
    "lng": 26.9845,
    "radiusKm": 4.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Aro",
    "postalCode": 46230,
    "postalCodeMin": 46230,
    "postalCodeMax": 46239,
    "lat": 61.0607,
    "lng": 26.8686,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Kaipiainen",
    "postalCode": 46400,
    "postalCodeMin": 46400,
    "postalCodeMax": 46409,
    "lat": 60.8976,
    "lng": 27.1214,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Tirva",
    "postalCode": 46430,
    "postalCodeMin": 46430,
    "postalCodeMax": 46439,
    "lat": 60.9441,
    "lng": 27.0483,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Enäjärvi",
    "postalCode": 46450,
    "postalCodeMin": 46450,
    "postalCodeMax": 46459,
    "lat": 60.8478,
    "lng": 27.127,
    "radiusKm": 4.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Saaramaa",
    "postalCode": 46570,
    "postalCodeMin": 46570,
    "postalCodeMax": 46579,
    "lat": 60.8527,
    "lng": 27.3291,
    "radiusKm": 4.4
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Sippola",
    "postalCode": 46710,
    "postalCodeMin": 46710,
    "postalCodeMax": 46719,
    "lat": 60.7392,
    "lng": 27.0007,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Ruotila",
    "postalCode": 46730,
    "postalCodeMin": 46730,
    "postalCodeMax": 46739,
    "lat": 60.6938,
    "lng": 27.0576,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Liikkala",
    "postalCode": 46750,
    "postalCodeMin": 46750,
    "postalCodeMax": 46759,
    "lat": 60.6987,
    "lng": 27.009,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Myllykoski",
    "postalCode": 46800,
    "postalCodeMin": 46800,
    "postalCodeMax": 46809,
    "lat": 60.7649,
    "lng": 26.7858,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Ummeljoki",
    "postalCode": 46810,
    "postalCodeMin": 46810,
    "postalCodeMax": 46819,
    "lat": 60.7656,
    "lng": 26.7649,
    "radiusKm": 3.6
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Keltakangas",
    "postalCode": 46860,
    "postalCodeMin": 46860,
    "postalCodeMax": 46869,
    "lat": 60.7495,
    "lng": 26.8234,
    "radiusKm": 4.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Inkeroinen",
    "postalCode": 46900,
    "postalCodeMin": 46900,
    "postalCodeMax": 46909,
    "lat": 60.7016,
    "lng": 26.8495,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Anjala",
    "postalCode": 46910,
    "postalCodeMin": 46910,
    "postalCodeMax": 46919,
    "lat": 60.6887,
    "lng": 26.808,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Ahvio",
    "postalCode": 46950,
    "postalCodeMin": 46950,
    "postalCodeMax": 46959,
    "lat": 60.6356,
    "lng": 26.74,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Muhniemi",
    "postalCode": 46960,
    "postalCodeMin": 46960,
    "postalCodeMax": 46969,
    "lat": 60.6929,
    "lng": 26.717,
    "radiusKm": 3.6
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Löytty",
    "postalCode": 47110,
    "postalCodeMin": 47110,
    "postalCodeMax": 47119,
    "lat": 60.759,
    "lng": 26.5839,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Raussila",
    "postalCode": 47150,
    "postalCodeMin": 47150,
    "postalCodeMax": 47159,
    "lat": 60.666,
    "lng": 26.5634,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Elimäki",
    "postalCode": 47200,
    "postalCodeMin": 47200,
    "postalCodeMax": 47209,
    "lat": 60.7213,
    "lng": 26.4509,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Ratula",
    "postalCode": 47260,
    "postalCodeMin": 47260,
    "postalCodeMax": 47269,
    "lat": 60.6532,
    "lng": 26.4694,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Kimola",
    "postalCode": 47650,
    "postalCodeMin": 47650,
    "postalCodeMax": 47659,
    "lat": 61.035,
    "lng": 26.3535,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Jaala",
    "postalCode": 47710,
    "postalCodeMin": 47710,
    "postalCodeMax": 47719,
    "lat": 61.0514,
    "lng": 26.4696,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Huhdasjärvi",
    "postalCode": 47760,
    "postalCodeMin": 47760,
    "postalCodeMax": 47769,
    "lat": 61.1616,
    "lng": 26.566,
    "radiusKm": 4.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Selänpää",
    "postalCode": 47810,
    "postalCodeMin": 47810,
    "postalCodeMax": 47819,
    "lat": 61.0532,
    "lng": 26.7328,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Hasula",
    "postalCode": 47830,
    "postalCodeMin": 47830,
    "postalCodeMax": 47839,
    "lat": 61.0553,
    "lng": 26.6997,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Verla",
    "postalCode": 47850,
    "postalCodeMin": 47850,
    "postalCodeMax": 47859,
    "lat": 61.062,
    "lng": 26.6353,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Vuohijärvi",
    "postalCode": 47900,
    "postalCodeMin": 47900,
    "postalCodeMax": 47909,
    "lat": 61.09,
    "lng": 26.7947,
    "radiusKm": 4.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Hillosensalmi",
    "postalCode": 47910,
    "postalCodeMin": 47910,
    "postalCodeMax": 47919,
    "lat": 61.1957,
    "lng": 26.7906,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Kouvola",
    "area": "Voikoski",
    "postalCode": 52920,
    "postalCodeMin": 52920,
    "postalCodeMax": 52929,
    "lat": 61.255,
    "lng": 26.7708,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Miehikkälä",
    "area": "Miehikkälä",
    "postalCode": 49700,
    "postalCodeMin": 49700,
    "postalCodeMax": 49709,
    "lat": 60.6722,
    "lng": 27.7011,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Miehikkälä",
    "area": "Hurttala",
    "postalCode": 49720,
    "postalCodeMin": 49720,
    "postalCodeMax": 49729,
    "lat": 60.6899,
    "lng": 27.7557,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Miehikkälä",
    "area": "Muurikkala",
    "postalCode": 49730,
    "postalCodeMin": 49730,
    "postalCodeMax": 49739,
    "lat": 60.6609,
    "lng": 27.8855,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Miehikkälä",
    "area": "Kalliokoski",
    "postalCode": 49750,
    "postalCodeMin": 49750,
    "postalCodeMax": 49759,
    "lat": 60.6831,
    "lng": 27.5718,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Miehikkälä",
    "area": "Suur-Miehikkälä",
    "postalCode": 49760,
    "postalCodeMin": 49760,
    "postalCodeMax": 49769,
    "lat": 60.7229,
    "lng": 27.5689,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Miehikkälä",
    "area": "Salo-Miehikkälä",
    "postalCode": 49770,
    "postalCodeMin": 49770,
    "postalCodeMax": 49779,
    "lat": 60.6891,
    "lng": 27.467,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Miehikkälä",
    "area": "Ahomäki",
    "postalCode": 54490,
    "postalCodeMin": 54490,
    "postalCodeMax": 54499,
    "lat": 60.7869,
    "lng": 27.7144,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Pyhtää",
    "area": "Heinlahti / Heinlax",
    "postalCode": 49200,
    "postalCodeMin": 49200,
    "postalCodeMax": 49209,
    "lat": 60.473,
    "lng": 26.7735,
    "radiusKm": 3.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Pyhtää",
    "area": "Huutjärvi",
    "postalCode": 49210,
    "postalCodeMin": 49210,
    "postalCodeMax": 49219,
    "lat": 60.4876,
    "lng": 26.7498,
    "radiusKm": 4.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Pyhtää",
    "area": "Siltakylä / Broby",
    "postalCode": 49220,
    "postalCodeMin": 49220,
    "postalCodeMax": 49229,
    "lat": 60.4956,
    "lng": 26.7159,
    "radiusKm": 3.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Pyhtää",
    "area": "Purola / Svartbäck",
    "postalCode": 49240,
    "postalCodeMin": 49240,
    "postalCodeMax": 49249,
    "lat": 60.4635,
    "lng": 26.6299,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Pyhtää",
    "area": "Pyhtää / Pyttis",
    "postalCode": 49270,
    "postalCodeMin": 49270,
    "postalCodeMax": 49279,
    "lat": 60.4922,
    "lng": 26.5431,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Pyhtää",
    "area": "Vastila",
    "postalCode": 49290,
    "postalCodeMin": 49290,
    "postalCodeMax": 49299,
    "lat": 60.6165,
    "lng": 26.6546,
    "radiusKm": 2.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Virolahti",
    "area": "Klamila",
    "postalCode": 49860,
    "postalCodeMin": 49860,
    "postalCodeMax": 49869,
    "lat": 60.5153,
    "lng": 27.4657,
    "radiusKm": 2.8
  },
  {
    "region": "Kymenlaakso",
    "city": "Virolahti",
    "area": "Virojoki",
    "postalCode": 49900,
    "postalCodeMin": 49900,
    "postalCodeMax": 49909,
    "lat": 60.5829,
    "lng": 27.7068,
    "radiusKm": 5.0
  },
  {
    "region": "Kymenlaakso",
    "city": "Virolahti",
    "area": "Vaalimaa",
    "postalCode": 49930,
    "postalCodeMin": 49930,
    "postalCodeMax": 49939,
    "lat": 60.5953,
    "lng": 27.808,
    "radiusKm": 6.2
  },
  {
    "region": "Kymenlaakso",
    "city": "Virolahti",
    "area": "Ala-Pihlaja",
    "postalCode": 49960,
    "postalCodeMin": 49960,
    "postalCodeMax": 49969,
    "lat": 60.5328,
    "lng": 27.6179,
    "radiusKm": 2.8
  },
  {
    "region": "Kymenlaakso",
    "city": "Virolahti",
    "area": "Ravijoki",
    "postalCode": 49980,
    "postalCodeMin": 49980,
    "postalCodeMax": 49989,
    "lat": 60.5268,
    "lng": 27.5604,
    "radiusKm": 5.0
  },
  {
    "region": "Etelä-Karjala",
    "city": "Imatra",
    "area": "Imatra keskus- Imatrankoski",
    "postalCode": 55100,
    "postalCodeMin": 55100,
    "postalCodeMax": 55109,
    "lat": 61.1694,
    "lng": 28.7666,
    "radiusKm": 1.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Imatra",
    "area": "Mansikkala-Tuulikallio",
    "postalCode": 55120,
    "postalCodeMin": 55120,
    "postalCodeMax": 55129,
    "lat": 61.1892,
    "lng": 28.766,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Imatra",
    "area": "Tainionkoski-Mustalampi",
    "postalCode": 55400,
    "postalCodeMin": 55400,
    "postalCodeMax": 55409,
    "lat": 61.2102,
    "lng": 28.7799,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Imatra",
    "area": "Karhumäki-Karhukallio",
    "postalCode": 55420,
    "postalCodeMin": 55420,
    "postalCodeMax": 55429,
    "lat": 61.2078,
    "lng": 28.7415,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Imatra",
    "area": "Sotkulampi-Linnasuo",
    "postalCode": 55510,
    "postalCodeMin": 55510,
    "postalCodeMax": 55519,
    "lat": 61.1783,
    "lng": 28.824,
    "radiusKm": 4.4
  },
  {
    "region": "Etelä-Karjala",
    "city": "Imatra",
    "area": "Rajapatsas-Teppanala",
    "postalCode": 55610,
    "postalCodeMin": 55610,
    "postalCodeMax": 55619,
    "lat": 61.1534,
    "lng": 28.8106,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Imatra",
    "area": "Vintteri-Virasoja",
    "postalCode": 55700,
    "postalCodeMin": 55700,
    "postalCodeMax": 55709,
    "lat": 61.2023,
    "lng": 28.8177,
    "radiusKm": 2.9
  },
  {
    "region": "Etelä-Karjala",
    "city": "Imatra",
    "area": "Vuoksenniska-Saarlampi",
    "postalCode": 55800,
    "postalCodeMin": 55800,
    "postalCodeMax": 55809,
    "lat": 61.2256,
    "lng": 28.8341,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Imatra",
    "area": "Rautio-Kurkvuori",
    "postalCode": 55910,
    "postalCodeMin": 55910,
    "postalCodeMax": 55919,
    "lat": 61.2598,
    "lng": 28.8927,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Lappeenranta keskus",
    "postalCode": 53100,
    "postalCodeMin": 53100,
    "postalCodeMax": 53109,
    "lat": 61.0585,
    "lng": 28.186,
    "radiusKm": 1.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Keskussairaala-alue-Kimpinen",
    "postalCode": 53130,
    "postalCodeMin": 53130,
    "postalCodeMax": 53139,
    "lat": 61.0647,
    "lng": 28.2111,
    "radiusKm": 1.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Kaukas-Tirilä",
    "postalCode": 53200,
    "postalCodeMin": 53200,
    "postalCodeMax": 53209,
    "lat": 61.0656,
    "lng": 28.2307,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Lauritsala-Mälkiä",
    "postalCode": 53300,
    "postalCodeMin": 53300,
    "postalCodeMax": 53309,
    "lat": 61.077,
    "lng": 28.3038,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Laihia",
    "postalCode": 53400,
    "postalCodeMin": 53400,
    "postalCodeMax": 53409,
    "lat": 61.0815,
    "lng": 28.3301,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Mustola",
    "postalCode": 53420,
    "postalCodeMin": 53420,
    "postalCodeMax": 53429,
    "lat": 61.0658,
    "lng": 28.3178,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Parkkarila-Harapainen-Reijola",
    "postalCode": 53500,
    "postalCodeMin": 53500,
    "postalCodeMax": 53509,
    "lat": 61.052,
    "lng": 28.2202,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Kourulanmäki",
    "postalCode": 53550,
    "postalCodeMin": 53550,
    "postalCodeMax": 53559,
    "lat": 61.0368,
    "lng": 28.2007,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Kesämäki",
    "postalCode": 53600,
    "postalCodeMin": 53600,
    "postalCodeMax": 53609,
    "lat": 61.0451,
    "lng": 28.1649,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Mattila-Kuusela",
    "postalCode": 53650,
    "postalCodeMin": 53650,
    "postalCodeMax": 53659,
    "lat": 61.0217,
    "lng": 28.1589,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Huhtiniemi-Kuusimäki-Lavola",
    "postalCode": 53810,
    "postalCodeMin": 53810,
    "postalCodeMax": 53819,
    "lat": 61.0588,
    "lng": 28.1384,
    "radiusKm": 4.8
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Rutola",
    "postalCode": 53830,
    "postalCodeMin": 53830,
    "postalCodeMax": 53839,
    "lat": 61.0379,
    "lng": 28.0421,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Sammonlahti-Skinnarila",
    "postalCode": 53850,
    "postalCodeMin": 53850,
    "postalCodeMax": 53859,
    "lat": 61.0507,
    "lng": 28.1081,
    "radiusKm": 4.0
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Pallo-Tysterniemi-Leiri",
    "postalCode": 53900,
    "postalCodeMin": 53900,
    "postalCodeMax": 53909,
    "lat": 61.0647,
    "lng": 28.1745,
    "radiusKm": 4.8
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Voisalmi",
    "postalCode": 53920,
    "postalCodeMin": 53920,
    "postalCodeMax": 53929,
    "lat": 61.0808,
    "lng": 28.1489,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Kivisalmi",
    "postalCode": 53950,
    "postalCodeMin": 53950,
    "postalCodeMax": 53959,
    "lat": 61.0903,
    "lng": 28.1468,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Joutseno",
    "postalCode": 54100,
    "postalCodeMin": 54100,
    "postalCodeMax": 54109,
    "lat": 61.1182,
    "lng": 28.5082,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Lampikangas",
    "postalCode": 54110,
    "postalCodeMin": 54110,
    "postalCodeMax": 54119,
    "lat": 61.1065,
    "lng": 28.4674,
    "radiusKm": 5.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Pulp",
    "postalCode": 54120,
    "postalCodeMin": 54120,
    "postalCodeMax": 54129,
    "lat": 61.1269,
    "lng": 28.4511,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Konnunsuo",
    "postalCode": 54190,
    "postalCodeMin": 54190,
    "postalCodeMax": 54199,
    "lat": 61.03,
    "lng": 28.5399,
    "radiusKm": 5.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Nuijamaa",
    "postalCode": 54230,
    "postalCodeMin": 54230,
    "postalCodeMax": 54239,
    "lat": 60.9603,
    "lng": 28.5401,
    "radiusKm": 5.8
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Rapattila",
    "postalCode": 54250,
    "postalCodeMin": 54250,
    "postalCodeMax": 54259,
    "lat": 60.9515,
    "lng": 28.4173,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Hanhijärvi",
    "postalCode": 54260,
    "postalCodeMin": 54260,
    "postalCodeMax": 54269,
    "lat": 61.0121,
    "lng": 28.2092,
    "radiusKm": 5.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Vainikkala",
    "postalCode": 54270,
    "postalCodeMin": 54270,
    "postalCodeMax": 54279,
    "lat": 60.8664,
    "lng": 28.2999,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Vilkjärvi",
    "postalCode": 54300,
    "postalCodeMin": 54300,
    "postalCodeMax": 54309,
    "lat": 60.9642,
    "lng": 27.9819,
    "radiusKm": 5.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Hytti",
    "postalCode": 54310,
    "postalCodeMin": 54310,
    "postalCodeMax": 54319,
    "lat": 60.9678,
    "lng": 28.1594,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Simola",
    "postalCode": 54330,
    "postalCodeMin": 54330,
    "postalCodeMax": 54339,
    "lat": 60.9076,
    "lng": 28.1488,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Pulsa",
    "postalCode": 54390,
    "postalCodeMin": 54390,
    "postalCodeMax": 54399,
    "lat": 60.9288,
    "lng": 27.9752,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Ylämaa",
    "postalCode": 54410,
    "postalCodeMin": 54410,
    "postalCodeMax": 54419,
    "lat": 60.799,
    "lng": 28.0089,
    "radiusKm": 5.8
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Hujakkala",
    "postalCode": 54430,
    "postalCodeMin": 54430,
    "postalCodeMax": 54439,
    "lat": 60.7126,
    "lng": 27.9541,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Ylijärvi",
    "postalCode": 54460,
    "postalCodeMin": 54460,
    "postalCodeMax": 54469,
    "lat": 60.7702,
    "lng": 27.927,
    "radiusKm": 5.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Rauha",
    "postalCode": 55300,
    "postalCodeMin": 55300,
    "postalCodeMax": 55309,
    "lat": 61.1783,
    "lng": 28.6876,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Rauha",
    "postalCode": 55320,
    "postalCodeMin": 55320,
    "postalCodeMax": 55329,
    "lat": 61.1906,
    "lng": 28.6985,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lappeenranta",
    "area": "Tiuruniemi",
    "postalCode": 55330,
    "postalCodeMin": 55330,
    "postalCodeMax": 55339,
    "lat": 61.1986,
    "lng": 28.6702,
    "radiusKm": 4.8
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lemi",
    "area": "Lemi",
    "postalCode": 54710,
    "postalCodeMin": 54710,
    "postalCodeMax": 54719,
    "lat": 61.0615,
    "lng": 27.804,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lemi",
    "area": "Laksiainen",
    "postalCode": 54720,
    "postalCodeMin": 54720,
    "postalCodeMax": 54729,
    "lat": 61.093,
    "lng": 27.6762,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lemi",
    "area": "Kotimäki",
    "postalCode": 54820,
    "postalCodeMin": 54820,
    "postalCodeMax": 54829,
    "lat": 61.1411,
    "lng": 27.8209,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Lemi",
    "area": "Kuukanniemi",
    "postalCode": 54850,
    "postalCodeMin": 54850,
    "postalCodeMax": 54859,
    "lat": 61.0911,
    "lng": 27.9407,
    "radiusKm": 4.0
  },
  {
    "region": "Etelä-Karjala",
    "city": "Luumäki",
    "area": "Kannuskoski",
    "postalCode": 46530,
    "postalCodeMin": 46530,
    "postalCodeMax": 46539,
    "lat": 60.9647,
    "lng": 27.2535,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Luumäki",
    "area": "Taavetti",
    "postalCode": 54500,
    "postalCodeMin": 54500,
    "postalCodeMax": 54509,
    "lat": 60.9225,
    "lng": 27.5693,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Luumäki",
    "area": "Uro",
    "postalCode": 54510,
    "postalCodeMin": 54510,
    "postalCodeMax": 54519,
    "lat": 60.924,
    "lng": 27.6588,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Luumäki",
    "area": "Luumäki",
    "postalCode": 54530,
    "postalCodeMin": 54530,
    "postalCodeMax": 54539,
    "lat": 60.9666,
    "lng": 27.7602,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Luumäki",
    "area": "Suo-Anttila",
    "postalCode": 54550,
    "postalCodeMin": 54550,
    "postalCodeMax": 54559,
    "lat": 60.8804,
    "lng": 27.7999,
    "radiusKm": 4.4
  },
  {
    "region": "Etelä-Karjala",
    "city": "Luumäki",
    "area": "Somerharju",
    "postalCode": 54580,
    "postalCodeMin": 54580,
    "postalCodeMax": 54589,
    "lat": 60.9146,
    "lng": 27.4273,
    "radiusKm": 2.0
  },
  {
    "region": "Etelä-Karjala",
    "city": "Luumäki",
    "area": "Kaitjärvi",
    "postalCode": 54590,
    "postalCodeMin": 54590,
    "postalCodeMax": 54599,
    "lat": 60.9111,
    "lng": 27.3441,
    "radiusKm": 4.4
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Parikkala",
    "postalCode": 59100,
    "postalCodeMin": 59100,
    "postalCodeMax": 59109,
    "lat": 61.5502,
    "lng": 29.5024,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Koitsanlahti",
    "postalCode": 59130,
    "postalCodeMin": 59130,
    "postalCodeMax": 59139,
    "lat": 61.4735,
    "lng": 29.4553,
    "radiusKm": 3.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Melkoniemi",
    "postalCode": 59210,
    "postalCodeMin": 59210,
    "postalCodeMax": 59219,
    "lat": 61.5327,
    "lng": 29.3679,
    "radiusKm": 4.0
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Särkisalmi",
    "postalCode": 59310,
    "postalCodeMin": 59310,
    "postalCodeMax": 59319,
    "lat": 61.6033,
    "lng": 29.4822,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Haapaoja",
    "postalCode": 59320,
    "postalCodeMin": 59320,
    "postalCodeMax": 59329,
    "lat": 61.6405,
    "lng": 29.539,
    "radiusKm": 2.9
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Kirjavala",
    "postalCode": 59410,
    "postalCodeMin": 59410,
    "postalCodeMax": 59419,
    "lat": 61.6723,
    "lng": 29.6477,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Akonpohja",
    "postalCode": 59510,
    "postalCodeMin": 59510,
    "postalCodeMax": 59519,
    "lat": 61.6951,
    "lng": 29.6871,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Saari kk",
    "postalCode": 59520,
    "postalCodeMin": 59520,
    "postalCodeMax": 59529,
    "lat": 61.6595,
    "lng": 29.7686,
    "radiusKm": 4.4
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Mikkolanniemi",
    "postalCode": 59530,
    "postalCodeMin": 59530,
    "postalCodeMax": 59539,
    "lat": 61.6856,
    "lng": 29.785,
    "radiusKm": 4.0
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Tarnala",
    "postalCode": 59610,
    "postalCodeMin": 59610,
    "postalCodeMax": 59619,
    "lat": 61.7225,
    "lng": 29.7468,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Kummunkylä",
    "postalCode": 59710,
    "postalCodeMin": 59710,
    "postalCodeMax": 59719,
    "lat": 61.7681,
    "lng": 29.8189,
    "radiusKm": 3.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Niukkala",
    "postalCode": 59720,
    "postalCodeMin": 59720,
    "postalCodeMax": 59729,
    "lat": 61.7553,
    "lng": 29.8941,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Parikkala",
    "area": "Kirkonkylä",
    "postalCode": 59730,
    "postalCodeMin": 59730,
    "postalCodeMax": 59739,
    "lat": 61.7883,
    "lng": 30.0131,
    "radiusKm": 3.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Rautjärvi",
    "area": "Niska-Pietilä",
    "postalCode": 56550,
    "postalCodeMin": 56550,
    "postalCodeMax": 56559,
    "lat": 61.2326,
    "lng": 29.0573,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Rautjärvi",
    "area": "Rautjärvi",
    "postalCode": 56610,
    "postalCodeMin": 56610,
    "postalCodeMax": 56619,
    "lat": 61.3294,
    "lng": 29.1258,
    "radiusKm": 4.4
  },
  {
    "region": "Etelä-Karjala",
    "city": "Rautjärvi",
    "area": "Purnujärvi",
    "postalCode": 56640,
    "postalCodeMin": 56640,
    "postalCodeMax": 56649,
    "lat": 61.2517,
    "lng": 29.1455,
    "radiusKm": 4.4
  },
  {
    "region": "Etelä-Karjala",
    "city": "Rautjärvi",
    "area": "Miettilä",
    "postalCode": 56710,
    "postalCodeMin": 56710,
    "postalCodeMax": 56719,
    "lat": 61.2983,
    "lng": 29.2178,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Rautjärvi",
    "area": "Laikko",
    "postalCode": 56730,
    "postalCodeMin": 56730,
    "postalCodeMax": 56739,
    "lat": 61.3624,
    "lng": 29.2647,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Rautjärvi",
    "area": "Simpele",
    "postalCode": 56800,
    "postalCodeMin": 56800,
    "postalCodeMax": 56809,
    "lat": 61.4349,
    "lng": 29.3593,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Ruokolahti",
    "area": "Ruokolahti",
    "postalCode": 56100,
    "postalCodeMin": 56100,
    "postalCodeMax": 56109,
    "lat": 61.2863,
    "lng": 28.8275,
    "radiusKm": 4.6
  },
  {
    "region": "Etelä-Karjala",
    "city": "Ruokolahti",
    "area": "Salosaari",
    "postalCode": 56120,
    "postalCodeMin": 56120,
    "postalCodeMax": 56129,
    "lat": 61.2754,
    "lng": 28.7809,
    "radiusKm": 6.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Ruokolahti",
    "area": "Äitsaari",
    "postalCode": 56140,
    "postalCodeMin": 56140,
    "postalCodeMax": 56149,
    "lat": 61.3149,
    "lng": 28.6375,
    "radiusKm": 6.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Ruokolahti",
    "area": "Virmutjoki",
    "postalCode": 56210,
    "postalCodeMin": 56210,
    "postalCodeMax": 56219,
    "lat": 61.3402,
    "lng": 28.7796,
    "radiusKm": 5.5
  },
  {
    "region": "Etelä-Karjala",
    "city": "Ruokolahti",
    "area": "Syyspohja",
    "postalCode": 56310,
    "postalCodeMin": 56310,
    "postalCodeMax": 56319,
    "lat": 61.3993,
    "lng": 28.6274,
    "radiusKm": 3.1
  },
  {
    "region": "Etelä-Karjala",
    "city": "Ruokolahti",
    "area": "Utula",
    "postalCode": 56330,
    "postalCodeMin": 56330,
    "postalCodeMax": 56339,
    "lat": 61.3524,
    "lng": 28.4737,
    "radiusKm": 3.1
  },
  {
    "region": "Etelä-Karjala",
    "city": "Ruokolahti",
    "area": "Kaiturinpää",
    "postalCode": 56410,
    "postalCodeMin": 56410,
    "postalCodeMax": 56419,
    "lat": 61.338,
    "lng": 28.9874,
    "radiusKm": 3.1
  },
  {
    "region": "Etelä-Karjala",
    "city": "Ruokolahti",
    "area": "Pohjalankila",
    "postalCode": 56440,
    "postalCodeMin": 56440,
    "postalCodeMax": 56449,
    "lat": 61.4503,
    "lng": 29.0028,
    "radiusKm": 3.1
  },
  {
    "region": "Etelä-Karjala",
    "city": "Ruokolahti",
    "area": "Puntala",
    "postalCode": 56510,
    "postalCodeMin": 56510,
    "postalCodeMax": 56519,
    "lat": 61.2667,
    "lng": 28.9559,
    "radiusKm": 3.1
  },
  {
    "region": "Etelä-Karjala",
    "city": "Savitaipale",
    "area": "Välijoki",
    "postalCode": 54750,
    "postalCodeMin": 54750,
    "postalCodeMax": 54759,
    "lat": 61.0667,
    "lng": 27.5769,
    "radiusKm": 4.0
  },
  {
    "region": "Etelä-Karjala",
    "city": "Savitaipale",
    "area": "Heituinlahti",
    "postalCode": 54770,
    "postalCodeMin": 54770,
    "postalCodeMax": 54779,
    "lat": 61.125,
    "lng": 27.5091,
    "radiusKm": 3.3
  },
  {
    "region": "Etelä-Karjala",
    "city": "Savitaipale",
    "area": "Savitaipale",
    "postalCode": 54800,
    "postalCodeMin": 54800,
    "postalCodeMax": 54809,
    "lat": 61.1975,
    "lng": 27.6959,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Savitaipale",
    "area": "Pettilä",
    "postalCode": 54950,
    "postalCodeMin": 54950,
    "postalCodeMax": 54959,
    "lat": 61.3008,
    "lng": 27.761,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Taipalsaari",
    "area": "Saimaanharju",
    "postalCode": 54915,
    "postalCodeMin": 54910,
    "postalCodeMax": 54919,
    "lat": 61.136,
    "lng": 28.1032,
    "radiusKm": 2.0
  },
  {
    "region": "Etelä-Karjala",
    "city": "Taipalsaari",
    "area": "Taipalsaari",
    "postalCode": 54920,
    "postalCodeMin": 54920,
    "postalCodeMax": 54929,
    "lat": 61.1521,
    "lng": 28.0739,
    "radiusKm": 4.4
  },
  {
    "region": "Etelä-Karjala",
    "city": "Taipalsaari",
    "area": "Levänen",
    "postalCode": 54930,
    "postalCodeMin": 54930,
    "postalCodeMax": 54939,
    "lat": 61.2131,
    "lng": 27.9525,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Taipalsaari",
    "area": "Solkei",
    "postalCode": 54940,
    "postalCodeMin": 54940,
    "postalCodeMax": 54949,
    "lat": 61.2484,
    "lng": 27.8603,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Taipalsaari",
    "area": "Vehkataipale",
    "postalCode": 54960,
    "postalCodeMin": 54960,
    "postalCodeMax": 54969,
    "lat": 61.1503,
    "lng": 28.228,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Karjala",
    "city": "Taipalsaari",
    "area": "Kyläniemi",
    "postalCode": 56350,
    "postalCodeMin": 56350,
    "postalCodeMax": 56359,
    "lat": 61.3108,
    "lng": 28.2181,
    "radiusKm": 3.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Aura (kunta)",
    "area": "Aura kk",
    "postalCode": 21370,
    "postalCodeMin": 21370,
    "postalCodeMax": 21379,
    "lat": 60.6084,
    "lng": 22.563,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Aura (kunta)",
    "area": "Aura",
    "postalCode": 21380,
    "postalCodeMin": 21380,
    "postalCodeMax": 21389,
    "lat": 60.6466,
    "lng": 22.5912,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kaarina",
    "area": "Littoinen",
    "postalCode": 20660,
    "postalCodeMin": 20660,
    "postalCodeMax": 20669,
    "lat": 60.4461,
    "lng": 22.3834,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kaarina",
    "area": "Piispanristi",
    "postalCode": 20760,
    "postalCodeMin": 20760,
    "postalCodeMax": 20769,
    "lat": 60.4162,
    "lng": 22.3286,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kaarina",
    "area": "Kaarina",
    "postalCode": 20780,
    "postalCodeMin": 20780,
    "postalCodeMax": 20789,
    "lat": 60.4114,
    "lng": 22.3766,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kaarina",
    "area": "Piikkiö",
    "postalCode": 21500,
    "postalCodeMin": 21500,
    "postalCodeMax": 21509,
    "lat": 60.4263,
    "lng": 22.5232,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kaarina",
    "area": "Kuusisto",
    "postalCode": 21620,
    "postalCodeMin": 21620,
    "postalCodeMax": 21629,
    "lat": 60.3871,
    "lng": 22.4103,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Strömma",
    "postalCode": 25650,
    "postalCodeMin": 25650,
    "postalCodeMax": 25659,
    "lat": 60.1849,
    "lng": 22.8636,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Kemiö / Kimito",
    "postalCode": 25700,
    "postalCodeMin": 25700,
    "postalCodeMax": 25709,
    "lat": 60.1631,
    "lng": 22.7296,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Vreta",
    "postalCode": 25710,
    "postalCodeMin": 25710,
    "postalCodeMax": 25719,
    "lat": 60.1623,
    "lng": 22.7039,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Mjösund",
    "postalCode": 25730,
    "postalCodeMin": 25730,
    "postalCodeMax": 25739,
    "lat": 60.2001,
    "lng": 22.4705,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Kiila / Kila",
    "postalCode": 25760,
    "postalCodeMin": 25760,
    "postalCodeMax": 25769,
    "lat": 60.1126,
    "lng": 22.6122,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Mark",
    "postalCode": 25810,
    "postalCodeMin": 25810,
    "postalCodeMax": 25819,
    "lat": 60.1055,
    "lng": 22.7188,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Vestlax",
    "postalCode": 25820,
    "postalCodeMin": 25820,
    "postalCodeMax": 25829,
    "lat": 60.0786,
    "lng": 22.7737,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Västanfjärd",
    "postalCode": 25830,
    "postalCodeMin": 25830,
    "postalCodeMax": 25839,
    "lat": 60.0499,
    "lng": 22.6666,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Nivelax",
    "postalCode": 25840,
    "postalCodeMin": 25840,
    "postalCodeMax": 25849,
    "lat": 60.0781,
    "lng": 22.6347,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Björkboda",
    "postalCode": 25860,
    "postalCodeMin": 25860,
    "postalCodeMax": 25869,
    "lat": 60.0912,
    "lng": 22.5609,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Dragsfjärd",
    "postalCode": 25870,
    "postalCodeMin": 25870,
    "postalCodeMax": 25879,
    "lat": 60.0723,
    "lng": 22.4704,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Taalintehdas / Dalsbruk",
    "postalCode": 25900,
    "postalCodeMin": 25900,
    "postalCodeMax": 25909,
    "lat": 60.0199,
    "lng": 22.5055,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Vänoxa",
    "postalCode": 25910,
    "postalCodeMin": 25910,
    "postalCodeMax": 25919,
    "lat": 59.9546,
    "lng": 22.6241,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Kasnäs",
    "postalCode": 25930,
    "postalCodeMin": 25930,
    "postalCodeMax": 25939,
    "lat": 59.9263,
    "lng": 22.4144,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Hiittinen / Hitis",
    "postalCode": 25940,
    "postalCodeMin": 25940,
    "postalCodeMax": 25949,
    "lat": 59.8909,
    "lng": 22.5224,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Rosala",
    "postalCode": 25950,
    "postalCodeMin": 25950,
    "postalCodeMax": 25959,
    "lat": 59.8626,
    "lng": 22.4573,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kemiönsaari",
    "area": "Högsåra",
    "postalCode": 25960,
    "postalCodeMin": 25960,
    "postalCodeMax": 25969,
    "lat": 59.9553,
    "lng": 22.3612,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Koski Tl",
    "area": "Koski Tl",
    "postalCode": 31500,
    "postalCodeMin": 31500,
    "postalCodeMax": 31509,
    "lat": 60.6533,
    "lng": 23.1404,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Kustavi",
    "area": "Kustavi",
    "postalCode": 23360,
    "postalCodeMin": 23360,
    "postalCodeMax": 23369,
    "lat": 60.545,
    "lng": 21.3554,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Laitila",
    "area": "Laitila",
    "postalCode": 23800,
    "postalCodeMin": 23800,
    "postalCodeMax": 23809,
    "lat": 60.8742,
    "lng": 21.698,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Laitila",
    "area": "Soukainen",
    "postalCode": 23840,
    "postalCodeMin": 23840,
    "postalCodeMax": 23849,
    "lat": 60.9283,
    "lng": 21.6969,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Laitila",
    "area": "Suontaka",
    "postalCode": 23880,
    "postalCodeMin": 23880,
    "postalCodeMax": 23889,
    "lat": 60.9422,
    "lng": 21.8134,
    "radiusKm": 4.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Lieto",
    "area": "Littoinen",
    "postalCode": 20660,
    "postalCodeMin": 20660,
    "postalCodeMax": 20669,
    "lat": 60.4461,
    "lng": 22.3834,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Lieto",
    "area": "Ilmarinen",
    "postalCode": 21350,
    "postalCodeMin": 21350,
    "postalCodeMax": 21359,
    "lat": 60.5073,
    "lng": 22.3824,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Lieto",
    "area": "Lieto as",
    "postalCode": 21360,
    "postalCodeMin": 21360,
    "postalCodeMax": 21369,
    "lat": 60.5708,
    "lng": 22.4384,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Lieto",
    "area": "Vanhalinna",
    "postalCode": 21410,
    "postalCodeMin": 21410,
    "postalCodeMax": 21419,
    "lat": 60.4863,
    "lng": 22.3793,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Lieto",
    "area": "Lieto",
    "postalCode": 21420,
    "postalCodeMin": 21420,
    "postalCodeMax": 21429,
    "lat": 60.5009,
    "lng": 22.4613,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Lieto",
    "area": "Yliskulma",
    "postalCode": 21430,
    "postalCodeMin": 21430,
    "postalCodeMax": 21439,
    "lat": 60.5396,
    "lng": 22.5949,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Lieto",
    "area": "Tarvasjoki",
    "postalCode": 21450,
    "postalCodeMin": 21450,
    "postalCodeMax": 21459,
    "lat": 60.584,
    "lng": 22.7376,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Orisuo",
    "postalCode": 31960,
    "postalCodeMin": 31960,
    "postalCodeMax": 31969,
    "lat": 61.0179,
    "lng": 23.1265,
    "radiusKm": 4.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Loimaa",
    "postalCode": 32200,
    "postalCodeMin": 32200,
    "postalCodeMax": 32209,
    "lat": 60.8535,
    "lng": 23.0429,
    "radiusKm": 4.8
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Hirvikoski",
    "postalCode": 32210,
    "postalCodeMin": 32210,
    "postalCodeMax": 32219,
    "lat": 60.8677,
    "lng": 22.985,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Kojonkulma",
    "postalCode": 32250,
    "postalCodeMin": 32250,
    "postalCodeMax": 32259,
    "lat": 60.9545,
    "lng": 23.0208,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Kojonperä",
    "postalCode": 32260,
    "postalCodeMin": 32260,
    "postalCodeMax": 32269,
    "lat": 60.9759,
    "lng": 23.0212,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Metsämaa",
    "postalCode": 32270,
    "postalCodeMin": 32270,
    "postalCodeMax": 32279,
    "lat": 60.9381,
    "lng": 23.1514,
    "radiusKm": 5.4
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Metsäkorpi",
    "postalCode": 32280,
    "postalCodeMin": 32280,
    "postalCodeMax": 32289,
    "lat": 60.9322,
    "lng": 23.2462,
    "radiusKm": 5.4
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Mellilä",
    "postalCode": 32300,
    "postalCodeMin": 32300,
    "postalCodeMax": 32309,
    "lat": 60.78,
    "lng": 22.9235,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Niinijoki",
    "postalCode": 32410,
    "postalCodeMin": 32410,
    "postalCodeMax": 32419,
    "lat": 60.8623,
    "lng": 22.8794,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Ylhäinen",
    "postalCode": 32430,
    "postalCodeMin": 32430,
    "postalCodeMax": 32439,
    "lat": 60.8976,
    "lng": 22.8507,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Alastaro",
    "postalCode": 32440,
    "postalCodeMin": 32440,
    "postalCodeMax": 32449,
    "lat": 60.9523,
    "lng": 22.8618,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Tammiainen",
    "postalCode": 32450,
    "postalCodeMin": 32450,
    "postalCodeMax": 32459,
    "lat": 60.9962,
    "lng": 22.8495,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Loimaa",
    "area": "Virttaa",
    "postalCode": 32560,
    "postalCodeMin": 32560,
    "postalCodeMax": 32569,
    "lat": 60.9393,
    "lng": 22.6732,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Marttila",
    "area": "Prunkila",
    "postalCode": 21480,
    "postalCodeMin": 21480,
    "postalCodeMax": 21489,
    "lat": 60.565,
    "lng": 22.8158,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Marttila",
    "area": "Marttila",
    "postalCode": 21490,
    "postalCodeMin": 21490,
    "postalCodeMax": 21499,
    "lat": 60.5854,
    "lng": 22.8999,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Marttila",
    "area": "Ollila",
    "postalCode": 21560,
    "postalCodeMin": 21560,
    "postalCodeMax": 21569,
    "lat": 60.6263,
    "lng": 22.9676,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Masku",
    "area": "Lemu",
    "postalCode": 21230,
    "postalCodeMin": 21230,
    "postalCodeMax": 21239,
    "lat": 60.5692,
    "lng": 21.9675,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Masku",
    "area": "Askainen",
    "postalCode": 21240,
    "postalCodeMin": 21240,
    "postalCodeMax": 21249,
    "lat": 60.5703,
    "lng": 21.8627,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Masku",
    "area": "Masku",
    "postalCode": 21250,
    "postalCodeMin": 21250,
    "postalCodeMax": 21259,
    "lat": 60.5704,
    "lng": 22.0991,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Mynämäki",
    "area": "Mynämäki",
    "postalCode": 23100,
    "postalCodeMin": 23100,
    "postalCodeMax": 23109,
    "lat": 60.6783,
    "lng": 21.9886,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Mynämäki",
    "area": "Mietoinen",
    "postalCode": 23120,
    "postalCodeMin": 23120,
    "postalCodeMax": 23129,
    "lat": 60.6265,
    "lng": 21.9275,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Mynämäki",
    "area": "Hietamäki",
    "postalCode": 23140,
    "postalCodeMin": 23140,
    "postalCodeMax": 23149,
    "lat": 60.6522,
    "lng": 21.8563,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Naantali",
    "area": "Naantali keskus",
    "postalCode": 21100,
    "postalCodeMin": 21100,
    "postalCodeMax": 21109,
    "lat": 60.4587,
    "lng": 21.9665,
    "radiusKm": 1.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Naantali",
    "area": "Taimo-Nuhjala-Lietsala",
    "postalCode": 21110,
    "postalCodeMin": 21110,
    "postalCodeMax": 21119,
    "lat": 60.4815,
    "lng": 22.0349,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Naantali",
    "area": "Poikko",
    "postalCode": 21130,
    "postalCodeMin": 21130,
    "postalCodeMax": 21139,
    "lat": 60.4143,
    "lng": 21.8977,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Naantali",
    "area": "Rymättylä",
    "postalCode": 21140,
    "postalCodeMin": 21140,
    "postalCodeMax": 21149,
    "lat": 60.3757,
    "lng": 21.9439,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Naantali",
    "area": "Röölä",
    "postalCode": 21150,
    "postalCodeMin": 21150,
    "postalCodeMax": 21159,
    "lat": 60.3464,
    "lng": 21.9568,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Naantali",
    "area": "Merimasku",
    "postalCode": 21160,
    "postalCodeMin": 21160,
    "postalCodeMax": 21169,
    "lat": 60.4811,
    "lng": 21.8711,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Naantali",
    "area": "Livonsaari",
    "postalCode": 21180,
    "postalCodeMin": 21180,
    "postalCodeMax": 21189,
    "lat": 60.5201,
    "lng": 21.7518,
    "radiusKm": 4.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Naantali",
    "area": "Velkua",
    "postalCode": 21195,
    "postalCodeMin": 21190,
    "postalCodeMax": 21199,
    "lat": 60.4659,
    "lng": 21.6647,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Nousiainen",
    "area": "Nousiainen",
    "postalCode": 21270,
    "postalCodeMin": 21270,
    "postalCodeMax": 21279,
    "lat": 60.669,
    "lng": 22.2346,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Oripää",
    "area": "Oripää",
    "postalCode": 32500,
    "postalCodeMin": 32500,
    "postalCodeMax": 32509,
    "lat": 60.856,
    "lng": 22.6972,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Oripää",
    "area": "Latva",
    "postalCode": 32520,
    "postalCodeMin": 32520,
    "postalCodeMax": 32529,
    "lat": 60.891,
    "lng": 22.6258,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Paimio",
    "area": "Hevonpää",
    "postalCode": 21510,
    "postalCodeMin": 21510,
    "postalCodeMax": 21519,
    "lat": 60.4269,
    "lng": 22.6247,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Paimio",
    "area": "Naskarla",
    "postalCode": 21520,
    "postalCodeMin": 21520,
    "postalCodeMax": 21529,
    "lat": 60.4315,
    "lng": 22.6835,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Paimio",
    "area": "Paimio",
    "postalCode": 21530,
    "postalCodeMin": 21530,
    "postalCodeMax": 21539,
    "lat": 60.4569,
    "lng": 22.687,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Paimio",
    "area": "Preitilä",
    "postalCode": 21540,
    "postalCodeMin": 21540,
    "postalCodeMax": 21549,
    "lat": 60.4653,
    "lng": 22.7317,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Paimio",
    "area": "Taatila",
    "postalCode": 21555,
    "postalCodeMin": 21550,
    "postalCodeMax": 21559,
    "lat": 60.507,
    "lng": 22.7755,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Parainen / Pargas",
    "postalCode": 21600,
    "postalCodeMin": 21600,
    "postalCodeMax": 21609,
    "lat": 60.3011,
    "lng": 22.3022,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Kirjala",
    "postalCode": 21610,
    "postalCodeMin": 21610,
    "postalCodeMax": 21619,
    "lat": 60.3591,
    "lng": 22.3574,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Lielahti Tl / Lielax",
    "postalCode": 21630,
    "postalCodeMin": 21630,
    "postalCodeMax": 21639,
    "lat": 60.3135,
    "lng": 22.4185,
    "radiusKm": 3.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Lillandet",
    "postalCode": 21650,
    "postalCodeMin": 21650,
    "postalCodeMax": 21659,
    "lat": 60.1875,
    "lng": 22.017,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Nauvo / Nagu",
    "postalCode": 21660,
    "postalCodeMin": 21660,
    "postalCodeMax": 21669,
    "lat": 60.1927,
    "lng": 21.9092,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Pärnäinen / Pärnäs",
    "postalCode": 21670,
    "postalCodeMin": 21670,
    "postalCodeMax": 21679,
    "lat": 60.1633,
    "lng": 21.7071,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Nötö",
    "postalCode": 21680,
    "postalCodeMin": 21680,
    "postalCodeMax": 21689,
    "lat": 59.9555,
    "lng": 21.7602,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Korppoo / Korpo",
    "postalCode": 21710,
    "postalCodeMin": 21710,
    "postalCodeMax": 21719,
    "lat": 60.1627,
    "lng": 21.5618,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Korpoström",
    "postalCode": 21720,
    "postalCodeMin": 21720,
    "postalCodeMax": 21729,
    "lat": 60.1132,
    "lng": 21.6008,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Utö",
    "postalCode": 21740,
    "postalCodeMin": 21740,
    "postalCodeMax": 21749,
    "lat": 59.7794,
    "lng": 21.378,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Norrskata",
    "postalCode": 21750,
    "postalCodeMin": 21750,
    "postalCodeMax": 21759,
    "lat": 60.2292,
    "lng": 21.5953,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Houtskari / Houtskär",
    "postalCode": 21760,
    "postalCodeMin": 21760,
    "postalCodeMax": 21769,
    "lat": 60.2269,
    "lng": 21.382,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Mossala",
    "postalCode": 21770,
    "postalCodeMin": 21770,
    "postalCodeMax": 21779,
    "lat": 60.2833,
    "lng": 21.4167,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Parainen",
    "area": "Iniö",
    "postalCode": 23390,
    "postalCodeMin": 23390,
    "postalCodeMax": 23399,
    "lat": 60.3833,
    "lng": 21.4,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pyhäranta",
    "area": "Pyhäranta",
    "postalCode": 23950,
    "postalCodeMin": 23950,
    "postalCodeMax": 23959,
    "lat": 60.9502,
    "lng": 21.4448,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pyhäranta",
    "area": "Santtio",
    "postalCode": 23960,
    "postalCodeMin": 23960,
    "postalCodeMax": 23969,
    "lat": 60.9777,
    "lng": 21.408,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pyhäranta",
    "area": "Ihode",
    "postalCode": 27320,
    "postalCodeMin": 27320,
    "postalCodeMax": 27329,
    "lat": 60.9851,
    "lng": 21.5877,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pyhäranta",
    "area": "Reila",
    "postalCode": 27340,
    "postalCodeMin": 27340,
    "postalCodeMax": 27349,
    "lat": 61.0328,
    "lng": 21.3695,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pöytyä",
    "area": "Kyrö",
    "postalCode": 21800,
    "postalCodeMin": 21800,
    "postalCodeMax": 21809,
    "lat": 60.7023,
    "lng": 22.7577,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pöytyä",
    "area": "Kumila",
    "postalCode": 21820,
    "postalCodeMin": 21820,
    "postalCodeMax": 21829,
    "lat": 60.7414,
    "lng": 22.8135,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pöytyä",
    "area": "Karinainen",
    "postalCode": 21840,
    "postalCodeMin": 21840,
    "postalCodeMax": 21849,
    "lat": 60.7023,
    "lng": 22.7577,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pöytyä",
    "area": "Auvainen",
    "postalCode": 21860,
    "postalCodeMin": 21860,
    "postalCodeMax": 21869,
    "lat": 60.6736,
    "lng": 22.5695,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pöytyä",
    "area": "Riihikoski",
    "postalCode": 21870,
    "postalCodeMin": 21870,
    "postalCodeMax": 21879,
    "lat": 60.7199,
    "lng": 22.6036,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pöytyä",
    "area": "Pöytyä",
    "postalCode": 21880,
    "postalCodeMin": 21880,
    "postalCodeMax": 21889,
    "lat": 60.7882,
    "lng": 22.6034,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pöytyä",
    "area": "Haveri",
    "postalCode": 21890,
    "postalCodeMin": 21890,
    "postalCodeMax": 21899,
    "lat": 60.8032,
    "lng": 22.6732,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pöytyä",
    "area": "Yläne",
    "postalCode": 21900,
    "postalCodeMin": 21900,
    "postalCodeMax": 21909,
    "lat": 60.8796,
    "lng": 22.4095,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Pöytyä",
    "area": "Uusikartano",
    "postalCode": 21930,
    "postalCodeMin": 21930,
    "postalCodeMax": 21939,
    "lat": 60.8205,
    "lng": 22.4503,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Raisio",
    "area": "Vanto",
    "postalCode": 21120,
    "postalCodeMin": 21120,
    "postalCodeMax": 21129,
    "lat": 60.4663,
    "lng": 22.0987,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Raisio",
    "area": "Raisio keskus",
    "postalCode": 21200,
    "postalCodeMin": 21200,
    "postalCodeMax": 21209,
    "lat": 60.4859,
    "lng": 22.1689,
    "radiusKm": 1.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Raisio",
    "area": "Tikanmaa",
    "postalCode": 21210,
    "postalCodeMin": 21210,
    "postalCodeMax": 21219,
    "lat": 60.4919,
    "lng": 22.1014,
    "radiusKm": 4.8
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Raisio",
    "area": "Somersoja",
    "postalCode": 21220,
    "postalCodeMin": 21220,
    "postalCodeMax": 21229,
    "lat": 60.5113,
    "lng": 22.1198,
    "radiusKm": 2.8
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Raisio",
    "area": "Ihala",
    "postalCode": 21260,
    "postalCodeMin": 21260,
    "postalCodeMax": 21269,
    "lat": 60.4717,
    "lng": 22.1784,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Raisio",
    "area": "Kuloinen",
    "postalCode": 21280,
    "postalCodeMin": 21280,
    "postalCodeMax": 21289,
    "lat": 60.4825,
    "lng": 22.1937,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Rusko",
    "area": "Rusko",
    "postalCode": 21290,
    "postalCodeMin": 21290,
    "postalCodeMax": 21299,
    "lat": 60.5422,
    "lng": 22.2222,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Rusko",
    "area": "Vahto",
    "postalCode": 21310,
    "postalCodeMin": 21310,
    "postalCodeMax": 21319,
    "lat": 60.6085,
    "lng": 22.3043,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Salo",
    "postalCode": 24100,
    "postalCodeMin": 24100,
    "postalCodeMax": 24109,
    "lat": 60.3788,
    "lng": 23.153,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Ylhäisi",
    "postalCode": 24130,
    "postalCodeMin": 24130,
    "postalCodeMax": 24139,
    "lat": 60.3637,
    "lng": 23.1239,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Rappula",
    "postalCode": 24240,
    "postalCodeMin": 24240,
    "postalCodeMax": 24249,
    "lat": 60.399,
    "lng": 23.0967,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Ollikkala",
    "postalCode": 24260,
    "postalCodeMin": 24260,
    "postalCodeMax": 24269,
    "lat": 60.3978,
    "lng": 23.1387,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Tupuri",
    "postalCode": 24280,
    "postalCodeMin": 24280,
    "postalCodeMax": 24289,
    "lat": 60.3932,
    "lng": 23.1794,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Halikko",
    "postalCode": 24800,
    "postalCodeMin": 24800,
    "postalCodeMax": 24809,
    "lat": 60.3973,
    "lng": 23.0776,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Halikko as",
    "postalCode": 24910,
    "postalCodeMin": 24910,
    "postalCodeMax": 24919,
    "lat": 60.389,
    "lng": 23.0407,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Kruusila",
    "postalCode": 25110,
    "postalCodeMin": 25110,
    "postalCodeMax": 25119,
    "lat": 60.3728,
    "lng": 23.4878,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Muurla",
    "postalCode": 25130,
    "postalCodeMin": 25130,
    "postalCodeMax": 25139,
    "lat": 60.3496,
    "lng": 23.2801,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Tuohittu",
    "postalCode": 25160,
    "postalCodeMin": 25160,
    "postalCodeMax": 25169,
    "lat": 60.2903,
    "lng": 23.2409,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Kotalato",
    "postalCode": 25170,
    "postalCodeMin": 25170,
    "postalCodeMax": 25179,
    "lat": 60.3059,
    "lng": 23.1046,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Romsila",
    "postalCode": 25180,
    "postalCodeMin": 25180,
    "postalCodeMax": 25189,
    "lat": 60.409,
    "lng": 23.3391,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Inkere",
    "postalCode": 25190,
    "postalCodeMin": 25190,
    "postalCodeMax": 25199,
    "lat": 60.4366,
    "lng": 23.2778,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Vartsala",
    "postalCode": 25210,
    "postalCodeMin": 25210,
    "postalCodeMax": 25219,
    "lat": 60.3342,
    "lng": 23.0044,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Angelniemi",
    "postalCode": 25230,
    "postalCodeMin": 25230,
    "postalCodeMax": 25239,
    "lat": 60.2974,
    "lng": 22.908,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Hajala",
    "postalCode": 25240,
    "postalCodeMin": 25240,
    "postalCodeMax": 25249,
    "lat": 60.4167,
    "lng": 22.9147,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Märynummi",
    "postalCode": 25250,
    "postalCodeMin": 25250,
    "postalCodeMax": 25259,
    "lat": 60.4361,
    "lng": 23.0455,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Vaskio",
    "postalCode": 25260,
    "postalCodeMin": 25260,
    "postalCodeMax": 25269,
    "lat": 60.4878,
    "lng": 22.9964,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Raatala",
    "postalCode": 25320,
    "postalCodeMin": 25320,
    "postalCodeMax": 25329,
    "lat": 60.5325,
    "lng": 23.163,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Kuusjoki",
    "postalCode": 25330,
    "postalCodeMin": 25330,
    "postalCodeMax": 25339,
    "lat": 60.5202,
    "lng": 23.217,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Kanunki",
    "postalCode": 25340,
    "postalCodeMin": 25340,
    "postalCodeMax": 25349,
    "lat": 60.5554,
    "lng": 23.3124,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Kaivola",
    "postalCode": 25360,
    "postalCodeMin": 25360,
    "postalCodeMax": 25369,
    "lat": 60.4499,
    "lng": 23.2378,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Hiisi",
    "postalCode": 25370,
    "postalCodeMin": 25370,
    "postalCodeMax": 25379,
    "lat": 60.4784,
    "lng": 23.3626,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Rekijoki",
    "postalCode": 25380,
    "postalCodeMin": 25380,
    "postalCodeMax": 25389,
    "lat": 60.4868,
    "lng": 23.4461,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Kiikala",
    "postalCode": 25390,
    "postalCodeMin": 25390,
    "postalCodeMax": 25399,
    "lat": 60.4624,
    "lng": 23.5497,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Suomusjärvi",
    "postalCode": 25410,
    "postalCodeMin": 25410,
    "postalCodeMax": 25419,
    "lat": 60.3791,
    "lng": 23.5875,
    "radiusKm": 4.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Lahnajärvi",
    "postalCode": 25420,
    "postalCodeMin": 25420,
    "postalCodeMax": 25429,
    "lat": 60.3785,
    "lng": 23.7081,
    "radiusKm": 4.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Kettula",
    "postalCode": 25430,
    "postalCodeMin": 25430,
    "postalCodeMax": 25439,
    "lat": 60.4025,
    "lng": 23.7531,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Toija",
    "postalCode": 25460,
    "postalCodeMin": 25460,
    "postalCodeMax": 25469,
    "lat": 60.2648,
    "lng": 23.4471,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Kisko",
    "postalCode": 25470,
    "postalCodeMin": 25470,
    "postalCodeMax": 25479,
    "lat": 60.2478,
    "lng": 23.4753,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Perniö/ Bjärnåselvennä",
    "postalCode": 25500,
    "postalCodeMin": 25500,
    "postalCodeMax": 25509,
    "lat": 60.2036,
    "lng": 23.1254,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Perniö as",
    "postalCode": 25520,
    "postalCodeMin": 25520,
    "postalCodeMax": 25529,
    "lat": 60.251,
    "lng": 23.1345,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Knaapila",
    "postalCode": 25540,
    "postalCodeMin": 25540,
    "postalCodeMax": 25549,
    "lat": 60.2494,
    "lng": 23.2716,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Aijala",
    "postalCode": 25550,
    "postalCodeMin": 25550,
    "postalCodeMax": 25559,
    "lat": 60.1921,
    "lng": 23.35,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Koski as",
    "postalCode": 25560,
    "postalCodeMin": 25560,
    "postalCodeMax": 25569,
    "lat": 60.1799,
    "lng": 23.2863,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Teijo",
    "postalCode": 25570,
    "postalCodeMin": 25570,
    "postalCodeMax": 25579,
    "lat": 60.2554,
    "lng": 22.9521,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Ylönkylä",
    "postalCode": 25610,
    "postalCodeMin": 25610,
    "postalCodeMax": 25619,
    "lat": 60.1681,
    "lng": 22.999,
    "radiusKm": 3.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Särkisalo / Finby",
    "postalCode": 25630,
    "postalCodeMin": 25630,
    "postalCodeMax": 25639,
    "lat": 60.1129,
    "lng": 22.9536,
    "radiusKm": 3.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Förby",
    "postalCode": 25640,
    "postalCodeMin": 25640,
    "postalCodeMax": 25649,
    "lat": 60.0951,
    "lng": 22.8806,
    "radiusKm": 3.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Mathildedal",
    "postalCode": 25660,
    "postalCodeMin": 25660,
    "postalCodeMax": 25669,
    "lat": 60.2172,
    "lng": 22.909,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Salo",
    "area": "Kiila / Kila",
    "postalCode": 25760,
    "postalCodeMin": 25760,
    "postalCodeMax": 25769,
    "lat": 60.2407,
    "lng": 22.8847,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Sauvo",
    "area": "Sauvo",
    "postalCode": 21570,
    "postalCodeMin": 21570,
    "postalCodeMax": 21579,
    "lat": 60.3435,
    "lng": 22.6954,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Sauvo",
    "area": "Karuna",
    "postalCode": 21590,
    "postalCodeMin": 21590,
    "postalCodeMax": 21599,
    "lat": 60.2728,
    "lng": 22.5426,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Somero",
    "area": "Somero",
    "postalCode": 31400,
    "postalCodeMin": 31400,
    "postalCodeMax": 31409,
    "lat": 60.6285,
    "lng": 23.5147,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Somero",
    "area": "Ylöpirtti",
    "postalCode": 31410,
    "postalCodeMin": 31410,
    "postalCodeMax": 31419,
    "lat": 60.6285,
    "lng": 23.5147,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Somero",
    "area": "Häntälä",
    "postalCode": 31450,
    "postalCodeMin": 31450,
    "postalCodeMax": 31459,
    "lat": 60.5812,
    "lng": 23.3579,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Somero",
    "area": "Hirsjärvi",
    "postalCode": 31460,
    "postalCodeMin": 31460,
    "postalCodeMax": 31469,
    "lat": 60.6012,
    "lng": 23.6457,
    "radiusKm": 4.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Somero",
    "area": "Somerniemi",
    "postalCode": 31470,
    "postalCodeMin": 31470,
    "postalCodeMax": 31479,
    "lat": 60.5675,
    "lng": 23.7414,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Somero",
    "area": "Terttilä",
    "postalCode": 31490,
    "postalCodeMin": 31490,
    "postalCodeMax": 31499,
    "lat": 60.5394,
    "lng": 23.5567,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Somero",
    "area": "Pitkäjärvi",
    "postalCode": 31520,
    "postalCodeMin": 31520,
    "postalCodeMax": 31529,
    "lat": 60.6611,
    "lng": 23.3033,
    "radiusKm": 4.3
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Somero",
    "area": "Pyöli",
    "postalCode": 31530,
    "postalCodeMin": 31530,
    "postalCodeMax": 31539,
    "lat": 60.6503,
    "lng": 23.3732,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Taivassalo",
    "area": "Taivassalo",
    "postalCode": 23310,
    "postalCodeMin": 23310,
    "postalCodeMax": 23319,
    "lat": 60.5627,
    "lng": 21.6051,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "VI ja VII kaupunginosat",
    "postalCode": 20100,
    "postalCodeMin": 20100,
    "postalCodeMax": 20109,
    "lat": 60.4494,
    "lng": 22.252,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Iso-Heikkilä",
    "postalCode": 20200,
    "postalCodeMin": 20200,
    "postalCodeMax": 20209,
    "lat": 60.4476,
    "lng": 22.2232,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Pahaniemi",
    "postalCode": 20210,
    "postalCodeMin": 20210,
    "postalCodeMax": 20219,
    "lat": 60.458,
    "lng": 22.1989,
    "radiusKm": 7.0
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Pansio",
    "postalCode": 20240,
    "postalCodeMin": 20240,
    "postalCodeMax": 20249,
    "lat": 60.4543,
    "lng": 22.1499,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Pitkämäki",
    "postalCode": 20250,
    "postalCodeMin": 20250,
    "postalCodeMax": 20259,
    "lat": 60.4572,
    "lng": 22.2295,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Raunistula, Kastu, Kähäri",
    "postalCode": 20300,
    "postalCodeMin": 20300,
    "postalCodeMax": 20309,
    "lat": 60.4693,
    "lng": 22.2673,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Hepokulta, Teräsrautela, Länsinummi, Ruohonpää",
    "postalCode": 20320,
    "postalCodeMin": 20320,
    "postalCodeMax": 20329,
    "lat": 60.4677,
    "lng": 22.2241,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Runosmäki, Kaerla",
    "postalCode": 20360,
    "postalCodeMin": 20360,
    "postalCodeMax": 20369,
    "lat": 60.478,
    "lng": 22.2685,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Räntämäki, Oriketo, Saramäki",
    "postalCode": 20380,
    "postalCodeMin": 20380,
    "postalCodeMax": 20389,
    "lat": 60.5069,
    "lng": 22.3235,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Moisio, Yli-Maaria",
    "postalCode": 20400,
    "postalCodeMin": 20400,
    "postalCodeMax": 20409,
    "lat": 60.5321,
    "lng": 22.3027,
    "radiusKm": 8.6
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Jäkärlä",
    "postalCode": 20460,
    "postalCodeMin": 20460,
    "postalCodeMax": 20469,
    "lat": 60.5406,
    "lng": 22.3512,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Yliopiston alue",
    "postalCode": 20500,
    "postalCodeMin": 20500,
    "postalCodeMax": 20509,
    "lat": 60.4529,
    "lng": 22.2857,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Itäharju",
    "postalCode": 20520,
    "postalCodeMin": 20520,
    "postalCodeMax": 20529,
    "lat": 60.447,
    "lng": 22.3052,
    "radiusKm": 3.5
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Itäharju, Nummi, Halinen, Kurala, Kohmo",
    "postalCode": 20540,
    "postalCodeMin": 20540,
    "postalCodeMax": 20549,
    "lat": 60.45,
    "lng": 22.3087,
    "radiusKm": 3.5
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Pääskyvuori, Varissuo",
    "postalCode": 20610,
    "postalCodeMin": 20610,
    "postalCodeMax": 20619,
    "lat": 60.4511,
    "lng": 22.344,
    "radiusKm": 7.8
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "II kaupunginosa",
    "postalCode": 20700,
    "postalCodeMin": 20700,
    "postalCodeMax": 20709,
    "lat": 60.4472,
    "lng": 22.2787,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Vasaramäki",
    "postalCode": 20720,
    "postalCodeMin": 20720,
    "postalCodeMax": 20729,
    "lat": 60.4322,
    "lng": 22.311,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Skanssi",
    "postalCode": 20730,
    "postalCodeMin": 20730,
    "postalCodeMax": 20739,
    "lat": 60.4275,
    "lng": 22.3214,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Ilpoinen",
    "postalCode": 20740,
    "postalCodeMin": 20740,
    "postalCodeMax": 20749,
    "lat": 60.4219,
    "lng": 22.2859,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Lauste, Vaala",
    "postalCode": 20750,
    "postalCodeMin": 20750,
    "postalCodeMax": 20759,
    "lat": 60.4371,
    "lng": 22.3589,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Virastotalo",
    "postalCode": 20800,
    "postalCodeMin": 20800,
    "postalCodeMax": 20809,
    "lat": 60.4451,
    "lng": 22.263,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Mäntymäki, Vähäheikkilä",
    "postalCode": 20810,
    "postalCodeMin": 20810,
    "postalCodeMax": 20819,
    "lat": 60.4377,
    "lng": 22.2679,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Uittamo, Ispoinen",
    "postalCode": 20880,
    "postalCodeMin": 20880,
    "postalCodeMax": 20889,
    "lat": 60.4181,
    "lng": 22.2644,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Hirvensalo",
    "postalCode": 20900,
    "postalCodeMin": 20900,
    "postalCodeMax": 20909,
    "lat": 60.3971,
    "lng": 22.2149,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Satava, Kakskerta",
    "postalCode": 20960,
    "postalCodeMin": 20960,
    "postalCodeMax": 20969,
    "lat": 60.3763,
    "lng": 22.215,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Paattinen / Patis",
    "postalCode": 21330,
    "postalCodeMin": 21330,
    "postalCodeMax": 21339,
    "lat": 60.5931,
    "lng": 22.3841,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Turku",
    "area": "Tortinmäki",
    "postalCode": 21340,
    "postalCodeMin": 21340,
    "postalCodeMax": 21349,
    "lat": 60.6864,
    "lng": 22.4415,
    "radiusKm": 3.9
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Uusikaupunki",
    "area": "Lokalahti",
    "postalCode": 23450,
    "postalCodeMin": 23450,
    "postalCodeMax": 23459,
    "lat": 60.6809,
    "lng": 21.4646,
    "radiusKm": 3.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Uusikaupunki",
    "area": "Uusikaupunki",
    "postalCode": 23500,
    "postalCodeMin": 23500,
    "postalCodeMax": 23509,
    "lat": 60.8076,
    "lng": 21.4027,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Uusikaupunki",
    "area": "Kalanti",
    "postalCode": 23600,
    "postalCodeMin": 23600,
    "postalCodeMax": 23609,
    "lat": 60.8192,
    "lng": 21.5601,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Uusikaupunki",
    "area": "Kalanti as",
    "postalCode": 23660,
    "postalCodeMin": 23660,
    "postalCodeMax": 23669,
    "lat": 60.8192,
    "lng": 21.5601,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Uusikaupunki",
    "area": "Pyhämaa",
    "postalCode": 23930,
    "postalCodeMin": 23930,
    "postalCodeMax": 23939,
    "lat": 60.9502,
    "lng": 21.369,
    "radiusKm": 4.8
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Vehmaa",
    "area": "Vinkkilä",
    "postalCode": 23200,
    "postalCodeMin": 23200,
    "postalCodeMax": 23209,
    "lat": 60.6858,
    "lng": 21.7134,
    "radiusKm": 2.2
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Vehmaa",
    "area": "Vehmaa",
    "postalCode": 23210,
    "postalCodeMin": 23210,
    "postalCodeMax": 23219,
    "lat": 60.6588,
    "lng": 21.6539,
    "radiusKm": 4.8
  },
  {
    "region": "Varsinais-Suomi",
    "city": "Vehmaa",
    "area": "Rautila",
    "postalCode": 23260,
    "postalCodeMin": 23260,
    "postalCodeMax": 23269,
    "lat": 60.6148,
    "lng": 21.7105,
    "radiusKm": 2.2
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Kiukainen",
    "postalCode": 27400,
    "postalCodeMin": 27400,
    "postalCodeMax": 27409,
    "lat": 61.2072,
    "lng": 22.0837,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Panelia as",
    "postalCode": 27420,
    "postalCodeMin": 27420,
    "postalCodeMax": 27429,
    "lat": 61.2013,
    "lng": 21.9762,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Panelia",
    "postalCode": 27430,
    "postalCodeMin": 27430,
    "postalCodeMax": 27439,
    "lat": 61.2484,
    "lng": 21.9333,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Harola",
    "postalCode": 27450,
    "postalCodeMin": 27450,
    "postalCodeMax": 27459,
    "lat": 61.2372,
    "lng": 22.1098,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Kauttua",
    "postalCode": 27500,
    "postalCodeMin": 27500,
    "postalCodeMax": 27509,
    "lat": 61.1156,
    "lng": 22.1605,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Eura",
    "postalCode": 27510,
    "postalCodeMin": 27510,
    "postalCodeMax": 27519,
    "lat": 61.1296,
    "lng": 22.131,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Hinnerjoki",
    "postalCode": 27600,
    "postalCodeMin": 27600,
    "postalCodeMax": 27609,
    "lat": 60.9999,
    "lng": 21.9838,
    "radiusKm": 4.2
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Honkilahti kk",
    "postalCode": 27640,
    "postalCodeMin": 27640,
    "postalCodeMax": 27649,
    "lat": 60.9679,
    "lng": 22.1064,
    "radiusKm": 3.5
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Honkilahti",
    "postalCode": 27650,
    "postalCodeMin": 27650,
    "postalCodeMax": 27659,
    "lat": 60.9554,
    "lng": 22.2097,
    "radiusKm": 3.5
  },
  {
    "region": "Satakunta",
    "city": "Eura",
    "area": "Mannila",
    "postalCode": 27670,
    "postalCodeMin": 27670,
    "postalCodeMax": 27679,
    "lat": 61.0172,
    "lng": 22.1662,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eurajoki",
    "area": "Eurajoki",
    "postalCode": 27100,
    "postalCodeMin": 27100,
    "postalCodeMax": 27109,
    "lat": 61.2024,
    "lng": 21.734,
    "radiusKm": 4.2
  },
  {
    "region": "Satakunta",
    "city": "Eurajoki",
    "area": "Irjanne",
    "postalCode": 27110,
    "postalCodeMin": 27110,
    "postalCodeMax": 27119,
    "lat": 61.242,
    "lng": 21.7813,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eurajoki",
    "area": "Eurajoki as",
    "postalCode": 27130,
    "postalCodeMin": 27130,
    "postalCodeMax": 27139,
    "lat": 61.185,
    "lng": 21.8728,
    "radiusKm": 4.2
  },
  {
    "region": "Satakunta",
    "city": "Eurajoki",
    "area": "Lapijoki",
    "postalCode": 27150,
    "postalCodeMin": 27150,
    "postalCodeMax": 27159,
    "lat": 61.181,
    "lng": 21.6656,
    "radiusKm": 4.2
  },
  {
    "region": "Satakunta",
    "city": "Eurajoki",
    "area": "Olkiluoto",
    "postalCode": 27160,
    "postalCodeMin": 27160,
    "postalCodeMax": 27169,
    "lat": 61.2397,
    "lng": 21.4553,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eurajoki",
    "area": "Kuivalahti",
    "postalCode": 27170,
    "postalCodeMin": 27170,
    "postalCodeMax": 27179,
    "lat": 61.2727,
    "lng": 21.5895,
    "radiusKm": 3.5
  },
  {
    "region": "Satakunta",
    "city": "Eurajoki",
    "area": "Luvia",
    "postalCode": 29100,
    "postalCodeMin": 29100,
    "postalCodeMax": 29109,
    "lat": 61.3605,
    "lng": 21.626,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Eurajoki",
    "area": "Peränkylä",
    "postalCode": 29180,
    "postalCodeMin": 29180,
    "postalCodeMax": 29189,
    "lat": 61.3214,
    "lng": 21.6637,
    "radiusKm": 3.5
  },
  {
    "region": "Satakunta",
    "city": "Harjavalta",
    "area": "Harjavalta",
    "postalCode": 29200,
    "postalCodeMin": 29200,
    "postalCodeMax": 29209,
    "lat": 61.3137,
    "lng": 22.1413,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Huittinen",
    "area": "Vampula",
    "postalCode": 32610,
    "postalCodeMin": 32610,
    "postalCodeMax": 32619,
    "lat": 61.022,
    "lng": 22.7039,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Huittinen",
    "area": "Rutava",
    "postalCode": 32620,
    "postalCodeMin": 32620,
    "postalCodeMax": 32629,
    "lat": 61.0614,
    "lng": 22.6811,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Huittinen",
    "area": "Lauttakylä",
    "postalCode": 32700,
    "postalCodeMin": 32700,
    "postalCodeMax": 32709,
    "lat": 61.176,
    "lng": 22.6982,
    "radiusKm": 3.5
  },
  {
    "region": "Satakunta",
    "city": "Huittinen",
    "area": "Sampu",
    "postalCode": 32710,
    "postalCodeMin": 32710,
    "postalCodeMax": 32719,
    "lat": 61.2015,
    "lng": 22.7014,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Huittinen",
    "area": "Suttila",
    "postalCode": 32760,
    "postalCodeMin": 32760,
    "postalCodeMax": 32769,
    "lat": 61.1368,
    "lng": 22.9241,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Huittinen",
    "area": "Huhtamo",
    "postalCode": 32770,
    "postalCodeMin": 32770,
    "postalCodeMax": 32779,
    "lat": 61.0849,
    "lng": 22.9156,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Jämijärvi",
    "area": "Jämijärvi",
    "postalCode": 38800,
    "postalCodeMin": 38800,
    "postalCodeMax": 38809,
    "lat": 61.8198,
    "lng": 22.6917,
    "radiusKm": 4.7
  },
  {
    "region": "Satakunta",
    "city": "Jämijärvi",
    "area": "Suurimaa",
    "postalCode": 38860,
    "postalCodeMin": 38860,
    "postalCodeMax": 38869,
    "lat": 61.8953,
    "lng": 22.6002,
    "radiusKm": 5.1
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Kankaanpää",
    "postalCode": 38700,
    "postalCodeMin": 38700,
    "postalCodeMax": 38709,
    "lat": 61.8127,
    "lng": 22.3752,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Myllymäki",
    "postalCode": 38710,
    "postalCodeMin": 38710,
    "postalCodeMax": 38719,
    "lat": 61.8097,
    "lng": 22.3701,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Vihteljärvi",
    "postalCode": 38720,
    "postalCodeMin": 38720,
    "postalCodeMax": 38729,
    "lat": 61.7525,
    "lng": 22.504,
    "radiusKm": 4.7
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Hapuoja",
    "postalCode": 38740,
    "postalCodeMin": 38740,
    "postalCodeMax": 38749,
    "lat": 61.7976,
    "lng": 22.3246,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Veneskoski",
    "postalCode": 38750,
    "postalCodeMin": 38750,
    "postalCodeMax": 38759,
    "lat": 61.7815,
    "lng": 22.2222,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Venesjärvi",
    "postalCode": 38760,
    "postalCodeMin": 38760,
    "postalCodeMax": 38769,
    "lat": 61.8252,
    "lng": 22.1728,
    "radiusKm": 4.7
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Lohikko",
    "postalCode": 38770,
    "postalCodeMin": 38770,
    "postalCodeMax": 38779,
    "lat": 61.8325,
    "lng": 22.3541,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Niinisalo",
    "postalCode": 38840,
    "postalCodeMin": 38840,
    "postalCodeMax": 38849,
    "lat": 61.8453,
    "lng": 22.4819,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Ala-Honkajoki",
    "postalCode": 38910,
    "postalCodeMin": 38910,
    "postalCodeMax": 38919,
    "lat": 61.8815,
    "lng": 22.2952,
    "radiusKm": 4.2
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Vatajankoski",
    "postalCode": 38920,
    "postalCodeMin": 38920,
    "postalCodeMax": 38929,
    "lat": 61.8126,
    "lng": 22.3737,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Honkajoki",
    "postalCode": 38950,
    "postalCodeMin": 38950,
    "postalCodeMax": 38959,
    "lat": 61.9932,
    "lng": 22.2637,
    "radiusKm": 4.2
  },
  {
    "region": "Satakunta",
    "city": "Kankaanpää",
    "area": "Lauhala",
    "postalCode": 38970,
    "postalCodeMin": 38970,
    "postalCodeMax": 38979,
    "lat": 62.0907,
    "lng": 22.246,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Karvia",
    "area": "Suomijärvi",
    "postalCode": 39920,
    "postalCodeMin": 39920,
    "postalCodeMax": 39929,
    "lat": 62.1053,
    "lng": 22.6922,
    "radiusKm": 4.7
  },
  {
    "region": "Satakunta",
    "city": "Karvia",
    "area": "Karvia",
    "postalCode": 39930,
    "postalCodeMin": 39930,
    "postalCodeMax": 39939,
    "lat": 62.1332,
    "lng": 22.5581,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Karvia",
    "area": "Kantti",
    "postalCode": 39940,
    "postalCodeMin": 39940,
    "postalCodeMax": 39949,
    "lat": 62.0836,
    "lng": 22.5218,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Karvia",
    "area": "Sarvela",
    "postalCode": 39960,
    "postalCodeMin": 39960,
    "postalCodeMax": 39969,
    "lat": 62.1709,
    "lng": 22.5918,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Karvia",
    "area": "Karviankylä",
    "postalCode": 39965,
    "postalCodeMin": 39960,
    "postalCodeMax": 39969,
    "lat": 62.2196,
    "lng": 22.6773,
    "radiusKm": 3.5
  },
  {
    "region": "Satakunta",
    "city": "Karvia",
    "area": "Sara",
    "postalCode": 39980,
    "postalCodeMin": 39980,
    "postalCodeMax": 39989,
    "lat": 62.2508,
    "lng": 22.6089,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Karvia",
    "area": "Alkkia",
    "postalCode": 39990,
    "postalCodeMin": 39990,
    "postalCodeMax": 39999,
    "lat": 62.1906,
    "lng": 22.7558,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kokemäki",
    "area": "Kokemäki",
    "postalCode": 32800,
    "postalCodeMin": 32800,
    "postalCodeMax": 32809,
    "lat": 61.2583,
    "lng": 22.3539,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kokemäki",
    "area": "Peipohja",
    "postalCode": 32810,
    "postalCodeMin": 32810,
    "postalCodeMax": 32819,
    "lat": 61.2576,
    "lng": 22.3083,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kokemäki",
    "area": "Riste",
    "postalCode": 32830,
    "postalCodeMin": 32830,
    "postalCodeMax": 32839,
    "lat": 61.2666,
    "lng": 22.4086,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kokemäki",
    "area": "Korkeaoja",
    "postalCode": 32860,
    "postalCodeMin": 32860,
    "postalCodeMax": 32869,
    "lat": 61.3837,
    "lng": 22.278,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Kokemäki",
    "area": "Kauvatsa as",
    "postalCode": 32910,
    "postalCodeMin": 32910,
    "postalCodeMax": 32919,
    "lat": 61.3115,
    "lng": 22.541,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Kokemäki",
    "area": "Kauvatsa",
    "postalCode": 32920,
    "postalCodeMin": 32920,
    "postalCodeMax": 32929,
    "lat": 61.3375,
    "lng": 22.5022,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Merikarvia",
    "area": "Etelämaa",
    "postalCode": 29740,
    "postalCodeMin": 29740,
    "postalCodeMax": 29749,
    "lat": 61.7816,
    "lng": 21.6771,
    "radiusKm": 5.1
  },
  {
    "region": "Satakunta",
    "city": "Merikarvia",
    "area": "Pohjansaha",
    "postalCode": 29750,
    "postalCodeMin": 29750,
    "postalCodeMax": 29759,
    "lat": 61.7464,
    "lng": 21.5659,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Merikarvia",
    "area": "Köörtilä",
    "postalCode": 29760,
    "postalCodeMin": 29760,
    "postalCodeMax": 29769,
    "lat": 61.7751,
    "lng": 21.5341,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Merikarvia",
    "area": "Tuorila",
    "postalCode": 29790,
    "postalCodeMin": 29790,
    "postalCodeMax": 29799,
    "lat": 61.8709,
    "lng": 21.6343,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Merikarvia",
    "area": "Merikarvia",
    "postalCode": 29900,
    "postalCodeMin": 29900,
    "postalCodeMax": 29909,
    "lat": 61.8583,
    "lng": 21.5004,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Merikarvia",
    "area": "Kuvaskangas",
    "postalCode": 29940,
    "postalCodeMin": 29940,
    "postalCodeMax": 29949,
    "lat": 61.9445,
    "lng": 21.6227,
    "radiusKm": 4.7
  },
  {
    "region": "Satakunta",
    "city": "Nakkila",
    "area": "Nakkila",
    "postalCode": 29250,
    "postalCodeMin": 29250,
    "postalCodeMax": 29259,
    "lat": 61.3648,
    "lng": 22.0054,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Nakkila",
    "area": "Hormisto",
    "postalCode": 29270,
    "postalCodeMin": 29270,
    "postalCodeMax": 29279,
    "lat": 61.3255,
    "lng": 21.9136,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Nakkila",
    "area": "Järvimaa",
    "postalCode": 29280,
    "postalCodeMin": 29280,
    "postalCodeMax": 29289,
    "lat": 61.367,
    "lng": 21.8132,
    "radiusKm": 4.7
  },
  {
    "region": "Satakunta",
    "city": "Pomarkku",
    "area": "Pomarkku",
    "postalCode": 29630,
    "postalCodeMin": 29630,
    "postalCodeMax": 29639,
    "lat": 61.6935,
    "lng": 22.0085,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Pomarkku",
    "area": "Honkakoski",
    "postalCode": 29640,
    "postalCodeMin": 29640,
    "postalCodeMax": 29649,
    "lat": 61.7616,
    "lng": 22.1302,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Pomarkku",
    "area": "Tuunajärvi",
    "postalCode": 38680,
    "postalCodeMin": 38680,
    "postalCodeMax": 38689,
    "lat": 61.7272,
    "lng": 22.2635,
    "radiusKm": 4.7
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Keskusta",
    "postalCode": 28100,
    "postalCodeMin": 28100,
    "postalCodeMax": 28109,
    "lat": 61.4898,
    "lng": 21.7957,
    "radiusKm": 1.5
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Käppärä",
    "postalCode": 28120,
    "postalCodeMin": 28120,
    "postalCodeMax": 28129,
    "lat": 61.4846,
    "lng": 21.7625,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Uusikoivisto, Impola, Mikkola",
    "postalCode": 28130,
    "postalCodeMin": 28130,
    "postalCodeMax": 28139,
    "lat": 61.4721,
    "lng": 21.8134,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Pormestarinluoto, Lyttylä",
    "postalCode": 28190,
    "postalCodeMin": 28190,
    "postalCodeMax": 28199,
    "lat": 61.5878,
    "lng": 21.6678,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Toejoki, Hyvelä",
    "postalCode": 28200,
    "postalCodeMin": 28200,
    "postalCodeMax": 28209,
    "lat": 61.5278,
    "lng": 21.8144,
    "radiusKm": 5.5
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Ruosniemi",
    "postalCode": 28220,
    "postalCodeMin": 28220,
    "postalCodeMax": 28229,
    "lat": 61.5082,
    "lng": 21.8541,
    "radiusKm": 5.5
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Isojoenranta",
    "postalCode": 28240,
    "postalCodeMin": 28240,
    "postalCodeMax": 28249,
    "lat": 61.4935,
    "lng": 21.8497,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Kalaholma, Lukkarinsanta, Väinölä",
    "postalCode": 28300,
    "postalCodeMin": 28300,
    "postalCodeMax": 28309,
    "lat": 61.4842,
    "lng": 21.8581,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Koivistonluoto",
    "postalCode": 28330,
    "postalCodeMin": 28330,
    "postalCodeMax": 28339,
    "lat": 61.4676,
    "lng": 21.8703,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Vanhakoivisto",
    "postalCode": 28360,
    "postalCodeMin": 28360,
    "postalCodeMax": 28369,
    "lat": 61.4777,
    "lng": 21.831,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Sampola",
    "postalCode": 28370,
    "postalCodeMin": 28370,
    "postalCodeMax": 28379,
    "lat": 61.4649,
    "lng": 21.8449,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Kartano, Harmaalinna",
    "postalCode": 28430,
    "postalCodeMin": 28430,
    "postalCodeMax": 28439,
    "lat": 61.4471,
    "lng": 21.8508,
    "radiusKm": 6.7
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Keskussairaala-alue, Tiilimäki, Lentoasema",
    "postalCode": 28500,
    "postalCodeMin": 28500,
    "postalCodeMax": 28509,
    "lat": 61.473,
    "lng": 21.7802,
    "radiusKm": 1.8
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Liikastenmäki, Pinomäki",
    "postalCode": 28540,
    "postalCodeMin": 28540,
    "postalCodeMax": 28549,
    "lat": 61.4604,
    "lng": 21.7498,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Lattomeri",
    "postalCode": 28560,
    "postalCodeMin": 28560,
    "postalCodeMax": 28569,
    "lat": 61.4051,
    "lng": 21.7806,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Niittumaa",
    "postalCode": 28580,
    "postalCodeMin": 28580,
    "postalCodeMax": 28589,
    "lat": 61.425,
    "lng": 21.7267,
    "radiusKm": 6.7
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Vähärauma, Ulasoori, Tuorsniemi",
    "postalCode": 28600,
    "postalCodeMin": 28600,
    "postalCodeMax": 28609,
    "lat": 61.5103,
    "lng": 21.7108,
    "radiusKm": 5.5
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Musa",
    "postalCode": 28610,
    "postalCodeMin": 28610,
    "postalCodeMax": 28619,
    "lat": 61.4815,
    "lng": 21.7415,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Pietniemi, Leppäkorpi, Paarnoori, Preiviiki",
    "postalCode": 28660,
    "postalCodeMin": 28660,
    "postalCodeMax": 28669,
    "lat": 61.4879,
    "lng": 21.6999,
    "radiusKm": 5.5
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Kyläsaari",
    "postalCode": 28760,
    "postalCodeMin": 28760,
    "postalCodeMax": 28769,
    "lat": 61.536,
    "lng": 21.6716,
    "radiusKm": 4.6
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Pihlava",
    "postalCode": 28800,
    "postalCodeMin": 28800,
    "postalCodeMax": 28809,
    "lat": 61.5594,
    "lng": 21.6121,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Kaanaa, Yyteri",
    "postalCode": 28840,
    "postalCodeMin": 28840,
    "postalCodeMax": 28849,
    "lat": 61.5694,
    "lng": 21.5286,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Mäntyluoto",
    "postalCode": 28880,
    "postalCodeMin": 28880,
    "postalCodeMax": 28889,
    "lat": 61.5919,
    "lng": 21.4823,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Reposaari, Tahkoluoto, Lampaluoto",
    "postalCode": 28900,
    "postalCodeMin": 28900,
    "postalCodeMax": 28909,
    "lat": 61.612,
    "lng": 21.4478,
    "radiusKm": 6.1
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Söörmarkku",
    "postalCode": 29570,
    "postalCodeMin": 29570,
    "postalCodeMax": 29579,
    "lat": 61.5668,
    "lng": 21.8153,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Noormarkku",
    "postalCode": 29600,
    "postalCodeMin": 29600,
    "postalCodeMax": 29609,
    "lat": 61.5927,
    "lng": 21.8684,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Lassila",
    "postalCode": 29680,
    "postalCodeMin": 29680,
    "postalCodeMax": 29689,
    "lat": 61.6173,
    "lng": 22.2312,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Ahlainen",
    "postalCode": 29700,
    "postalCodeMin": 29700,
    "postalCodeMax": 29709,
    "lat": 61.675,
    "lng": 21.6206,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Lamppi",
    "postalCode": 29720,
    "postalCodeMin": 29720,
    "postalCodeMax": 29729,
    "lat": 61.6536,
    "lng": 21.7467,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Lavia",
    "postalCode": 38600,
    "postalCodeMin": 38600,
    "postalCodeMax": 38609,
    "lat": 61.5966,
    "lng": 22.5857,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Yli-Putto",
    "postalCode": 38650,
    "postalCodeMin": 38650,
    "postalCodeMax": 38659,
    "lat": 61.6781,
    "lng": 22.445,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Pori",
    "area": "Kalliala",
    "postalCode": 38670,
    "postalCodeMin": 38670,
    "postalCodeMax": 38679,
    "lat": 61.5936,
    "lng": 22.4022,
    "radiusKm": 3.0
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Rauma",
    "postalCode": 26100,
    "postalCodeMin": 26100,
    "postalCodeMax": 26109,
    "lat": 61.1261,
    "lng": 21.4937,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Merirauma, Kappelinluhta",
    "postalCode": 26200,
    "postalCodeMin": 26200,
    "postalCodeMax": 26209,
    "lat": 61.1494,
    "lng": 21.5019,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Kaaro",
    "postalCode": 26410,
    "postalCodeMin": 26410,
    "postalCodeMax": 26419,
    "lat": 61.1665,
    "lng": 21.5357,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Uotila",
    "postalCode": 26510,
    "postalCodeMin": 26510,
    "postalCodeMax": 26519,
    "lat": 61.1314,
    "lng": 21.571,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Kolla",
    "postalCode": 26560,
    "postalCodeMin": 26560,
    "postalCodeMax": 26569,
    "lat": 61.1169,
    "lng": 21.6394,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Paroalho",
    "postalCode": 26660,
    "postalCodeMin": 26660,
    "postalCodeMax": 26669,
    "lat": 61.1163,
    "lng": 21.5237,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Monnanummi",
    "postalCode": 26720,
    "postalCodeMin": 26720,
    "postalCodeMax": 26729,
    "lat": 61.0942,
    "lng": 21.5474,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Vasarainen",
    "postalCode": 26740,
    "postalCodeMin": 26740,
    "postalCodeMax": 26749,
    "lat": 61.088,
    "lng": 21.5987,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Sampaanala",
    "postalCode": 26820,
    "postalCodeMin": 26820,
    "postalCodeMax": 26829,
    "lat": 61.1077,
    "lng": 21.494,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Kortela",
    "postalCode": 26840,
    "postalCodeMin": 26840,
    "postalCodeMax": 26849,
    "lat": 61.0959,
    "lng": 21.5017,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Unaja",
    "postalCode": 26910,
    "postalCodeMin": 26910,
    "postalCodeMax": 26919,
    "lat": 61.0721,
    "lng": 21.5164,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Vermuntila",
    "postalCode": 26930,
    "postalCodeMin": 26930,
    "postalCodeMax": 26939,
    "lat": 61.0311,
    "lng": 21.5538,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Voiluoto",
    "postalCode": 26950,
    "postalCodeMin": 26950,
    "postalCodeMax": 26959,
    "lat": 61.0617,
    "lng": 21.4638,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Ala-Kieri",
    "postalCode": 27220,
    "postalCodeMin": 27220,
    "postalCodeMax": 27229,
    "lat": 61.0985,
    "lng": 21.7868,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Lappi",
    "postalCode": 27230,
    "postalCodeMin": 27230,
    "postalCodeMax": 27239,
    "lat": 61.103,
    "lng": 21.844,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Kodiksami",
    "postalCode": 27250,
    "postalCodeMin": 27250,
    "postalCodeMax": 27259,
    "lat": 61.0506,
    "lng": 21.9579,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Kuolimaa",
    "postalCode": 27260,
    "postalCodeMin": 27260,
    "postalCodeMax": 27269,
    "lat": 61.0287,
    "lng": 21.9475,
    "radiusKm": 5.1
  },
  {
    "region": "Satakunta",
    "city": "Rauma",
    "area": "Kodisjoki",
    "postalCode": 27310,
    "postalCodeMin": 27310,
    "postalCodeMax": 27319,
    "lat": 61.0261,
    "lng": 21.6885,
    "radiusKm": 4.2
  },
  {
    "region": "Satakunta",
    "city": "Siikainen",
    "area": "Siikainen",
    "postalCode": 29810,
    "postalCodeMin": 29810,
    "postalCodeMax": 29819,
    "lat": 61.8767,
    "lng": 21.8216,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Siikainen",
    "area": "Sammi",
    "postalCode": 29830,
    "postalCodeMin": 29830,
    "postalCodeMax": 29839,
    "lat": 61.903,
    "lng": 22.0421,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Siikainen",
    "area": "Otamo",
    "postalCode": 29860,
    "postalCodeMin": 29860,
    "postalCodeMax": 29869,
    "lat": 61.8283,
    "lng": 21.7689,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Siikainen",
    "area": "Leväsjoki",
    "postalCode": 29880,
    "postalCodeMin": 29880,
    "postalCodeMax": 29889,
    "lat": 61.7904,
    "lng": 21.8663,
    "radiusKm": 4.2
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Köyliö",
    "postalCode": 27710,
    "postalCodeMin": 27710,
    "postalCodeMax": 27719,
    "lat": 61.1187,
    "lng": 22.3073,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Tuiskula",
    "postalCode": 27730,
    "postalCodeMin": 27730,
    "postalCodeMax": 27739,
    "lat": 61.1754,
    "lng": 22.2299,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Voitoinen",
    "postalCode": 27740,
    "postalCodeMin": 27740,
    "postalCodeMax": 27749,
    "lat": 61.2186,
    "lng": 22.2001,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Yttilä",
    "postalCode": 27750,
    "postalCodeMin": 27750,
    "postalCodeMax": 27759,
    "lat": 61.1117,
    "lng": 22.3795,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Säkylä",
    "postalCode": 27800,
    "postalCodeMin": 27800,
    "postalCodeMax": 27809,
    "lat": 61.0543,
    "lng": 22.3353,
    "radiusKm": 3.5
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Iso-Vimma",
    "postalCode": 27820,
    "postalCodeMin": 27820,
    "postalCodeMax": 27829,
    "lat": 61.0751,
    "lng": 22.2503,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Kakkuri",
    "postalCode": 27840,
    "postalCodeMin": 27840,
    "postalCodeMax": 27849,
    "lat": 61.0748,
    "lng": 22.4066,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Vuori",
    "postalCode": 27860,
    "postalCodeMin": 27860,
    "postalCodeMax": 27869,
    "lat": 61.0678,
    "lng": 22.5515,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Huovinrinne",
    "postalCode": 27910,
    "postalCodeMin": 27910,
    "postalCodeMax": 27919,
    "lat": 61.0381,
    "lng": 22.4167,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Säkylä",
    "area": "Otajoki",
    "postalCode": 27920,
    "postalCodeMin": 27920,
    "postalCodeMax": 27929,
    "lat": 60.9907,
    "lng": 22.3598,
    "radiusKm": 4.2
  },
  {
    "region": "Satakunta",
    "city": "Ulvila",
    "area": "Harjunpää",
    "postalCode": 28260,
    "postalCodeMin": 28260,
    "postalCodeMax": 28269,
    "lat": 61.4979,
    "lng": 21.9102,
    "radiusKm": 2.1
  },
  {
    "region": "Satakunta",
    "city": "Ulvila",
    "area": "Ulvila",
    "postalCode": 28400,
    "postalCodeMin": 28400,
    "postalCodeMax": 28409,
    "lat": 61.4302,
    "lng": 21.875,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Ulvila",
    "area": "Vanha-Ulvila",
    "postalCode": 28450,
    "postalCodeMin": 28450,
    "postalCodeMax": 28459,
    "lat": 61.4347,
    "lng": 21.8969,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Ulvila",
    "area": "Kaasmarkku",
    "postalCode": 29310,
    "postalCodeMin": 29310,
    "postalCodeMax": 29319,
    "lat": 61.4302,
    "lng": 21.875,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Ulvila",
    "area": "Leineperi",
    "postalCode": 29320,
    "postalCodeMin": 29320,
    "postalCodeMax": 29329,
    "lat": 61.443,
    "lng": 22.0961,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Ulvila",
    "area": "Kullaa",
    "postalCode": 29340,
    "postalCodeMin": 29340,
    "postalCodeMax": 29349,
    "lat": 61.468,
    "lng": 22.1581,
    "radiusKm": 2.3
  },
  {
    "region": "Satakunta",
    "city": "Ulvila",
    "area": "Palus",
    "postalCode": 29350,
    "postalCodeMin": 29350,
    "postalCodeMax": 29359,
    "lat": 61.5056,
    "lng": 22.077,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Akaa",
    "area": "Toijala",
    "postalCode": 37800,
    "postalCodeMin": 37800,
    "postalCodeMax": 37809,
    "lat": 61.1677,
    "lng": 23.8673,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Akaa",
    "area": "Viiala",
    "postalCode": 37830,
    "postalCodeMin": 37830,
    "postalCodeMax": 37839,
    "lat": 61.2106,
    "lng": 23.7672,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Akaa",
    "area": "Kylmäkoski as",
    "postalCode": 37900,
    "postalCodeMin": 37900,
    "postalCodeMax": 37909,
    "lat": 61.1072,
    "lng": 23.6784,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Akaa",
    "area": "Kylmäkoski",
    "postalCode": 37910,
    "postalCodeMin": 37910,
    "postalCodeMax": 37919,
    "lat": 61.1505,
    "lng": 23.6901,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Akaa",
    "area": "Sotkia",
    "postalCode": 37960,
    "postalCodeMin": 37960,
    "postalCodeMax": 37969,
    "lat": 61.1377,
    "lng": 23.8073,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Haukijärvi",
    "postalCode": 38490,
    "postalCodeMin": 38490,
    "postalCodeMax": 38499,
    "lat": 61.5623,
    "lng": 23.087,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Hämeenkyrö",
    "postalCode": 39100,
    "postalCodeMin": 39100,
    "postalCodeMax": 39109,
    "lat": 61.6381,
    "lng": 23.1965,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Simuna",
    "postalCode": 39110,
    "postalCodeMin": 39110,
    "postalCodeMax": 39119,
    "lat": 61.6381,
    "lng": 23.1965,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Sasi",
    "postalCode": 39130,
    "postalCodeMin": 39130,
    "postalCodeMax": 39139,
    "lat": 61.5875,
    "lng": 23.3537,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Jumesniemi",
    "postalCode": 39170,
    "postalCodeMin": 39170,
    "postalCodeMax": 39179,
    "lat": 61.5366,
    "lng": 23.265,
    "radiusKm": 4.2
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Herttuala",
    "postalCode": 39180,
    "postalCodeMin": 39180,
    "postalCodeMax": 39189,
    "lat": 61.5957,
    "lng": 23.1514,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Kaipio",
    "postalCode": 39195,
    "postalCodeMin": 39190,
    "postalCodeMax": 39199,
    "lat": 61.6381,
    "lng": 23.1965,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Kyröskoski",
    "postalCode": 39200,
    "postalCodeMin": 39200,
    "postalCodeMax": 39209,
    "lat": 61.6381,
    "lng": 23.1965,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Osara",
    "postalCode": 39230,
    "postalCodeMin": 39230,
    "postalCodeMax": 39239,
    "lat": 61.7081,
    "lng": 23.1711,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Vesajärvi",
    "postalCode": 39290,
    "postalCodeMin": 39290,
    "postalCodeMax": 39299,
    "lat": 61.6445,
    "lng": 22.8874,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Komi",
    "postalCode": 39360,
    "postalCodeMin": 39360,
    "postalCodeMax": 39369,
    "lat": 61.6677,
    "lng": 23.4022,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Hämeenkyrö",
    "area": "Lavajärvi",
    "postalCode": 39380,
    "postalCodeMin": 39380,
    "postalCodeMax": 39389,
    "lat": 61.6591,
    "lng": 23.4455,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Ikaalinen",
    "area": "Luhalahti",
    "postalCode": 39410,
    "postalCodeMin": 39410,
    "postalCodeMax": 39419,
    "lat": 61.7749,
    "lng": 23.2766,
    "radiusKm": 3.5
  },
  {
    "region": "Pirkanmaa",
    "city": "Ikaalinen",
    "area": "Röyhiö",
    "postalCode": 39430,
    "postalCodeMin": 39430,
    "postalCodeMax": 39439,
    "lat": 61.8075,
    "lng": 23.1585,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ikaalinen",
    "area": "Sisättö",
    "postalCode": 39450,
    "postalCodeMin": 39450,
    "postalCodeMax": 39459,
    "lat": 61.8345,
    "lng": 23.3377,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ikaalinen",
    "area": "Ikaalinen",
    "postalCode": 39500,
    "postalCodeMin": 39500,
    "postalCodeMax": 39509,
    "lat": 61.7683,
    "lng": 23.0747,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ikaalinen",
    "area": "Kilvakkala",
    "postalCode": 39530,
    "postalCodeMin": 39530,
    "postalCodeMax": 39539,
    "lat": 61.7602,
    "lng": 23.0095,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ikaalinen",
    "area": "Riitiala",
    "postalCode": 39580,
    "postalCodeMin": 39580,
    "postalCodeMax": 39589,
    "lat": 61.8697,
    "lng": 22.9771,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ikaalinen",
    "area": "Tevaniemi",
    "postalCode": 39590,
    "postalCodeMin": 39590,
    "postalCodeMax": 39599,
    "lat": 61.8496,
    "lng": 23.0501,
    "radiusKm": 4.2
  },
  {
    "region": "Pirkanmaa",
    "city": "Ikaalinen",
    "area": "Kovelahti",
    "postalCode": 39610,
    "postalCodeMin": 39610,
    "postalCodeMax": 39619,
    "lat": 61.9081,
    "lng": 22.8388,
    "radiusKm": 3.5
  },
  {
    "region": "Pirkanmaa",
    "city": "Juupajoki",
    "area": "Korkeakoski",
    "postalCode": 35500,
    "postalCodeMin": 35500,
    "postalCodeMax": 35509,
    "lat": 61.8068,
    "lng": 24.3594,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Juupajoki",
    "area": "Pirttikangas",
    "postalCode": 35520,
    "postalCodeMin": 35520,
    "postalCodeMax": 35529,
    "lat": 61.8579,
    "lng": 24.4647,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Juupajoki",
    "area": "Lyly",
    "postalCode": 35530,
    "postalCodeMin": 35530,
    "postalCodeMax": 35539,
    "lat": 61.8863,
    "lng": 24.4784,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Juupajoki",
    "area": "Juupajoki",
    "postalCode": 35540,
    "postalCodeMin": 35540,
    "postalCodeMax": 35549,
    "lat": 61.7928,
    "lng": 24.5525,
    "radiusKm": 4.2
  },
  {
    "region": "Pirkanmaa",
    "city": "Juupajoki",
    "area": "Salokunta",
    "postalCode": 35550,
    "postalCodeMin": 35550,
    "postalCodeMax": 35559,
    "lat": 61.7623,
    "lng": 24.4584,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Kangasala as",
    "postalCode": 36100,
    "postalCodeMin": 36100,
    "postalCodeMax": 36109,
    "lat": 61.4963,
    "lng": 23.9759,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Ruutana",
    "postalCode": 36110,
    "postalCodeMin": 36110,
    "postalCodeMax": 36119,
    "lat": 61.527,
    "lng": 24.018,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Suinula",
    "postalCode": 36120,
    "postalCodeMin": 36120,
    "postalCodeMax": 36129,
    "lat": 61.5423,
    "lng": 24.0564,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Kangasala",
    "postalCode": 36200,
    "postalCodeMin": 36200,
    "postalCodeMax": 36209,
    "lat": 61.4637,
    "lng": 24.0718,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Suorama",
    "postalCode": 36220,
    "postalCodeMin": 36220,
    "postalCodeMax": 36229,
    "lat": 61.4752,
    "lng": 24.0033,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Nattari",
    "postalCode": 36240,
    "postalCodeMin": 36240,
    "postalCodeMax": 36249,
    "lat": 61.4768,
    "lng": 23.9455,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Huutijärvi",
    "postalCode": 36270,
    "postalCodeMin": 36270,
    "postalCodeMax": 36279,
    "lat": 61.4523,
    "lng": 24.1168,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Pikonlinna",
    "postalCode": 36280,
    "postalCodeMin": 36280,
    "postalCodeMax": 36289,
    "lat": 61.4915,
    "lng": 24.0866,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Tohkala",
    "postalCode": 36340,
    "postalCodeMin": 36340,
    "postalCodeMax": 36349,
    "lat": 61.538,
    "lng": 24.2689,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Sahalahti",
    "postalCode": 36420,
    "postalCodeMin": 36420,
    "postalCodeMax": 36429,
    "lat": 61.4753,
    "lng": 24.3302,
    "radiusKm": 3.5
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Pakkala",
    "postalCode": 36430,
    "postalCodeMin": 36430,
    "postalCodeMax": 36439,
    "lat": 61.4521,
    "lng": 24.3897,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Raikku",
    "postalCode": 36520,
    "postalCodeMin": 36520,
    "postalCodeMax": 36529,
    "lat": 61.4079,
    "lng": 24.1731,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Kaivanto",
    "postalCode": 36570,
    "postalCodeMin": 36570,
    "postalCodeMax": 36579,
    "lat": 61.4264,
    "lng": 24.1362,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Kuhmalahti",
    "postalCode": 36810,
    "postalCodeMin": 36810,
    "postalCodeMax": 36819,
    "lat": 61.5052,
    "lng": 24.5616,
    "radiusKm": 3.5
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Pohja",
    "postalCode": 36840,
    "postalCodeMin": 36840,
    "postalCodeMax": 36849,
    "lat": 61.4817,
    "lng": 24.7039,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kangasala",
    "area": "Vehkajärvi",
    "postalCode": 36880,
    "postalCodeMin": 36880,
    "postalCodeMax": 36889,
    "lat": 61.4829,
    "lng": 24.8704,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Kihniö",
    "area": "Linnankylä",
    "postalCode": 39810,
    "postalCodeMin": 39810,
    "postalCodeMax": 39819,
    "lat": 62.1137,
    "lng": 23.0934,
    "radiusKm": 3.5
  },
  {
    "region": "Pirkanmaa",
    "city": "Kihniö",
    "area": "Kihniö",
    "postalCode": 39820,
    "postalCodeMin": 39820,
    "postalCodeMax": 39829,
    "lat": 62.203,
    "lng": 23.1763,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Kihniö",
    "area": "Kihniö as",
    "postalCode": 39880,
    "postalCodeMin": 39880,
    "postalCodeMax": 39889,
    "lat": 62.1467,
    "lng": 23.3074,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Lempäälä",
    "area": "Sääksjärvi",
    "postalCode": 33880,
    "postalCodeMin": 33880,
    "postalCodeMax": 33889,
    "lat": 61.416,
    "lng": 23.7587,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Lempäälä",
    "area": "Lempäälä",
    "postalCode": 37500,
    "postalCodeMin": 37500,
    "postalCodeMax": 37509,
    "lat": 61.3141,
    "lng": 23.7524,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Lempäälä",
    "area": "Säijä",
    "postalCode": 37530,
    "postalCodeMin": 37530,
    "postalCodeMax": 37539,
    "lat": 61.368,
    "lng": 23.5734,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Lempäälä",
    "area": "Moisio",
    "postalCode": 37550,
    "postalCodeMin": 37550,
    "postalCodeMax": 37559,
    "lat": 61.3463,
    "lng": 23.7576,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Lempäälä",
    "area": "Kulju",
    "postalCode": 37560,
    "postalCodeMin": 37560,
    "postalCodeMax": 37569,
    "lat": 61.3842,
    "lng": 23.7744,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Lempäälä",
    "area": "Ideapark",
    "postalCode": 37570,
    "postalCodeMin": 37570,
    "postalCodeMax": 37579,
    "lat": 61.3618,
    "lng": 23.795,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Mänttä-Vilppula",
    "area": "Vilppula",
    "postalCode": 35700,
    "postalCodeMin": 35700,
    "postalCodeMax": 35709,
    "lat": 62.0214,
    "lng": 24.5095,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Mänttä-Vilppula",
    "area": "Mänttä",
    "postalCode": 35800,
    "postalCodeMin": 35800,
    "postalCodeMax": 35809,
    "lat": 62.03,
    "lng": 24.6232,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Mänttä-Vilppula",
    "area": "Mänttä",
    "postalCode": 35820,
    "postalCodeMin": 35820,
    "postalCodeMax": 35829,
    "lat": 62.036,
    "lng": 24.5608,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Mänttä-Vilppula",
    "area": "Kolho",
    "postalCode": 35990,
    "postalCodeMin": 35990,
    "postalCodeMax": 35999,
    "lat": 62.1383,
    "lng": 24.5013,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Mänttä-Vilppula",
    "area": "Ylä-Kolkki",
    "postalCode": 42830,
    "postalCodeMin": 42830,
    "postalCodeMax": 42839,
    "lat": 62.2051,
    "lng": 24.2204,
    "radiusKm": 2.6
  },
  {
    "region": "Pirkanmaa",
    "city": "Mänttä-Vilppula",
    "area": "Kolkki",
    "postalCode": 42840,
    "postalCodeMin": 42840,
    "postalCodeMax": 42849,
    "lat": 62.1313,
    "lng": 24.2044,
    "radiusKm": 2.6
  },
  {
    "region": "Pirkanmaa",
    "city": "Mänttä-Vilppula",
    "area": "Pohjaslahti",
    "postalCode": 42850,
    "postalCodeMin": 42850,
    "postalCodeMax": 42859,
    "lat": 62.1564,
    "lng": 24.1312,
    "radiusKm": 3.9
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Pitkäniemi",
    "postalCode": 33380,
    "postalCodeMin": 33380,
    "postalCodeMax": 33389,
    "lat": 61.4804,
    "lng": 23.5787,
    "radiusKm": 4.2
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Nokia",
    "postalCode": 37100,
    "postalCodeMin": 37100,
    "postalCodeMax": 37109,
    "lat": 61.481,
    "lng": 23.4993,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Koskenmäki",
    "postalCode": 37120,
    "postalCodeMin": 37120,
    "postalCodeMax": 37129,
    "lat": 61.4691,
    "lng": 23.495,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Alhoniitty",
    "postalCode": 37130,
    "postalCodeMin": 37130,
    "postalCodeMax": 37139,
    "lat": 61.4849,
    "lng": 23.4842,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Harjuniitty",
    "postalCode": 37140,
    "postalCodeMin": 37140,
    "postalCodeMax": 37149,
    "lat": 61.4741,
    "lng": 23.4656,
    "radiusKm": 2.1
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Kankaantaka",
    "postalCode": 37150,
    "postalCodeMin": 37150,
    "postalCodeMax": 37159,
    "lat": 61.4887,
    "lng": 23.5299,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Sarkola",
    "postalCode": 37180,
    "postalCodeMin": 37180,
    "postalCodeMax": 37189,
    "lat": 61.4103,
    "lng": 23.2583,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Siuro",
    "postalCode": 37200,
    "postalCodeMin": 37200,
    "postalCodeMax": 37209,
    "lat": 61.4763,
    "lng": 23.3431,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Kulovesi",
    "postalCode": 37210,
    "postalCodeMin": 37210,
    "postalCodeMax": 37219,
    "lat": 61.4492,
    "lng": 23.1941,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Linnavuori",
    "postalCode": 37240,
    "postalCodeMin": 37240,
    "postalCodeMax": 37249,
    "lat": 61.4956,
    "lng": 23.3723,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Nokia (kaupunki)",
    "area": "Tottijärvi",
    "postalCode": 37310,
    "postalCodeMin": 37310,
    "postalCodeMax": 37319,
    "lat": 61.4006,
    "lng": 23.3428,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Orivesi",
    "area": "Orivesi as",
    "postalCode": 35100,
    "postalCodeMin": 35100,
    "postalCodeMax": 35109,
    "lat": 61.6774,
    "lng": 24.3574,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Orivesi",
    "area": "Eräjärvi",
    "postalCode": 35220,
    "postalCodeMin": 35220,
    "postalCodeMax": 35229,
    "lat": 61.5799,
    "lng": 24.5579,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Orivesi",
    "area": "Ristakallio",
    "postalCode": 35240,
    "postalCodeMin": 35240,
    "postalCodeMax": 35249,
    "lat": 61.5311,
    "lng": 24.7248,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Orivesi",
    "area": "Hoivamäki",
    "postalCode": 35260,
    "postalCodeMin": 35260,
    "postalCodeMax": 35269,
    "lat": 61.6267,
    "lng": 24.6045,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Orivesi",
    "area": "Västilä",
    "postalCode": 35270,
    "postalCodeMin": 35270,
    "postalCodeMax": 35279,
    "lat": 61.6418,
    "lng": 24.7056,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Orivesi",
    "area": "Orivesi",
    "postalCode": 35300,
    "postalCodeMin": 35300,
    "postalCodeMax": 35309,
    "lat": 61.6774,
    "lng": 24.3574,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Orivesi",
    "area": "Hirsilä",
    "postalCode": 35320,
    "postalCodeMin": 35320,
    "postalCodeMax": 35329,
    "lat": 61.7414,
    "lng": 24.3243,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Orivesi",
    "area": "Talviainen",
    "postalCode": 35420,
    "postalCodeMin": 35420,
    "postalCodeMax": 35429,
    "lat": 61.7353,
    "lng": 24.6572,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Orivesi",
    "area": "Längelmäki",
    "postalCode": 35480,
    "postalCodeMin": 35480,
    "postalCodeMax": 35489,
    "lat": 61.6911,
    "lng": 24.7246,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Parkano",
    "area": "Kovesjoki",
    "postalCode": 39620,
    "postalCodeMin": 39620,
    "postalCodeMax": 39629,
    "lat": 61.9356,
    "lng": 22.788,
    "radiusKm": 4.2
  },
  {
    "region": "Pirkanmaa",
    "city": "Parkano",
    "area": "Lapinneva",
    "postalCode": 39660,
    "postalCodeMin": 39660,
    "postalCodeMax": 39669,
    "lat": 61.9852,
    "lng": 22.9355,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Parkano",
    "area": "Parkano",
    "postalCode": 39700,
    "postalCodeMin": 39700,
    "postalCodeMax": 39709,
    "lat": 62.0103,
    "lng": 23.0214,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Parkano",
    "area": "Kuivasjärvi",
    "postalCode": 39750,
    "postalCodeMin": 39750,
    "postalCodeMax": 39759,
    "lat": 62.142,
    "lng": 22.9944,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Parkano",
    "area": "Aureskoski",
    "postalCode": 39770,
    "postalCodeMin": 39770,
    "postalCodeMax": 39779,
    "lat": 61.982,
    "lng": 23.3179,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Parkano",
    "area": "Alaskylä",
    "postalCode": 39780,
    "postalCodeMin": 39780,
    "postalCodeMax": 39789,
    "lat": 61.9584,
    "lng": 22.9948,
    "radiusKm": 3.5
  },
  {
    "region": "Pirkanmaa",
    "city": "Pirkkala",
    "area": "Toivio",
    "postalCode": 33920,
    "postalCodeMin": 33920,
    "postalCodeMax": 33929,
    "lat": 61.455,
    "lng": 23.7186,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Pirkkala",
    "area": "Killo",
    "postalCode": 33950,
    "postalCodeMin": 33950,
    "postalCodeMax": 33959,
    "lat": 61.4672,
    "lng": 23.6866,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Pirkkala",
    "area": "Pirkkala",
    "postalCode": 33960,
    "postalCodeMin": 33960,
    "postalCodeMax": 33969,
    "lat": 61.4439,
    "lng": 23.6552,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Pirkkala",
    "area": "Pirkkala",
    "postalCode": 33980,
    "postalCodeMin": 33980,
    "postalCodeMax": 33989,
    "lat": 61.4271,
    "lng": 23.5776,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Punkalaidun",
    "area": "Oriniemi",
    "postalCode": 31810,
    "postalCodeMin": 31810,
    "postalCodeMax": 31819,
    "lat": 61.1472,
    "lng": 23.1944,
    "radiusKm": 4.2
  },
  {
    "region": "Pirkanmaa",
    "city": "Punkalaidun",
    "area": "Halkivaha",
    "postalCode": 31830,
    "postalCodeMin": 31830,
    "postalCodeMax": 31839,
    "lat": 61.1962,
    "lng": 23.3084,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Punkalaidun",
    "area": "Koskioinen",
    "postalCode": 31850,
    "postalCodeMin": 31850,
    "postalCodeMax": 31859,
    "lat": 61.1005,
    "lng": 23.2054,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Punkalaidun",
    "area": "Tursa",
    "postalCode": 31860,
    "postalCodeMin": 31860,
    "postalCodeMax": 31869,
    "lat": 61.1027,
    "lng": 23.2865,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Punkalaidun",
    "area": "Punkalaidun",
    "postalCode": 31900,
    "postalCodeMin": 31900,
    "postalCodeMax": 31909,
    "lat": 61.1117,
    "lng": 23.1066,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Punkalaidun",
    "area": "Vanttila",
    "postalCode": 31930,
    "postalCodeMin": 31930,
    "postalCodeMax": 31939,
    "lat": 61.1423,
    "lng": 22.9506,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Punkalaidun",
    "area": "Sadonmaa",
    "postalCode": 31950,
    "postalCodeMin": 31950,
    "postalCodeMax": 31959,
    "lat": 61.0355,
    "lng": 23.2283,
    "radiusKm": 5.1
  },
  {
    "region": "Pirkanmaa",
    "city": "Punkalaidun",
    "area": "Kanteenmaa",
    "postalCode": 31970,
    "postalCodeMin": 31970,
    "postalCodeMax": 31979,
    "lat": 61.0486,
    "lng": 22.9969,
    "radiusKm": 5.1
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Puutikkala",
    "postalCode": 14960,
    "postalCodeMin": 14960,
    "postalCodeMax": 14969,
    "lat": 61.2867,
    "lng": 24.6972,
    "radiusKm": 2.1
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Kuohijoki",
    "postalCode": 14980,
    "postalCodeMin": 14980,
    "postalCodeMax": 14989,
    "lat": 61.305,
    "lng": 24.8015,
    "radiusKm": 3.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Salmentaka",
    "postalCode": 36450,
    "postalCodeMin": 36450,
    "postalCodeMax": 36459,
    "lat": 61.3995,
    "lng": 24.3968,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Pälkäne",
    "postalCode": 36600,
    "postalCodeMin": 36600,
    "postalCodeMax": 36609,
    "lat": 61.3356,
    "lng": 24.2705,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Iltasmäki",
    "postalCode": 36640,
    "postalCodeMin": 36640,
    "postalCodeMax": 36649,
    "lat": 61.2982,
    "lng": 24.3138,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Laitikkala",
    "postalCode": 36660,
    "postalCodeMin": 36660,
    "postalCodeMax": 36669,
    "lat": 61.2616,
    "lng": 24.3533,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Aitoo",
    "postalCode": 36720,
    "postalCodeMin": 36720,
    "postalCodeMax": 36729,
    "lat": 61.3389,
    "lng": 24.4943,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Luopioinen",
    "postalCode": 36760,
    "postalCodeMin": 36760,
    "postalCodeMax": 36769,
    "lat": 61.3649,
    "lng": 24.6566,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Rautajärvi",
    "postalCode": 36910,
    "postalCodeMin": 36910,
    "postalCodeMax": 36919,
    "lat": 61.4094,
    "lng": 24.7197,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Pälkäne",
    "area": "Kyynärö",
    "postalCode": 36930,
    "postalCodeMin": 36930,
    "postalCodeMax": 36939,
    "lat": 61.4041,
    "lng": 24.7999,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ruovesi",
    "area": "Murole",
    "postalCode": 34410,
    "postalCodeMin": 34410,
    "postalCodeMax": 34419,
    "lat": 61.8246,
    "lng": 23.9441,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ruovesi",
    "area": "Muroleen kanava",
    "postalCode": 34420,
    "postalCodeMin": 34420,
    "postalCodeMax": 34429,
    "lat": 61.8555,
    "lng": 23.9067,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ruovesi",
    "area": "Kekkonen",
    "postalCode": 34430,
    "postalCodeMin": 34430,
    "postalCodeMax": 34439,
    "lat": 61.8544,
    "lng": 24.02,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ruovesi",
    "area": "Jäminkipohja",
    "postalCode": 34450,
    "postalCodeMin": 34450,
    "postalCodeMax": 34459,
    "lat": 61.8971,
    "lng": 24.1073,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ruovesi",
    "area": "Ruovesi",
    "postalCode": 34600,
    "postalCodeMin": 34600,
    "postalCodeMax": 34609,
    "lat": 61.9852,
    "lng": 24.0719,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ruovesi",
    "area": "Mustajärvi",
    "postalCode": 34640,
    "postalCodeMin": 34640,
    "postalCodeMax": 34649,
    "lat": 62.0403,
    "lng": 24.0225,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Ruovesi",
    "area": "Visuvesi",
    "postalCode": 34870,
    "postalCodeMin": 34870,
    "postalCodeMax": 34879,
    "lat": 62.1238,
    "lng": 23.9211,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ruovesi",
    "area": "Ylä-Vääri",
    "postalCode": 35740,
    "postalCodeMin": 35740,
    "postalCodeMax": 35749,
    "lat": 61.9519,
    "lng": 24.3194,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ruovesi",
    "area": "Väärinmaja",
    "postalCode": 35750,
    "postalCodeMin": 35750,
    "postalCodeMax": 35759,
    "lat": 61.952,
    "lng": 24.2638,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Keikyä",
    "postalCode": 32730,
    "postalCodeMin": 32730,
    "postalCodeMax": 32739,
    "lat": 61.2696,
    "lng": 22.7055,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Äetsä",
    "postalCode": 32740,
    "postalCodeMin": 32740,
    "postalCodeMax": 32749,
    "lat": 61.2967,
    "lng": 22.7065,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Karkku",
    "postalCode": 38100,
    "postalCodeMin": 38100,
    "postalCodeMax": 38109,
    "lat": 61.4444,
    "lng": 23.0456,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Kutala",
    "postalCode": 38120,
    "postalCodeMin": 38120,
    "postalCodeMax": 38129,
    "lat": 61.42,
    "lng": 23.1411,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Ellivuori",
    "postalCode": 38130,
    "postalCodeMin": 38130,
    "postalCodeMax": 38139,
    "lat": 61.4025,
    "lng": 23.0677,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Kärppälä",
    "postalCode": 38140,
    "postalCodeMin": 38140,
    "postalCodeMax": 38149,
    "lat": 61.3734,
    "lng": 23.1051,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Vammala",
    "postalCode": 38200,
    "postalCodeMin": 38200,
    "postalCodeMax": 38209,
    "lat": 61.3433,
    "lng": 22.9127,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Vammala, Asemanseutu",
    "postalCode": 38210,
    "postalCodeMin": 38210,
    "postalCodeMax": 38219,
    "lat": 61.3494,
    "lng": 22.8886,
    "radiusKm": 1.6
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Stormi",
    "postalCode": 38220,
    "postalCodeMin": 38220,
    "postalCodeMax": 38229,
    "lat": 61.3371,
    "lng": 23.0394,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Roismala",
    "postalCode": 38250,
    "postalCodeMin": 38250,
    "postalCodeMax": 38259,
    "lat": 61.3082,
    "lng": 22.9219,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Sammaljoki",
    "postalCode": 38270,
    "postalCodeMin": 38270,
    "postalCodeMax": 38279,
    "lat": 61.2315,
    "lng": 23.1295,
    "radiusKm": 4.2
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Illo",
    "postalCode": 38280,
    "postalCodeMin": 38280,
    "postalCodeMax": 38289,
    "lat": 61.2087,
    "lng": 23.0349,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Kiikka",
    "postalCode": 38300,
    "postalCodeMin": 38300,
    "postalCodeMax": 38309,
    "lat": 61.319,
    "lng": 22.7762,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Kiikoinen",
    "postalCode": 38360,
    "postalCodeMin": 38360,
    "postalCodeMax": 38369,
    "lat": 61.4522,
    "lng": 22.5779,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Häijää",
    "postalCode": 38420,
    "postalCodeMin": 38420,
    "postalCodeMax": 38429,
    "lat": 61.5001,
    "lng": 23.0957,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Mouhijärvi",
    "postalCode": 38460,
    "postalCodeMin": 38460,
    "postalCodeMax": 38469,
    "lat": 61.5123,
    "lng": 23.0093,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Hyynilä",
    "postalCode": 38470,
    "postalCodeMin": 38470,
    "postalCodeMax": 38479,
    "lat": 61.5353,
    "lng": 22.9509,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Sastamala",
    "area": "Suodenniemi",
    "postalCode": 38510,
    "postalCodeMin": 38510,
    "postalCodeMax": 38519,
    "lat": 61.5572,
    "lng": 22.7822,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "keskusta",
    "postalCode": 33100,
    "postalCodeMin": 33100,
    "postalCodeMax": 33109,
    "lat": 61.4902,
    "lng": 23.7809,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Lappi",
    "postalCode": 33180,
    "postalCodeMin": 33180,
    "postalCodeMax": 33189,
    "lat": 61.5091,
    "lng": 23.778,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Kaakinmaa, Nalkala",
    "postalCode": 33200,
    "postalCodeMin": 33200,
    "postalCodeMax": 33209,
    "lat": 61.4939,
    "lng": 23.7527,
    "radiusKm": 10.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Tammerkoski, Finlayson",
    "postalCode": 33210,
    "postalCodeMin": 33210,
    "postalCodeMax": 33219,
    "lat": 61.4978,
    "lng": 23.7623,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Amuri, Särkänniemi, Pyynikinrinne, Pyynikki",
    "postalCode": 33230,
    "postalCodeMin": 33230,
    "postalCodeMax": 33239,
    "lat": 61.4993,
    "lng": 23.7416,
    "radiusKm": 8.4
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Tahmela",
    "postalCode": 33240,
    "postalCodeMin": 33240,
    "postalCodeMax": 33249,
    "lat": 61.4985,
    "lng": 23.7152,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Ala-Pispala, Ylä-Pispala",
    "postalCode": 33250,
    "postalCodeMin": 33250,
    "postalCodeMax": 33259,
    "lat": 61.5053,
    "lng": 23.708,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Epilä, Kaarila, Hyhky",
    "postalCode": 33270,
    "postalCodeMin": 33270,
    "postalCodeMax": 33279,
    "lat": 61.5054,
    "lng": 23.6906,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Rahola",
    "postalCode": 33300,
    "postalCodeMin": 33300,
    "postalCodeMax": 33309,
    "lat": 61.4981,
    "lng": 23.639,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Tesomajärvi, Ristimäki, Tohloppi",
    "postalCode": 33310,
    "postalCodeMin": 33310,
    "postalCodeMax": 33319,
    "lat": 61.5083,
    "lng": 23.6116,
    "radiusKm": 9.4
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Kalkku, Myllypuro",
    "postalCode": 33330,
    "postalCodeMin": 33330,
    "postalCodeMax": 33339,
    "lat": 61.4948,
    "lng": 23.5696,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Ikuri, Haukiluoma, Lamminpää",
    "postalCode": 33340,
    "postalCodeMin": 33340,
    "postalCodeMax": 33349,
    "lat": 61.5188,
    "lng": 23.6069,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Lielahti, Ryydynpohja, Lintulampi",
    "postalCode": 33400,
    "postalCodeMin": 33400,
    "postalCodeMax": 33409,
    "lat": 61.5264,
    "lng": 23.6694,
    "radiusKm": 7.0
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Lentävänniemi",
    "postalCode": 33410,
    "postalCodeMin": 33410,
    "postalCodeMax": 33419,
    "lat": 61.527,
    "lng": 23.7056,
    "radiusKm": 8.4
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Lamminpää, Epilänharju",
    "postalCode": 33420,
    "postalCodeMin": 33420,
    "postalCodeMax": 33429,
    "lat": 61.5203,
    "lng": 23.6267,
    "radiusKm": 4.2
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Petsamo, Tammela",
    "postalCode": 33500,
    "postalCodeMin": 33500,
    "postalCodeMax": 33509,
    "lat": 61.5072,
    "lng": 23.7947,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Kauppi",
    "postalCode": 33520,
    "postalCodeMin": 33520,
    "postalCodeMax": 33529,
    "lat": 61.5077,
    "lng": 23.8098,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Kissanmaa, Uusikylä, Hakametsä",
    "postalCode": 33530,
    "postalCodeMin": 33530,
    "postalCodeMax": 33539,
    "lat": 61.4936,
    "lng": 23.8265,
    "radiusKm": 7.0
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Kaleva, Liisankallio, Kalevanrinne",
    "postalCode": 33540,
    "postalCodeMin": 33540,
    "postalCodeMax": 33549,
    "lat": 61.4928,
    "lng": 23.812,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Janka, Irjala, Pappila, Takahuhti, Pohtola",
    "postalCode": 33560,
    "postalCodeMin": 33560,
    "postalCodeMax": 33569,
    "lat": 61.4884,
    "lng": 23.8459,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Atala, Linnainmaa",
    "postalCode": 33580,
    "postalCodeMin": 33580,
    "postalCodeMax": 33589,
    "lat": 61.4942,
    "lng": 23.8827,
    "radiusKm": 10.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Olkahinen, Tasanne",
    "postalCode": 33610,
    "postalCodeMin": 33610,
    "postalCodeMax": 33619,
    "lat": 61.5177,
    "lng": 23.9307,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Aitolahti",
    "postalCode": 33680,
    "postalCodeMin": 33680,
    "postalCodeMax": 33689,
    "lat": 61.5446,
    "lng": 23.8887,
    "radiusKm": 7.0
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Messukylä",
    "postalCode": 33700,
    "postalCodeMin": 33700,
    "postalCodeMax": 33709,
    "lat": 61.4851,
    "lng": 23.8443,
    "radiusKm": 7.0
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Kaukajärvi",
    "postalCode": 33710,
    "postalCodeMin": 33710,
    "postalCodeMax": 33719,
    "lat": 61.4706,
    "lng": 23.8701,
    "radiusKm": 9.4
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Hervanta, Rusko",
    "postalCode": 33720,
    "postalCodeMin": 33720,
    "postalCodeMax": 33729,
    "lat": 61.4509,
    "lng": 23.8491,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Vehmainen",
    "postalCode": 33730,
    "postalCodeMin": 33730,
    "postalCodeMax": 33739,
    "lat": 61.4771,
    "lng": 23.9184,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Nekala, Vihioja, Jokipohja",
    "postalCode": 33800,
    "postalCodeMin": 33800,
    "postalCodeMax": 33809,
    "lat": 61.4827,
    "lng": 23.7979,
    "radiusKm": 8.4
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Koivistonkylä, Hallila",
    "postalCode": 33820,
    "postalCodeMin": 33820,
    "postalCodeMax": 33829,
    "lat": 61.4641,
    "lng": 23.8292,
    "radiusKm": 7.0
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Lakalaiva, Peltolammi",
    "postalCode": 33840,
    "postalCodeMin": 33840,
    "postalCodeMax": 33849,
    "lat": 61.4588,
    "lng": 23.7637,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Multisilta",
    "postalCode": 33850,
    "postalCodeMin": 33850,
    "postalCodeMax": 33859,
    "lat": 61.4398,
    "lng": 23.7504,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Vuores",
    "postalCode": 33870,
    "postalCodeMin": 33870,
    "postalCodeMax": 33879,
    "lat": 61.4339,
    "lng": 23.8076,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Härmälä, Rantaperkiö",
    "postalCode": 33900,
    "postalCodeMin": 33900,
    "postalCodeMax": 33909,
    "lat": 61.4702,
    "lng": 23.7416,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Kämmenniemi",
    "postalCode": 34240,
    "postalCodeMin": 34240,
    "postalCodeMax": 34249,
    "lat": 61.628,
    "lng": 23.84,
    "radiusKm": 8.4
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Terälahti",
    "postalCode": 34260,
    "postalCodeMin": 34260,
    "postalCodeMax": 34269,
    "lat": 61.7082,
    "lng": 23.9003,
    "radiusKm": 7.0
  },
  {
    "region": "Pirkanmaa",
    "city": "Tampere",
    "area": "Velaatta",
    "postalCode": 34270,
    "postalCodeMin": 34270,
    "postalCodeMax": 34279,
    "lat": 61.747,
    "lng": 23.9232,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Urjala",
    "area": "Menonen",
    "postalCode": 31140,
    "postalCodeMin": 31140,
    "postalCodeMax": 31149,
    "lat": 61.0198,
    "lng": 23.4827,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Urjala",
    "area": "Nuutajärvi",
    "postalCode": 31160,
    "postalCodeMin": 31160,
    "postalCodeMax": 31169,
    "lat": 61.0454,
    "lng": 23.4299,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Urjala",
    "area": "Urjala as",
    "postalCode": 31700,
    "postalCodeMin": 31700,
    "postalCodeMax": 31709,
    "lat": 61.0631,
    "lng": 23.6193,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Urjala",
    "area": "Urjalankylä",
    "postalCode": 31720,
    "postalCodeMin": 31720,
    "postalCodeMax": 31729,
    "lat": 61.0845,
    "lng": 23.4707,
    "radiusKm": 3.5
  },
  {
    "region": "Pirkanmaa",
    "city": "Urjala",
    "area": "Honkola",
    "postalCode": 31730,
    "postalCodeMin": 31730,
    "postalCodeMax": 31739,
    "lat": 61.2741,
    "lng": 22.685,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Urjala",
    "area": "Kehro",
    "postalCode": 31750,
    "postalCodeMin": 31750,
    "postalCodeMax": 31759,
    "lat": 61.0803,
    "lng": 23.5486,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Urjala",
    "area": "Urjala",
    "postalCode": 31760,
    "postalCodeMin": 31760,
    "postalCodeMax": 31769,
    "lat": 61.0803,
    "lng": 23.5486,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Urjala",
    "area": "Halkivaha",
    "postalCode": 31830,
    "postalCodeMin": 31830,
    "postalCodeMax": 31839,
    "lat": 61.1962,
    "lng": 23.3084,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Urjala",
    "area": "Tursa",
    "postalCode": 31860,
    "postalCodeMin": 31860,
    "postalCodeMax": 31869,
    "lat": 61.1027,
    "lng": 23.2865,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Valkeakoski",
    "area": "Valkeakoski",
    "postalCode": 37600,
    "postalCodeMin": 37600,
    "postalCodeMax": 37609,
    "lat": 61.2711,
    "lng": 24.0218,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Valkeakoski",
    "area": "Valkeakoski",
    "postalCode": 37630,
    "postalCodeMin": 37630,
    "postalCodeMax": 37639,
    "lat": 61.3035,
    "lng": 23.9772,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Valkeakoski",
    "area": "Sääksmäki",
    "postalCode": 37700,
    "postalCodeMin": 37700,
    "postalCodeMax": 37709,
    "lat": 61.201,
    "lng": 24.0696,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Valkeakoski",
    "area": "Ritvala",
    "postalCode": 37720,
    "postalCodeMin": 37720,
    "postalCodeMax": 37729,
    "lat": 61.1848,
    "lng": 24.1452,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Valkeakoski",
    "area": "Haukila",
    "postalCode": 37740,
    "postalCodeMin": 37740,
    "postalCodeMax": 37749,
    "lat": 61.2143,
    "lng": 24.2493,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Valkeakoski",
    "area": "Tarttila",
    "postalCode": 37770,
    "postalCodeMin": 37770,
    "postalCodeMax": 37779,
    "lat": 61.1566,
    "lng": 24.0013,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Valkeakoski",
    "area": "Metsäkansa",
    "postalCode": 37850,
    "postalCodeMin": 37850,
    "postalCodeMax": 37859,
    "lat": 61.2353,
    "lng": 23.8758,
    "radiusKm": 5.9
  },
  {
    "region": "Pirkanmaa",
    "city": "Valkeakoski",
    "area": "Kärjenniemi",
    "postalCode": 37860,
    "postalCodeMin": 37860,
    "postalCodeMax": 37869,
    "lat": 61.2637,
    "lng": 23.9473,
    "radiusKm": 4.2
  },
  {
    "region": "Pirkanmaa",
    "city": "Vesilahti",
    "area": "Rämsöö",
    "postalCode": 37350,
    "postalCodeMin": 37350,
    "postalCodeMax": 37359,
    "lat": 61.343,
    "lng": 23.2903,
    "radiusKm": 3.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Vesilahti",
    "area": "Narva",
    "postalCode": 37370,
    "postalCodeMin": 37370,
    "postalCodeMax": 37379,
    "lat": 61.2967,
    "lng": 23.5038,
    "radiusKm": 3.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Vesilahti",
    "area": "Krääkkiö",
    "postalCode": 37380,
    "postalCodeMin": 37380,
    "postalCodeMax": 37389,
    "lat": 61.2358,
    "lng": 23.3983,
    "radiusKm": 3.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Vesilahti",
    "area": "Valkkinen",
    "postalCode": 37420,
    "postalCodeMin": 37420,
    "postalCodeMax": 37429,
    "lat": 61.2664,
    "lng": 23.6616,
    "radiusKm": 3.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Vesilahti",
    "area": "Vesilahti",
    "postalCode": 37470,
    "postalCodeMin": 37470,
    "postalCodeMax": 37479,
    "lat": 61.3096,
    "lng": 23.6158,
    "radiusKm": 4.9
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Vaskivesi",
    "postalCode": 34710,
    "postalCodeMin": 34710,
    "postalCodeMax": 34719,
    "lat": 62.1419,
    "lng": 23.6655,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Vaskuu",
    "postalCode": 34730,
    "postalCodeMin": 34730,
    "postalCodeMax": 34739,
    "lat": 62.2128,
    "lng": 23.557,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Koro",
    "postalCode": 34740,
    "postalCodeMin": 34740,
    "postalCodeMax": 34749,
    "lat": 62.2123,
    "lng": 23.6455,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Kurjenkylä",
    "postalCode": 34770,
    "postalCodeMin": 34770,
    "postalCodeMax": 34779,
    "lat": 62.2705,
    "lng": 23.3874,
    "radiusKm": 3.5
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Virrat",
    "postalCode": 34800,
    "postalCodeMin": 34800,
    "postalCodeMax": 34809,
    "lat": 62.2409,
    "lng": 23.7702,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Äijänneva",
    "postalCode": 34910,
    "postalCodeMin": 34910,
    "postalCodeMax": 34919,
    "lat": 62.3212,
    "lng": 23.5154,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Liedenpohja",
    "postalCode": 34930,
    "postalCodeMin": 34930,
    "postalCodeMax": 34939,
    "lat": 62.3782,
    "lng": 23.6532,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Ohtola",
    "postalCode": 34950,
    "postalCodeMin": 34950,
    "postalCodeMax": 34959,
    "lat": 62.3435,
    "lng": 23.8242,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Toisvesi",
    "postalCode": 34970,
    "postalCodeMin": 34970,
    "postalCodeMax": 34979,
    "lat": 62.3741,
    "lng": 23.8449,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Killinkoski",
    "postalCode": 34980,
    "postalCodeMin": 34980,
    "postalCodeMax": 34989,
    "lat": 62.3955,
    "lng": 23.8811,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Virrat",
    "area": "Kotala",
    "postalCode": 42870,
    "postalCodeMin": 42870,
    "postalCodeMax": 42879,
    "lat": 62.266,
    "lng": 24.0327,
    "radiusKm": 2.6
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Vuorentausta",
    "postalCode": 33430,
    "postalCodeMin": 33430,
    "postalCodeMax": 33439,
    "lat": 61.5312,
    "lng": 23.6026,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Siivikkala",
    "postalCode": 33450,
    "postalCodeMin": 33450,
    "postalCodeMax": 33459,
    "lat": 61.5495,
    "lng": 23.6676,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Ylöjärvi",
    "postalCode": 33470,
    "postalCodeMin": 33470,
    "postalCodeMax": 33479,
    "lat": 61.5489,
    "lng": 23.5949,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Ylöjärvi",
    "postalCode": 33480,
    "postalCodeMin": 33480,
    "postalCodeMax": 33489,
    "lat": 61.5489,
    "lng": 23.5949,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Lakiala",
    "postalCode": 34110,
    "postalCodeMin": 34110,
    "postalCodeMax": 34119,
    "lat": 61.6259,
    "lng": 23.527,
    "radiusKm": 5.4
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Ylinen",
    "postalCode": 34130,
    "postalCodeMin": 34130,
    "postalCodeMax": 34139,
    "lat": 61.6317,
    "lng": 23.6165,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Mutala",
    "postalCode": 34140,
    "postalCodeMin": 34140,
    "postalCodeMax": 34149,
    "lat": 61.6598,
    "lng": 23.568,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Kyrönlahti",
    "postalCode": 34150,
    "postalCodeMin": 34150,
    "postalCodeMax": 34159,
    "lat": 61.7045,
    "lng": 23.5485,
    "radiusKm": 3.5
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Länsi-Teisko",
    "postalCode": 34180,
    "postalCodeMin": 34180,
    "postalCodeMax": 34189,
    "lat": 61.7497,
    "lng": 23.6999,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Kuru",
    "postalCode": 34300,
    "postalCodeMin": 34300,
    "postalCodeMax": 34309,
    "lat": 61.8795,
    "lng": 23.7311,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Parkkuu",
    "postalCode": 34320,
    "postalCodeMin": 34320,
    "postalCodeMax": 34329,
    "lat": 61.8191,
    "lng": 23.6976,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Poikelus",
    "postalCode": 34330,
    "postalCodeMin": 34330,
    "postalCodeMax": 34339,
    "lat": 61.7925,
    "lng": 23.6293,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Luode",
    "postalCode": 34510,
    "postalCodeMin": 34510,
    "postalCodeMax": 34519,
    "lat": 61.964,
    "lng": 23.516,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Länsi-Aure",
    "postalCode": 34530,
    "postalCodeMin": 34530,
    "postalCodeMax": 34539,
    "lat": 61.9775,
    "lng": 23.3593,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Itä-Aure",
    "postalCode": 34550,
    "postalCodeMin": 34550,
    "postalCodeMax": 34559,
    "lat": 62.0452,
    "lng": 23.443,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Pinsiö",
    "postalCode": 39150,
    "postalCodeMin": 39150,
    "postalCodeMax": 39159,
    "lat": 61.5503,
    "lng": 23.4373,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Julkujärvi",
    "postalCode": 39160,
    "postalCodeMin": 39160,
    "postalCodeMax": 39169,
    "lat": 61.5596,
    "lng": 23.519,
    "radiusKm": 4.7
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Viljakkala",
    "postalCode": 39310,
    "postalCodeMin": 39310,
    "postalCodeMax": 39319,
    "lat": 61.7017,
    "lng": 23.2639,
    "radiusKm": 2.3
  },
  {
    "region": "Pirkanmaa",
    "city": "Ylöjärvi",
    "area": "Karhe",
    "postalCode": 39340,
    "postalCodeMin": 39340,
    "postalCodeMax": 39349,
    "lat": 61.7281,
    "lng": 23.44,
    "radiusKm": 2.3
  },
  {
    "region": "Keski-Suomi",
    "city": "Hankasalmi",
    "area": "Niemisjärvi",
    "postalCode": 41490,
    "postalCodeMin": 41490,
    "postalCodeMax": 41499,
    "lat": 62.2802,
    "lng": 26.3474,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Hankasalmi",
    "area": "Hankasalmi as",
    "postalCode": 41500,
    "postalCodeMin": 41500,
    "postalCodeMax": 41509,
    "lat": 62.2905,
    "lng": 26.4913,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Hankasalmi",
    "area": "Hankasalmi",
    "postalCode": 41520,
    "postalCodeMin": 41520,
    "postalCodeMax": 41529,
    "lat": 62.3894,
    "lng": 26.4361,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Hankasalmi",
    "area": "Veneranta",
    "postalCode": 41530,
    "postalCodeMin": 41530,
    "postalCodeMax": 41539,
    "lat": 62.3809,
    "lng": 26.3689,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Hankasalmi",
    "area": "Ristimäki",
    "postalCode": 41540,
    "postalCodeMin": 41540,
    "postalCodeMax": 41549,
    "lat": 62.4642,
    "lng": 26.3352,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Hankasalmi",
    "area": "Hannula",
    "postalCode": 41550,
    "postalCodeMin": 41550,
    "postalCodeMax": 41559,
    "lat": 62.5177,
    "lng": 26.247,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Hankasalmi",
    "area": "Säkinmäki",
    "postalCode": 41560,
    "postalCodeMin": 41560,
    "postalCodeMax": 41569,
    "lat": 62.4734,
    "lng": 26.4935,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Hankasalmi",
    "area": "Sauvamäki",
    "postalCode": 41580,
    "postalCodeMin": 41580,
    "postalCodeMax": 41589,
    "lat": 62.3084,
    "lng": 26.6339,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Joutsa",
    "area": "Joutsa",
    "postalCode": 19650,
    "postalCodeMin": 19650,
    "postalCodeMax": 19659,
    "lat": 61.7421,
    "lng": 26.1149,
    "radiusKm": 2.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Joutsa",
    "area": "Mieskonmäki",
    "postalCode": 19670,
    "postalCodeMin": 19670,
    "postalCodeMax": 19679,
    "lat": 61.8425,
    "lng": 26.3061,
    "radiusKm": 2.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Joutsa",
    "area": "Pappinen",
    "postalCode": 19920,
    "postalCodeMin": 19920,
    "postalCodeMax": 19929,
    "lat": 61.8116,
    "lng": 25.9443,
    "radiusKm": 2.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Joutsa",
    "area": "Rutalahti",
    "postalCode": 41710,
    "postalCodeMin": 41710,
    "postalCodeMax": 41719,
    "lat": 61.9955,
    "lng": 25.9733,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Joutsa",
    "area": "Kivisuo",
    "postalCode": 41730,
    "postalCodeMin": 41730,
    "postalCodeMax": 41739,
    "lat": 61.8817,
    "lng": 25.9537,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Joutsa",
    "area": "Havumäki",
    "postalCode": 41750,
    "postalCodeMin": 41750,
    "postalCodeMax": 41759,
    "lat": 61.9883,
    "lng": 26.2733,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Joutsa",
    "area": "Leivonmäki",
    "postalCode": 41770,
    "postalCodeMin": 41770,
    "postalCodeMax": 41779,
    "lat": 61.9151,
    "lng": 26.1231,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "keskusta",
    "postalCode": 40100,
    "postalCodeMin": 40100,
    "postalCodeMax": 40109,
    "lat": 62.2417,
    "lng": 25.7496,
    "radiusKm": 2.1
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Taulumäki, Mannila",
    "postalCode": 40200,
    "postalCodeMin": 40200,
    "postalCodeMax": 40209,
    "lat": 62.2698,
    "lng": 25.7206,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Lohikoski",
    "postalCode": 40250,
    "postalCodeMin": 40250,
    "postalCodeMax": 40259,
    "lat": 62.2658,
    "lng": 25.7637,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Palokka",
    "postalCode": 40270,
    "postalCodeMin": 40270,
    "postalCodeMax": 40279,
    "lat": 62.2881,
    "lng": 25.7416,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Seppälä",
    "postalCode": 40320,
    "postalCodeMin": 40320,
    "postalCodeMax": 40329,
    "lat": 62.2602,
    "lng": 25.779,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Huhtasuo",
    "postalCode": 40340,
    "postalCodeMin": 40340,
    "postalCodeMax": 40349,
    "lat": 62.272,
    "lng": 25.8007,
    "radiusKm": 8.4
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Jyväskylä",
    "postalCode": 40350,
    "postalCodeMin": 40350,
    "postalCodeMax": 40359,
    "lat": 62.2426,
    "lng": 25.7473,
    "radiusKm": 6.3
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Halssila",
    "postalCode": 40400,
    "postalCodeMin": 40400,
    "postalCodeMax": 40409,
    "lat": 62.2432,
    "lng": 25.7926,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Jyskä",
    "postalCode": 40420,
    "postalCodeMin": 40420,
    "postalCodeMax": 40429,
    "lat": 62.242,
    "lng": 25.8448,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Keljo",
    "postalCode": 40500,
    "postalCodeMin": 40500,
    "postalCodeMax": 40509,
    "lat": 62.2135,
    "lng": 25.716,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Kuokkala",
    "postalCode": 40520,
    "postalCodeMin": 40520,
    "postalCodeMax": 40529,
    "lat": 62.2261,
    "lng": 25.7747,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Keljonkangas",
    "postalCode": 40530,
    "postalCodeMin": 40530,
    "postalCodeMax": 40539,
    "lat": 62.1925,
    "lng": 25.7151,
    "radiusKm": 8.4
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Mattilanpelto",
    "postalCode": 40600,
    "postalCodeMin": 40600,
    "postalCodeMax": 40609,
    "lat": 62.2313,
    "lng": 25.7247,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Kyllö",
    "postalCode": 40620,
    "postalCodeMin": 40620,
    "postalCodeMax": 40629,
    "lat": 62.2334,
    "lng": 25.7079,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Kypärämäki",
    "postalCode": 40630,
    "postalCodeMin": 40630,
    "postalCodeMax": 40639,
    "lat": 62.2413,
    "lng": 25.6994,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Keltinmäki",
    "postalCode": 40640,
    "postalCodeMin": 40640,
    "postalCodeMax": 40649,
    "lat": 62.2295,
    "lng": 25.6813,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Ruoke",
    "postalCode": 40660,
    "postalCodeMin": 40660,
    "postalCodeMax": 40669,
    "lat": 62.2606,
    "lng": 25.6158,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Mäki-Matti",
    "postalCode": 40700,
    "postalCodeMin": 40700,
    "postalCodeMax": 40709,
    "lat": 62.2435,
    "lng": 25.7276,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Nisula",
    "postalCode": 40720,
    "postalCodeMin": 40720,
    "postalCodeMax": 40729,
    "lat": 62.2484,
    "lng": 25.7388,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Kortepohja, Laajavuori, Haukkala",
    "postalCode": 40740,
    "postalCodeMin": 40740,
    "postalCodeMax": 40749,
    "lat": 62.2492,
    "lng": 25.7071,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Vaajakoski",
    "postalCode": 40800,
    "postalCodeMin": 40800,
    "postalCodeMax": 40809,
    "lat": 62.2473,
    "lng": 25.8703,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Haapaniemi",
    "postalCode": 40820,
    "postalCodeMin": 40820,
    "postalCodeMax": 40829,
    "lat": 62.2238,
    "lng": 25.8518,
    "radiusKm": 7.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Säynätsalo",
    "postalCode": 40900,
    "postalCodeMin": 40900,
    "postalCodeMax": 40909,
    "lat": 62.1407,
    "lng": 25.7703,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Puuppola",
    "postalCode": 41120,
    "postalCodeMin": 41120,
    "postalCodeMax": 41129,
    "lat": 62.343,
    "lng": 25.6885,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Kuikka",
    "postalCode": 41140,
    "postalCodeMin": 41140,
    "postalCodeMax": 41149,
    "lat": 62.38,
    "lng": 25.5975,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Tikkakoski",
    "postalCode": 41160,
    "postalCodeMin": 41160,
    "postalCodeMax": 41169,
    "lat": 62.3892,
    "lng": 25.6467,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Leppälahti",
    "postalCode": 41450,
    "postalCodeMin": 41450,
    "postalCodeMax": 41459,
    "lat": 62.2427,
    "lng": 25.9705,
    "radiusKm": 6.3
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Oravasaari",
    "postalCode": 41630,
    "postalCodeMin": 41630,
    "postalCodeMax": 41639,
    "lat": 62.1663,
    "lng": 25.9208,
    "radiusKm": 8.4
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Korpilahti",
    "postalCode": 41800,
    "postalCodeMin": 41800,
    "postalCodeMax": 41809,
    "lat": 62.021,
    "lng": 25.5718,
    "radiusKm": 6.3
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Saakoski",
    "postalCode": 41820,
    "postalCodeMin": 41820,
    "postalCodeMax": 41829,
    "lat": 61.9718,
    "lng": 25.3877,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Moksi",
    "postalCode": 41840,
    "postalCodeMin": 41840,
    "postalCodeMax": 41849,
    "lat": 62.0981,
    "lng": 25.4242,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Tikkala",
    "postalCode": 41860,
    "postalCodeMin": 41860,
    "postalCodeMax": 41869,
    "lat": 62.1503,
    "lng": 25.4731,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Putkilahti",
    "postalCode": 41870,
    "postalCodeMin": 41870,
    "postalCodeMax": 41879,
    "lat": 61.8884,
    "lng": 25.7238,
    "radiusKm": 6.3
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Oittila",
    "postalCode": 41880,
    "postalCodeMin": 41880,
    "postalCodeMax": 41889,
    "lat": 61.9481,
    "lng": 25.7542,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Kuohu",
    "postalCode": 41930,
    "postalCodeMin": 41930,
    "postalCodeMax": 41939,
    "lat": 62.2648,
    "lng": 25.4575,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jyväskylä",
    "area": "Vesanka",
    "postalCode": 41940,
    "postalCodeMin": 41940,
    "postalCodeMax": 41949,
    "lat": 62.2679,
    "lng": 25.5783,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Länkipohja",
    "postalCode": 35400,
    "postalCodeMin": 35400,
    "postalCodeMax": 35409,
    "lat": 61.729,
    "lng": 24.7881,
    "radiusKm": 2.5
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Halli",
    "postalCode": 35600,
    "postalCodeMin": 35600,
    "postalCodeMax": 35609,
    "lat": 61.8631,
    "lng": 24.8183,
    "radiusKm": 2.5
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Pihlaisto",
    "postalCode": 35610,
    "postalCodeMin": 35610,
    "postalCodeMax": 35619,
    "lat": 61.8773,
    "lng": 24.7248,
    "radiusKm": 2.5
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Kuorevesi",
    "postalCode": 35630,
    "postalCodeMin": 35630,
    "postalCodeMax": 35639,
    "lat": 61.9218,
    "lng": 24.7941,
    "radiusKm": 2.5
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Jämsä",
    "postalCode": 42100,
    "postalCodeMin": 42100,
    "postalCodeMax": 42109,
    "lat": 61.862,
    "lng": 25.1802,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Juokslahti",
    "postalCode": 42140,
    "postalCodeMin": 42140,
    "postalCodeMax": 42149,
    "lat": 61.9355,
    "lng": 25.3457,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Kaipola",
    "postalCode": 42220,
    "postalCodeMin": 42220,
    "postalCodeMax": 42229,
    "lat": 61.8158,
    "lng": 25.235,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Jämsänkoski",
    "postalCode": 42300,
    "postalCodeMin": 42300,
    "postalCodeMax": 42309,
    "lat": 61.919,
    "lng": 25.1695,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Haavisto",
    "postalCode": 42330,
    "postalCodeMin": 42330,
    "postalCodeMax": 42339,
    "lat": 61.9836,
    "lng": 25.1563,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Jämsä",
    "area": "Koskenpää",
    "postalCode": 42440,
    "postalCodeMin": 42440,
    "postalCodeMax": 42449,
    "lat": 62.0814,
    "lng": 25.1414,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Kannonkoski",
    "area": "Kannonkoski",
    "postalCode": 43300,
    "postalCodeMin": 43300,
    "postalCodeMax": 43309,
    "lat": 62.9758,
    "lng": 25.2613,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Kannonkoski",
    "area": "Kannonjärvi",
    "postalCode": 43340,
    "postalCodeMin": 43340,
    "postalCodeMax": 43349,
    "lat": 62.8903,
    "lng": 25.2106,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Karstula",
    "area": "Kangasaho",
    "postalCode": 43490,
    "postalCodeMin": 43490,
    "postalCodeMax": 43499,
    "lat": 62.8017,
    "lng": 24.6961,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Karstula",
    "area": "Karstula",
    "postalCode": 43500,
    "postalCodeMin": 43500,
    "postalCodeMax": 43509,
    "lat": 62.8778,
    "lng": 24.8009,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Karstula",
    "area": "Kiminki",
    "postalCode": 43520,
    "postalCodeMin": 43520,
    "postalCodeMax": 43529,
    "lat": 62.9728,
    "lng": 24.7333,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Karstula",
    "area": "Rantakylä",
    "postalCode": 43540,
    "postalCodeMin": 43540,
    "postalCodeMax": 43549,
    "lat": 62.8663,
    "lng": 24.6781,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Karstula",
    "area": "Vahanka",
    "postalCode": 43560,
    "postalCodeMin": 43560,
    "postalCodeMax": 43569,
    "lat": 62.8733,
    "lng": 24.521,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Karstula",
    "area": "Aho",
    "postalCode": 43610,
    "postalCodeMin": 43610,
    "postalCodeMax": 43619,
    "lat": 62.8886,
    "lng": 25.1294,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Karstula",
    "area": "Humppi",
    "postalCode": 43640,
    "postalCodeMin": 43640,
    "postalCodeMax": 43649,
    "lat": 62.9062,
    "lng": 24.8966,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Karstula",
    "area": "Vastinki",
    "postalCode": 43660,
    "postalCodeMin": 43660,
    "postalCodeMax": 43669,
    "lat": 62.937,
    "lng": 24.9548,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Keuruu",
    "area": "Huttula",
    "postalCode": 41970,
    "postalCodeMin": 41970,
    "postalCodeMax": 41979,
    "lat": 62.242,
    "lng": 25.0039,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Keuruu",
    "area": "Asunta",
    "postalCode": 42520,
    "postalCodeMin": 42520,
    "postalCodeMax": 42529,
    "lat": 62.2454,
    "lng": 24.8849,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Keuruu",
    "area": "Pohjoisjärvi",
    "postalCode": 42560,
    "postalCodeMin": 42560,
    "postalCodeMax": 42569,
    "lat": 62.2028,
    "lng": 24.7795,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Keuruu",
    "area": "Keuruu",
    "postalCode": 42700,
    "postalCodeMin": 42700,
    "postalCodeMax": 42709,
    "lat": 62.256,
    "lng": 24.7079,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Keuruu",
    "area": "Keuruu",
    "postalCode": 42720,
    "postalCodeMin": 42720,
    "postalCodeMax": 42729,
    "lat": 62.2201,
    "lng": 24.667,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Keuruu",
    "area": "Haapamäki",
    "postalCode": 42800,
    "postalCodeMin": 42800,
    "postalCodeMax": 42809,
    "lat": 62.2524,
    "lng": 24.4524,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Keuruu",
    "area": "Riiho",
    "postalCode": 42820,
    "postalCodeMin": 42820,
    "postalCodeMax": 42829,
    "lat": 62.2045,
    "lng": 24.3587,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Keuruu",
    "area": "Pihlajavesi",
    "postalCode": 42910,
    "postalCodeMin": 42910,
    "postalCodeMax": 42919,
    "lat": 62.3465,
    "lng": 24.2933,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Keuruu",
    "area": "Katajamäki",
    "postalCode": 42930,
    "postalCodeMin": 42930,
    "postalCodeMax": 42939,
    "lat": 62.2964,
    "lng": 24.1774,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Kinnula",
    "area": "Kinnula",
    "postalCode": 43900,
    "postalCodeMin": 43900,
    "postalCodeMax": 43909,
    "lat": 63.3664,
    "lng": 24.9677,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Kinnula",
    "area": "Muhola",
    "postalCode": 43940,
    "postalCodeMin": 43940,
    "postalCodeMax": 43949,
    "lat": 63.2978,
    "lng": 25.0912,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Kinnula",
    "area": "Saarensalmi",
    "postalCode": 43960,
    "postalCodeMin": 43960,
    "postalCodeMax": 43969,
    "lat": 63.2664,
    "lng": 25.1269,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Kivijärvi",
    "area": "Lokakylä",
    "postalCode": 43390,
    "postalCodeMin": 43390,
    "postalCodeMax": 43399,
    "lat": 63.0956,
    "lng": 25.2524,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Kivijärvi",
    "area": "Kivijärvi",
    "postalCode": 43800,
    "postalCodeMin": 43800,
    "postalCodeMax": 43809,
    "lat": 63.1199,
    "lng": 25.0747,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Kivijärvi",
    "area": "Sompala",
    "postalCode": 43840,
    "postalCodeMin": 43840,
    "postalCodeMax": 43849,
    "lat": 63.0451,
    "lng": 25.1031,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Konnevesi",
    "area": "Konnevesi",
    "postalCode": 44300,
    "postalCodeMin": 44300,
    "postalCodeMax": 44309,
    "lat": 62.6278,
    "lng": 26.2939,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Konnevesi",
    "area": "Sirkkamäki",
    "postalCode": 44320,
    "postalCodeMin": 44320,
    "postalCodeMax": 44329,
    "lat": 62.5496,
    "lng": 26.3909,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Konnevesi",
    "area": "Hytölä",
    "postalCode": 44330,
    "postalCodeMin": 44330,
    "postalCodeMax": 44339,
    "lat": 62.5885,
    "lng": 26.1844,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Konnevesi",
    "area": "Istunmäki",
    "postalCode": 44350,
    "postalCodeMin": 44350,
    "postalCodeMax": 44359,
    "lat": 62.7031,
    "lng": 26.4643,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Konnevesi",
    "area": "Mäntymäki",
    "postalCode": 44370,
    "postalCodeMin": 44370,
    "postalCodeMax": 44379,
    "lat": 60.4377,
    "lng": 22.2679,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Kuhmoinen",
    "area": "Harmoinen",
    "postalCode": 17780,
    "postalCodeMin": 17780,
    "postalCodeMax": 17789,
    "lat": 61.4814,
    "lng": 25.1494,
    "radiusKm": 2.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Kuhmoinen",
    "area": "Kuhmoinen",
    "postalCode": 17800,
    "postalCodeMin": 17800,
    "postalCodeMax": 17809,
    "lat": 61.5592,
    "lng": 25.164,
    "radiusKm": 2.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Kuhmoinen",
    "area": "Harjunsalmi",
    "postalCode": 17840,
    "postalCodeMin": 17840,
    "postalCodeMax": 17849,
    "lat": 61.6886,
    "lng": 25.2858,
    "radiusKm": 2.0
  },
  {
    "region": "Keski-Suomi",
    "city": "Kuhmoinen",
    "area": "Pihlajakoski",
    "postalCode": 17850,
    "postalCodeMin": 17850,
    "postalCodeMax": 17859,
    "lat": 61.6818,
    "lng": 25.3537,
    "radiusKm": 2.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Kuhmoinen",
    "area": "Ruolahti",
    "postalCode": 17870,
    "postalCodeMin": 17870,
    "postalCodeMax": 17879,
    "lat": 61.601,
    "lng": 25.3714,
    "radiusKm": 3.4
  },
  {
    "region": "Keski-Suomi",
    "city": "Kuhmoinen",
    "area": "Päijälä",
    "postalCode": 17930,
    "postalCodeMin": 17930,
    "postalCodeMax": 17939,
    "lat": 61.5986,
    "lng": 24.8671,
    "radiusKm": 2.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Kuhmoinen",
    "area": "Kylämä",
    "postalCode": 17950,
    "postalCodeMin": 17950,
    "postalCodeMax": 17959,
    "lat": 61.6528,
    "lng": 25.0725,
    "radiusKm": 3.4
  },
  {
    "region": "Keski-Suomi",
    "city": "Kuhmoinen",
    "area": "Puukkoinen",
    "postalCode": 17970,
    "postalCodeMin": 17970,
    "postalCodeMax": 17979,
    "lat": 61.7146,
    "lng": 25.1375,
    "radiusKm": 2.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Kyyjärvi",
    "area": "Kyyjärvi",
    "postalCode": 43700,
    "postalCodeMin": 43700,
    "postalCodeMax": 43709,
    "lat": 63.0431,
    "lng": 24.5649,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Kyyjärvi",
    "area": "Kumpulainen",
    "postalCode": 43720,
    "postalCodeMin": 43720,
    "postalCodeMax": 43729,
    "lat": 63.0596,
    "lng": 24.7569,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Vehniä",
    "postalCode": 41180,
    "postalCodeMin": 41180,
    "postalCodeMax": 41189,
    "lat": 62.4463,
    "lng": 25.6768,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Leppävesi",
    "postalCode": 41310,
    "postalCodeMin": 41310,
    "postalCodeMax": 41319,
    "lat": 62.3262,
    "lng": 25.8387,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Laukkavirta",
    "postalCode": 41325,
    "postalCodeMin": 41320,
    "postalCodeMax": 41329,
    "lat": 62.3757,
    "lng": 26.0633,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Vihtavuori",
    "postalCode": 41330,
    "postalCodeMin": 41330,
    "postalCodeMax": 41339,
    "lat": 62.3683,
    "lng": 25.9023,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Laukaa",
    "postalCode": 41340,
    "postalCodeMin": 41340,
    "postalCodeMax": 41349,
    "lat": 62.3927,
    "lng": 25.9553,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Laukaa as",
    "postalCode": 41350,
    "postalCodeMin": 41350,
    "postalCodeMax": 41359,
    "lat": 62.437,
    "lng": 25.8918,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Valkola",
    "postalCode": 41360,
    "postalCodeMin": 41360,
    "postalCodeMax": 41369,
    "lat": 62.4672,
    "lng": 25.8173,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Kuusa",
    "postalCode": 41370,
    "postalCodeMin": 41370,
    "postalCodeMax": 41379,
    "lat": 62.4606,
    "lng": 25.9413,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Äijälä",
    "postalCode": 41390,
    "postalCodeMin": 41390,
    "postalCodeMax": 41399,
    "lat": 62.5257,
    "lng": 26.0515,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Laukaa",
    "area": "Lievestuore",
    "postalCode": 41400,
    "postalCodeMin": 41400,
    "postalCodeMax": 41409,
    "lat": 62.262,
    "lng": 26.2012,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Luhanka",
    "area": "Tammijärvi",
    "postalCode": 19910,
    "postalCodeMin": 19910,
    "postalCodeMax": 19919,
    "lat": 61.8307,
    "lng": 25.8215,
    "radiusKm": 4.5
  },
  {
    "region": "Keski-Suomi",
    "city": "Luhanka",
    "area": "Luhanka",
    "postalCode": 19950,
    "postalCodeMin": 19950,
    "postalCodeMax": 19959,
    "lat": 61.7969,
    "lng": 25.7036,
    "radiusKm": 2.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Multia",
    "area": "Multia",
    "postalCode": 42600,
    "postalCodeMin": 42600,
    "postalCodeMax": 42609,
    "lat": 62.4098,
    "lng": 24.7982,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Multia",
    "area": "Sahrajärvi",
    "postalCode": 42660,
    "postalCodeMin": 42660,
    "postalCodeMax": 42669,
    "lat": 62.5366,
    "lng": 25.0587,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Multia",
    "area": "Väätäiskylä",
    "postalCode": 43430,
    "postalCodeMin": 43430,
    "postalCodeMax": 43439,
    "lat": 62.5893,
    "lng": 24.5926,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Muurame",
    "area": "Kinkomaa",
    "postalCode": 40930,
    "postalCodeMin": 40930,
    "postalCodeMax": 40939,
    "lat": 62.1579,
    "lng": 25.7537,
    "radiusKm": 6.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Muurame",
    "area": "Muurame",
    "postalCode": 40950,
    "postalCodeMin": 40950,
    "postalCodeMax": 40959,
    "lat": 62.1292,
    "lng": 25.6759,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Petäjävesi",
    "area": "Petäjävesi",
    "postalCode": 41900,
    "postalCodeMin": 41900,
    "postalCodeMax": 41909,
    "lat": 62.2571,
    "lng": 25.1884,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Petäjävesi",
    "area": "Kintaus",
    "postalCode": 41920,
    "postalCodeMin": 41920,
    "postalCodeMax": 41929,
    "lat": 62.2743,
    "lng": 25.3338,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Petäjävesi",
    "area": "Ylä-Kintaus",
    "postalCode": 41925,
    "postalCodeMin": 41920,
    "postalCodeMax": 41929,
    "lat": 62.3618,
    "lng": 25.316,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Petäjävesi",
    "area": "Kuivasmäki",
    "postalCode": 41980,
    "postalCodeMin": 41980,
    "postalCodeMax": 41989,
    "lat": 62.3277,
    "lng": 25.1788,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Pihtipudas",
    "area": "Pihtipudas",
    "postalCode": 44800,
    "postalCodeMin": 44800,
    "postalCodeMax": 44809,
    "lat": 63.3706,
    "lng": 25.5755,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Pihtipudas",
    "area": "Alvajärvi",
    "postalCode": 44860,
    "postalCodeMin": 44860,
    "postalCodeMax": 44869,
    "lat": 63.4357,
    "lng": 25.3777,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Pihtipudas",
    "area": "Muurasjärvi",
    "postalCode": 44880,
    "postalCodeMin": 44880,
    "postalCodeMax": 44889,
    "lat": 63.544,
    "lng": 25.2463,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Pihtipudas",
    "area": "Elämäjärvi",
    "postalCode": 44910,
    "postalCodeMin": 44910,
    "postalCodeMax": 44919,
    "lat": 63.4814,
    "lng": 25.6569,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Pihtipudas",
    "area": "Peninki",
    "postalCode": 44920,
    "postalCodeMin": 44920,
    "postalCodeMax": 44929,
    "lat": 63.4531,
    "lng": 25.7032,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Pihtipudas",
    "area": "Kärväsjärvi",
    "postalCode": 44950,
    "postalCodeMin": 44950,
    "postalCodeMax": 44959,
    "lat": 63.3688,
    "lng": 25.7468,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Pihtipudas",
    "area": "Korppinen",
    "postalCode": 44970,
    "postalCodeMin": 44970,
    "postalCodeMax": 44979,
    "lat": 63.3445,
    "lng": 25.899,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Hoikankylä",
    "postalCode": 41260,
    "postalCodeMin": 41260,
    "postalCodeMax": 41269,
    "lat": 62.5724,
    "lng": 25.3357,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Lannevesi",
    "postalCode": 41270,
    "postalCodeMin": 41270,
    "postalCodeMax": 41279,
    "lat": 62.6062,
    "lng": 25.3976,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Saarijärvi",
    "postalCode": 43100,
    "postalCodeMin": 43100,
    "postalCodeMax": 43109,
    "lat": 62.7067,
    "lng": 25.2554,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Tarvaala",
    "postalCode": 43130,
    "postalCodeMin": 43130,
    "postalCodeMax": 43139,
    "lat": 62.6551,
    "lng": 25.3102,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Häkkilä",
    "postalCode": 43170,
    "postalCodeMin": 43170,
    "postalCodeMax": 43179,
    "lat": 62.7858,
    "lng": 25.4561,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Mahlu",
    "postalCode": 43220,
    "postalCodeMin": 43220,
    "postalCodeMax": 43229,
    "lat": 62.6485,
    "lng": 25.0232,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Lehtola",
    "postalCode": 43240,
    "postalCodeMin": 43240,
    "postalCodeMax": 43249,
    "lat": 62.7232,
    "lng": 25.0158,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Kolkanlahti",
    "postalCode": 43250,
    "postalCodeMin": 43250,
    "postalCodeMax": 43259,
    "lat": 62.7381,
    "lng": 25.1739,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Kalmari",
    "postalCode": 43270,
    "postalCodeMin": 43270,
    "postalCodeMax": 43279,
    "lat": 62.8051,
    "lng": 25.0494,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Kukko",
    "postalCode": 43420,
    "postalCodeMin": 43420,
    "postalCodeMax": 43429,
    "lat": 62.6179,
    "lng": 24.7547,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Pylkönmäki",
    "postalCode": 43440,
    "postalCodeMin": 43440,
    "postalCodeMax": 43449,
    "lat": 62.6683,
    "lng": 24.8061,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Saarijärvi",
    "area": "Pääjärvi",
    "postalCode": 43480,
    "postalCodeMin": 43480,
    "postalCodeMax": 43489,
    "lat": 62.7686,
    "lng": 24.8339,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Toivakka",
    "area": "Kankainen",
    "postalCode": 41410,
    "postalCodeMin": 41410,
    "postalCodeMax": 41419,
    "lat": 62.1859,
    "lng": 26.2586,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Toivakka",
    "area": "Ruuhimäki",
    "postalCode": 41440,
    "postalCodeMin": 41440,
    "postalCodeMax": 41449,
    "lat": 62.2022,
    "lng": 26.1662,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Toivakka",
    "area": "Toivakka",
    "postalCode": 41660,
    "postalCodeMin": 41660,
    "postalCodeMax": 41669,
    "lat": 62.098,
    "lng": 26.0817,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Uurainen",
    "area": "Jokihaara",
    "postalCode": 41210,
    "postalCodeMin": 41210,
    "postalCodeMax": 41219,
    "lat": 62.4283,
    "lng": 25.4975,
    "radiusKm": 5.0
  },
  {
    "region": "Keski-Suomi",
    "city": "Uurainen",
    "area": "Höytiä",
    "postalCode": 41220,
    "postalCodeMin": 41220,
    "postalCodeMax": 41229,
    "lat": 62.4251,
    "lng": 25.3739,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Uurainen",
    "area": "Uurainen",
    "postalCode": 41230,
    "postalCodeMin": 41230,
    "postalCodeMax": 41239,
    "lat": 62.4969,
    "lng": 25.4418,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Uurainen",
    "area": "Kyynämöinen",
    "postalCode": 41240,
    "postalCodeMin": 41240,
    "postalCodeMax": 41249,
    "lat": 62.4842,
    "lng": 25.2974,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Uurainen",
    "area": "Kangashäkki",
    "postalCode": 41290,
    "postalCodeMin": 41290,
    "postalCodeMax": 41299,
    "lat": 62.5302,
    "lng": 25.6016,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Niinilahti",
    "postalCode": 44480,
    "postalCodeMin": 44480,
    "postalCodeMax": 44489,
    "lat": 62.9261,
    "lng": 25.8116,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Viitasaari",
    "postalCode": 44500,
    "postalCodeMin": 44500,
    "postalCodeMax": 44509,
    "lat": 63.0734,
    "lng": 25.8597,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Ilmolahti",
    "postalCode": 44530,
    "postalCodeMin": 44530,
    "postalCodeMax": 44539,
    "lat": 62.9848,
    "lng": 25.8711,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Huopanankoski",
    "postalCode": 44580,
    "postalCodeMin": 44580,
    "postalCodeMax": 44589,
    "lat": 63.0454,
    "lng": 25.535,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Vuorilahti",
    "postalCode": 44590,
    "postalCodeMin": 44590,
    "postalCodeMax": 44599,
    "lat": 62.9807,
    "lng": 25.5568,
    "radiusKm": 4.2
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Kärnä",
    "postalCode": 44610,
    "postalCodeMin": 44610,
    "postalCodeMax": 44619,
    "lat": 63.1714,
    "lng": 25.9403,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Kumpumäki",
    "postalCode": 44630,
    "postalCodeMin": 44630,
    "postalCodeMax": 44639,
    "lat": 63.1846,
    "lng": 26.0621,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Kymönkoski",
    "postalCode": 44640,
    "postalCodeMin": 44640,
    "postalCodeMax": 44649,
    "lat": 63.1143,
    "lng": 25.9451,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Suovanlahti",
    "postalCode": 44670,
    "postalCodeMin": 44670,
    "postalCodeMax": 44679,
    "lat": 63.0097,
    "lng": 26.0699,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Lahnanen",
    "postalCode": 44680,
    "postalCodeMin": 44680,
    "postalCodeMax": 44689,
    "lat": 63.0617,
    "lng": 26.1242,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Löytänä",
    "postalCode": 44730,
    "postalCodeMin": 44730,
    "postalCodeMax": 44739,
    "lat": 63.2381,
    "lng": 25.6644,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Keitelepohja",
    "postalCode": 44740,
    "postalCodeMin": 44740,
    "postalCodeMax": 44749,
    "lat": 63.2046,
    "lng": 25.5515,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Keihärinkoski",
    "postalCode": 44760,
    "postalCodeMin": 44760,
    "postalCodeMax": 44769,
    "lat": 63.1127,
    "lng": 25.5618,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Valkeisjärvi",
    "postalCode": 44770,
    "postalCodeMin": 44770,
    "postalCodeMax": 44779,
    "lat": 63.1641,
    "lng": 25.3784,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Viitasaari",
    "area": "Kotvala",
    "postalCode": 44790,
    "postalCodeMin": 44790,
    "postalCodeMax": 44799,
    "lat": 63.2185,
    "lng": 25.4016,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Äänekoski",
    "postalCode": 44100,
    "postalCodeMin": 44100,
    "postalCodeMax": 44109,
    "lat": 62.6016,
    "lng": 25.7278,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Äänekoski",
    "postalCode": 44120,
    "postalCodeMin": 44120,
    "postalCodeMax": 44129,
    "lat": 62.6236,
    "lng": 25.7316,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Äänekoski",
    "postalCode": 44150,
    "postalCodeMin": 44150,
    "postalCodeMax": 44159,
    "lat": 62.6016,
    "lng": 25.7278,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Huutomäki",
    "postalCode": 44160,
    "postalCodeMin": 44160,
    "postalCodeMax": 44169,
    "lat": 62.572,
    "lng": 25.672,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Hietama",
    "postalCode": 44170,
    "postalCodeMin": 44170,
    "postalCodeMax": 44179,
    "lat": 62.6018,
    "lng": 25.5786,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Parantala",
    "postalCode": 44190,
    "postalCodeMin": 44190,
    "postalCodeMax": 44199,
    "lat": 62.6502,
    "lng": 25.5016,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Suolahti",
    "postalCode": 44200,
    "postalCodeMin": 44200,
    "postalCodeMax": 44209,
    "lat": 62.5679,
    "lng": 25.8536,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Suolahti",
    "postalCode": 44220,
    "postalCodeMin": 44220,
    "postalCodeMax": 44229,
    "lat": 62.6122,
    "lng": 25.8216,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Äänekoivisto",
    "postalCode": 44250,
    "postalCodeMin": 44250,
    "postalCodeMax": 44259,
    "lat": 62.5328,
    "lng": 25.8209,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Vihijärvi",
    "postalCode": 44260,
    "postalCodeMin": 44260,
    "postalCodeMax": 44269,
    "lat": 62.6324,
    "lng": 25.9645,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Sumiainen",
    "postalCode": 44280,
    "postalCodeMin": 44280,
    "postalCodeMax": 44289,
    "lat": 62.6572,
    "lng": 26.0472,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Konginkangas",
    "postalCode": 44400,
    "postalCodeMin": 44400,
    "postalCodeMax": 44409,
    "lat": 62.7791,
    "lng": 25.8062,
    "radiusKm": 5.6
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Liimattala",
    "postalCode": 44420,
    "postalCodeMin": 44420,
    "postalCodeMax": 44429,
    "lat": 62.7223,
    "lng": 25.8022,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Räihä",
    "postalCode": 44440,
    "postalCodeMin": 44440,
    "postalCodeMax": 44449,
    "lat": 62.8413,
    "lng": 25.8199,
    "radiusKm": 2.8
  },
  {
    "region": "Keski-Suomi",
    "city": "Äänekoski",
    "area": "Kalaniemi",
    "postalCode": 44460,
    "postalCodeMin": 44460,
    "postalCodeMax": 44469,
    "lat": 62.871,
    "lng": 25.8235,
    "radiusKm": 5.0
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Kurejoki",
    "postalCode": 62710,
    "postalCodeMin": 62710,
    "postalCodeMax": 62719,
    "lat": 63.0014,
    "lng": 23.7043,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Sissala",
    "postalCode": 62720,
    "postalCodeMin": 62720,
    "postalCodeMax": 62729,
    "lat": 63.0098,
    "lng": 23.6128,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Haukkala",
    "postalCode": 62730,
    "postalCodeMin": 62730,
    "postalCodeMax": 62739,
    "lat": 63.0321,
    "lng": 23.6814,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Koskenvarsi",
    "postalCode": 62740,
    "postalCodeMin": 62740,
    "postalCodeMax": 62749,
    "lat": 62.9791,
    "lng": 23.7491,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Saukonkylä",
    "postalCode": 62750,
    "postalCodeMin": 62750,
    "postalCodeMax": 62759,
    "lat": 62.9463,
    "lng": 23.7395,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Menkijärvi",
    "postalCode": 62760,
    "postalCodeMin": 62760,
    "postalCodeMax": 62769,
    "lat": 62.9653,
    "lng": 23.5591,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Luoma-aho",
    "postalCode": 62830,
    "postalCodeMin": 62830,
    "postalCodeMax": 62839,
    "lat": 63.0901,
    "lng": 23.855,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Alajärvi",
    "postalCode": 62900,
    "postalCodeMin": 62900,
    "postalCodeMax": 62909,
    "lat": 63.0001,
    "lng": 23.8159,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Levijoki",
    "postalCode": 62920,
    "postalCodeMin": 62920,
    "postalCodeMax": 62929,
    "lat": 62.9761,
    "lng": 23.9484,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Hoisko",
    "postalCode": 62940,
    "postalCodeMin": 62940,
    "postalCodeMax": 62949,
    "lat": 63.0338,
    "lng": 23.8716,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Paalijärvi",
    "postalCode": 62950,
    "postalCodeMin": 62950,
    "postalCodeMax": 62959,
    "lat": 63.0621,
    "lng": 23.9091,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Möksy",
    "postalCode": 62990,
    "postalCodeMin": 62990,
    "postalCodeMax": 62999,
    "lat": 63.0377,
    "lng": 24.2464,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Leppälänkylä",
    "postalCode": 63120,
    "postalCodeMin": 63120,
    "postalCodeMax": 63129,
    "lat": 62.7868,
    "lng": 23.6067,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Lehtimäki",
    "postalCode": 63500,
    "postalCodeMin": 63500,
    "postalCodeMax": 63509,
    "lat": 62.8179,
    "lng": 23.9434,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Lehtimäki kk",
    "postalCode": 63510,
    "postalCodeMin": 63510,
    "postalCodeMax": 63519,
    "lat": 62.7903,
    "lng": 23.9264,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Länsikylä",
    "postalCode": 63530,
    "postalCodeMin": 63530,
    "postalCodeMax": 63539,
    "lat": 62.8418,
    "lng": 23.7736,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alajärvi",
    "area": "Hernesmaa",
    "postalCode": 63540,
    "postalCodeMin": 63540,
    "postalCodeMax": 63549,
    "lat": 62.8303,
    "lng": 23.9619,
    "radiusKm": 7.9
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Pasto",
    "postalCode": 61140,
    "postalCodeMin": 61140,
    "postalCodeMax": 61149,
    "lat": 62.618,
    "lng": 23.1528,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Sydänmaa",
    "postalCode": 61150,
    "postalCodeMin": 61150,
    "postalCodeMax": 61159,
    "lat": 62.67,
    "lng": 23.2004,
    "radiusKm": 7.9
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Sääskiniemi",
    "postalCode": 61170,
    "postalCodeMin": 61170,
    "postalCodeMax": 61179,
    "lat": 62.6496,
    "lng": 23.2823,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Kitinoja",
    "postalCode": 61470,
    "postalCodeMin": 61470,
    "postalCodeMax": 61479,
    "lat": 62.9129,
    "lng": 22.8046,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Salmi",
    "postalCode": 63160,
    "postalCodeMin": 63160,
    "postalCodeMax": 63169,
    "lat": 62.5865,
    "lng": 23.6187,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Niinimaa",
    "postalCode": 63210,
    "postalCodeMin": 63210,
    "postalCodeMax": 63219,
    "lat": 62.6436,
    "lng": 23.4131,
    "radiusKm": 7.9
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Alavus",
    "postalCode": 63300,
    "postalCodeMin": 63300,
    "postalCodeMax": 63309,
    "lat": 62.5865,
    "lng": 23.6187,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Kattelus",
    "postalCode": 63320,
    "postalCodeMin": 63320,
    "postalCodeMax": 63329,
    "lat": 62.4708,
    "lng": 23.7678,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Pahajoki",
    "postalCode": 63330,
    "postalCodeMin": 63330,
    "postalCodeMax": 63339,
    "lat": 62.4897,
    "lng": 23.6199,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Sapsalampi",
    "postalCode": 63340,
    "postalCodeMin": 63340,
    "postalCodeMax": 63349,
    "lat": 62.4452,
    "lng": 23.6287,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Sulkavankylä",
    "postalCode": 63350,
    "postalCodeMin": 63350,
    "postalCodeMax": 63359,
    "lat": 62.4504,
    "lng": 23.5448,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Seinäjärvi",
    "postalCode": 63355,
    "postalCodeMin": 63350,
    "postalCodeMax": 63359,
    "lat": 62.3788,
    "lng": 23.373,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Kuivaskylä",
    "postalCode": 63360,
    "postalCodeMin": 63360,
    "postalCodeMax": 63369,
    "lat": 62.5905,
    "lng": 23.4607,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Taipalus",
    "postalCode": 63370,
    "postalCodeMin": 63370,
    "postalCodeMax": 63379,
    "lat": 62.5804,
    "lng": 23.3486,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Alavus as",
    "postalCode": 63400,
    "postalCodeMin": 63400,
    "postalCodeMax": 63409,
    "lat": 62.6175,
    "lng": 23.6068,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Rantatöysä",
    "postalCode": 63410,
    "postalCodeMin": 63410,
    "postalCodeMax": 63419,
    "lat": 62.6374,
    "lng": 23.6333,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Kätkänjoki",
    "postalCode": 63430,
    "postalCodeMin": 63430,
    "postalCodeMax": 63439,
    "lat": 62.6951,
    "lng": 23.6594,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Töysä",
    "postalCode": 63600,
    "postalCodeMin": 63600,
    "postalCodeMax": 63609,
    "lat": 62.6274,
    "lng": 23.8123,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Tuuri",
    "postalCode": 63610,
    "postalCodeMin": 63610,
    "postalCodeMax": 63619,
    "lat": 62.6054,
    "lng": 23.741,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Ritola",
    "postalCode": 63640,
    "postalCodeMin": 63640,
    "postalCodeMax": 63649,
    "lat": 62.7018,
    "lng": 23.8816,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Alavus",
    "area": "Hakojärvi",
    "postalCode": 63680,
    "postalCodeMin": 63680,
    "postalCodeMax": 63689,
    "lat": 62.6044,
    "lng": 23.9123,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Evijärvi",
    "area": "Evijärvi",
    "postalCode": 62500,
    "postalCodeMin": 62500,
    "postalCodeMax": 62509,
    "lat": 63.3641,
    "lng": 23.4861,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Evijärvi",
    "area": "Kuoppa-aho",
    "postalCode": 62510,
    "postalCodeMin": 62510,
    "postalCodeMax": 62519,
    "lat": 63.3593,
    "lng": 23.4512,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Evijärvi",
    "area": "Kautiainen",
    "postalCode": 62520,
    "postalCodeMin": 62520,
    "postalCodeMax": 62529,
    "lat": 63.3311,
    "lng": 23.4261,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Evijärvi",
    "area": "Vasikka-aho",
    "postalCode": 62540,
    "postalCodeMin": 62540,
    "postalCodeMax": 62549,
    "lat": 63.4214,
    "lng": 23.3468,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Evijärvi",
    "area": "Särkilä",
    "postalCode": 62570,
    "postalCodeMin": 62570,
    "postalCodeMax": 62579,
    "lat": 63.3319,
    "lng": 23.6694,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Evijärvi",
    "area": "Nederlappfors",
    "postalCode": 68840,
    "postalCodeMin": 68840,
    "postalCodeMax": 68849,
    "lat": 63.5132,
    "lng": 23.2753,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ilmajoki",
    "area": "Munakka",
    "postalCode": 60450,
    "postalCodeMin": 60450,
    "postalCodeMax": 60459,
    "lat": 62.8425,
    "lng": 22.7337,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ilmajoki",
    "area": "Tuomikylä",
    "postalCode": 60720,
    "postalCodeMin": 60720,
    "postalCodeMax": 60729,
    "lat": 62.7327,
    "lng": 22.7112,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ilmajoki",
    "area": "Pojanluoma",
    "postalCode": 60760,
    "postalCodeMin": 60760,
    "postalCodeMax": 60769,
    "lat": 62.6916,
    "lng": 22.7391,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ilmajoki",
    "area": "Ilmajoki",
    "postalCode": 60800,
    "postalCodeMin": 60800,
    "postalCodeMax": 60809,
    "lat": 62.7346,
    "lng": 22.5709,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ilmajoki",
    "area": "Koskenkorva",
    "postalCode": 61330,
    "postalCodeMin": 61330,
    "postalCodeMax": 61339,
    "lat": 62.691,
    "lng": 22.4539,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ilmajoki",
    "area": "Nopankylä",
    "postalCode": 61340,
    "postalCodeMin": 61340,
    "postalCodeMax": 61349,
    "lat": 62.7168,
    "lng": 22.2815,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ilmajoki",
    "area": "Huissi",
    "postalCode": 61350,
    "postalCodeMin": 61350,
    "postalCodeMax": 61359,
    "lat": 62.7599,
    "lng": 22.3785,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Isojoki",
    "area": "Vanhakylä",
    "postalCode": 64810,
    "postalCodeMin": 64810,
    "postalCodeMax": 64819,
    "lat": 62.1865,
    "lng": 21.7965,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Isojoki",
    "area": "Kärjenkoski",
    "postalCode": 64820,
    "postalCodeMin": 64820,
    "postalCodeMax": 64829,
    "lat": 62.1319,
    "lng": 21.6788,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Isojoki",
    "area": "Villamo",
    "postalCode": 64830,
    "postalCodeMin": 64830,
    "postalCodeMax": 64839,
    "lat": 62.1573,
    "lng": 21.881,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Isojoki",
    "area": "Heikkilänjoki",
    "postalCode": 64840,
    "postalCodeMin": 64840,
    "postalCodeMax": 64849,
    "lat": 62.1945,
    "lng": 21.9115,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Isojoki",
    "area": "Möykky",
    "postalCode": 64850,
    "postalCodeMin": 64850,
    "postalCodeMax": 64859,
    "lat": 62.1886,
    "lng": 21.9838,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Isojoki",
    "area": "Isojoki",
    "postalCode": 64900,
    "postalCodeMin": 64900,
    "postalCodeMax": 64909,
    "lat": 62.1141,
    "lng": 21.9577,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Isojoki",
    "area": "Kodesjärvi",
    "postalCode": 64930,
    "postalCodeMin": 64930,
    "postalCodeMax": 64939,
    "lat": 62.0525,
    "lng": 22.0671,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Karijoki",
    "area": "Karijoki",
    "postalCode": 64350,
    "postalCodeMin": 64350,
    "postalCodeMax": 64359,
    "lat": 62.3078,
    "lng": 21.7069,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Karijoki",
    "area": "Myrkky",
    "postalCode": 64370,
    "postalCodeMin": 64370,
    "postalCodeMax": 64379,
    "lat": 62.3797,
    "lng": 21.5561,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Karijoki",
    "area": "Vanhakylä",
    "postalCode": 64810,
    "postalCodeMin": 64810,
    "postalCodeMax": 64819,
    "lat": 62.1865,
    "lng": 21.7965,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Kauhajoki",
    "postalCode": 61800,
    "postalCodeMin": 61800,
    "postalCodeMax": 61809,
    "lat": 62.4363,
    "lng": 22.1875,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Luomankylä",
    "postalCode": 61810,
    "postalCodeMin": 61810,
    "postalCodeMax": 61819,
    "lat": 62.4536,
    "lng": 22.1166,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Kainasto",
    "postalCode": 61820,
    "postalCodeMin": 61820,
    "postalCodeMax": 61829,
    "lat": 62.4651,
    "lng": 22.0288,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Kauhajoki as",
    "postalCode": 61850,
    "postalCodeMin": 61850,
    "postalCodeMax": 61859,
    "lat": 62.4363,
    "lng": 22.1875,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Harja",
    "postalCode": 61860,
    "postalCodeMin": 61860,
    "postalCodeMax": 61869,
    "lat": 62.517,
    "lng": 22.2785,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Ikkeläjärvi",
    "postalCode": 61880,
    "postalCodeMin": 61880,
    "postalCodeMax": 61889,
    "lat": 62.3904,
    "lng": 22.5673,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Nummijärvi",
    "postalCode": 61910,
    "postalCodeMin": 61910,
    "postalCodeMax": 61919,
    "lat": 62.2901,
    "lng": 22.4433,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Nummikoski",
    "postalCode": 61920,
    "postalCodeMin": 61920,
    "postalCodeMax": 61929,
    "lat": 62.2512,
    "lng": 22.5104,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Hyyppä",
    "postalCode": 61940,
    "postalCodeMin": 61940,
    "postalCodeMax": 61949,
    "lat": 62.3373,
    "lng": 22.2319,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Juonikylä",
    "postalCode": 61950,
    "postalCodeMin": 61950,
    "postalCodeMax": 61959,
    "lat": 62.2833,
    "lng": 22.2508,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Kyrönlatva",
    "postalCode": 61960,
    "postalCodeMin": 61960,
    "postalCodeMax": 61969,
    "lat": 62.1851,
    "lng": 22.2999,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhajoki",
    "area": "Päntäne",
    "postalCode": 61980,
    "postalCodeMin": 61980,
    "postalCodeMax": 61989,
    "lat": 62.3545,
    "lng": 22.0594,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Rintakangas",
    "postalCode": 62150,
    "postalCodeMin": 62150,
    "postalCodeMax": 62159,
    "lat": 63.0791,
    "lng": 22.853,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Kauhava",
    "postalCode": 62200,
    "postalCodeMin": 62200,
    "postalCodeMax": 62209,
    "lat": 63.1012,
    "lng": 23.065,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Pernaa",
    "postalCode": 62220,
    "postalCodeMin": 62220,
    "postalCodeMax": 62229,
    "lat": 63.0913,
    "lng": 22.9617,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Jylhä",
    "postalCode": 62230,
    "postalCodeMin": 62230,
    "postalCodeMax": 62239,
    "lat": 63.1058,
    "lng": 23.1419,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Huhmarkoski",
    "postalCode": 62240,
    "postalCodeMin": 62240,
    "postalCodeMax": 62249,
    "lat": 63.129,
    "lng": 23.2103,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Hirvijoki",
    "postalCode": 62260,
    "postalCodeMin": 62260,
    "postalCodeMax": 62269,
    "lat": 63.0519,
    "lng": 23.2655,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Härmä",
    "postalCode": 62300,
    "postalCodeMin": 62300,
    "postalCodeMax": 62309,
    "lat": 63.2343,
    "lng": 22.8762,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Voltti",
    "postalCode": 62310,
    "postalCodeMin": 62310,
    "postalCodeMax": 62319,
    "lat": 63.2867,
    "lng": 22.8176,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Kuoppa",
    "postalCode": 62340,
    "postalCodeMin": 62340,
    "postalCodeMax": 62349,
    "lat": 63.2333,
    "lng": 22.65,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Ekola",
    "postalCode": 62350,
    "postalCodeMin": 62350,
    "postalCodeMax": 62359,
    "lat": 63.3323,
    "lng": 22.7637,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Kangasto",
    "postalCode": 62370,
    "postalCodeMin": 62370,
    "postalCodeMax": 62379,
    "lat": 63.166,
    "lng": 22.8368,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Ylihärmä",
    "postalCode": 62375,
    "postalCodeMin": 62370,
    "postalCodeMax": 62379,
    "lat": 63.1455,
    "lng": 22.7948,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Kosolankylä",
    "postalCode": 62380,
    "postalCodeMin": 62380,
    "postalCodeMax": 62389,
    "lat": 63.0794,
    "lng": 22.7779,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Rintala",
    "postalCode": 62410,
    "postalCodeMin": 62410,
    "postalCodeMax": 62419,
    "lat": 63.2174,
    "lng": 23.1433,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Kortesjärvi",
    "postalCode": 62420,
    "postalCodeMin": 62420,
    "postalCodeMax": 62429,
    "lat": 63.3021,
    "lng": 23.1574,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Peltotupa",
    "postalCode": 62430,
    "postalCodeMin": 62430,
    "postalCodeMax": 62439,
    "lat": 63.3371,
    "lng": 23.0613,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Pirttinen",
    "postalCode": 62435,
    "postalCodeMin": 62430,
    "postalCodeMax": 62439,
    "lat": 63.2861,
    "lng": 23.0234,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Perkiömäki",
    "postalCode": 62440,
    "postalCodeMin": 62440,
    "postalCodeMax": 62449,
    "lat": 63.3077,
    "lng": 22.9359,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kauhava",
    "area": "Purmojärvi",
    "postalCode": 62470,
    "postalCodeMin": 62470,
    "postalCodeMax": 62479,
    "lat": 63.2735,
    "lng": 23.2969,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kuortane",
    "area": "Kuortane",
    "postalCode": 63100,
    "postalCodeMin": 63100,
    "postalCodeMax": 63109,
    "lat": 62.807,
    "lng": 23.5069,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kuortane",
    "area": "Leppälänkylä",
    "postalCode": 63120,
    "postalCodeMin": 63120,
    "postalCodeMax": 63129,
    "lat": 62.7868,
    "lng": 23.6067,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kuortane",
    "area": "Mäyry",
    "postalCode": 63130,
    "postalCodeMin": 63130,
    "postalCodeMax": 63139,
    "lat": 62.7692,
    "lng": 23.5167,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kuortane",
    "area": "Ruona",
    "postalCode": 63150,
    "postalCodeMin": 63150,
    "postalCodeMax": 63159,
    "lat": 62.8453,
    "lng": 23.4881,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kuortane",
    "area": "Salmi",
    "postalCode": 63160,
    "postalCodeMin": 63160,
    "postalCodeMax": 63169,
    "lat": 62.865,
    "lng": 23.4115,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kuortane",
    "area": "Lentilä",
    "postalCode": 63230,
    "postalCodeMin": 63230,
    "postalCodeMax": 63239,
    "lat": 62.7,
    "lng": 23.5404,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kuortane",
    "area": "Rantala",
    "postalCode": 63250,
    "postalCodeMin": 63250,
    "postalCodeMax": 63259,
    "lat": 62.7251,
    "lng": 23.5154,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kuortane",
    "area": "Löyä",
    "postalCode": 63450,
    "postalCodeMin": 63450,
    "postalCodeMax": 63459,
    "lat": 62.7512,
    "lng": 23.7607,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Myllysalo",
    "postalCode": 61220,
    "postalCodeMin": 61220,
    "postalCodeMax": 61229,
    "lat": 62.5994,
    "lng": 22.4838,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Luopa",
    "postalCode": 61230,
    "postalCodeMin": 61230,
    "postalCodeMax": 61239,
    "lat": 62.5918,
    "lng": 22.5349,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Jalasto",
    "postalCode": 61250,
    "postalCodeMin": 61250,
    "postalCodeMax": 61259,
    "lat": 62.5421,
    "lng": 22.6626,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Luopajärvi",
    "postalCode": 61270,
    "postalCodeMin": 61270,
    "postalCodeMax": 61279,
    "lat": 62.5795,
    "lng": 22.75,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Jokipii",
    "postalCode": 61280,
    "postalCodeMin": 61280,
    "postalCodeMax": 61289,
    "lat": 62.525,
    "lng": 22.6912,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Taivalmaa",
    "postalCode": 61290,
    "postalCodeMin": 61290,
    "postalCodeMax": 61299,
    "lat": 62.5554,
    "lng": 22.8857,
    "radiusKm": 7.9
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Kurikka",
    "postalCode": 61300,
    "postalCodeMin": 61300,
    "postalCodeMax": 61309,
    "lat": 62.6171,
    "lng": 22.3987,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Panttila",
    "postalCode": 61310,
    "postalCodeMin": 61310,
    "postalCodeMax": 61319,
    "lat": 62.6596,
    "lng": 22.4031,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Mieto",
    "postalCode": 61360,
    "postalCodeMin": 61360,
    "postalCodeMax": 61369,
    "lat": 62.5834,
    "lng": 22.3491,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Lohiluoma",
    "postalCode": 61370,
    "postalCodeMin": 61370,
    "postalCodeMax": 61379,
    "lat": 62.5452,
    "lng": 22.297,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Polvenkylä",
    "postalCode": 61380,
    "postalCodeMin": 61380,
    "postalCodeMax": 61389,
    "lat": 62.5762,
    "lng": 22.153,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Jalasjärvi",
    "postalCode": 61600,
    "postalCodeMin": 61600,
    "postalCodeMax": 61609,
    "lat": 62.4902,
    "lng": 22.7592,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Hirvijärvi",
    "postalCode": 61630,
    "postalCodeMin": 61630,
    "postalCodeMax": 61639,
    "lat": 62.4687,
    "lng": 22.8117,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Ala-Valli",
    "postalCode": 61640,
    "postalCodeMin": 61640,
    "postalCodeMax": 61649,
    "lat": 62.4632,
    "lng": 22.9731,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Mantila",
    "postalCode": 61680,
    "postalCodeMin": 61680,
    "postalCodeMax": 61689,
    "lat": 62.4484,
    "lng": 22.7744,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Pentinmäki",
    "postalCode": 61710,
    "postalCodeMin": 61710,
    "postalCodeMax": 61719,
    "lat": 62.4036,
    "lng": 22.7876,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Koskue",
    "postalCode": 61720,
    "postalCodeMin": 61720,
    "postalCodeMax": 61729,
    "lat": 62.3604,
    "lng": 22.8404,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Yli-Valli",
    "postalCode": 61730,
    "postalCodeMin": 61730,
    "postalCodeMax": 61739,
    "lat": 62.3814,
    "lng": 22.9565,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Ilvesjoki",
    "postalCode": 61760,
    "postalCodeMin": 61760,
    "postalCodeMax": 61769,
    "lat": 62.3447,
    "lng": 22.7127,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Jurva",
    "postalCode": 66300,
    "postalCodeMin": 66300,
    "postalCodeMax": 66309,
    "lat": 62.6827,
    "lng": 21.9723,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Niemenkylä",
    "postalCode": 66320,
    "postalCodeMin": 66320,
    "postalCodeMax": 66329,
    "lat": 62.7164,
    "lng": 21.9153,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Hakko",
    "postalCode": 66330,
    "postalCodeMin": 66330,
    "postalCodeMax": 66339,
    "lat": 62.7422,
    "lng": 21.8539,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Sarvijoki",
    "postalCode": 66340,
    "postalCodeMin": 66340,
    "postalCodeMax": 66349,
    "lat": 62.8231,
    "lng": 21.8023,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Tainus",
    "postalCode": 66350,
    "postalCodeMin": 66350,
    "postalCodeMax": 66359,
    "lat": 62.6172,
    "lng": 22.3987,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Kesti",
    "postalCode": 66360,
    "postalCodeMin": 66360,
    "postalCodeMax": 66369,
    "lat": 62.6317,
    "lng": 21.8785,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Kurikka",
    "area": "Närvijoki",
    "postalCode": 66370,
    "postalCodeMin": 66370,
    "postalCodeMax": 66379,
    "lat": 62.6568,
    "lng": 21.7701,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lappajärvi",
    "area": "Lappajärvi",
    "postalCode": 62600,
    "postalCodeMin": 62600,
    "postalCodeMax": 62609,
    "lat": 63.2248,
    "lng": 23.6296,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lappajärvi",
    "area": "Tarvola",
    "postalCode": 62610,
    "postalCodeMin": 62610,
    "postalCodeMax": 62619,
    "lat": 63.2042,
    "lng": 23.5687,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lappajärvi",
    "area": "Ala-Seppä",
    "postalCode": 62620,
    "postalCodeMin": 62620,
    "postalCodeMax": 62629,
    "lat": 63.1752,
    "lng": 23.5429,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lappajärvi",
    "area": "Karvala",
    "postalCode": 62630,
    "postalCodeMin": 62630,
    "postalCodeMax": 62639,
    "lat": 63.1425,
    "lng": 23.5396,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lappajärvi",
    "area": "Savonkylä",
    "postalCode": 62640,
    "postalCodeMin": 62640,
    "postalCodeMax": 62649,
    "lat": 63.0492,
    "lng": 23.5666,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lappajärvi",
    "area": "Itäkylä",
    "postalCode": 62660,
    "postalCodeMin": 62660,
    "postalCodeMax": 62669,
    "lat": 63.2294,
    "lng": 23.7366,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Lapua",
    "postalCode": 62100,
    "postalCodeMin": 62100,
    "postalCodeMax": 62109,
    "lat": 62.972,
    "lng": 23.0024,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Hellanmaa",
    "postalCode": 62130,
    "postalCodeMin": 62130,
    "postalCodeMax": 62139,
    "lat": 63.0369,
    "lng": 22.837,
    "radiusKm": 7.9
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Karhunkylä",
    "postalCode": 62160,
    "postalCodeMin": 62160,
    "postalCodeMax": 62169,
    "lat": 62.9392,
    "lng": 23.1587,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Tiistenjoki",
    "postalCode": 62165,
    "postalCodeMin": 62160,
    "postalCodeMax": 62169,
    "lat": 62.9091,
    "lng": 23.2426,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Lakaluoma",
    "postalCode": 62170,
    "postalCodeMin": 62170,
    "postalCodeMax": 62179,
    "lat": 62.9258,
    "lng": 23.3288,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Ylikylä",
    "postalCode": 62175,
    "postalCodeMin": 62170,
    "postalCodeMax": 62179,
    "lat": 62.858,
    "lng": 23.2803,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Mäki-Paavola",
    "postalCode": 62185,
    "postalCodeMin": 62180,
    "postalCodeMax": 62189,
    "lat": 62.8992,
    "lng": 23.2141,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Ruha",
    "postalCode": 62190,
    "postalCodeMin": 62190,
    "postalCodeMax": 62199,
    "lat": 62.9071,
    "lng": 22.976,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Mustamaa",
    "postalCode": 62280,
    "postalCodeMin": 62280,
    "postalCodeMax": 62289,
    "lat": 63.0149,
    "lng": 23.2038,
    "radiusKm": 7.9
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Hirvikylä",
    "postalCode": 62290,
    "postalCodeMin": 62290,
    "postalCodeMax": 62299,
    "lat": 62.9874,
    "lng": 23.3484,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Lapua",
    "area": "Kauhajärvi",
    "postalCode": 62295,
    "postalCodeMin": 62290,
    "postalCodeMax": 62299,
    "lat": 63.0206,
    "lng": 23.4327,
    "radiusKm": 7.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "keskusta, Kapernaumi, Länsi-Kivistö, Uppa",
    "postalCode": 60100,
    "postalCodeMin": 60100,
    "postalCodeMax": 60109,
    "lat": 62.7865,
    "lng": 22.8737,
    "radiusKm": 2.2
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Seinäjoki",
    "postalCode": 60110,
    "postalCodeMin": 60110,
    "postalCodeMax": 60119,
    "lat": 62.7877,
    "lng": 22.8504,
    "radiusKm": 7.8
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Pohja",
    "postalCode": 60120,
    "postalCodeMin": 60120,
    "postalCodeMax": 60129,
    "lat": 62.795,
    "lng": 22.8563,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Itä-Kivistö, Kasperi",
    "postalCode": 60150,
    "postalCodeMin": 60150,
    "postalCodeMax": 60159,
    "lat": 62.773,
    "lng": 22.8628,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Törnävä",
    "postalCode": 60200,
    "postalCodeMin": 60200,
    "postalCodeMax": 60209,
    "lat": 62.7592,
    "lng": 22.8412,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Huhtala",
    "postalCode": 60220,
    "postalCodeMin": 60220,
    "postalCodeMax": 60229,
    "lat": 62.7774,
    "lng": 22.8302,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Eskoo",
    "postalCode": 60280,
    "postalCodeMin": 60280,
    "postalCodeMax": 60289,
    "lat": 62.7316,
    "lng": 22.8613,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Jouppi, Katajalaakso",
    "postalCode": 60320,
    "postalCodeMin": 60320,
    "postalCodeMax": 60329,
    "lat": 62.7924,
    "lng": 22.8073,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Aunes, Heikkilä, Impivaara, Kiikku",
    "postalCode": 60420,
    "postalCodeMin": 60420,
    "postalCodeMax": 60429,
    "lat": 62.8269,
    "lng": 22.7521,
    "radiusKm": 9.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Hyllykallio",
    "postalCode": 60510,
    "postalCodeMin": 60510,
    "postalCodeMax": 60519,
    "lat": 62.7984,
    "lng": 22.886,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Nurmo",
    "postalCode": 60550,
    "postalCodeMin": 60550,
    "postalCodeMax": 60559,
    "lat": 62.8292,
    "lng": 22.91,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Halkosaari",
    "postalCode": 60560,
    "postalCodeMin": 60560,
    "postalCodeMax": 60569,
    "lat": 62.8613,
    "lng": 22.7574,
    "radiusKm": 8.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Isokoski",
    "postalCode": 60640,
    "postalCodeMin": 60640,
    "postalCodeMax": 60649,
    "lat": 62.7911,
    "lng": 22.8308,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Peräseinäjoki",
    "postalCode": 61100,
    "postalCodeMin": 61100,
    "postalCodeMax": 61109,
    "lat": 62.5619,
    "lng": 23.0622,
    "radiusKm": 7.8
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Vuolle",
    "postalCode": 61110,
    "postalCodeMin": 61110,
    "postalCodeMax": 61119,
    "lat": 62.6039,
    "lng": 23.0071,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Louko",
    "postalCode": 61120,
    "postalCodeMin": 61120,
    "postalCodeMax": 61129,
    "lat": 62.64,
    "lng": 22.9589,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Pasto",
    "postalCode": 61140,
    "postalCodeMin": 61140,
    "postalCodeMax": 61149,
    "lat": 62.618,
    "lng": 23.1528,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Sydänmaa",
    "postalCode": 61150,
    "postalCodeMin": 61150,
    "postalCodeMax": 61159,
    "lat": 62.67,
    "lng": 23.2004,
    "radiusKm": 9.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Koura",
    "postalCode": 61160,
    "postalCodeMin": 61160,
    "postalCodeMax": 61169,
    "lat": 62.7162,
    "lng": 23.0994,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Haapaluoma",
    "postalCode": 61180,
    "postalCodeMin": 61180,
    "postalCodeMax": 61189,
    "lat": 62.5737,
    "lng": 23.1967,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Ylistaro",
    "postalCode": 61400,
    "postalCodeMin": 61400,
    "postalCodeMax": 61409,
    "lat": 62.94,
    "lng": 22.5142,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Ylistaro as",
    "postalCode": 61410,
    "postalCodeMin": 61410,
    "postalCodeMax": 61419,
    "lat": 62.9176,
    "lng": 22.5327,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Isorehto",
    "postalCode": 61430,
    "postalCodeMin": 61430,
    "postalCodeMax": 61439,
    "lat": 62.9347,
    "lng": 22.454,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Untamala",
    "postalCode": 61440,
    "postalCodeMin": 61440,
    "postalCodeMax": 61449,
    "lat": 63.0551,
    "lng": 22.5976,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Kylänpää",
    "postalCode": 61450,
    "postalCodeMin": 61450,
    "postalCodeMax": 61459,
    "lat": 62.9663,
    "lng": 22.6045,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Hanhikoski",
    "postalCode": 61460,
    "postalCodeMin": 61460,
    "postalCodeMax": 61469,
    "lat": 62.9622,
    "lng": 22.7105,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Kitinoja",
    "postalCode": 61470,
    "postalCodeMin": 61470,
    "postalCodeMax": 61479,
    "lat": 62.9129,
    "lng": 22.8046,
    "radiusKm": 5.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Orismala",
    "postalCode": 61550,
    "postalCodeMin": 61550,
    "postalCodeMax": 61559,
    "lat": 62.9508,
    "lng": 22.3977,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Orisberg",
    "postalCode": 61560,
    "postalCodeMin": 61560,
    "postalCodeMax": 61569,
    "lat": 62.9508,
    "lng": 22.3977,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Seinäjoki",
    "area": "Kalakoski",
    "postalCode": 61650,
    "postalCodeMin": 61650,
    "postalCodeMax": 61659,
    "lat": 62.4703,
    "lng": 23.1027,
    "radiusKm": 4.3
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Soini",
    "area": "Soini",
    "postalCode": 63800,
    "postalCodeMin": 63800,
    "postalCodeMax": 63809,
    "lat": 62.8732,
    "lng": 24.2064,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Soini",
    "area": "Keisala",
    "postalCode": 63830,
    "postalCodeMin": 63830,
    "postalCodeMax": 63839,
    "lat": 62.9772,
    "lng": 24.2139,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Soini",
    "area": "Kukonkylä",
    "postalCode": 63880,
    "postalCodeMin": 63880,
    "postalCodeMax": 63889,
    "lat": 62.7971,
    "lng": 24.1075,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Soini",
    "area": "Hautakylä",
    "postalCode": 63890,
    "postalCodeMin": 63890,
    "postalCodeMax": 63899,
    "lat": 62.7454,
    "lng": 24.1596,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Soini",
    "area": "Vehunkylä",
    "postalCode": 63950,
    "postalCodeMin": 63950,
    "postalCodeMax": 63959,
    "lat": 62.6617,
    "lng": 24.4617,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Teuva",
    "area": "Norinkylä",
    "postalCode": 61840,
    "postalCodeMin": 61840,
    "postalCodeMax": 61849,
    "lat": 62.5676,
    "lng": 22.0322,
    "radiusKm": 5.4
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Teuva",
    "area": "Teuva",
    "postalCode": 64700,
    "postalCodeMin": 64700,
    "postalCodeMax": 64709,
    "lat": 62.4795,
    "lng": 21.7391,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Teuva",
    "area": "Perälä",
    "postalCode": 64720,
    "postalCodeMin": 64720,
    "postalCodeMax": 64729,
    "lat": 62.4547,
    "lng": 21.6015,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Teuva",
    "area": "Horo",
    "postalCode": 64740,
    "postalCodeMin": 64740,
    "postalCodeMax": 64749,
    "lat": 62.6,
    "lng": 21.6333,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Teuva",
    "area": "Peltola",
    "postalCode": 64760,
    "postalCodeMin": 64760,
    "postalCodeMax": 64769,
    "lat": 62.4981,
    "lng": 21.8701,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Teuva",
    "area": "Äystö",
    "postalCode": 64770,
    "postalCodeMin": 64770,
    "postalCodeMax": 64779,
    "lat": 62.4813,
    "lng": 21.9171,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Vimpeli",
    "area": "Vimpeli",
    "postalCode": 62800,
    "postalCodeMin": 62800,
    "postalCodeMax": 62809,
    "lat": 63.1646,
    "lng": 23.8282,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Vimpeli",
    "area": "Savonjoki",
    "postalCode": 62810,
    "postalCodeMin": 62810,
    "postalCodeMax": 62819,
    "lat": 63.1344,
    "lng": 23.9336,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Vimpeli",
    "area": "Lakaniemi",
    "postalCode": 62840,
    "postalCodeMin": 62840,
    "postalCodeMax": 62849,
    "lat": 63.1215,
    "lng": 23.802,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Vimpeli",
    "area": "Sahi",
    "postalCode": 62860,
    "postalCodeMin": 62860,
    "postalCodeMax": 62869,
    "lat": 63.1817,
    "lng": 23.7743,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Vimpeli",
    "area": "Vinni",
    "postalCode": 62870,
    "postalCodeMin": 62870,
    "postalCodeMax": 62879,
    "lat": 63.2084,
    "lng": 23.9061,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Vimpeli",
    "area": "Sääksvesi",
    "postalCode": 62880,
    "postalCodeMin": 62880,
    "postalCodeMax": 62889,
    "lat": 63.2209,
    "lng": 23.9713,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ähtäri",
    "area": "Ähtärinranta",
    "postalCode": 63660,
    "postalCodeMin": 63660,
    "postalCodeMax": 63669,
    "lat": 62.7106,
    "lng": 24.0018,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ähtäri",
    "area": "Ähtäri",
    "postalCode": 63700,
    "postalCodeMin": 63700,
    "postalCodeMax": 63709,
    "lat": 62.5502,
    "lng": 24.0694,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ähtäri",
    "area": "Peränne",
    "postalCode": 63770,
    "postalCodeMin": 63770,
    "postalCodeMax": 63779,
    "lat": 62.4793,
    "lng": 23.9682,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ähtäri",
    "area": "Alastaipale",
    "postalCode": 63780,
    "postalCodeMin": 63780,
    "postalCodeMax": 63789,
    "lat": 62.4437,
    "lng": 23.9518,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ähtäri",
    "area": "Myllymäki",
    "postalCode": 63900,
    "postalCodeMin": 63900,
    "postalCodeMax": 63909,
    "lat": 62.5265,
    "lng": 24.2798,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ähtäri",
    "area": "Inhan Tehtaat",
    "postalCode": 63910,
    "postalCodeMin": 63910,
    "postalCodeMax": 63919,
    "lat": 62.5125,
    "lng": 24.1483,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ähtäri",
    "area": "Inha",
    "postalCode": 63920,
    "postalCodeMin": 63920,
    "postalCodeMax": 63929,
    "lat": 62.5496,
    "lng": 24.1524,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Pohjanmaa",
    "city": "Ähtäri",
    "area": "Vehunkylä",
    "postalCode": 63950,
    "postalCodeMin": 63950,
    "postalCodeMax": 63959,
    "lat": 62.6617,
    "lng": 24.4617,
    "radiusKm": 5.4
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Halsua",
    "area": "Halsua",
    "postalCode": 69510,
    "postalCodeMin": 69510,
    "postalCodeMax": 69519,
    "lat": 63.4636,
    "lng": 24.1673,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Halsua",
    "area": "Kanala",
    "postalCode": 69550,
    "postalCodeMin": 69550,
    "postalCodeMax": 69559,
    "lat": 63.471,
    "lng": 24.4091,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Halsua",
    "area": "Karvonen",
    "postalCode": 69570,
    "postalCodeMin": 69570,
    "postalCodeMax": 69579,
    "lat": 63.4096,
    "lng": 24.2087,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kannus (kaupunki)",
    "area": "Kannus",
    "postalCode": 69100,
    "postalCodeMin": 69100,
    "postalCodeMax": 69109,
    "lat": 63.9004,
    "lng": 23.9167,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kannus (kaupunki)",
    "area": "Eskola",
    "postalCode": 69150,
    "postalCodeMin": 69150,
    "postalCodeMax": 69159,
    "lat": 63.9154,
    "lng": 24.1563,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kannus (kaupunki)",
    "area": "Yli-Kannus",
    "postalCode": 69170,
    "postalCodeMin": 69170,
    "postalCodeMax": 69179,
    "lat": 63.8753,
    "lng": 24.022,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kaustinen",
    "area": "Kaustinen",
    "postalCode": 69600,
    "postalCodeMin": 69600,
    "postalCodeMax": 69609,
    "lat": 63.5481,
    "lng": 23.6965,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kaustinen",
    "area": "Köyhäjoki",
    "postalCode": 69660,
    "postalCodeMin": 69660,
    "postalCodeMax": 69669,
    "lat": 63.5714,
    "lng": 23.9405,
    "radiusKm": 6.5
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "keskusta",
    "postalCode": 67100,
    "postalCodeMin": 67100,
    "postalCodeMax": 67109,
    "lat": 63.8361,
    "lng": 23.1169,
    "radiusKm": 1.8
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Leenala",
    "postalCode": 67200,
    "postalCodeMin": 67200,
    "postalCodeMax": 67209,
    "lat": 63.8446,
    "lng": 23.1162,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Halkokari",
    "postalCode": 67300,
    "postalCodeMin": 67300,
    "postalCodeMax": 67309,
    "lat": 63.8596,
    "lng": 23.1305,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Rytimäki",
    "postalCode": 67400,
    "postalCodeMin": 67400,
    "postalCodeMax": 67409,
    "lat": 63.8512,
    "lng": 23.1643,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Vitsari",
    "postalCode": 67410,
    "postalCodeMin": 67410,
    "postalCodeMax": 67419,
    "lat": 63.8515,
    "lng": 23.2157,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Rimmi",
    "postalCode": 67500,
    "postalCodeMin": 67500,
    "postalCodeMax": 67509,
    "lat": 63.7763,
    "lng": 23.2759,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Kaustari",
    "postalCode": 67600,
    "postalCodeMin": 67600,
    "postalCodeMax": 67609,
    "lat": 63.8283,
    "lng": 23.1695,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Kirkonmäki, Tarharanta",
    "postalCode": 67700,
    "postalCodeMin": 67700,
    "postalCodeMax": 67709,
    "lat": 63.8227,
    "lng": 23.1317,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Koivuhaka",
    "postalCode": 67800,
    "postalCodeMin": 67800,
    "postalCodeMax": 67809,
    "lat": 63.8271,
    "lng": 23.0712,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Ykspihlaja",
    "postalCode": 67900,
    "postalCodeMin": 67900,
    "postalCodeMax": 67909,
    "lat": 63.8409,
    "lng": 23.042,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Marinkainen",
    "postalCode": 68210,
    "postalCodeMin": 68210,
    "postalCodeMax": 68219,
    "lat": 63.9432,
    "lng": 23.4364,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Karhi",
    "postalCode": 68220,
    "postalCodeMin": 68220,
    "postalCodeMax": 68229,
    "lat": 63.9785,
    "lng": 23.4297,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Lohtaja / Lochteå",
    "postalCode": 68230,
    "postalCodeMin": 68230,
    "postalCodeMax": 68239,
    "lat": 64.025,
    "lng": 23.5048,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Ala-Viirre",
    "postalCode": 68240,
    "postalCodeMin": 68240,
    "postalCodeMax": 68249,
    "lat": 64.0252,
    "lng": 23.6032,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Kälviä / Kelviå",
    "postalCode": 68300,
    "postalCodeMin": 68300,
    "postalCodeMax": 68309,
    "lat": 63.8602,
    "lng": 23.4541,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Ruotsalo",
    "postalCode": 68320,
    "postalCodeMin": 68320,
    "postalCodeMax": 68329,
    "lat": 63.9022,
    "lng": 23.3399,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Ullava",
    "postalCode": 68370,
    "postalCodeMin": 68370,
    "postalCodeMax": 68379,
    "lat": 63.7045,
    "lng": 23.8972,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Yli-Ullava",
    "postalCode": 68380,
    "postalCodeMin": 68380,
    "postalCodeMax": 68389,
    "lat": 63.7045,
    "lng": 23.8972,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Rahkonen",
    "postalCode": 68390,
    "postalCodeMin": 68390,
    "postalCodeMax": 68399,
    "lat": 63.6168,
    "lng": 24.0281,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Öja",
    "postalCode": 68550,
    "postalCodeMin": 68550,
    "postalCodeMax": 68559,
    "lat": 63.8355,
    "lng": 22.9038,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Kokkola",
    "area": "Kokkola / Karleby",
    "postalCode": 68999,
    "postalCodeMin": 68990,
    "postalCodeMax": 68999,
    "lat": 63.7675,
    "lng": 23.474,
    "radiusKm": 5.4
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Lestijärvi",
    "area": "Syri",
    "postalCode": 69420,
    "postalCodeMin": 69420,
    "postalCodeMax": 69429,
    "lat": 63.5714,
    "lng": 24.4951,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Lestijärvi",
    "area": "Lestijärvi",
    "postalCode": 69440,
    "postalCodeMin": 69440,
    "postalCodeMax": 69449,
    "lat": 63.5272,
    "lng": 24.6581,
    "radiusKm": 7.2
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Lestijärvi",
    "area": "Yli-Lesti",
    "postalCode": 69450,
    "postalCodeMin": 69450,
    "postalCodeMax": 69459,
    "lat": 63.4757,
    "lng": 24.7574,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Perho (kunta)",
    "area": "Kivikangas",
    "postalCode": 69910,
    "postalCodeMin": 69910,
    "postalCodeMax": 69919,
    "lat": 63.325,
    "lng": 24.16,
    "radiusKm": 7.2
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Perho (kunta)",
    "area": "Oksakoski",
    "postalCode": 69920,
    "postalCodeMin": 69920,
    "postalCodeMax": 69929,
    "lat": 63.255,
    "lng": 24.2977,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Perho (kunta)",
    "area": "Perho",
    "postalCode": 69950,
    "postalCodeMin": 69950,
    "postalCodeMax": 69959,
    "lat": 63.2146,
    "lng": 24.4179,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Perho (kunta)",
    "area": "Salamajärvi",
    "postalCode": 69970,
    "postalCodeMin": 69970,
    "postalCodeMax": 69979,
    "lat": 63.3245,
    "lng": 24.597,
    "radiusKm": 7.2
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Perho (kunta)",
    "area": "Möttönen",
    "postalCode": 69980,
    "postalCodeMin": 69980,
    "postalCodeMax": 69989,
    "lat": 63.1775,
    "lng": 24.5161,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Toholampi",
    "area": "Toholampi",
    "postalCode": 69300,
    "postalCodeMin": 69300,
    "postalCodeMax": 69309,
    "lat": 63.7716,
    "lng": 24.2478,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Toholampi",
    "area": "Laitala",
    "postalCode": 69310,
    "postalCodeMin": 69310,
    "postalCodeMax": 69319,
    "lat": 63.8124,
    "lng": 24.1618,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Toholampi",
    "area": "Määttälä",
    "postalCode": 69330,
    "postalCodeMin": 69330,
    "postalCodeMax": 69339,
    "lat": 63.717,
    "lng": 24.2994,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Toholampi",
    "area": "Purontaka",
    "postalCode": 69340,
    "postalCodeMin": 69340,
    "postalCodeMax": 69349,
    "lat": 63.6881,
    "lng": 24.3296,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Toholampi",
    "area": "Sykäräinen",
    "postalCode": 69410,
    "postalCodeMin": 69410,
    "postalCodeMax": 69419,
    "lat": 63.6191,
    "lng": 24.4065,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Veteli",
    "area": "Veteli",
    "postalCode": 69700,
    "postalCodeMin": 69700,
    "postalCodeMax": 69709,
    "lat": 63.4799,
    "lng": 23.7864,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Veteli",
    "area": "Tunkkari",
    "postalCode": 69730,
    "postalCodeMin": 69730,
    "postalCodeMax": 69739,
    "lat": 63.5009,
    "lng": 23.752,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Veteli",
    "area": "Sillanpää",
    "postalCode": 69750,
    "postalCodeMin": 69750,
    "postalCodeMax": 69759,
    "lat": 63.4183,
    "lng": 23.9303,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Veteli",
    "area": "Räyrinki",
    "postalCode": 69820,
    "postalCodeMin": 69820,
    "postalCodeMax": 69829,
    "lat": 63.3835,
    "lng": 23.8193,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Veteli",
    "area": "Pulkkinen",
    "postalCode": 69830,
    "postalCodeMin": 69830,
    "postalCodeMax": 69839,
    "lat": 63.3676,
    "lng": 23.9658,
    "radiusKm": 3.6
  },
  {
    "region": "Keski-Pohjanmaa",
    "city": "Veteli",
    "area": "Patana",
    "postalCode": 69850,
    "postalCodeMin": 69850,
    "postalCodeMax": 69859,
    "lat": 63.3232,
    "lng": 23.8948,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Isokyrö",
    "area": "Isokyrö",
    "postalCode": 61500,
    "postalCodeMin": 61500,
    "postalCodeMax": 61509,
    "lat": 62.9999,
    "lng": 22.3245,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Isokyrö",
    "area": "Lehmäjoki",
    "postalCode": 61520,
    "postalCodeMin": 61520,
    "postalCodeMax": 61529,
    "lat": 63.0835,
    "lng": 22.494,
    "radiusKm": 6.5
  },
  {
    "region": "Pohjanmaa",
    "city": "Isokyrö",
    "area": "Orismala",
    "postalCode": 61550,
    "postalCodeMin": 61550,
    "postalCodeMax": 61559,
    "lat": 62.9508,
    "lng": 22.3977,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Isokyrö",
    "area": "Orisberg",
    "postalCode": 61560,
    "postalCodeMin": 61560,
    "postalCodeMax": 61569,
    "lat": 62.9508,
    "lng": 22.3977,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kaskinen",
    "area": "Kaskinen / Kaskö",
    "postalCode": 64260,
    "postalCodeMin": 64260,
    "postalCodeMax": 64269,
    "lat": 62.3823,
    "lng": 21.2278,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Korsnäs",
    "area": "Korsnäs",
    "postalCode": 66200,
    "postalCodeMin": 66200,
    "postalCodeMax": 66209,
    "lat": 62.7846,
    "lng": 21.1887,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Korsnäs",
    "area": "Molpe",
    "postalCode": 66210,
    "postalCodeMin": 66210,
    "postalCodeMax": 66219,
    "lat": 62.8651,
    "lng": 21.2846,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Korsnäs",
    "area": "Korsbäck",
    "postalCode": 66230,
    "postalCodeMin": 66230,
    "postalCodeMax": 66239,
    "lat": 62.7892,
    "lng": 21.2948,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Korsnäs",
    "area": "Taklax",
    "postalCode": 66280,
    "postalCodeMin": 66280,
    "postalCodeMax": 66289,
    "lat": 62.7288,
    "lng": 21.2778,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Korsnäs",
    "area": "Harrström",
    "postalCode": 66290,
    "postalCodeMin": 66290,
    "postalCodeMax": 66299,
    "lat": 62.7275,
    "lng": 21.1806,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kristiinankaupunki",
    "area": "Kristiinankaupunki / Kristinestad",
    "postalCode": 64100,
    "postalCodeMin": 64100,
    "postalCodeMax": 64109,
    "lat": 62.2739,
    "lng": 21.3798,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kristiinankaupunki",
    "area": "Tiukka / Tjöck",
    "postalCode": 64140,
    "postalCodeMin": 64140,
    "postalCodeMax": 64149,
    "lat": 62.3013,
    "lng": 21.4556,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kristiinankaupunki",
    "area": "Lapväärtti / Lappfjärd",
    "postalCode": 64300,
    "postalCodeMin": 64300,
    "postalCodeMax": 64309,
    "lat": 62.2451,
    "lng": 21.5286,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kristiinankaupunki",
    "area": "Dagsmark",
    "postalCode": 64320,
    "postalCodeMin": 64320,
    "postalCodeMax": 64329,
    "lat": 62.2309,
    "lng": 21.6358,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kristiinankaupunki",
    "area": "Metsälä / Ömossa",
    "postalCode": 64440,
    "postalCodeMin": 64440,
    "postalCodeMax": 64449,
    "lat": 62.0708,
    "lng": 21.5247,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjanmaa",
    "city": "Kristiinankaupunki",
    "area": "Kallträsk",
    "postalCode": 64450,
    "postalCodeMin": 64450,
    "postalCodeMax": 64459,
    "lat": 62.0297,
    "lng": 21.5407,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kristiinankaupunki",
    "area": "Härkmeri",
    "postalCode": 64460,
    "postalCodeMin": 64460,
    "postalCodeMax": 64469,
    "lat": 62.1597,
    "lng": 21.4338,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kristiinankaupunki",
    "area": "Skaftung",
    "postalCode": 64480,
    "postalCodeMin": 64480,
    "postalCodeMax": 64489,
    "lat": 62.1211,
    "lng": 21.3556,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kristiinankaupunki",
    "area": "Siipyy / Sideby",
    "postalCode": 64490,
    "postalCodeMin": 64490,
    "postalCodeMax": 64499,
    "lat": 62.028,
    "lng": 21.3373,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Kruunupyy",
    "area": "Alaveteli / Nedervetil",
    "postalCode": 68410,
    "postalCodeMin": 68410,
    "postalCodeMax": 68419,
    "lat": 63.7084,
    "lng": 23.3266,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Kruunupyy",
    "area": "Kruunupyy / Kronoby",
    "postalCode": 68500,
    "postalCodeMin": 68500,
    "postalCodeMax": 68509,
    "lat": 63.728,
    "lng": 23.0337,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Kruunupyy",
    "area": "Teerijärvi / Terjärv",
    "postalCode": 68700,
    "postalCodeMin": 68700,
    "postalCodeMax": 68709,
    "lat": 63.5447,
    "lng": 23.5114,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjanmaa",
    "city": "Kruunupyy",
    "area": "Småbönders",
    "postalCode": 68750,
    "postalCodeMin": 68750,
    "postalCodeMax": 68759,
    "lat": 63.4335,
    "lng": 23.6179,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Laihia",
    "area": "Laihia",
    "postalCode": 66400,
    "postalCodeMin": 66400,
    "postalCodeMax": 66409,
    "lat": 62.9761,
    "lng": 22.0115,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Laihia",
    "area": "Ruto",
    "postalCode": 66420,
    "postalCodeMin": 66420,
    "postalCodeMax": 66429,
    "lat": 62.9907,
    "lng": 21.9047,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Laihia",
    "area": "Vedenoja",
    "postalCode": 66430,
    "postalCodeMin": 66430,
    "postalCodeMax": 66439,
    "lat": 62.9874,
    "lng": 22.0606,
    "radiusKm": 4.7
  },
  {
    "region": "Pohjanmaa",
    "city": "Laihia",
    "area": "Jakkula",
    "postalCode": 66450,
    "postalCodeMin": 66450,
    "postalCodeMax": 66459,
    "lat": 62.9357,
    "lng": 22.0652,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Laihia",
    "area": "Haapala",
    "postalCode": 66460,
    "postalCodeMin": 66460,
    "postalCodeMax": 66469,
    "lat": 62.8988,
    "lng": 22.0709,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Laihia",
    "area": "Jukaja",
    "postalCode": 66470,
    "postalCodeMin": 66470,
    "postalCodeMax": 66479,
    "lat": 62.8614,
    "lng": 22.2025,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Luoto",
    "area": "Bosund",
    "postalCode": 68555,
    "postalCodeMin": 68550,
    "postalCodeMax": 68559,
    "lat": 63.8324,
    "lng": 22.8316,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Luoto",
    "area": "Eugmo",
    "postalCode": 68560,
    "postalCodeMin": 68560,
    "postalCodeMax": 68569,
    "lat": 63.815,
    "lng": 22.7485,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Luoto",
    "area": "Luoto / Larsmo",
    "postalCode": 68570,
    "postalCodeMin": 68570,
    "postalCodeMax": 68579,
    "lat": 63.7525,
    "lng": 22.7462,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Luoto",
    "area": "Furuholmen",
    "postalCode": 68580,
    "postalCodeMin": 68580,
    "postalCodeMax": 68589,
    "lat": 63.7099,
    "lng": 22.7596,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Maalahti",
    "area": "Maalahti / Malax",
    "postalCode": 66100,
    "postalCodeMin": 66100,
    "postalCodeMax": 66109,
    "lat": 62.9453,
    "lng": 21.5477,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Maalahti",
    "area": "Övermalax",
    "postalCode": 66140,
    "postalCodeMin": 66140,
    "postalCodeMax": 66149,
    "lat": 62.9202,
    "lng": 21.6292,
    "radiusKm": 5.0
  },
  {
    "region": "Pohjanmaa",
    "city": "Maalahti",
    "area": "Långåminne",
    "postalCode": 66160,
    "postalCodeMin": 66160,
    "postalCodeMax": 66169,
    "lat": 62.8941,
    "lng": 21.7271,
    "radiusKm": 5.0
  },
  {
    "region": "Pohjanmaa",
    "city": "Maalahti",
    "area": "Bergö",
    "postalCode": 66220,
    "postalCodeMin": 66220,
    "postalCodeMax": 66229,
    "lat": 62.9689,
    "lng": 21.1912,
    "radiusKm": 5.0
  },
  {
    "region": "Pohjanmaa",
    "city": "Maalahti",
    "area": "Petolahti / Petalax",
    "postalCode": 66240,
    "postalCodeMin": 66240,
    "postalCodeMax": 66249,
    "lat": 62.8387,
    "lng": 21.4243,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Maalahti",
    "area": "Svarvar",
    "postalCode": 66260,
    "postalCodeMin": 66260,
    "postalCodeMax": 66269,
    "lat": 62.8054,
    "lng": 21.6795,
    "radiusKm": 5.0
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Sulva / Solf",
    "postalCode": 65450,
    "postalCodeMin": 65450,
    "postalCodeMax": 65459,
    "lat": 63.013,
    "lng": 21.6489,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Tölby",
    "postalCode": 65460,
    "postalCodeMin": 65460,
    "postalCodeMax": 65469,
    "lat": 63.0154,
    "lng": 21.6936,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Rimal",
    "postalCode": 65470,
    "postalCodeMin": 65470,
    "postalCodeMax": 65479,
    "lat": 62.9532,
    "lng": 21.7732,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Vikby",
    "postalCode": 65480,
    "postalCodeMin": 65480,
    "postalCodeMax": 65489,
    "lat": 63.0272,
    "lng": 21.7354,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Helsingby",
    "postalCode": 65520,
    "postalCodeMin": 65520,
    "postalCodeMax": 65529,
    "lat": 63.0292,
    "lng": 21.813,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Sepänkylä",
    "postalCode": 65610,
    "postalCodeMin": 65610,
    "postalCodeMax": 65619,
    "lat": 63.1141,
    "lng": 21.6822,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Karperö",
    "postalCode": 65630,
    "postalCodeMin": 65630,
    "postalCodeMax": 65639,
    "lat": 63.1591,
    "lng": 21.689,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Koskö",
    "postalCode": 65650,
    "postalCodeMin": 65650,
    "postalCodeMax": 65659,
    "lat": 63.1862,
    "lng": 21.7201,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Singsby",
    "postalCode": 65710,
    "postalCodeMin": 65710,
    "postalCodeMax": 65719,
    "lat": 63.1606,
    "lng": 21.6534,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Jungsund",
    "postalCode": 65730,
    "postalCodeMin": 65730,
    "postalCodeMax": 65739,
    "lat": 63.1864,
    "lng": 21.6205,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Iskmo",
    "postalCode": 65760,
    "postalCodeMin": 65760,
    "postalCodeMax": 65769,
    "lat": 63.204,
    "lng": 21.6055,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Raippaluoto / Replot",
    "postalCode": 65800,
    "postalCodeMin": 65800,
    "postalCodeMax": 65809,
    "lat": 63.25,
    "lng": 21.4,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Björköby",
    "postalCode": 65870,
    "postalCodeMin": 65870,
    "postalCodeMax": 65879,
    "lat": 63.3421,
    "lng": 21.3575,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Norra Vallgrund",
    "postalCode": 65920,
    "postalCodeMin": 65920,
    "postalCodeMax": 65929,
    "lat": 63.1961,
    "lng": 21.3059,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Södra Vallgrund",
    "postalCode": 65930,
    "postalCodeMin": 65930,
    "postalCodeMax": 65939,
    "lat": 63.1789,
    "lng": 21.2801,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Söderudden",
    "postalCode": 65970,
    "postalCodeMin": 65970,
    "postalCodeMax": 65979,
    "lat": 63.285,
    "lng": 21.1216,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Veikkaala / Veikars",
    "postalCode": 66520,
    "postalCodeMin": 66520,
    "postalCodeMax": 66529,
    "lat": 63.0862,
    "lng": 21.8858,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Koivulahti / Kvevlax",
    "postalCode": 66530,
    "postalCodeMin": 66530,
    "postalCodeMax": 66539,
    "lat": 63.1606,
    "lng": 21.8419,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Petsmo",
    "postalCode": 66540,
    "postalCodeMin": 66540,
    "postalCodeMax": 66549,
    "lat": 63.2211,
    "lng": 21.7876,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Västerhankmo",
    "postalCode": 66550,
    "postalCodeMin": 66550,
    "postalCodeMax": 66559,
    "lat": 63.2132,
    "lng": 21.8521,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Österhankmo",
    "postalCode": 66560,
    "postalCodeMin": 66560,
    "postalCodeMax": 66569,
    "lat": 63.2309,
    "lng": 21.9264,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Kuni",
    "postalCode": 66580,
    "postalCodeMin": 66580,
    "postalCodeMax": 66589,
    "lat": 63.1579,
    "lng": 21.9598,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Vassor",
    "postalCode": 66590,
    "postalCodeMin": 66590,
    "postalCodeMax": 66599,
    "lat": 63.1807,
    "lng": 22.0066,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Mustasaari",
    "area": "Vaasa / Vasa",
    "postalCode": 66999,
    "postalCodeMin": 66990,
    "postalCodeMax": 66999,
    "lat": 63.3017,
    "lng": 21.672,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Närpiö / Närpes",
    "postalCode": 64200,
    "postalCodeMin": 64200,
    "postalCodeMax": 64209,
    "lat": 62.4728,
    "lng": 21.3372,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Kalax",
    "postalCode": 64210,
    "postalCodeMin": 64210,
    "postalCodeMax": 64219,
    "lat": 62.4872,
    "lng": 21.2938,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Yttermark",
    "postalCode": 64220,
    "postalCodeMin": 64220,
    "postalCodeMax": 64229,
    "lat": 62.546,
    "lng": 21.3979,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Närpiö as / Närpes st",
    "postalCode": 64230,
    "postalCodeMin": 64230,
    "postalCodeMax": 64239,
    "lat": 62.4805,
    "lng": 21.3695,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Böle",
    "postalCode": 64240,
    "postalCodeMin": 64240,
    "postalCodeMax": 64249,
    "lat": 62.4329,
    "lng": 21.3511,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Pjelax",
    "postalCode": 64250,
    "postalCodeMin": 64250,
    "postalCodeMax": 64259,
    "lat": 62.3924,
    "lng": 21.3758,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Nämpnäs",
    "postalCode": 64510,
    "postalCodeMin": 64510,
    "postalCodeMax": 64519,
    "lat": 62.5064,
    "lng": 21.2103,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Norrnäs",
    "postalCode": 64530,
    "postalCodeMin": 64530,
    "postalCodeMax": 64539,
    "lat": 62.5749,
    "lng": 21.2283,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Rangsby",
    "postalCode": 64550,
    "postalCodeMin": 64550,
    "postalCodeMax": 64559,
    "lat": 62.6075,
    "lng": 21.2648,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Ylimarkku / Övermark",
    "postalCode": 64610,
    "postalCodeMin": 64610,
    "postalCodeMax": 64619,
    "lat": 62.6113,
    "lng": 21.4714,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Pirttikylä / Pörtom",
    "postalCode": 66270,
    "postalCodeMin": 66270,
    "postalCodeMax": 66279,
    "lat": 62.7129,
    "lng": 21.6123,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Närpiö",
    "area": "Töjby",
    "postalCode": 66295,
    "postalCodeMin": 66290,
    "postalCodeMax": 66299,
    "lat": 62.6595,
    "lng": 21.1694,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Lepplax",
    "postalCode": 68530,
    "postalCodeMin": 68530,
    "postalCodeMax": 68539,
    "lat": 63.6704,
    "lng": 22.8867,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Sundby",
    "postalCode": 68690,
    "postalCodeMin": 68690,
    "postalCodeMax": 68699,
    "lat": 63.5965,
    "lng": 22.6457,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Kållby / Kolppi",
    "postalCode": 68800,
    "postalCodeMin": 68800,
    "postalCodeMax": 68809,
    "lat": 63.6276,
    "lng": 22.8983,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Ytteresse",
    "postalCode": 68810,
    "postalCodeMin": 68810,
    "postalCodeMax": 68819,
    "lat": 63.624,
    "lng": 22.9823,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Esse / Ähtävä",
    "postalCode": 68820,
    "postalCodeMin": 68820,
    "postalCodeMax": 68829,
    "lat": 63.593,
    "lng": 23.054,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Bäckby",
    "postalCode": 68830,
    "postalCodeMin": 68830,
    "postalCodeMax": 68839,
    "lat": 63.6231,
    "lng": 23.1173,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Nederlappfors",
    "postalCode": 68840,
    "postalCodeMin": 68840,
    "postalCodeMax": 68849,
    "lat": 63.5132,
    "lng": 23.2753,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Edsevö",
    "postalCode": 68870,
    "postalCodeMin": 68870,
    "postalCodeMax": 68879,
    "lat": 63.6297,
    "lng": 22.8421,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Bennäs / Pännäinen",
    "postalCode": 68910,
    "postalCodeMin": 68910,
    "postalCodeMax": 68919,
    "lat": 63.5956,
    "lng": 22.7901,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Forsby",
    "postalCode": 68920,
    "postalCodeMin": 68920,
    "postalCodeMax": 68929,
    "lat": 63.571,
    "lng": 22.8735,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Purmo",
    "postalCode": 68930,
    "postalCodeMin": 68930,
    "postalCodeMax": 68939,
    "lat": 63.5234,
    "lng": 22.9579,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Lillby",
    "postalCode": 68940,
    "postalCodeMin": 68940,
    "postalCodeMax": 68949,
    "lat": 63.4795,
    "lng": 23.0094,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Pedersöre",
    "area": "Överpurmo",
    "postalCode": 68970,
    "postalCodeMin": 68970,
    "postalCodeMax": 68979,
    "lat": 63.3941,
    "lng": 23.02,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Pietarsaari",
    "area": "Pietarsaari / Jakobstad",
    "postalCode": 68600,
    "postalCodeMin": 68600,
    "postalCodeMax": 68609,
    "lat": 63.6744,
    "lng": 22.6966,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjanmaa",
    "city": "Pietarsaari",
    "area": "Pietarsaari / Jakobstad",
    "postalCode": 68620,
    "postalCodeMin": 68620,
    "postalCodeMax": 68629,
    "lat": 63.6744,
    "lng": 22.6966,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjanmaa",
    "city": "Pietarsaari",
    "area": "Pietarsaari / Jakobstad",
    "postalCode": 68630,
    "postalCodeMin": 68630,
    "postalCodeMax": 68639,
    "lat": 63.6569,
    "lng": 22.6653,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjanmaa",
    "city": "Pietarsaari",
    "area": "Pietarsaari / Jakobstad",
    "postalCode": 68660,
    "postalCodeMin": 68660,
    "postalCodeMax": 68669,
    "lat": 63.694,
    "lng": 22.7428,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjanmaa",
    "city": "Uusikaarlepyy",
    "area": "Pensala",
    "postalCode": 66840,
    "postalCodeMin": 66840,
    "postalCodeMax": 66849,
    "lat": 63.3445,
    "lng": 22.5553,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Uusikaarlepyy",
    "area": "Jepua / Jeppo",
    "postalCode": 66850,
    "postalCodeMin": 66850,
    "postalCodeMax": 66859,
    "lat": 63.408,
    "lng": 22.6471,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Uusikaarlepyy",
    "area": "Uusikaarlepyy / Nykarleby",
    "postalCode": 66900,
    "postalCodeMin": 66900,
    "postalCodeMax": 66909,
    "lat": 63.5218,
    "lng": 22.5304,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Uusikaarlepyy",
    "area": "Sokaluoto / Socklot",
    "postalCode": 66910,
    "postalCodeMin": 66910,
    "postalCodeMax": 66919,
    "lat": 63.5758,
    "lng": 22.5493,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Uusikaarlepyy",
    "area": "Kovjoki",
    "postalCode": 66930,
    "postalCodeMin": 66930,
    "postalCodeMax": 66939,
    "lat": 63.5218,
    "lng": 22.5304,
    "radiusKm": 6.5
  },
  {
    "region": "Pohjanmaa",
    "city": "Uusikaarlepyy",
    "area": "Munsala",
    "postalCode": 66950,
    "postalCodeMin": 66950,
    "postalCodeMax": 66959,
    "lat": 63.4526,
    "lng": 22.4371,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Uusikaarlepyy",
    "area": "Hirvlax",
    "postalCode": 66970,
    "postalCodeMin": 66970,
    "postalCodeMax": 66979,
    "lat": 63.4153,
    "lng": 22.3486,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Uusikaarlepyy",
    "area": "Monå",
    "postalCode": 66980,
    "postalCodeMin": 66980,
    "postalCodeMax": 66989,
    "lat": 63.3899,
    "lng": 22.3625,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "keskusta, Vöyrinkaupunki",
    "postalCode": 65100,
    "postalCodeMin": 65100,
    "postalCodeMax": 65109,
    "lat": 63.1023,
    "lng": 21.6197,
    "radiusKm": 2.3
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Hietalahti",
    "postalCode": 65130,
    "postalCodeMin": 65130,
    "postalCodeMax": 65139,
    "lat": 63.083,
    "lng": 21.6144,
    "radiusKm": 7.0
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Vaskiluoto",
    "postalCode": 65170,
    "postalCodeMin": 65170,
    "postalCodeMax": 65179,
    "lat": 63.089,
    "lng": 21.5777,
    "radiusKm": 4.7
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Palosaari",
    "postalCode": 65200,
    "postalCodeMin": 65200,
    "postalCodeMax": 65209,
    "lat": 63.1069,
    "lng": 21.5897,
    "radiusKm": 9.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Vetokannas",
    "postalCode": 65230,
    "postalCodeMin": 65230,
    "postalCodeMax": 65239,
    "lat": 63.1186,
    "lng": 21.6161,
    "radiusKm": 4.7
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Gerby",
    "postalCode": 65280,
    "postalCodeMin": 65280,
    "postalCodeMax": 65289,
    "lat": 63.1298,
    "lng": 21.6019,
    "radiusKm": 7.0
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Kivihaka, Asevelikylä",
    "postalCode": 65300,
    "postalCodeMin": 65300,
    "postalCodeMax": 65309,
    "lat": 63.1013,
    "lng": 21.6547,
    "radiusKm": 7.0
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Huutoniemi",
    "postalCode": 65320,
    "postalCodeMin": 65320,
    "postalCodeMax": 65329,
    "lat": 63.0929,
    "lng": 21.6744,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Suvilahti",
    "postalCode": 65350,
    "postalCodeMin": 65350,
    "postalCodeMax": 65359,
    "lat": 63.0743,
    "lng": 21.6582,
    "radiusKm": 7.0
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Ristinummi",
    "postalCode": 65370,
    "postalCodeMin": 65370,
    "postalCodeMax": 65379,
    "lat": 63.092,
    "lng": 21.7229,
    "radiusKm": 4.7
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Vanha Vaasa",
    "postalCode": 65380,
    "postalCodeMin": 65380,
    "postalCodeMax": 65389,
    "lat": 63.073,
    "lng": 21.7224,
    "radiusKm": 4.7
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Sundom",
    "postalCode": 65410,
    "postalCodeMin": 65410,
    "postalCodeMax": 65419,
    "lat": 63.0366,
    "lng": 21.5505,
    "radiusKm": 4.7
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Vedenoja",
    "postalCode": 66430,
    "postalCodeMin": 66430,
    "postalCodeMax": 66439,
    "lat": 62.991,
    "lng": 22.0614,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Tervajoki",
    "postalCode": 66440,
    "postalCodeMin": 66440,
    "postalCodeMax": 66449,
    "lat": 63.0045,
    "lng": 22.1435,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Vähäkyrö / Lillkyro",
    "postalCode": 66500,
    "postalCodeMin": 66500,
    "postalCodeMax": 66509,
    "lat": 63.0564,
    "lng": 22.1058,
    "radiusKm": 4.7
  },
  {
    "region": "Pohjanmaa",
    "city": "Vaasa",
    "area": "Merikaarto / Merikart",
    "postalCode": 66510,
    "postalCodeMin": 66510,
    "postalCodeMax": 66519,
    "lat": 63.0702,
    "lng": 21.9477,
    "radiusKm": 4.7
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Petterinmäki / Pettersbacka",
    "postalCode": 62395,
    "postalCodeMin": 62390,
    "postalCodeMax": 62399,
    "lat": 63.124,
    "lng": 22.6272,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Vöyri / Vörå",
    "postalCode": 66600,
    "postalCodeMin": 66600,
    "postalCodeMax": 66609,
    "lat": 63.1285,
    "lng": 22.2507,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Maksamaa / Maxmo",
    "postalCode": 66640,
    "postalCodeMin": 66640,
    "postalCodeMax": 66649,
    "lat": 63.2136,
    "lng": 22.0595,
    "radiusKm": 7.9
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Bertby",
    "postalCode": 66660,
    "postalCodeMin": 66660,
    "postalCodeMax": 66669,
    "lat": 63.2179,
    "lng": 22.2376,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Kaurajärvi",
    "postalCode": 66680,
    "postalCodeMin": 66680,
    "postalCodeMax": 66689,
    "lat": 63.1206,
    "lng": 22.5093,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Kaitsor",
    "postalCode": 66710,
    "postalCodeMin": 66710,
    "postalCodeMax": 66719,
    "lat": 63.254,
    "lng": 22.2717,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Oxkangar",
    "postalCode": 66730,
    "postalCodeMin": 66730,
    "postalCodeMax": 66739,
    "lat": 63.3,
    "lng": 22.2015,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Oravainen / Oravais",
    "postalCode": 66800,
    "postalCodeMin": 66800,
    "postalCodeMax": 66809,
    "lat": 63.3042,
    "lng": 22.3787,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Kimo",
    "postalCode": 66810,
    "postalCodeMin": 66810,
    "postalCodeMax": 66819,
    "lat": 63.2459,
    "lng": 22.4472,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Komossa",
    "postalCode": 66820,
    "postalCodeMin": 66820,
    "postalCodeMax": 66829,
    "lat": 63.2182,
    "lng": 22.5513,
    "radiusKm": 3.6
  },
  {
    "region": "Pohjanmaa",
    "city": "Vöyri",
    "area": "Oravaisten tehdas / Oravais fabrik",
    "postalCode": 66830,
    "postalCodeMin": 66830,
    "postalCodeMax": 66839,
    "lat": 63.3102,
    "lng": 22.4208,
    "radiusKm": 3.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Enonkoski",
    "area": "Karvila",
    "postalCode": 58160,
    "postalCodeMin": 58160,
    "postalCodeMax": 58169,
    "lat": 62.0347,
    "lng": 28.8875,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Enonkoski",
    "area": "Simanala",
    "postalCode": 58170,
    "postalCodeMin": 58170,
    "postalCodeMax": 58179,
    "lat": 62.0347,
    "lng": 28.9745,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Enonkoski",
    "area": "Enonkoski",
    "postalCode": 58175,
    "postalCodeMin": 58170,
    "postalCodeMax": 58179,
    "lat": 62.0893,
    "lng": 28.9161,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Enonkoski",
    "area": "Ihamaniemi",
    "postalCode": 58180,
    "postalCodeMin": 58180,
    "postalCodeMax": 58189,
    "lat": 62.1628,
    "lng": 28.8752,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Heinävesi",
    "postalCode": 79700,
    "postalCodeMin": 79700,
    "postalCodeMax": 79709,
    "lat": 62.4228,
    "lng": 28.6318,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Karvionkanava",
    "postalCode": 79810,
    "postalCodeMin": 79810,
    "postalCodeMax": 79819,
    "lat": 62.5129,
    "lng": 28.6513,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Varistaipale",
    "postalCode": 79820,
    "postalCodeMin": 79820,
    "postalCodeMax": 79829,
    "lat": 62.5475,
    "lng": 28.6424,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Palokki",
    "postalCode": 79830,
    "postalCodeMin": 79830,
    "postalCodeMax": 79839,
    "lat": 62.571,
    "lng": 28.5793,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Uusi-Valamo",
    "postalCode": 79850,
    "postalCodeMin": 79850,
    "postalCodeMax": 79859,
    "lat": 62.5611,
    "lng": 28.7934,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Suuraho",
    "postalCode": 79860,
    "postalCodeMin": 79860,
    "postalCodeMax": 79869,
    "lat": 62.543,
    "lng": 28.8811,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Etelä-Petruma",
    "postalCode": 79885,
    "postalCodeMin": 79880,
    "postalCodeMax": 79889,
    "lat": 62.4667,
    "lng": 28.8333,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Sarvikumpu",
    "postalCode": 79895,
    "postalCodeMin": 79890,
    "postalCodeMax": 79899,
    "lat": 62.4699,
    "lng": 29.0267,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Kerma",
    "postalCode": 79910,
    "postalCodeMin": 79910,
    "postalCodeMax": 79919,
    "lat": 62.394,
    "lng": 28.7594,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Heinävesi",
    "area": "Vihtari",
    "postalCode": 79940,
    "postalCodeMin": 79940,
    "postalCodeMax": 79949,
    "lat": 62.3675,
    "lng": 29.0028,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Hirvensalmi",
    "area": "Syväsmäki",
    "postalCode": 52520,
    "postalCodeMin": 52520,
    "postalCodeMax": 52529,
    "lat": 61.6485,
    "lng": 26.9648,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Hirvensalmi",
    "area": "Hirvensalmi",
    "postalCode": 52550,
    "postalCodeMin": 52550,
    "postalCodeMax": 52559,
    "lat": 61.6426,
    "lng": 26.7732,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Hirvensalmi",
    "area": "Tuukkala",
    "postalCode": 52610,
    "postalCodeMin": 52610,
    "postalCodeMax": 52619,
    "lat": 61.7195,
    "lng": 26.5751,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Hirvensalmi",
    "area": "Kuitula",
    "postalCode": 52620,
    "postalCodeMin": 52620,
    "postalCodeMax": 52629,
    "lat": 61.7475,
    "lng": 26.5153,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Joroinen",
    "area": "Maavesi",
    "postalCode": 77460,
    "postalCodeMin": 77460,
    "postalCodeMax": 77469,
    "lat": 62.2558,
    "lng": 27.553,
    "radiusKm": 5.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Joroinen",
    "area": "Savuniemi",
    "postalCode": 77480,
    "postalCodeMin": 77480,
    "postalCodeMax": 77489,
    "lat": 62.1758,
    "lng": 27.6755,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Joroinen",
    "area": "Kuvansi",
    "postalCode": 78880,
    "postalCodeMin": 78880,
    "postalCodeMax": 78889,
    "lat": 62.2697,
    "lng": 27.8844,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Joroinen",
    "area": "Joroinen",
    "postalCode": 79600,
    "postalCodeMin": 79600,
    "postalCodeMax": 79609,
    "lat": 62.1792,
    "lng": 27.8259,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Joroinen",
    "area": "Huutokoski",
    "postalCode": 79620,
    "postalCodeMin": 79620,
    "postalCodeMax": 79629,
    "lat": 62.2123,
    "lng": 27.6892,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Joroinen",
    "area": "Kolma",
    "postalCode": 79630,
    "postalCodeMin": 79630,
    "postalCodeMax": 79639,
    "lat": 62.237,
    "lng": 27.7557,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Joroinen",
    "area": "Kerisalo",
    "postalCode": 79660,
    "postalCodeMin": 79660,
    "postalCodeMax": 79669,
    "lat": 62.1043,
    "lng": 27.9662,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Joroinen",
    "area": "Lahnalahti",
    "postalCode": 79680,
    "postalCodeMin": 79680,
    "postalCodeMax": 79689,
    "lat": 62.0931,
    "lng": 27.7846,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Joroinen",
    "area": "Kaitainen",
    "postalCode": 79690,
    "postalCodeMin": 79690,
    "postalCodeMax": 79699,
    "lat": 62.0555,
    "lng": 27.7275,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Nuutilanmäki",
    "postalCode": 51760,
    "postalCodeMin": 51760,
    "postalCodeMax": 51769,
    "lat": 61.8031,
    "lng": 27.5856,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Kuosmala",
    "postalCode": 51780,
    "postalCodeMin": 51780,
    "postalCodeMax": 51789,
    "lat": 61.7268,
    "lng": 27.7116,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Maivala",
    "postalCode": 51810,
    "postalCodeMin": 51810,
    "postalCodeMax": 51819,
    "lat": 61.8002,
    "lng": 27.7137,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Hatsola",
    "postalCode": 51820,
    "postalCodeMin": 51820,
    "postalCodeMax": 51829,
    "lat": 61.8745,
    "lng": 27.776,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Vuorenmaa",
    "postalCode": 51850,
    "postalCodeMin": 51850,
    "postalCodeMax": 51859,
    "lat": 62.0011,
    "lng": 27.517,
    "radiusKm": 5.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Narila",
    "postalCode": 51860,
    "postalCodeMin": 51860,
    "postalCodeMax": 51869,
    "lat": 62.0152,
    "lng": 27.5926,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Koikkala",
    "postalCode": 51880,
    "postalCodeMin": 51880,
    "postalCodeMax": 51889,
    "lat": 61.7557,
    "lng": 27.9121,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Risulahti",
    "postalCode": 51890,
    "postalCodeMin": 51890,
    "postalCodeMax": 51899,
    "lat": 61.6627,
    "lng": 27.9756,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Juva",
    "postalCode": 51900,
    "postalCodeMin": 51900,
    "postalCodeMax": 51909,
    "lat": 61.8947,
    "lng": 27.8618,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Paatela",
    "postalCode": 51930,
    "postalCodeMin": 51930,
    "postalCodeMax": 51939,
    "lat": 61.917,
    "lng": 28.0396,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Härkälä",
    "postalCode": 51940,
    "postalCodeMin": 51940,
    "postalCodeMax": 51949,
    "lat": 61.9432,
    "lng": 28.1493,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Juva",
    "area": "Lauteala",
    "postalCode": 51980,
    "postalCodeMin": 51980,
    "postalCodeMax": 51989,
    "lat": 61.7691,
    "lng": 28.0556,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Kangasniemi",
    "postalCode": 51200,
    "postalCodeMin": 51200,
    "postalCodeMax": 51209,
    "lat": 61.9881,
    "lng": 26.6419,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Tahkomäki",
    "postalCode": 51260,
    "postalCodeMin": 51260,
    "postalCodeMax": 51269,
    "lat": 62.2019,
    "lng": 26.6354,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Kutemajärvi",
    "postalCode": 51270,
    "postalCodeMin": 51270,
    "postalCodeMax": 51279,
    "lat": 62.1002,
    "lng": 26.7449,
    "radiusKm": 5.2
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Levä",
    "postalCode": 51310,
    "postalCodeMin": 51310,
    "postalCodeMax": 51319,
    "lat": 61.9039,
    "lng": 26.4628,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Kaihlamäki",
    "postalCode": 51335,
    "postalCodeMin": 51330,
    "postalCodeMax": 51339,
    "lat": 62.0021,
    "lng": 26.5232,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Hännilä",
    "postalCode": 51340,
    "postalCodeMin": 51340,
    "postalCodeMax": 51349,
    "lat": 62.0019,
    "lng": 26.4797,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Koivula",
    "postalCode": 51360,
    "postalCodeMin": 51360,
    "postalCodeMax": 51369,
    "lat": 62.117,
    "lng": 26.411,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Synsiö",
    "postalCode": 51380,
    "postalCodeMin": 51380,
    "postalCodeMax": 51389,
    "lat": 62.0886,
    "lng": 26.5182,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Läsäkoski",
    "postalCode": 51430,
    "postalCodeMin": 51430,
    "postalCodeMax": 51439,
    "lat": 61.9109,
    "lng": 26.9181,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Vuojalahti",
    "postalCode": 51440,
    "postalCodeMin": 51440,
    "postalCodeMax": 51449,
    "lat": 61.9663,
    "lng": 26.8005,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Kangasniemi",
    "area": "Luusniemi",
    "postalCode": 51460,
    "postalCodeMin": 51460,
    "postalCodeMax": 51469,
    "lat": 61.9764,
    "lng": 26.9708,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50100,
    "postalCodeMin": 50100,
    "postalCodeMax": 50109,
    "lat": 61.6937,
    "lng": 27.2639,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50120,
    "postalCodeMin": 50120,
    "postalCodeMax": 50129,
    "lat": 61.6948,
    "lng": 27.2365,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50130,
    "postalCodeMin": 50130,
    "postalCodeMax": 50139,
    "lat": 61.6858,
    "lng": 27.2414,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50150,
    "postalCodeMin": 50150,
    "postalCodeMax": 50159,
    "lat": 61.7078,
    "lng": 27.2203,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50160,
    "postalCodeMin": 50160,
    "postalCodeMax": 50169,
    "lat": 61.6674,
    "lng": 27.2605,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50170,
    "postalCodeMin": 50170,
    "postalCodeMax": 50179,
    "lat": 61.7043,
    "lng": 27.3028,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50180,
    "postalCodeMin": 50180,
    "postalCodeMax": 50189,
    "lat": 61.6984,
    "lng": 27.3598,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50190,
    "postalCodeMin": 50190,
    "postalCodeMax": 50199,
    "lat": 61.6849,
    "lng": 27.3045,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Kovala",
    "postalCode": 50200,
    "postalCodeMin": 50200,
    "postalCodeMax": 50209,
    "lat": 61.7666,
    "lng": 27.1161,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Rämälä",
    "postalCode": 50300,
    "postalCodeMin": 50300,
    "postalCodeMax": 50309,
    "lat": 61.7387,
    "lng": 27.3333,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Norola",
    "postalCode": 50350,
    "postalCodeMin": 50350,
    "postalCodeMax": 50359,
    "lat": 61.7039,
    "lng": 27.387,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50500,
    "postalCodeMin": 50500,
    "postalCodeMax": 50509,
    "lat": 61.6412,
    "lng": 27.257,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50520,
    "postalCodeMin": 50520,
    "postalCodeMax": 50529,
    "lat": 61.657,
    "lng": 27.2796,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Rantakylä",
    "postalCode": 50600,
    "postalCodeMin": 50600,
    "postalCodeMax": 50609,
    "lat": 61.6762,
    "lng": 27.1992,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Otava",
    "postalCode": 50670,
    "postalCodeMin": 50670,
    "postalCodeMax": 50679,
    "lat": 61.6435,
    "lng": 27.0781,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50700,
    "postalCodeMin": 50700,
    "postalCodeMax": 50709,
    "lat": 61.6156,
    "lng": 27.2923,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Korpikoski",
    "postalCode": 50770,
    "postalCodeMin": 50770,
    "postalCodeMax": 50779,
    "lat": 61.7167,
    "lng": 27.0667,
    "radiusKm": 6.5
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Mikkeli",
    "postalCode": 50800,
    "postalCodeMin": 50800,
    "postalCodeMax": 50809,
    "lat": 61.6309,
    "lng": 27.3341,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Ihastjärvi",
    "postalCode": 50970,
    "postalCodeMin": 50970,
    "postalCodeMax": 50979,
    "lat": 61.8515,
    "lng": 27.1908,
    "radiusKm": 5.2
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Vanhamäki",
    "postalCode": 51130,
    "postalCodeMin": 51130,
    "postalCodeMax": 51139,
    "lat": 61.8128,
    "lng": 26.9307,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Harjumaa",
    "postalCode": 51420,
    "postalCodeMin": 51420,
    "postalCodeMax": 51429,
    "lat": 61.8356,
    "lng": 27.0448,
    "radiusKm": 2.3
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Pajulankylä",
    "postalCode": 51450,
    "postalCodeMin": 51450,
    "postalCodeMax": 51459,
    "lat": 61.8935,
    "lng": 27.0385,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Hiirola",
    "postalCode": 51520,
    "postalCodeMin": 51520,
    "postalCodeMax": 51529,
    "lat": 61.8091,
    "lng": 27.3142,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Kalvitsa",
    "postalCode": 51540,
    "postalCodeMin": 51540,
    "postalCodeMax": 51549,
    "lat": 61.9102,
    "lng": 27.2853,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Haukivuori",
    "postalCode": 51600,
    "postalCodeMin": 51600,
    "postalCodeMax": 51609,
    "lat": 62.0253,
    "lng": 27.2047,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Pitkäaho",
    "postalCode": 51620,
    "postalCodeMin": 51620,
    "postalCodeMax": 51629,
    "lat": 61.9586,
    "lng": 27.2668,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Nykälä",
    "postalCode": 51670,
    "postalCodeMin": 51670,
    "postalCodeMax": 51679,
    "lat": 62.12,
    "lng": 26.9818,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Rahula",
    "postalCode": 51720,
    "postalCodeMin": 51720,
    "postalCodeMax": 51729,
    "lat": 61.7143,
    "lng": 27.4509,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Huuhanaho",
    "postalCode": 51740,
    "postalCodeMin": 51740,
    "postalCodeMax": 51749,
    "lat": 61.7504,
    "lng": 27.5396,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Anttola",
    "postalCode": 52100,
    "postalCodeMin": 52100,
    "postalCodeMax": 52109,
    "lat": 61.5829,
    "lng": 27.6511,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Majavesi",
    "postalCode": 52110,
    "postalCodeMin": 52110,
    "postalCodeMax": 52119,
    "lat": 61.6246,
    "lng": 27.4805,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Hauhala",
    "postalCode": 52150,
    "postalCodeMin": 52150,
    "postalCodeMax": 52159,
    "lat": 61.5342,
    "lng": 27.7387,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Ristiina",
    "postalCode": 52300,
    "postalCodeMin": 52300,
    "postalCodeMax": 52309,
    "lat": 61.5065,
    "lng": 27.2578,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Vitsiälä",
    "postalCode": 52320,
    "postalCodeMin": 52320,
    "postalCodeMax": 52329,
    "lat": 61.5795,
    "lng": 27.2195,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Heimari",
    "postalCode": 52330,
    "postalCodeMin": 52330,
    "postalCodeMax": 52339,
    "lat": 61.5869,
    "lng": 27.2893,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Hangastenmaa",
    "postalCode": 52340,
    "postalCodeMin": 52340,
    "postalCodeMax": 52349,
    "lat": 61.5389,
    "lng": 27.3845,
    "radiusKm": 5.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Someenjärvi",
    "postalCode": 52360,
    "postalCodeMin": 52360,
    "postalCodeMax": 52369,
    "lat": 61.4728,
    "lng": 27.5024,
    "radiusKm": 5.2
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Pellosniemi",
    "postalCode": 52420,
    "postalCodeMin": 52420,
    "postalCodeMax": 52429,
    "lat": 61.472,
    "lng": 27.2614,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Hietanen",
    "postalCode": 52510,
    "postalCodeMin": 52510,
    "postalCodeMax": 52519,
    "lat": 61.5805,
    "lng": 27.0094,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Kuomiokoski",
    "postalCode": 52780,
    "postalCodeMin": 52780,
    "postalCodeMax": 52789,
    "lat": 61.4408,
    "lng": 27.1245,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Suomenniemi",
    "postalCode": 52830,
    "postalCodeMin": 52830,
    "postalCodeMax": 52839,
    "lat": 61.3262,
    "lng": 27.4506,
    "radiusKm": 5.2
  },
  {
    "region": "Etelä-Savo",
    "city": "Mikkeli",
    "area": "Kantala",
    "postalCode": 77380,
    "postalCodeMin": 77380,
    "postalCodeMax": 77389,
    "lat": 62.1201,
    "lng": 27.2119,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Kuortti",
    "postalCode": 19410,
    "postalCodeMin": 19410,
    "postalCodeMax": 19419,
    "lat": 61.4218,
    "lng": 26.4103,
    "radiusKm": 2.1
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Mansikkamäki",
    "postalCode": 19420,
    "postalCodeMin": 19420,
    "postalCodeMax": 19429,
    "lat": 61.4861,
    "lng": 26.3462,
    "radiusKm": 2.1
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Pertunmaa",
    "postalCode": 19430,
    "postalCodeMin": 19430,
    "postalCodeMax": 19439,
    "lat": 61.5072,
    "lng": 26.4821,
    "radiusKm": 4.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Ruorasmäki",
    "postalCode": 19460,
    "postalCodeMin": 19460,
    "postalCodeMax": 19469,
    "lat": 61.5955,
    "lng": 26.3997,
    "radiusKm": 2.1
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Lihavanpää",
    "postalCode": 19470,
    "postalCodeMin": 19470,
    "postalCodeMax": 19479,
    "lat": 61.5245,
    "lng": 26.5468,
    "radiusKm": 2.1
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Hartosenpää",
    "postalCode": 19480,
    "postalCodeMin": 19480,
    "postalCodeMax": 19489,
    "lat": 61.5261,
    "lng": 26.6079,
    "radiusKm": 2.1
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Mäntyharju",
    "postalCode": 52700,
    "postalCodeMin": 52700,
    "postalCodeMax": 52709,
    "lat": 61.4176,
    "lng": 26.8805,
    "radiusKm": 2.3
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Karankamäki",
    "postalCode": 52720,
    "postalCodeMin": 52720,
    "postalCodeMax": 52729,
    "lat": 61.4585,
    "lng": 26.639,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Koirakivi",
    "postalCode": 52730,
    "postalCodeMin": 52730,
    "postalCodeMax": 52739,
    "lat": 61.4154,
    "lng": 26.5642,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Tuustaipale",
    "postalCode": 52740,
    "postalCodeMin": 52740,
    "postalCodeMax": 52749,
    "lat": 61.5279,
    "lng": 26.7493,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Mynttilä",
    "postalCode": 52760,
    "postalCodeMin": 52760,
    "postalCodeMax": 52769,
    "lat": 61.4865,
    "lng": 26.9149,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Halmeniemi",
    "postalCode": 52850,
    "postalCodeMin": 52850,
    "postalCodeMax": 52859,
    "lat": 61.281,
    "lng": 27.2194,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Käävänkylä",
    "postalCode": 52890,
    "postalCodeMin": 52890,
    "postalCodeMax": 52899,
    "lat": 61.201,
    "lng": 27.0996,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Nurmaa",
    "postalCode": 52960,
    "postalCodeMin": 52960,
    "postalCodeMax": 52969,
    "lat": 61.292,
    "lng": 26.6567,
    "radiusKm": 5.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Pankalahti",
    "postalCode": 52970,
    "postalCodeMin": 52970,
    "postalCodeMax": 52979,
    "lat": 61.3189,
    "lng": 26.6001,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Mäntyharju",
    "area": "Ahvenainen",
    "postalCode": 52980,
    "postalCodeMin": 52980,
    "postalCodeMax": 52989,
    "lat": 61.3,
    "lng": 26.5167,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Pieksämäki",
    "postalCode": 76100,
    "postalCodeMin": 76100,
    "postalCodeMax": 76109,
    "lat": 62.295,
    "lng": 27.1331,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Pieksämäki",
    "postalCode": 76120,
    "postalCodeMin": 76120,
    "postalCodeMax": 76129,
    "lat": 62.3011,
    "lng": 27.1878,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Pieksämäki",
    "postalCode": 76130,
    "postalCodeMin": 76130,
    "postalCodeMax": 76139,
    "lat": 62.3164,
    "lng": 27.1153,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Pieksämäki",
    "postalCode": 76150,
    "postalCodeMin": 76150,
    "postalCodeMax": 76159,
    "lat": 62.2911,
    "lng": 27.1296,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Partaharju",
    "postalCode": 76280,
    "postalCodeMin": 76280,
    "postalCodeMax": 76289,
    "lat": 62.3604,
    "lng": 27.2083,
    "radiusKm": 2.3
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Pyhitty",
    "postalCode": 76620,
    "postalCodeMin": 76620,
    "postalCodeMax": 76629,
    "lat": 62.2556,
    "lng": 27.2799,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Lamminmäki",
    "postalCode": 76780,
    "postalCodeMin": 76780,
    "postalCodeMax": 76789,
    "lat": 62.2214,
    "lng": 27.2029,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Naarajärvi",
    "postalCode": 76850,
    "postalCodeMin": 76850,
    "postalCodeMax": 76859,
    "lat": 62.2632,
    "lng": 27.0612,
    "radiusKm": 5.2
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Nenonpelto",
    "postalCode": 76940,
    "postalCodeMin": 76940,
    "postalCodeMax": 76949,
    "lat": 62.3734,
    "lng": 27.1107,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Paltanen",
    "postalCode": 77110,
    "postalCodeMin": 77110,
    "postalCodeMax": 77119,
    "lat": 62.3224,
    "lng": 26.8951,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Venetmäki",
    "postalCode": 77120,
    "postalCodeMin": 77120,
    "postalCodeMax": 77129,
    "lat": 62.3127,
    "lng": 26.7505,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Vanaja",
    "postalCode": 77140,
    "postalCodeMin": 77140,
    "postalCodeMax": 77149,
    "lat": 62.3917,
    "lng": 26.768,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Neuvola",
    "postalCode": 77220,
    "postalCodeMin": 77220,
    "postalCodeMax": 77229,
    "lat": 62.3024,
    "lng": 27.1484,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Halkokumpu",
    "postalCode": 77240,
    "postalCodeMin": 77240,
    "postalCodeMax": 77249,
    "lat": 62.182,
    "lng": 26.853,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Hurskaala",
    "postalCode": 77320,
    "postalCodeMin": 77320,
    "postalCodeMax": 77329,
    "lat": 62.1755,
    "lng": 27.364,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Virtasalmi",
    "postalCode": 77330,
    "postalCodeMin": 77330,
    "postalCodeMax": 77339,
    "lat": 62.1327,
    "lng": 27.4599,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Montola",
    "postalCode": 77350,
    "postalCodeMin": 77350,
    "postalCodeMax": 77359,
    "lat": 62.163,
    "lng": 27.302,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Siikamäki",
    "postalCode": 77430,
    "postalCodeMin": 77430,
    "postalCodeMax": 77439,
    "lat": 62.2905,
    "lng": 27.4062,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Haapakoski",
    "postalCode": 77520,
    "postalCodeMin": 77520,
    "postalCodeMax": 77529,
    "lat": 62.4578,
    "lng": 27.1701,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Jäppilä",
    "postalCode": 77570,
    "postalCodeMin": 77570,
    "postalCodeMax": 77579,
    "lat": 62.3786,
    "lng": 27.4346,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Pieksämäki",
    "area": "Tihusniemi",
    "postalCode": 77580,
    "postalCodeMin": 77580,
    "postalCodeMax": 77589,
    "lat": 62.3569,
    "lng": 27.5816,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Puumala",
    "area": "Puumala",
    "postalCode": 52200,
    "postalCodeMin": 52200,
    "postalCodeMax": 52209,
    "lat": 61.5239,
    "lng": 28.1778,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Puumala",
    "area": "Hurissalo",
    "postalCode": 52230,
    "postalCodeMin": 52230,
    "postalCodeMax": 52239,
    "lat": 61.4861,
    "lng": 27.8568,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Puumala",
    "area": "Ryhälä",
    "postalCode": 52270,
    "postalCodeMin": 52270,
    "postalCodeMax": 52279,
    "lat": 61.67,
    "lng": 28.2273,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Rantasalmi",
    "area": "Parkumäki",
    "postalCode": 58830,
    "postalCodeMin": 58830,
    "postalCodeMax": 58839,
    "lat": 61.9734,
    "lng": 28.5186,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Rantasalmi",
    "area": "Hiltula",
    "postalCode": 58850,
    "postalCodeMin": 58850,
    "postalCodeMax": 58859,
    "lat": 61.9603,
    "lng": 28.3884,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Rantasalmi",
    "area": "Rantasalmi",
    "postalCode": 58900,
    "postalCodeMin": 58900,
    "postalCodeMax": 58909,
    "lat": 62.064,
    "lng": 28.3028,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Rantasalmi",
    "area": "Rantasalmi as",
    "postalCode": 58910,
    "postalCodeMin": 58910,
    "postalCodeMax": 58919,
    "lat": 62.0074,
    "lng": 28.3191,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Rantasalmi",
    "area": "Kolkontaipale",
    "postalCode": 58920,
    "postalCodeMin": 58920,
    "postalCodeMax": 58929,
    "lat": 62.0576,
    "lng": 28.1191,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Rantasalmi",
    "area": "Tuusmäki",
    "postalCode": 58940,
    "postalCodeMin": 58940,
    "postalCodeMax": 58949,
    "lat": 62.0026,
    "lng": 28.0309,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Savonlinna",
    "postalCode": 57100,
    "postalCodeMin": 57100,
    "postalCodeMax": 57109,
    "lat": 61.7391,
    "lng": 28.8524,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Savonlinna",
    "postalCode": 57120,
    "postalCodeMin": 57120,
    "postalCodeMax": 57129,
    "lat": 61.8688,
    "lng": 28.8502,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Savonlinna",
    "postalCode": 57130,
    "postalCodeMin": 57130,
    "postalCodeMax": 57139,
    "lat": 61.8689,
    "lng": 28.8952,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Savonlinna",
    "postalCode": 57170,
    "postalCodeMin": 57170,
    "postalCodeMax": 57179,
    "lat": 61.8837,
    "lng": 28.8517,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Savonlinna",
    "postalCode": 57200,
    "postalCodeMin": 57200,
    "postalCodeMax": 57209,
    "lat": 61.8624,
    "lng": 28.9164,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Nojanmaa",
    "postalCode": 57210,
    "postalCodeMin": 57210,
    "postalCodeMax": 57219,
    "lat": 61.8748,
    "lng": 28.9381,
    "radiusKm": 3.4
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Savonlinna",
    "postalCode": 57220,
    "postalCodeMin": 57220,
    "postalCodeMax": 57229,
    "lat": 61.8629,
    "lng": 28.9702,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Savonlinna",
    "postalCode": 57230,
    "postalCodeMin": 57230,
    "postalCodeMax": 57239,
    "lat": 61.7411,
    "lng": 29.0666,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Rinkilä",
    "postalCode": 57310,
    "postalCodeMin": 57310,
    "postalCodeMax": 57319,
    "lat": 61.9131,
    "lng": 28.9213,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Savonlinna",
    "postalCode": 57510,
    "postalCodeMin": 57510,
    "postalCodeMax": 57519,
    "lat": 61.8762,
    "lng": 28.8285,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Poukkusilta",
    "postalCode": 57600,
    "postalCodeMin": 57600,
    "postalCodeMax": 57609,
    "lat": 61.8668,
    "lng": 28.8253,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Kellarpelto",
    "postalCode": 57710,
    "postalCodeMin": 57710,
    "postalCodeMax": 57719,
    "lat": 61.8861,
    "lng": 28.7965,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Aholahti",
    "postalCode": 57810,
    "postalCodeMin": 57810,
    "postalCodeMax": 57819,
    "lat": 61.8827,
    "lng": 28.7562,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Oravi",
    "postalCode": 58130,
    "postalCodeMin": 58130,
    "postalCodeMax": 58139,
    "lat": 62.1135,
    "lng": 28.6084,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Ahvensalmi",
    "postalCode": 58140,
    "postalCodeMin": 58140,
    "postalCodeMax": 58149,
    "lat": 62.1667,
    "lng": 28.4833,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Makkola",
    "postalCode": 58150,
    "postalCodeMin": 58150,
    "postalCodeMax": 58159,
    "lat": 61.9651,
    "lng": 28.9361,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Kerimäki",
    "postalCode": 58200,
    "postalCodeMin": 58200,
    "postalCodeMax": 58209,
    "lat": 61.9126,
    "lng": 29.2814,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Louhi",
    "postalCode": 58220,
    "postalCodeMin": 58220,
    "postalCodeMax": 58229,
    "lat": 61.9456,
    "lng": 29.042,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Kumpuranta",
    "postalCode": 58260,
    "postalCodeMin": 58260,
    "postalCodeMax": 58269,
    "lat": 61.9904,
    "lng": 29.375,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Savonranta",
    "postalCode": 58300,
    "postalCodeMin": 58300,
    "postalCodeMax": 58309,
    "lat": 62.1738,
    "lng": 29.2055,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Raikuu",
    "postalCode": 58320,
    "postalCodeMin": 58320,
    "postalCodeMax": 58329,
    "lat": 62.0358,
    "lng": 29.4473,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Säimen",
    "postalCode": 58360,
    "postalCodeMin": 58360,
    "postalCodeMax": 58369,
    "lat": 62.2639,
    "lng": 29.2092,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Rönkönvaara",
    "postalCode": 58390,
    "postalCodeMin": 58390,
    "postalCodeMax": 58399,
    "lat": 62.3256,
    "lng": 29.2236,
    "radiusKm": 5.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Haapakallio",
    "postalCode": 58410,
    "postalCodeMin": 58410,
    "postalCodeMax": 58419,
    "lat": 61.8991,
    "lng": 29.0783,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Silvola",
    "postalCode": 58420,
    "postalCodeMin": 58420,
    "postalCodeMax": 58429,
    "lat": 61.8627,
    "lng": 29.1151,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Kulennoinen",
    "postalCode": 58430,
    "postalCodeMin": 58430,
    "postalCodeMax": 58439,
    "lat": 61.8345,
    "lng": 29.218,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Punkaharju",
    "postalCode": 58450,
    "postalCodeMin": 58450,
    "postalCodeMax": 58459,
    "lat": 61.7767,
    "lng": 29.3003,
    "radiusKm": 2.3
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Punkasalmi",
    "postalCode": 58500,
    "postalCodeMin": 58500,
    "postalCodeMax": 58509,
    "lat": 61.7591,
    "lng": 29.3872,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Hiukkajoki",
    "postalCode": 58520,
    "postalCodeMin": 58520,
    "postalCodeMax": 58529,
    "lat": 61.778,
    "lng": 29.5506,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Putikko",
    "postalCode": 58550,
    "postalCodeMin": 58550,
    "postalCodeMax": 58559,
    "lat": 61.7132,
    "lng": 29.3968,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Ruhvana",
    "postalCode": 58570,
    "postalCodeMin": 58570,
    "postalCodeMax": 58579,
    "lat": 61.6504,
    "lng": 29.2901,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Vuoriniemi",
    "postalCode": 58580,
    "postalCodeMin": 58580,
    "postalCodeMax": 58589,
    "lat": 61.5997,
    "lng": 29.2184,
    "radiusKm": 4.7
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Kiviapaja",
    "postalCode": 58650,
    "postalCodeMin": 58650,
    "postalCodeMax": 58659,
    "lat": 61.6993,
    "lng": 28.7657,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Piojärvi",
    "postalCode": 58680,
    "postalCodeMin": 58680,
    "postalCodeMax": 58689,
    "lat": 61.5952,
    "lng": 28.9687,
    "radiusKm": 5.2
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Ala-Särkilahti",
    "postalCode": 58690,
    "postalCodeMin": 58690,
    "postalCodeMax": 58699,
    "lat": 61.55,
    "lng": 29.0833,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Pihlajalahti",
    "postalCode": 58770,
    "postalCodeMin": 58770,
    "postalCodeMax": 58779,
    "lat": 61.8733,
    "lng": 28.4827,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Savonlinna",
    "area": "Kallislahti",
    "postalCode": 58810,
    "postalCodeMin": 58810,
    "postalCodeMax": 58819,
    "lat": 61.9091,
    "lng": 28.6006,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Sulkava",
    "area": "Telakanava",
    "postalCode": 58610,
    "postalCodeMin": 58610,
    "postalCodeMax": 58619,
    "lat": 61.6541,
    "lng": 28.6034,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Sulkava",
    "area": "Lohilahti",
    "postalCode": 58620,
    "postalCodeMin": 58620,
    "postalCodeMax": 58629,
    "lat": 61.6115,
    "lng": 28.7031,
    "radiusKm": 3.9
  },
  {
    "region": "Etelä-Savo",
    "city": "Sulkava",
    "area": "Sulkava",
    "postalCode": 58700,
    "postalCodeMin": 58700,
    "postalCodeMax": 58709,
    "lat": 61.7861,
    "lng": 28.3706,
    "radiusKm": 2.6
  },
  {
    "region": "Etelä-Savo",
    "city": "Sulkava",
    "area": "Kaartilankoski",
    "postalCode": 58720,
    "postalCodeMin": 58720,
    "postalCodeMax": 58729,
    "lat": 61.7147,
    "lng": 28.3885,
    "radiusKm": 2.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Iisalmi",
    "postalCode": 74100,
    "postalCodeMin": 74100,
    "postalCodeMax": 74109,
    "lat": 63.5542,
    "lng": 27.1846,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Iisalmi",
    "postalCode": 74120,
    "postalCodeMin": 74120,
    "postalCodeMax": 74129,
    "lat": 63.5781,
    "lng": 27.2086,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Kihmula",
    "postalCode": 74130,
    "postalCodeMin": 74130,
    "postalCodeMax": 74139,
    "lat": 63.5484,
    "lng": 27.2211,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Ritoniemi",
    "postalCode": 74140,
    "postalCodeMin": 74140,
    "postalCodeMax": 74149,
    "lat": 63.579,
    "lng": 27.2616,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Iisalmi",
    "postalCode": 74150,
    "postalCodeMin": 74150,
    "postalCodeMax": 74159,
    "lat": 63.5694,
    "lng": 27.1826,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Koljonvirta",
    "postalCode": 74160,
    "postalCodeMin": 74160,
    "postalCodeMax": 74169,
    "lat": 63.5584,
    "lng": 27.1899,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Soinlahti",
    "postalCode": 74170,
    "postalCodeMin": 74170,
    "postalCodeMax": 74179,
    "lat": 63.6294,
    "lng": 27.214,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Hernejärvi",
    "postalCode": 74420,
    "postalCodeMin": 74420,
    "postalCodeMax": 74429,
    "lat": 63.542,
    "lng": 27.4983,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Peltosalmi",
    "postalCode": 74510,
    "postalCodeMin": 74510,
    "postalCodeMax": 74519,
    "lat": 63.5188,
    "lng": 27.2437,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Kirmanranta",
    "postalCode": 74520,
    "postalCodeMin": 74520,
    "postalCodeMax": 74529,
    "lat": 63.5694,
    "lng": 27.1826,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Kotikylä",
    "postalCode": 74540,
    "postalCodeMin": 74540,
    "postalCodeMax": 74549,
    "lat": 63.5694,
    "lng": 27.1826,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Pörsänmäki",
    "postalCode": 74550,
    "postalCodeMin": 74550,
    "postalCodeMax": 74559,
    "lat": 63.4015,
    "lng": 27.0935,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Kurenpolvi",
    "postalCode": 74590,
    "postalCodeMin": 74590,
    "postalCodeMax": 74599,
    "lat": 63.6085,
    "lng": 26.9634,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Iisalmi",
    "area": "Runni",
    "postalCode": 74595,
    "postalCodeMin": 74590,
    "postalCodeMax": 74599,
    "lat": 63.5893,
    "lng": 26.8601,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kaavi",
    "area": "Kaavi",
    "postalCode": 73600,
    "postalCodeMin": 73600,
    "postalCodeMax": 73609,
    "lat": 62.9747,
    "lng": 28.4933,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kaavi",
    "area": "Kortteinen",
    "postalCode": 73620,
    "postalCodeMin": 73620,
    "postalCodeMax": 73629,
    "lat": 63.0271,
    "lng": 28.633,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kaavi",
    "area": "Sivakkavaara",
    "postalCode": 73640,
    "postalCodeMin": 73640,
    "postalCodeMax": 73649,
    "lat": 62.9716,
    "lng": 28.7713,
    "radiusKm": 6.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kaavi",
    "area": "Niinivaara",
    "postalCode": 73645,
    "postalCodeMin": 73640,
    "postalCodeMax": 73649,
    "lat": 63.0055,
    "lng": 28.8797,
    "radiusKm": 6.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kaavi",
    "area": "Luikonlahti",
    "postalCode": 73670,
    "postalCodeMin": 73670,
    "postalCodeMax": 73679,
    "lat": 62.9227,
    "lng": 28.672,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Keitele",
    "area": "Keitele",
    "postalCode": 72600,
    "postalCodeMin": 72600,
    "postalCodeMax": 72609,
    "lat": 63.1785,
    "lng": 26.3412,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Keitele",
    "area": "Kuusela",
    "postalCode": 72630,
    "postalCodeMin": 72630,
    "postalCodeMax": 72639,
    "lat": 63.0464,
    "lng": 26.5238,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Keitele",
    "area": "Tossavanlahti",
    "postalCode": 72930,
    "postalCodeMin": 72930,
    "postalCodeMax": 72939,
    "lat": 63.2803,
    "lng": 26.2427,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Keitele",
    "area": "Porttila",
    "postalCode": 72950,
    "postalCodeMin": 72950,
    "postalCodeMax": 72959,
    "lat": 63.3413,
    "lng": 26.1942,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Keitele",
    "area": "Petäjäkylä",
    "postalCode": 72980,
    "postalCodeMin": 72980,
    "postalCodeMax": 72989,
    "lat": 63.4187,
    "lng": 26.202,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Honkaranta",
    "postalCode": 74610,
    "postalCodeMin": 74610,
    "postalCodeMax": 74619,
    "lat": 63.6148,
    "lng": 26.7599,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Heinäkylä",
    "postalCode": 74630,
    "postalCodeMin": 74630,
    "postalCodeMax": 74639,
    "lat": 63.5641,
    "lng": 26.7387,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Sulkavanjärvi",
    "postalCode": 74640,
    "postalCodeMin": 74640,
    "postalCodeMax": 74649,
    "lat": 63.477,
    "lng": 26.7244,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Rapakkojoki",
    "postalCode": 74670,
    "postalCodeMin": 74670,
    "postalCodeMax": 74679,
    "lat": 63.5884,
    "lng": 26.5986,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Myllyniemi",
    "postalCode": 74680,
    "postalCodeMin": 74680,
    "postalCodeMax": 74689,
    "lat": 63.4998,
    "lng": 26.5518,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Kiuruvesi",
    "postalCode": 74700,
    "postalCodeMin": 74700,
    "postalCodeMax": 74709,
    "lat": 63.6538,
    "lng": 26.6211,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Niemiskylä",
    "postalCode": 74720,
    "postalCodeMin": 74720,
    "postalCodeMax": 74729,
    "lat": 63.64,
    "lng": 26.5226,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Aittojärvi",
    "postalCode": 74740,
    "postalCodeMin": 74740,
    "postalCodeMax": 74749,
    "lat": 63.6721,
    "lng": 26.3908,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Kalliokylä",
    "postalCode": 74770,
    "postalCodeMin": 74770,
    "postalCodeMax": 74779,
    "lat": 63.5883,
    "lng": 26.4031,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Koppeloharju",
    "postalCode": 74840,
    "postalCodeMin": 74840,
    "postalCodeMax": 74849,
    "lat": 63.7609,
    "lng": 26.7793,
    "radiusKm": 2.7
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Remeskylä",
    "postalCode": 74940,
    "postalCodeMin": 74940,
    "postalCodeMax": 74949,
    "lat": 63.8116,
    "lng": 26.4224,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kiuruvesi",
    "area": "Tihilänkangas",
    "postalCode": 74980,
    "postalCodeMin": 74980,
    "postalCodeMax": 74989,
    "lat": 63.8859,
    "lng": 26.4318,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "keskusta",
    "postalCode": 70100,
    "postalCodeMin": 70100,
    "postalCodeMax": 70109,
    "lat": 62.8931,
    "lng": 27.6769,
    "radiusKm": 2.1
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "keskusta",
    "postalCode": 70110,
    "postalCodeMin": 70110,
    "postalCodeMax": 70119,
    "lat": 62.8933,
    "lng": 27.6712,
    "radiusKm": 2.1
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Neulamäki, Savilahti",
    "postalCode": 70150,
    "postalCodeMin": 70150,
    "postalCodeMax": 70159,
    "lat": 62.8843,
    "lng": 27.6106,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Puijonlaakso",
    "postalCode": 70200,
    "postalCodeMin": 70200,
    "postalCodeMax": 70209,
    "lat": 62.9017,
    "lng": 27.649,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Itä-Suomen yliopisto, Kuopion yliopistollinen sairaala",
    "postalCode": 70210,
    "postalCodeMin": 70210,
    "postalCodeMax": 70219,
    "lat": 62.8976,
    "lng": 27.6472,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Niuvanniemi",
    "postalCode": 70240,
    "postalCodeMin": 70240,
    "postalCodeMax": 70249,
    "lat": 62.9142,
    "lng": 27.626,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Julkula",
    "postalCode": 70260,
    "postalCodeMin": 70260,
    "postalCodeMax": 70269,
    "lat": 62.9255,
    "lng": 27.6323,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Rypysuo",
    "postalCode": 70280,
    "postalCodeMin": 70280,
    "postalCodeMax": 70289,
    "lat": 62.9191,
    "lng": 27.6346,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Linnanpelto",
    "postalCode": 70300,
    "postalCodeMin": 70300,
    "postalCodeMax": 70309,
    "lat": 62.9003,
    "lng": 27.6908,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Inkilänmäki, Peipposenrinne",
    "postalCode": 70340,
    "postalCodeMin": 70340,
    "postalCodeMax": 70349,
    "lat": 62.9147,
    "lng": 27.6759,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Kettulanlahti, Rahusenkangas",
    "postalCode": 70400,
    "postalCodeMin": 70400,
    "postalCodeMax": 70409,
    "lat": 62.9252,
    "lng": 27.692,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Päiväranta, Sorsasalo",
    "postalCode": 70420,
    "postalCodeMin": 70420,
    "postalCodeMax": 70429,
    "lat": 62.9328,
    "lng": 27.6604,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Kelloniemi",
    "postalCode": 70460,
    "postalCodeMin": 70460,
    "postalCodeMax": 70469,
    "lat": 62.9151,
    "lng": 27.707,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Itkonniemi, Männistö",
    "postalCode": 70500,
    "postalCodeMin": 70500,
    "postalCodeMax": 70509,
    "lat": 62.9013,
    "lng": 27.7055,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Niirala",
    "postalCode": 70600,
    "postalCodeMin": 70600,
    "postalCodeMax": 70609,
    "lat": 62.8917,
    "lng": 27.6565,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Haapaniemi",
    "postalCode": 70620,
    "postalCodeMin": 70620,
    "postalCodeMax": 70629,
    "lat": 62.8798,
    "lng": 27.6737,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Kolmisoppi, Särkiniemi",
    "postalCode": 70700,
    "postalCodeMin": 70700,
    "postalCodeMax": 70709,
    "lat": 62.8698,
    "lng": 27.6065,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Jynkkä, Levänen",
    "postalCode": 70780,
    "postalCodeMin": 70780,
    "postalCodeMax": 70789,
    "lat": 62.8611,
    "lng": 27.6272,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Litmanen, Pitkälahti",
    "postalCode": 70800,
    "postalCodeMin": 70800,
    "postalCodeMax": 70809,
    "lat": 62.8333,
    "lng": 27.6376,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Petonen, Pirtti",
    "postalCode": 70820,
    "postalCodeMin": 70820,
    "postalCodeMax": 70829,
    "lat": 62.839,
    "lng": 27.6379,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Saaristokaupunki",
    "postalCode": 70840,
    "postalCodeMin": 70840,
    "postalCodeMax": 70849,
    "lat": 62.8409,
    "lng": 27.7144,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Hiltulanlahti",
    "postalCode": 70870,
    "postalCodeMin": 70870,
    "postalCodeMax": 70879,
    "lat": 62.7988,
    "lng": 27.6197,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Kortejoki",
    "postalCode": 71130,
    "postalCodeMin": 71130,
    "postalCodeMax": 71139,
    "lat": 62.8958,
    "lng": 27.8546,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Vartiala",
    "postalCode": 71150,
    "postalCodeMin": 71150,
    "postalCodeMax": 71159,
    "lat": 62.9303,
    "lng": 28.0662,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Riistavesi",
    "postalCode": 71160,
    "postalCodeMin": 71160,
    "postalCodeMax": 71169,
    "lat": 62.8752,
    "lng": 28.1223,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Vehmersalmi",
    "postalCode": 71310,
    "postalCodeMin": 71310,
    "postalCodeMax": 71319,
    "lat": 62.7608,
    "lng": 28.0294,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Räsälä",
    "postalCode": 71330,
    "postalCodeMin": 71330,
    "postalCodeMax": 71339,
    "lat": 62.707,
    "lng": 27.9474,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Litmaniemi",
    "postalCode": 71360,
    "postalCodeMin": 71360,
    "postalCodeMax": 71369,
    "lat": 62.7547,
    "lng": 28.233,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Mustinlahti",
    "postalCode": 71380,
    "postalCodeMin": 71380,
    "postalCodeMax": 71389,
    "lat": 62.6975,
    "lng": 28.2733,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Kurkimäki",
    "postalCode": 71480,
    "postalCodeMin": 71480,
    "postalCodeMax": 71489,
    "lat": 62.7799,
    "lng": 27.49,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Airaksela",
    "postalCode": 71490,
    "postalCodeMin": 71490,
    "postalCodeMax": 71499,
    "lat": 62.7619,
    "lng": 27.3701,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Kaislastenlahti",
    "postalCode": 71520,
    "postalCodeMin": 71520,
    "postalCodeMax": 71529,
    "lat": 62.9037,
    "lng": 27.4419,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Syvänniemi",
    "postalCode": 71570,
    "postalCodeMin": 71570,
    "postalCodeMax": 71579,
    "lat": 62.8566,
    "lng": 27.1548,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Salonkulma",
    "postalCode": 71610,
    "postalCodeMin": 71610,
    "postalCodeMax": 71619,
    "lat": 62.9666,
    "lng": 27.3201,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Hirvilahti",
    "postalCode": 71650,
    "postalCodeMin": 71650,
    "postalCodeMax": 71659,
    "lat": 63.0125,
    "lng": 27.3486,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Leinolanlahti",
    "postalCode": 71660,
    "postalCodeMin": 71660,
    "postalCodeMax": 71669,
    "lat": 63.0762,
    "lng": 27.2439,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Kurolanlahti",
    "postalCode": 71670,
    "postalCodeMin": 71670,
    "postalCodeMax": 71679,
    "lat": 63.0905,
    "lng": 27.208,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Pulkonkoski",
    "postalCode": 71680,
    "postalCodeMin": 71680,
    "postalCodeMax": 71689,
    "lat": 63.1281,
    "lng": 27.1842,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Varpasmaa",
    "postalCode": 71690,
    "postalCodeMin": 71690,
    "postalCodeMax": 71699,
    "lat": 63.1439,
    "lng": 27.0938,
    "radiusKm": 9.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Käärmelahti",
    "postalCode": 71720,
    "postalCodeMin": 71720,
    "postalCodeMax": 71729,
    "lat": 63.0915,
    "lng": 27.4249,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Kinnulanlahti",
    "postalCode": 71730,
    "postalCodeMin": 71730,
    "postalCodeMax": 71739,
    "lat": 63.121,
    "lng": 27.3826,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Tavinsalmi",
    "postalCode": 71740,
    "postalCodeMin": 71740,
    "postalCodeMax": 71749,
    "lat": 63.1196,
    "lng": 27.2954,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Haatala",
    "postalCode": 71745,
    "postalCodeMin": 71740,
    "postalCodeMax": 71749,
    "lat": 63.1656,
    "lng": 27.2344,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Maaninka",
    "postalCode": 71750,
    "postalCodeMin": 71750,
    "postalCodeMax": 71759,
    "lat": 63.165,
    "lng": 27.3163,
    "radiusKm": 9.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Ahkionlahti",
    "postalCode": 71760,
    "postalCodeMin": 71760,
    "postalCodeMax": 71769,
    "lat": 63.2001,
    "lng": 27.2342,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Tuovilanlahti",
    "postalCode": 71775,
    "postalCodeMin": 71770,
    "postalCodeMax": 71779,
    "lat": 63.2141,
    "lng": 27.1511,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Lammasaho",
    "postalCode": 71950,
    "postalCodeMin": 71950,
    "postalCodeMax": 71959,
    "lat": 63.2281,
    "lng": 27.7794,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Karttula",
    "postalCode": 72100,
    "postalCodeMin": 72100,
    "postalCodeMax": 72109,
    "lat": 62.8946,
    "lng": 26.9732,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Itä-Karttula",
    "postalCode": 72140,
    "postalCodeMin": 72140,
    "postalCodeMax": 72149,
    "lat": 62.9433,
    "lng": 27.1514,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Saarinen",
    "postalCode": 72490,
    "postalCodeMin": 72490,
    "postalCodeMax": 72499,
    "lat": 63.128,
    "lng": 26.9999,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Nilsiä",
    "postalCode": 73300,
    "postalCodeMin": 73300,
    "postalCodeMax": 73309,
    "lat": 63.2038,
    "lng": 28.0865,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Tahkovuori",
    "postalCode": 73310,
    "postalCodeMin": 73310,
    "postalCodeMax": 73319,
    "lat": 63.289,
    "lng": 28.0401,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Reittiö",
    "postalCode": 73320,
    "postalCodeMin": 73320,
    "postalCodeMax": 73329,
    "lat": 63.2971,
    "lng": 27.926,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Haluna",
    "postalCode": 73350,
    "postalCodeMin": 73350,
    "postalCodeMax": 73359,
    "lat": 63.1201,
    "lng": 28.0135,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Pajulahti",
    "postalCode": 73360,
    "postalCodeMin": 73360,
    "postalCodeMax": 73369,
    "lat": 63.1426,
    "lng": 27.8619,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Pieksänkoski",
    "postalCode": 73410,
    "postalCodeMin": 73410,
    "postalCodeMax": 73419,
    "lat": 63.0919,
    "lng": 27.9375,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Muuruvesi",
    "postalCode": 73460,
    "postalCodeMin": 73460,
    "postalCodeMax": 73469,
    "lat": 63.0023,
    "lng": 28.2097,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Västinniemi",
    "postalCode": 73470,
    "postalCodeMin": 73470,
    "postalCodeMax": 73479,
    "lat": 62.9863,
    "lng": 28.2584,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Juankoski",
    "postalCode": 73500,
    "postalCodeMin": 73500,
    "postalCodeMax": 73509,
    "lat": 63.0661,
    "lng": 28.3308,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Viitaniemi",
    "postalCode": 73710,
    "postalCodeMin": 73710,
    "postalCodeMax": 73719,
    "lat": 63.1344,
    "lng": 28.4811,
    "radiusKm": 7.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Losomäki",
    "postalCode": 73730,
    "postalCodeMin": 73730,
    "postalCodeMax": 73739,
    "lat": 63.1496,
    "lng": 28.6293,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Säyneinen",
    "postalCode": 73770,
    "postalCodeMin": 73770,
    "postalCodeMax": 73779,
    "lat": 63.2052,
    "lng": 28.4809,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Palonurmi",
    "postalCode": 73810,
    "postalCodeMin": 73810,
    "postalCodeMax": 73819,
    "lat": 63.2921,
    "lng": 28.1856,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Kuopio",
    "area": "Siikajärvi",
    "postalCode": 73830,
    "postalCodeMin": 73830,
    "postalCodeMax": 73839,
    "lat": 63.2598,
    "lng": 28.315,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Alapitkä",
    "postalCode": 71910,
    "postalCodeMin": 71910,
    "postalCodeMax": 71919,
    "lat": 63.2065,
    "lng": 27.5411,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Pajujärvi",
    "postalCode": 71920,
    "postalCodeMin": 71920,
    "postalCodeMax": 71929,
    "lat": 63.2514,
    "lng": 27.4798,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Lukkarila",
    "postalCode": 71960,
    "postalCodeMin": 71960,
    "postalCodeMax": 71969,
    "lat": 63.2736,
    "lng": 27.6766,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Lapinlahti",
    "postalCode": 73100,
    "postalCodeMin": 73100,
    "postalCodeMax": 73109,
    "lat": 63.3667,
    "lng": 27.3922,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Mäntylahti",
    "postalCode": 73110,
    "postalCodeMin": 73110,
    "postalCodeMax": 73119,
    "lat": 63.3033,
    "lng": 27.4511,
    "radiusKm": 6.3
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Nerkoo",
    "postalCode": 73120,
    "postalCodeMin": 73120,
    "postalCodeMax": 73129,
    "lat": 63.4217,
    "lng": 27.3295,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Varpaisjärvi",
    "postalCode": 73200,
    "postalCodeMin": 73200,
    "postalCodeMax": 73209,
    "lat": 63.3656,
    "lng": 27.7672,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Syvärinpää",
    "postalCode": 73230,
    "postalCodeMin": 73230,
    "postalCodeMax": 73239,
    "lat": 63.4334,
    "lng": 27.8142,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Korpijärvi",
    "postalCode": 73250,
    "postalCodeMin": 73250,
    "postalCodeMax": 73259,
    "lat": 63.4841,
    "lng": 27.9669,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Lapinlahti",
    "area": "Paloinen",
    "postalCode": 74470,
    "postalCodeMin": 74470,
    "postalCodeMax": 74479,
    "lat": 63.4923,
    "lng": 27.8548,
    "radiusKm": 4.2
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Paukarlahti",
    "postalCode": 71460,
    "postalCodeMin": 71460,
    "postalCodeMax": 71469,
    "lat": 62.641,
    "lng": 27.6042,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Oravikoski",
    "postalCode": 71470,
    "postalCodeMin": 71470,
    "postalCodeMax": 71479,
    "lat": 62.5833,
    "lng": 27.6096,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Timola",
    "postalCode": 78480,
    "postalCodeMin": 78480,
    "postalCodeMax": 78489,
    "lat": 62.3768,
    "lng": 27.8609,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Leppävirta",
    "postalCode": 79100,
    "postalCodeMin": 79100,
    "postalCodeMax": 79109,
    "lat": 62.4917,
    "lng": 27.788,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Sorsakoski",
    "postalCode": 79130,
    "postalCodeMin": 79130,
    "postalCodeMax": 79139,
    "lat": 62.4493,
    "lng": 27.6633,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Kotalahti",
    "postalCode": 79140,
    "postalCodeMin": 79140,
    "postalCodeMax": 79149,
    "lat": 62.5541,
    "lng": 27.6167,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Konnuslahti",
    "postalCode": 79150,
    "postalCodeMin": 79150,
    "postalCodeMax": 79159,
    "lat": 62.5411,
    "lng": 27.8848,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Saamaiskylä",
    "postalCode": 79160,
    "postalCodeMin": 79160,
    "postalCodeMax": 79169,
    "lat": 62.6378,
    "lng": 27.8195,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Tuppurinmäki",
    "postalCode": 79180,
    "postalCodeMin": 79180,
    "postalCodeMax": 79189,
    "lat": 62.6189,
    "lng": 27.9568,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Valkeamäki",
    "postalCode": 79190,
    "postalCodeMin": 79190,
    "postalCodeMax": 79199,
    "lat": 62.6518,
    "lng": 28.0157,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Moninmäki",
    "postalCode": 79230,
    "postalCodeMin": 79230,
    "postalCodeMax": 79239,
    "lat": 62.4534,
    "lng": 28.0349,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Kurjala",
    "postalCode": 79255,
    "postalCodeMin": 79250,
    "postalCodeMax": 79259,
    "lat": 62.5456,
    "lng": 28.1113,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Puponmäki",
    "postalCode": 79265,
    "postalCodeMin": 79260,
    "postalCodeMax": 79269,
    "lat": 62.5916,
    "lng": 28.0822,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Näädänmaa",
    "postalCode": 79330,
    "postalCodeMin": 79330,
    "postalCodeMax": 79339,
    "lat": 62.4974,
    "lng": 28.2414,
    "radiusKm": 6.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Itä-Soisalo",
    "postalCode": 79350,
    "postalCodeMin": 79350,
    "postalCodeMax": 79359,
    "lat": 62.3833,
    "lng": 28.2167,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Leppävirta",
    "area": "Niinimäki",
    "postalCode": 79410,
    "postalCodeMin": 79410,
    "postalCodeMax": 79419,
    "lat": 62.3874,
    "lng": 28.1864,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Pielavesi",
    "postalCode": 72400,
    "postalCodeMin": 72400,
    "postalCodeMax": 72409,
    "lat": 63.2325,
    "lng": 26.7557,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Kumpula",
    "postalCode": 72430,
    "postalCodeMin": 72430,
    "postalCodeMax": 72439,
    "lat": 63.2325,
    "lng": 26.7553,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Jokijärvi",
    "postalCode": 72510,
    "postalCodeMin": 72510,
    "postalCodeMax": 72519,
    "lat": 63.089,
    "lng": 26.7184,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Säviäntaipale",
    "postalCode": 72530,
    "postalCodeMin": 72530,
    "postalCodeMax": 72539,
    "lat": 63.1136,
    "lng": 26.8209,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Säviä",
    "postalCode": 72550,
    "postalCodeMin": 72550,
    "postalCodeMax": 72559,
    "lat": 63.2,
    "lng": 26.6621,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Mäntylä",
    "postalCode": 72570,
    "postalCodeMin": 72570,
    "postalCodeMax": 72579,
    "lat": 63.2031,
    "lng": 26.5046,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Vaaraslahti",
    "postalCode": 72710,
    "postalCodeMin": 72710,
    "postalCodeMax": 72719,
    "lat": 63.3653,
    "lng": 26.7168,
    "radiusKm": 6.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Laukkala",
    "postalCode": 72740,
    "postalCodeMin": 72740,
    "postalCodeMax": 72749,
    "lat": 63.3987,
    "lng": 26.553,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Jylhänkylä",
    "postalCode": 72810,
    "postalCodeMin": 72810,
    "postalCodeMax": 72819,
    "lat": 63.2729,
    "lng": 26.5378,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Pielavesi",
    "area": "Saarela",
    "postalCode": 72840,
    "postalCodeMin": 72840,
    "postalCodeMax": 72849,
    "lat": 63.3513,
    "lng": 26.3361,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautalampi",
    "area": "Rautalampi",
    "postalCode": 77700,
    "postalCodeMin": 77700,
    "postalCodeMax": 77709,
    "lat": 62.6242,
    "lng": 26.8278,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautalampi",
    "area": "Myhinpää",
    "postalCode": 77770,
    "postalCodeMin": 77770,
    "postalCodeMax": 77779,
    "lat": 62.4771,
    "lng": 26.7442,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautalampi",
    "area": "Vaajasalmi",
    "postalCode": 77910,
    "postalCodeMin": 77910,
    "postalCodeMax": 77919,
    "lat": 62.7048,
    "lng": 26.8557,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautalampi",
    "area": "Kerkonjoensuu",
    "postalCode": 77930,
    "postalCodeMin": 77930,
    "postalCodeMax": 77939,
    "lat": 62.7667,
    "lng": 26.6833,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautalampi",
    "area": "Pakarila",
    "postalCode": 77960,
    "postalCodeMin": 77960,
    "postalCodeMax": 77969,
    "lat": 62.6611,
    "lng": 26.6271,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautavaara",
    "area": "Ala-Luosta",
    "postalCode": 73850,
    "postalCodeMin": 73850,
    "postalCodeMax": 73859,
    "lat": 63.269,
    "lng": 28.5179,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautavaara",
    "area": "Pykälikkö",
    "postalCode": 73860,
    "postalCodeMin": 73860,
    "postalCodeMax": 73869,
    "lat": 63.4942,
    "lng": 28.2984,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautavaara",
    "area": "Rautavaara",
    "postalCode": 73900,
    "postalCodeMin": 73900,
    "postalCodeMax": 73909,
    "lat": 63.4942,
    "lng": 28.2984,
    "radiusKm": 6.6
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautavaara",
    "area": "Riitasalo",
    "postalCode": 73970,
    "postalCodeMin": 73970,
    "postalCodeMax": 73979,
    "lat": 63.3398,
    "lng": 28.3107,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautavaara",
    "area": "Kangaslahti",
    "postalCode": 73990,
    "postalCodeMin": 73990,
    "postalCodeMax": 73999,
    "lat": 63.3947,
    "lng": 28.1277,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Rautavaara",
    "area": "Ylä-Luosta",
    "postalCode": 75680,
    "postalCodeMin": 75680,
    "postalCodeMax": 75689,
    "lat": 63.3773,
    "lng": 28.6773,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Siilinjärvi",
    "area": "Toivala",
    "postalCode": 70900,
    "postalCodeMin": 70900,
    "postalCodeMax": 70909,
    "lat": 62.9887,
    "lng": 27.729,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Siilinjärvi",
    "area": "Vuorela",
    "postalCode": 70910,
    "postalCodeMin": 70910,
    "postalCodeMax": 70919,
    "lat": 62.9807,
    "lng": 27.6979,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Siilinjärvi",
    "area": "Jännevirta",
    "postalCode": 70940,
    "postalCodeMin": 70940,
    "postalCodeMax": 70949,
    "lat": 62.9714,
    "lng": 27.8302,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Siilinjärvi",
    "area": "Siilinjärvi",
    "postalCode": 71800,
    "postalCodeMin": 71800,
    "postalCodeMax": 71809,
    "lat": 63.0737,
    "lng": 27.6619,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Siilinjärvi",
    "area": "Pöljä",
    "postalCode": 71820,
    "postalCodeMin": 71820,
    "postalCodeMax": 71829,
    "lat": 63.1389,
    "lng": 27.594,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Siilinjärvi",
    "area": "Kuuslahti",
    "postalCode": 71840,
    "postalCodeMin": 71840,
    "postalCodeMax": 71849,
    "lat": 63.1521,
    "lng": 27.7742,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Siilinjärvi",
    "area": "Leppäkaarre",
    "postalCode": 71850,
    "postalCodeMin": 71850,
    "postalCodeMax": 71859,
    "lat": 63.0693,
    "lng": 27.6905,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Siilinjärvi",
    "area": "Harjamäki",
    "postalCode": 71870,
    "postalCodeMin": 71870,
    "postalCodeMax": 71879,
    "lat": 63.0714,
    "lng": 27.5946,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Siilinjärvi",
    "area": "Hamula",
    "postalCode": 71890,
    "postalCodeMin": 71890,
    "postalCodeMax": 71899,
    "lat": 63.0832,
    "lng": 27.5727,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Sonkajärvi",
    "area": "Sonkajärvi",
    "postalCode": 74300,
    "postalCodeMin": 74300,
    "postalCodeMax": 74309,
    "lat": 63.6716,
    "lng": 27.5221,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Sonkajärvi",
    "area": "Sukeva",
    "postalCode": 74340,
    "postalCodeMin": 74340,
    "postalCodeMax": 74349,
    "lat": 63.8695,
    "lng": 27.4275,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Sonkajärvi",
    "area": "Kalliosuo",
    "postalCode": 74345,
    "postalCodeMin": 74340,
    "postalCodeMax": 74349,
    "lat": 63.9203,
    "lng": 27.4855,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Sonkajärvi",
    "area": "Sonkakoski",
    "postalCode": 74360,
    "postalCodeMin": 74360,
    "postalCodeMax": 74369,
    "lat": 63.7389,
    "lng": 27.4976,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Sonkajärvi",
    "area": "Jyrkkä",
    "postalCode": 74380,
    "postalCodeMin": 74380,
    "postalCodeMax": 74389,
    "lat": 63.7785,
    "lng": 27.8031,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Sonkajärvi",
    "area": "Laakajärvi",
    "postalCode": 74390,
    "postalCodeMin": 74390,
    "postalCodeMax": 74399,
    "lat": 63.7879,
    "lng": 28.0774,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Sonkajärvi",
    "area": "Koirakoski",
    "postalCode": 74490,
    "postalCodeMin": 74490,
    "postalCodeMax": 74499,
    "lat": 63.6075,
    "lng": 27.8103,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Suonenjoki",
    "area": "Suonenjoki",
    "postalCode": 77600,
    "postalCodeMin": 77600,
    "postalCodeMax": 77609,
    "lat": 62.6261,
    "lng": 27.1221,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Suonenjoki",
    "area": "Lempyy",
    "postalCode": 77630,
    "postalCodeMin": 77630,
    "postalCodeMax": 77639,
    "lat": 62.6477,
    "lng": 27.3675,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Suonenjoki",
    "area": "Suontee",
    "postalCode": 77690,
    "postalCodeMin": 77690,
    "postalCodeMax": 77699,
    "lat": 62.4866,
    "lng": 27.1967,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Suonenjoki",
    "area": "Iisvesi",
    "postalCode": 77800,
    "postalCodeMin": 77800,
    "postalCodeMax": 77809,
    "lat": 62.6655,
    "lng": 27.0428,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Tervo",
    "area": "Talluskylä",
    "postalCode": 71640,
    "postalCodeMin": 71640,
    "postalCodeMax": 71649,
    "lat": 63.0433,
    "lng": 26.9907,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Tervo",
    "area": "Tervo",
    "postalCode": 72210,
    "postalCodeMin": 72210,
    "postalCodeMax": 72219,
    "lat": 62.9565,
    "lng": 26.7604,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Tervo",
    "area": "Eliaksela",
    "postalCode": 72220,
    "postalCodeMin": 72220,
    "postalCodeMax": 72229,
    "lat": 62.8553,
    "lng": 26.7119,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Tuusniemi",
    "area": "Laukka-aho",
    "postalCode": 71170,
    "postalCodeMin": 71170,
    "postalCodeMax": 71179,
    "lat": 62.9277,
    "lng": 28.3416,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Tuusniemi",
    "area": "Tuusniemi",
    "postalCode": 71200,
    "postalCodeMin": 71200,
    "postalCodeMax": 71209,
    "lat": 62.8108,
    "lng": 28.4912,
    "radiusKm": 5.4
  },
  {
    "region": "Pohjois-Savo",
    "city": "Tuusniemi",
    "area": "Tuusjärvi",
    "postalCode": 71210,
    "postalCodeMin": 71210,
    "postalCodeMax": 71219,
    "lat": 62.8729,
    "lng": 28.3357,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Tuusniemi",
    "area": "Paakkila",
    "postalCode": 71240,
    "postalCodeMin": 71240,
    "postalCodeMax": 71249,
    "lat": 62.7871,
    "lng": 28.6531,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Tuusniemi",
    "area": "Juurikkamäki",
    "postalCode": 71260,
    "postalCodeMin": 71260,
    "postalCodeMax": 71269,
    "lat": 62.7478,
    "lng": 28.4116,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Tuusniemi",
    "area": "Kosula",
    "postalCode": 71280,
    "postalCodeMin": 71280,
    "postalCodeMax": 71289,
    "lat": 62.6543,
    "lng": 28.4948,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Varkaus",
    "postalCode": 78200,
    "postalCodeMin": 78200,
    "postalCodeMax": 78209,
    "lat": 62.3374,
    "lng": 28.0719,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Kuoppakangas",
    "postalCode": 78210,
    "postalCodeMin": 78210,
    "postalCodeMax": 78219,
    "lat": 62.3235,
    "lng": 27.8594,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Päiviönsaari",
    "postalCode": 78250,
    "postalCodeMin": 78250,
    "postalCodeMax": 78259,
    "lat": 62.3143,
    "lng": 27.8924,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Kommila",
    "postalCode": 78300,
    "postalCodeMin": 78300,
    "postalCodeMax": 78309,
    "lat": 62.3229,
    "lng": 27.9001,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Puurtila",
    "postalCode": 78310,
    "postalCodeMin": 78310,
    "postalCodeMax": 78319,
    "lat": 62.3378,
    "lng": 27.9183,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Varkaus",
    "postalCode": 78400,
    "postalCodeMin": 78400,
    "postalCodeMax": 78409,
    "lat": 62.3509,
    "lng": 27.8636,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Könönpelto",
    "postalCode": 78500,
    "postalCodeMin": 78500,
    "postalCodeMax": 78509,
    "lat": 62.3039,
    "lng": 27.9621,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Varkaus",
    "postalCode": 78610,
    "postalCodeMin": 78610,
    "postalCodeMax": 78619,
    "lat": 62.3107,
    "lng": 28.0041,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Varkaus",
    "postalCode": 78710,
    "postalCodeMin": 78710,
    "postalCodeMax": 78719,
    "lat": 62.2685,
    "lng": 28.0358,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Käpykangas",
    "postalCode": 78850,
    "postalCodeMin": 78850,
    "postalCodeMax": 78859,
    "lat": 62.3055,
    "lng": 27.8449,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Kaura-aho",
    "postalCode": 78870,
    "postalCodeMin": 78870,
    "postalCodeMax": 78879,
    "lat": 62.3188,
    "lng": 27.8308,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Varkaus",
    "postalCode": 78900,
    "postalCodeMin": 78900,
    "postalCodeMax": 78909,
    "lat": 62.3316,
    "lng": 27.7462,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Kangaslampi",
    "postalCode": 79480,
    "postalCodeMin": 79480,
    "postalCodeMax": 79489,
    "lat": 62.2956,
    "lng": 28.2514,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Varkaus (kaupunki)",
    "area": "Viljolahti",
    "postalCode": 79520,
    "postalCodeMin": 79520,
    "postalCodeMax": 79529,
    "lat": 62.2426,
    "lng": 28.4721,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vesanto",
    "area": "Vesanto",
    "postalCode": 72300,
    "postalCodeMin": 72300,
    "postalCodeMax": 72309,
    "lat": 62.9304,
    "lng": 26.4093,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vesanto",
    "area": "Niinivesi",
    "postalCode": 72310,
    "postalCodeMin": 72310,
    "postalCodeMax": 72319,
    "lat": 62.9841,
    "lng": 26.4702,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vesanto",
    "area": "Tiitilänkylä",
    "postalCode": 72330,
    "postalCodeMin": 72330,
    "postalCodeMax": 72339,
    "lat": 62.8668,
    "lng": 26.583,
    "radiusKm": 4.5
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vesanto",
    "area": "Pienola",
    "postalCode": 72350,
    "postalCodeMin": 72350,
    "postalCodeMax": 72359,
    "lat": 62.8712,
    "lng": 26.2563,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vesanto",
    "area": "Närhilä",
    "postalCode": 72360,
    "postalCodeMin": 72360,
    "postalCodeMax": 72369,
    "lat": 62.8157,
    "lng": 26.3452,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vesanto",
    "area": "Horontaipale",
    "postalCode": 72380,
    "postalCodeMin": 72380,
    "postalCodeMax": 72389,
    "lat": 62.9254,
    "lng": 26.1117,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vieremä",
    "area": "Vieremä",
    "postalCode": 74200,
    "postalCodeMin": 74200,
    "postalCodeMax": 74209,
    "lat": 63.7431,
    "lng": 27.0015,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vieremä",
    "area": "Salahmi",
    "postalCode": 74230,
    "postalCodeMin": 74230,
    "postalCodeMax": 74239,
    "lat": 63.8057,
    "lng": 26.9368,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vieremä",
    "area": "Marttisenjärvi",
    "postalCode": 74240,
    "postalCodeMin": 74240,
    "postalCodeMax": 74249,
    "lat": 63.9133,
    "lng": 26.9523,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vieremä",
    "area": "Nissilä",
    "postalCode": 74250,
    "postalCodeMin": 74250,
    "postalCodeMax": 74259,
    "lat": 63.9484,
    "lng": 26.8466,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Savo",
    "city": "Vieremä",
    "area": "Kauppilanmäki",
    "postalCode": 74270,
    "postalCodeMin": 74270,
    "postalCodeMax": 74279,
    "lat": 63.7071,
    "lng": 27.2152,
    "radiusKm": 3.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Tokrajärvi",
    "postalCode": 81350,
    "postalCodeMin": 81350,
    "postalCodeMax": 81359,
    "lat": 62.7594,
    "lng": 30.6197,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Tyrjänsaari",
    "postalCode": 81420,
    "postalCodeMin": 81420,
    "postalCodeMax": 81429,
    "lat": 62.905,
    "lng": 30.7134,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Kivilahti",
    "postalCode": 81430,
    "postalCodeMin": 81430,
    "postalCodeMax": 81439,
    "lat": 62.9692,
    "lng": 30.495,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Huhus",
    "postalCode": 81450,
    "postalCodeMin": 81450,
    "postalCodeMax": 81459,
    "lat": 62.8432,
    "lng": 30.7636,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Käenkoski",
    "postalCode": 81460,
    "postalCodeMin": 81460,
    "postalCodeMax": 81469,
    "lat": 62.9139,
    "lng": 30.9489,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Naarva",
    "postalCode": 81470,
    "postalCodeMin": 81470,
    "postalCodeMax": 81479,
    "lat": 63.0343,
    "lng": 31.0661,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Marjovaara",
    "postalCode": 82815,
    "postalCodeMin": 82810,
    "postalCodeMax": 82819,
    "lat": 62.602,
    "lng": 30.7414,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Maukkula",
    "postalCode": 82820,
    "postalCodeMin": 82820,
    "postalCodeMax": 82829,
    "lat": 62.6147,
    "lng": 30.8595,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Haukivaara",
    "postalCode": 82830,
    "postalCodeMin": 82830,
    "postalCodeMax": 82839,
    "lat": 62.5571,
    "lng": 30.9377,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Ilomantsi",
    "postalCode": 82900,
    "postalCodeMin": 82900,
    "postalCodeMax": 82909,
    "lat": 62.6679,
    "lng": 30.9395,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Sonkaja",
    "postalCode": 82915,
    "postalCodeMin": 82910,
    "postalCodeMax": 82919,
    "lat": 62.7072,
    "lng": 30.7616,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Lehtovaara",
    "postalCode": 82960,
    "postalCodeMin": 82960,
    "postalCodeMax": 82969,
    "lat": 62.798,
    "lng": 31.1267,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Hattu",
    "postalCode": 82967,
    "postalCodeMin": 82960,
    "postalCodeMax": 82969,
    "lat": 62.9634,
    "lng": 31.3487,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Ilomantsi",
    "area": "Möhkö",
    "postalCode": 82980,
    "postalCodeMin": 82980,
    "postalCodeMax": 82989,
    "lat": 62.6376,
    "lng": 31.2815,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80100,
    "postalCodeMin": 80100,
    "postalCodeMax": 80109,
    "lat": 62.6281,
    "lng": 29.7783,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80110,
    "postalCodeMin": 80110,
    "postalCodeMax": 80119,
    "lat": 62.5951,
    "lng": 29.7114,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80130,
    "postalCodeMin": 80130,
    "postalCodeMax": 80139,
    "lat": 62.6378,
    "lng": 29.7367,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80140,
    "postalCodeMin": 80140,
    "postalCodeMax": 80149,
    "lat": 62.6133,
    "lng": 29.6748,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80160,
    "postalCodeMin": 80160,
    "postalCodeMax": 80169,
    "lat": 62.6184,
    "lng": 29.8199,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80170,
    "postalCodeMin": 80170,
    "postalCodeMax": 80179,
    "lat": 62.6221,
    "lng": 29.8735,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80200,
    "postalCodeMin": 80200,
    "postalCodeMax": 80209,
    "lat": 62.5946,
    "lng": 29.7899,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80210,
    "postalCodeMin": 80210,
    "postalCodeMax": 80219,
    "lat": 62.5913,
    "lng": 29.7777,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80220,
    "postalCodeMin": 80220,
    "postalCodeMax": 80229,
    "lat": 62.5695,
    "lng": 29.7514,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80230,
    "postalCodeMin": 80230,
    "postalCodeMax": 80239,
    "lat": 62.5647,
    "lng": 29.8274,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Joensuu",
    "postalCode": 80260,
    "postalCodeMin": 80260,
    "postalCodeMax": 80269,
    "lat": 62.594,
    "lng": 29.8685,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Reijola",
    "postalCode": 80330,
    "postalCodeMin": 80330,
    "postalCodeMax": 80339,
    "lat": 62.5431,
    "lng": 29.8407,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Eno",
    "postalCode": 81200,
    "postalCodeMin": 81200,
    "postalCodeMax": 81209,
    "lat": 62.7934,
    "lng": 30.1586,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Louhioja",
    "postalCode": 81210,
    "postalCodeMin": 81210,
    "postalCodeMax": 81219,
    "lat": 62.8009,
    "lng": 30.1153,
    "radiusKm": 6.9
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Ahveninen",
    "postalCode": 81260,
    "postalCodeMin": 81260,
    "postalCodeMax": 81269,
    "lat": 62.9355,
    "lng": 30.113,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Paukkaja",
    "postalCode": 81270,
    "postalCodeMin": 81270,
    "postalCodeMax": 81279,
    "lat": 62.866,
    "lng": 30.1982,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Uimaharju",
    "postalCode": 81280,
    "postalCodeMin": 81280,
    "postalCodeMax": 81289,
    "lat": 62.914,
    "lng": 30.2516,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Ukkola",
    "postalCode": 81290,
    "postalCodeMin": 81290,
    "postalCodeMax": 81299,
    "lat": 62.9579,
    "lng": 30.1972,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Haapalahti",
    "postalCode": 81295,
    "postalCodeMin": 81290,
    "postalCodeMax": 81299,
    "lat": 62.9823,
    "lng": 30.1223,
    "radiusKm": 8.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Kuismavaara",
    "postalCode": 81320,
    "postalCodeMin": 81320,
    "postalCodeMax": 81329,
    "lat": 62.7221,
    "lng": 30.4544,
    "radiusKm": 11.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Luhtapohja",
    "postalCode": 81330,
    "postalCodeMin": 81330,
    "postalCodeMax": 81339,
    "lat": 62.7602,
    "lng": 30.5289,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Sarvinki",
    "postalCode": 81360,
    "postalCodeMin": 81360,
    "postalCodeMax": 81369,
    "lat": 62.6949,
    "lng": 30.2665,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Revonkylä",
    "postalCode": 81390,
    "postalCodeMin": 81390,
    "postalCodeMax": 81399,
    "lat": 62.6376,
    "lng": 30.5177,
    "radiusKm": 8.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Heinävaara",
    "postalCode": 82110,
    "postalCodeMin": 82110,
    "postalCodeMax": 82119,
    "lat": 62.5613,
    "lng": 30.1691,
    "radiusKm": 11.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Keskijärvi",
    "postalCode": 82120,
    "postalCodeMin": 82120,
    "postalCodeMax": 82129,
    "lat": 62.5692,
    "lng": 30.2829,
    "radiusKm": 10.6
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Kiihtelysvaara",
    "postalCode": 82140,
    "postalCodeMin": 82140,
    "postalCodeMax": 82149,
    "lat": 62.4931,
    "lng": 30.2512,
    "radiusKm": 11.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Oskola",
    "postalCode": 82160,
    "postalCodeMin": 82160,
    "postalCodeMax": 82169,
    "lat": 62.4463,
    "lng": 30.4977,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Uskali",
    "postalCode": 82170,
    "postalCodeMin": 82170,
    "postalCodeMax": 82179,
    "lat": 62.3706,
    "lng": 30.4816,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Huhtilampi",
    "postalCode": 82180,
    "postalCodeMin": 82180,
    "postalCodeMax": 82189,
    "lat": 62.4272,
    "lng": 30.3945,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Hammaslahti",
    "postalCode": 82200,
    "postalCodeMin": 82200,
    "postalCodeMax": 82209,
    "lat": 62.4327,
    "lng": 29.9696,
    "radiusKm": 8.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Suhmura",
    "postalCode": 82210,
    "postalCodeMin": 82210,
    "postalCodeMax": 82219,
    "lat": 62.479,
    "lng": 29.8843,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Niittylahti",
    "postalCode": 82220,
    "postalCodeMin": 82220,
    "postalCodeMax": 82229,
    "lat": 62.5089,
    "lng": 29.8132,
    "radiusKm": 8.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Kovero",
    "postalCode": 82710,
    "postalCodeMin": 82710,
    "postalCodeMax": 82719,
    "lat": 62.5443,
    "lng": 30.5402,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Tuupovaara",
    "postalCode": 82730,
    "postalCodeMin": 82730,
    "postalCodeMax": 82739,
    "lat": 62.4858,
    "lng": 30.6174,
    "radiusKm": 11.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Öllölä",
    "postalCode": 82750,
    "postalCodeMin": 82750,
    "postalCodeMax": 82759,
    "lat": 62.3763,
    "lng": 30.7595,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Hoilola",
    "postalCode": 82760,
    "postalCodeMin": 82760,
    "postalCodeMax": 82769,
    "lat": 62.3437,
    "lng": 30.8451,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Pirttiaho",
    "postalCode": 82840,
    "postalCodeMin": 82840,
    "postalCodeMax": 82849,
    "lat": 62.4949,
    "lng": 30.8531,
    "radiusKm": 5.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Kinnasniemi",
    "postalCode": 82850,
    "postalCodeMin": 82850,
    "postalCodeMax": 82859,
    "lat": 62.5019,
    "lng": 30.7587,
    "radiusKm": 9.5
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Kokinvaara",
    "postalCode": 82865,
    "postalCodeMin": 82860,
    "postalCodeMax": 82869,
    "lat": 62.4493,
    "lng": 30.8198,
    "radiusKm": 11.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Luutalahti",
    "postalCode": 82870,
    "postalCodeMin": 82870,
    "postalCodeMax": 82879,
    "lat": 62.3956,
    "lng": 30.8471,
    "radiusKm": 8.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Joensuu",
    "area": "Mannervaara",
    "postalCode": 82880,
    "postalCodeMin": 82880,
    "postalCodeMax": 82889,
    "lat": 62.3659,
    "lng": 30.929,
    "radiusKm": 11.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Juuka",
    "area": "Polvela",
    "postalCode": 83870,
    "postalCodeMin": 83870,
    "postalCodeMax": 83879,
    "lat": 63.1646,
    "lng": 29.1826,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Juuka",
    "area": "Kajoo",
    "postalCode": 83880,
    "postalCodeMin": 83880,
    "postalCodeMax": 83889,
    "lat": 63.0905,
    "lng": 29.0165,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Juuka",
    "area": "Juuka",
    "postalCode": 83900,
    "postalCodeMin": 83900,
    "postalCodeMax": 83909,
    "lat": 63.2433,
    "lng": 29.2546,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Juuka",
    "area": "Paalasmaa",
    "postalCode": 83910,
    "postalCodeMin": 83910,
    "postalCodeMax": 83919,
    "lat": 63.3027,
    "lng": 29.4438,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Juuka",
    "area": "Vihtasuo",
    "postalCode": 83915,
    "postalCodeMin": 83910,
    "postalCodeMax": 83919,
    "lat": 63.3134,
    "lng": 29.2308,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Juuka",
    "area": "Nunnanlahti",
    "postalCode": 83940,
    "postalCodeMin": 83940,
    "postalCodeMax": 83949,
    "lat": 63.1774,
    "lng": 29.4347,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Juuka",
    "area": "Ahmovaara",
    "postalCode": 83950,
    "postalCodeMin": 83950,
    "postalCodeMax": 83959,
    "lat": 63.0965,
    "lng": 29.6197,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Juuka",
    "area": "Tuopanjoki",
    "postalCode": 83985,
    "postalCodeMin": 83980,
    "postalCodeMax": 83989,
    "lat": 63.0351,
    "lng": 29.5736,
    "radiusKm": 7.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Villala",
    "postalCode": 58350,
    "postalCodeMin": 58350,
    "postalCodeMax": 58359,
    "lat": 62.0505,
    "lng": 29.5812,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Kesälahti",
    "postalCode": 59800,
    "postalCodeMin": 59800,
    "postalCodeMax": 59809,
    "lat": 61.8918,
    "lng": 29.8273,
    "radiusKm": 5.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Suurikylä",
    "postalCode": 59810,
    "postalCodeMin": 59810,
    "postalCodeMax": 59819,
    "lat": 61.8569,
    "lng": 29.7333,
    "radiusKm": 5.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Purujärvi",
    "postalCode": 59820,
    "postalCodeMin": 59820,
    "postalCodeMax": 59829,
    "lat": 61.8241,
    "lng": 29.7289,
    "radiusKm": 6.8
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Tolosenmäki",
    "postalCode": 82380,
    "postalCodeMin": 82380,
    "postalCodeMax": 82389,
    "lat": 62.1408,
    "lng": 30.0419,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Haarajärvi",
    "postalCode": 82395,
    "postalCodeMin": 82390,
    "postalCodeMax": 82399,
    "lat": 62.1759,
    "lng": 30.1854,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Puhos",
    "postalCode": 82430,
    "postalCodeMin": 82430,
    "postalCodeMax": 82439,
    "lat": 62.0856,
    "lng": 29.9045,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Hummovaara",
    "postalCode": 82460,
    "postalCodeMin": 82460,
    "postalCodeMax": 82469,
    "lat": 62.0781,
    "lng": 29.652,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Heinoniemi",
    "postalCode": 82490,
    "postalCodeMin": 82490,
    "postalCodeMax": 82499,
    "lat": 62.1658,
    "lng": 29.5526,
    "radiusKm": 7.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Kitee",
    "postalCode": 82500,
    "postalCodeMin": 82500,
    "postalCodeMax": 82509,
    "lat": 62.0929,
    "lng": 30.1543,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Kiteenlahti",
    "postalCode": 82510,
    "postalCodeMin": 82510,
    "postalCodeMax": 82519,
    "lat": 62.0665,
    "lng": 30.2585,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Juurikka",
    "postalCode": 82580,
    "postalCodeMin": 82580,
    "postalCodeMax": 82589,
    "lat": 61.9936,
    "lng": 30.0872,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kitee",
    "area": "Närsäkkälä",
    "postalCode": 82590,
    "postalCodeMin": 82590,
    "postalCodeMax": 82599,
    "lat": 61.9121,
    "lng": 30.1434,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Onttola",
    "postalCode": 80510,
    "postalCodeMin": 80510,
    "postalCodeMax": 80519,
    "lat": 62.6472,
    "lng": 29.6755,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Lehmo",
    "postalCode": 80710,
    "postalCodeMin": 80710,
    "postalCodeMax": 80719,
    "lat": 62.6591,
    "lng": 29.8135,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Kontiolahti as",
    "postalCode": 80770,
    "postalCodeMin": 80770,
    "postalCodeMax": 80779,
    "lat": 62.7323,
    "lng": 29.857,
    "radiusKm": 8.6
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Kontioniemi",
    "postalCode": 80780,
    "postalCodeMin": 80780,
    "postalCodeMax": 80789,
    "lat": 62.7441,
    "lng": 29.8061,
    "radiusKm": 10.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Kontioranta",
    "postalCode": 80790,
    "postalCodeMin": 80790,
    "postalCodeMax": 80799,
    "lat": 62.7357,
    "lng": 29.8126,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Paihola",
    "postalCode": 80850,
    "postalCodeMin": 80850,
    "postalCodeMax": 80859,
    "lat": 62.6858,
    "lng": 29.9313,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Kulho",
    "postalCode": 80910,
    "postalCodeMin": 80910,
    "postalCodeMax": 80919,
    "lat": 62.6204,
    "lng": 29.9207,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Kontiolahti",
    "postalCode": 81100,
    "postalCodeMin": 81100,
    "postalCodeMax": 81109,
    "lat": 62.7643,
    "lng": 29.8474,
    "radiusKm": 8.6
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Katajaranta",
    "postalCode": 81120,
    "postalCodeMin": 81120,
    "postalCodeMax": 81129,
    "lat": 62.8667,
    "lng": 29.8167,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Romppala",
    "postalCode": 81160,
    "postalCodeMin": 81160,
    "postalCodeMax": 81169,
    "lat": 62.9574,
    "lng": 29.7806,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Jakokoski",
    "postalCode": 81220,
    "postalCodeMin": 81220,
    "postalCodeMax": 81229,
    "lat": 62.7393,
    "lng": 29.9786,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Mönni",
    "postalCode": 81230,
    "postalCodeMin": 81230,
    "postalCodeMax": 81239,
    "lat": 62.6963,
    "lng": 30.1056,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Kontiolahti",
    "area": "Lehtoi",
    "postalCode": 81235,
    "postalCodeMin": 81230,
    "postalCodeMax": 81239,
    "lat": 62.6355,
    "lng": 30.1289,
    "radiusKm": 5.7
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Vuonisjärvi",
    "postalCode": 81560,
    "postalCodeMin": 81560,
    "postalCodeMax": 81569,
    "lat": 63.1503,
    "lng": 30.0988,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Kelvä",
    "postalCode": 81570,
    "postalCodeMin": 81570,
    "postalCodeMax": 81579,
    "lat": 63.0719,
    "lng": 30.0879,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Vuonislahti",
    "postalCode": 81590,
    "postalCodeMin": 81590,
    "postalCodeMax": 81599,
    "lat": 63.1508,
    "lng": 29.9889,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Hattuvaara",
    "postalCode": 81650,
    "postalCodeMin": 81650,
    "postalCodeMax": 81659,
    "lat": 63.2838,
    "lng": 30.5312,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Lehmikylä",
    "postalCode": 81660,
    "postalCodeMin": 81660,
    "postalCodeMax": 81669,
    "lat": 63.3083,
    "lng": 30.6296,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Lieksa",
    "postalCode": 81700,
    "postalCodeMin": 81700,
    "postalCodeMax": 81709,
    "lat": 63.3185,
    "lng": 30.0265,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Lieksa",
    "postalCode": 81720,
    "postalCodeMin": 81720,
    "postalCodeMax": 81729,
    "lat": 63.2471,
    "lng": 29.9427,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Pankakoski",
    "postalCode": 81750,
    "postalCodeMin": 81750,
    "postalCodeMax": 81759,
    "lat": 63.321,
    "lng": 30.1462,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Jamali",
    "postalCode": 81810,
    "postalCodeMin": 81810,
    "postalCodeMax": 81819,
    "lat": 63.3489,
    "lng": 29.8938,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Kylänlahti",
    "postalCode": 81820,
    "postalCodeMin": 81820,
    "postalCodeMax": 81829,
    "lat": 63.3638,
    "lng": 29.7514,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Mätäsvaara",
    "postalCode": 81850,
    "postalCodeMin": 81850,
    "postalCodeMax": 81859,
    "lat": 63.444,
    "lng": 29.5811,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Viekijärvi",
    "postalCode": 81860,
    "postalCodeMin": 81860,
    "postalCodeMax": 81869,
    "lat": 63.4805,
    "lng": 29.6279,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Pankajärvi",
    "postalCode": 81950,
    "postalCodeMin": 81950,
    "postalCodeMax": 81959,
    "lat": 63.4241,
    "lng": 30.1026,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Jongunjoki",
    "postalCode": 81970,
    "postalCodeMin": 81970,
    "postalCodeMax": 81979,
    "lat": 63.5167,
    "lng": 29.9667,
    "radiusKm": 7.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Lieksa",
    "area": "Koli",
    "postalCode": 83960,
    "postalCodeMin": 83960,
    "postalCodeMax": 83969,
    "lat": 63.1137,
    "lng": 29.7772,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Ylämylly",
    "postalCode": 80400,
    "postalCodeMin": 80400,
    "postalCodeMax": 80409,
    "lat": 62.6141,
    "lng": 29.5456,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Liperi",
    "postalCode": 83100,
    "postalCodeMin": 83100,
    "postalCodeMax": 83109,
    "lat": 62.5291,
    "lng": 29.3854,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Salokylä",
    "postalCode": 83130,
    "postalCodeMin": 83130,
    "postalCodeMax": 83139,
    "lat": 62.5812,
    "lng": 29.4874,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Puromäki",
    "postalCode": 83140,
    "postalCodeMin": 83140,
    "postalCodeMax": 83149,
    "lat": 62.5461,
    "lng": 29.5387,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Roukalahti",
    "postalCode": 83150,
    "postalCodeMin": 83150,
    "postalCodeMax": 83159,
    "lat": 62.4879,
    "lng": 29.5319,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Tutjunniemi",
    "postalCode": 83160,
    "postalCodeMin": 83160,
    "postalCodeMax": 83169,
    "lat": 62.4163,
    "lng": 29.5927,
    "radiusKm": 7.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Risti",
    "postalCode": 83320,
    "postalCodeMin": 83320,
    "postalCodeMax": 83329,
    "lat": 62.5747,
    "lng": 29.1963,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Kaatamo",
    "postalCode": 83330,
    "postalCodeMin": 83330,
    "postalCodeMax": 83339,
    "lat": 62.5551,
    "lng": 29.1574,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Kaarnalampi",
    "postalCode": 83340,
    "postalCodeMin": 83340,
    "postalCodeMax": 83349,
    "lat": 62.6129,
    "lng": 29.1561,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Viinijärvi",
    "postalCode": 83400,
    "postalCodeMin": 83400,
    "postalCodeMax": 83409,
    "lat": 62.6453,
    "lng": 29.2313,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Käsämä",
    "postalCode": 83430,
    "postalCodeMin": 83430,
    "postalCodeMax": 83439,
    "lat": 62.6382,
    "lng": 29.3549,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Vaivio",
    "postalCode": 83450,
    "postalCodeMin": 83450,
    "postalCodeMax": 83459,
    "lat": 62.672,
    "lng": 29.4902,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Harinjärvi",
    "postalCode": 83460,
    "postalCodeMin": 83460,
    "postalCodeMax": 83469,
    "lat": 62.6989,
    "lng": 29.5405,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Liperi (kunta)",
    "area": "Ahonkylä",
    "postalCode": 83480,
    "postalCodeMin": 83480,
    "postalCodeMax": 83489,
    "lat": 62.6675,
    "lng": 29.1358,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Nurmes",
    "postalCode": 75500,
    "postalCodeMin": 75500,
    "postalCodeMax": 75509,
    "lat": 63.5419,
    "lng": 29.1396,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Porokylä",
    "postalCode": 75530,
    "postalCodeMin": 75530,
    "postalCodeMax": 75539,
    "lat": 63.5557,
    "lng": 29.1098,
    "radiusKm": 5.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Savikylä",
    "postalCode": 75650,
    "postalCodeMin": 75650,
    "postalCodeMax": 75659,
    "lat": 63.5298,
    "lng": 28.8977,
    "radiusKm": 5.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Ylä-Luosta",
    "postalCode": 75680,
    "postalCodeMin": 75680,
    "postalCodeMax": 75689,
    "lat": 63.3773,
    "lng": 28.6773,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Valtimo",
    "postalCode": 75700,
    "postalCodeMin": 75700,
    "postalCodeMax": 75709,
    "lat": 63.6785,
    "lng": 28.8156,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Karhunpää",
    "postalCode": 75710,
    "postalCodeMin": 75710,
    "postalCodeMax": 75719,
    "lat": 63.6194,
    "lng": 28.8872,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Pajukoski",
    "postalCode": 75740,
    "postalCodeMin": 75740,
    "postalCodeMax": 75749,
    "lat": 63.6219,
    "lng": 28.7276,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Puukari",
    "postalCode": 75770,
    "postalCodeMin": 75770,
    "postalCodeMax": 75779,
    "lat": 63.7517,
    "lng": 28.6792,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Rumo",
    "postalCode": 75790,
    "postalCodeMin": 75790,
    "postalCodeMax": 75799,
    "lat": 63.8169,
    "lng": 28.5858,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Ylä-Valtimo",
    "postalCode": 75840,
    "postalCodeMin": 75840,
    "postalCodeMax": 75849,
    "lat": 63.7022,
    "lng": 28.8646,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Saramo",
    "postalCode": 75890,
    "postalCodeMin": 75890,
    "postalCodeMax": 75899,
    "lat": 63.7129,
    "lng": 29.2087,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Petäiskylä",
    "postalCode": 75930,
    "postalCodeMin": 75930,
    "postalCodeMax": 75939,
    "lat": 63.6825,
    "lng": 29.3081,
    "radiusKm": 5.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Mujejärvi",
    "postalCode": 75940,
    "postalCodeMin": 75940,
    "postalCodeMax": 75949,
    "lat": 63.8352,
    "lng": 29.4605,
    "radiusKm": 6.8
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Kohtavaara",
    "postalCode": 75970,
    "postalCodeMin": 75970,
    "postalCodeMax": 75979,
    "lat": 63.513,
    "lng": 29.2788,
    "radiusKm": 7.5
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Nurmes",
    "area": "Höljäkkä",
    "postalCode": 75990,
    "postalCodeMin": 75990,
    "postalCodeMax": 75999,
    "lat": 63.4565,
    "lng": 29.4384,
    "radiusKm": 3.4
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Outokumpu",
    "area": "Outokumpu",
    "postalCode": 83500,
    "postalCodeMin": 83500,
    "postalCodeMax": 83509,
    "lat": 62.7209,
    "lng": 29.0136,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Outokumpu",
    "area": "Kokonvaara",
    "postalCode": 83550,
    "postalCodeMin": 83550,
    "postalCodeMax": 83559,
    "lat": 62.7921,
    "lng": 29.179,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Outokumpu",
    "area": "Kuusjärvi",
    "postalCode": 83630,
    "postalCodeMin": 83630,
    "postalCodeMax": 83639,
    "lat": 62.702,
    "lng": 28.9266,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Outokumpu",
    "area": "Varislahti",
    "postalCode": 83660,
    "postalCodeMin": 83660,
    "postalCodeMax": 83669,
    "lat": 62.7473,
    "lng": 28.7757,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Polvijärvi",
    "postalCode": 83700,
    "postalCodeMin": 83700,
    "postalCodeMax": 83709,
    "lat": 62.8552,
    "lng": 29.3705,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Kuorevaara",
    "postalCode": 83720,
    "postalCodeMin": 83720,
    "postalCodeMax": 83729,
    "lat": 62.7954,
    "lng": 29.4562,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Sotkuma",
    "postalCode": 83750,
    "postalCodeMin": 83750,
    "postalCodeMax": 83759,
    "lat": 62.7388,
    "lng": 29.4399,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Sola",
    "postalCode": 83760,
    "postalCodeMin": 83760,
    "postalCodeMax": 83769,
    "lat": 62.7832,
    "lng": 29.3464,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Horsmanaho",
    "postalCode": 83780,
    "postalCodeMin": 83780,
    "postalCodeMax": 83789,
    "lat": 62.8268,
    "lng": 29.2601,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Kinahmo",
    "postalCode": 83825,
    "postalCodeMin": 83820,
    "postalCodeMax": 83829,
    "lat": 62.8638,
    "lng": 29.5305,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Hukkala",
    "postalCode": 83830,
    "postalCodeMin": 83830,
    "postalCodeMax": 83839,
    "lat": 62.8953,
    "lng": 29.1618,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Ruvaslahti",
    "postalCode": 83835,
    "postalCodeMin": 83830,
    "postalCodeMax": 83839,
    "lat": 62.9512,
    "lng": 29.5314,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Saarivaara",
    "postalCode": 83840,
    "postalCodeMin": 83840,
    "postalCodeMax": 83849,
    "lat": 62.8784,
    "lng": 29.0612,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Polvijärvi",
    "area": "Martonvaara",
    "postalCode": 83855,
    "postalCodeMin": 83850,
    "postalCodeMax": 83859,
    "lat": 63.0402,
    "lng": 29.4398,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Rääkkylä",
    "area": "Nieminen",
    "postalCode": 82290,
    "postalCodeMin": 82290,
    "postalCodeMax": 82299,
    "lat": 62.3524,
    "lng": 29.7588,
    "radiusKm": 7.3
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Rääkkylä",
    "area": "Rääkkylä",
    "postalCode": 82300,
    "postalCodeMin": 82300,
    "postalCodeMax": 82309,
    "lat": 62.3138,
    "lng": 29.6236,
    "radiusKm": 6.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Rääkkylä",
    "area": "Oravisalo",
    "postalCode": 82310,
    "postalCodeMin": 82310,
    "postalCodeMax": 82319,
    "lat": 62.3713,
    "lng": 29.5175,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Rääkkylä",
    "area": "Rasivaara",
    "postalCode": 82335,
    "postalCodeMin": 82330,
    "postalCodeMax": 82339,
    "lat": 62.27,
    "lng": 29.7517,
    "radiusKm": 9.0
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Tohmajärvi",
    "area": "Tikkala",
    "postalCode": 82350,
    "postalCodeMin": 82350,
    "postalCodeMax": 82359,
    "lat": 62.3563,
    "lng": 30.1055,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Tohmajärvi",
    "area": "Onkamo",
    "postalCode": 82360,
    "postalCodeMin": 82360,
    "postalCodeMax": 82369,
    "lat": 62.3104,
    "lng": 30.124,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Tohmajärvi",
    "area": "Tohmajärvi",
    "postalCode": 82600,
    "postalCodeMin": 82600,
    "postalCodeMax": 82609,
    "lat": 62.2252,
    "lng": 30.3354,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Tohmajärvi",
    "area": "Värtsilä",
    "postalCode": 82655,
    "postalCodeMin": 82650,
    "postalCodeMax": 82659,
    "lat": 62.2013,
    "lng": 30.6095,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Tohmajärvi",
    "area": "Uusi-Värtsilä",
    "postalCode": 82660,
    "postalCodeMin": 82660,
    "postalCodeMax": 82669,
    "lat": 62.1935,
    "lng": 30.4559,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Tohmajärvi",
    "area": "Kaurila",
    "postalCode": 82670,
    "postalCodeMin": 82670,
    "postalCodeMax": 82679,
    "lat": 62.1848,
    "lng": 30.5175,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Tohmajärvi",
    "area": "Niirala",
    "postalCode": 82675,
    "postalCodeMin": 82670,
    "postalCodeMax": 82679,
    "lat": 62.1753,
    "lng": 30.5935,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Tohmajärvi",
    "area": "Littilä",
    "postalCode": 82685,
    "postalCodeMin": 82680,
    "postalCodeMax": 82689,
    "lat": 62.1274,
    "lng": 30.4348,
    "radiusKm": 4.1
  },
  {
    "region": "Pohjois-Karjala",
    "city": "Tohmajärvi",
    "area": "Kaustajärvi",
    "postalCode": 82770,
    "postalCodeMin": 82770,
    "postalCodeMax": 82779,
    "lat": 62.244,
    "lng": 30.7491,
    "radiusKm": 8.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Alavieska",
    "area": "Alavieska",
    "postalCode": 85200,
    "postalCodeMin": 85200,
    "postalCodeMax": 85209,
    "lat": 64.1654,
    "lng": 24.3078,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Alavieska",
    "area": "Kähtävä",
    "postalCode": 85210,
    "postalCodeMin": 85210,
    "postalCodeMax": 85219,
    "lat": 64.1337,
    "lng": 24.3068,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Alavieska",
    "area": "Talus",
    "postalCode": 85230,
    "postalCodeMin": 85230,
    "postalCodeMax": 85239,
    "lat": 64.2557,
    "lng": 24.2867,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapajärvi",
    "area": "Parkkila",
    "postalCode": 85710,
    "postalCodeMin": 85710,
    "postalCodeMax": 85719,
    "lat": 63.8441,
    "lng": 25.4127,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapajärvi",
    "area": "Tulppo",
    "postalCode": 85730,
    "postalCodeMin": 85730,
    "postalCodeMax": 85739,
    "lat": 63.8638,
    "lng": 25.597,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapajärvi",
    "area": "Haapajärvi",
    "postalCode": 85800,
    "postalCodeMin": 85800,
    "postalCodeMax": 85809,
    "lat": 63.7487,
    "lng": 25.3181,
    "radiusKm": 9.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapajärvi",
    "area": "Oksava",
    "postalCode": 85820,
    "postalCodeMin": 85820,
    "postalCodeMax": 85829,
    "lat": 63.8135,
    "lng": 25.245,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapajärvi",
    "area": "Kuona",
    "postalCode": 85840,
    "postalCodeMin": 85840,
    "postalCodeMax": 85849,
    "lat": 63.7368,
    "lng": 25.5668,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapavesi",
    "area": "Karhukangas",
    "postalCode": 86480,
    "postalCodeMin": 86480,
    "postalCodeMax": 86489,
    "lat": 64.3394,
    "lng": 25.431,
    "radiusKm": 9.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapavesi",
    "area": "Mieluskylä",
    "postalCode": 86550,
    "postalCodeMin": 86550,
    "postalCodeMax": 86559,
    "lat": 64.1743,
    "lng": 25.1588,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapavesi",
    "area": "Haapavesi",
    "postalCode": 86600,
    "postalCodeMin": 86600,
    "postalCodeMax": 86609,
    "lat": 64.1374,
    "lng": 25.3669,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapavesi",
    "area": "Kytökylä",
    "postalCode": 86650,
    "postalCodeMin": 86650,
    "postalCodeMax": 86659,
    "lat": 64.1203,
    "lng": 25.478,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapavesi",
    "area": "Vatjusjärvi",
    "postalCode": 86680,
    "postalCodeMin": 86680,
    "postalCodeMax": 86689,
    "lat": 64.0786,
    "lng": 25.3131,
    "radiusKm": 9.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Haapavesi",
    "area": "Karsikas",
    "postalCode": 86690,
    "postalCodeMin": 86690,
    "postalCodeMax": 86699,
    "lat": 63.9574,
    "lng": 25.3725,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Hailuoto",
    "area": "Hailuoto",
    "postalCode": 90480,
    "postalCodeMin": 90480,
    "postalCodeMax": 90489,
    "lat": 65.0095,
    "lng": 24.7151,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ii",
    "area": "Ii",
    "postalCode": 91100,
    "postalCodeMin": 91100,
    "postalCodeMax": 91109,
    "lat": 65.3125,
    "lng": 25.3829,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ii",
    "area": "Ii as",
    "postalCode": 91110,
    "postalCodeMin": 91110,
    "postalCodeMax": 91119,
    "lat": 65.3125,
    "lng": 25.3829,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ii",
    "area": "Olhava",
    "postalCode": 91140,
    "postalCodeMin": 91140,
    "postalCodeMax": 91149,
    "lat": 65.4652,
    "lng": 25.3724,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ii",
    "area": "Yli-Olhava",
    "postalCode": 91150,
    "postalCodeMin": 91150,
    "postalCodeMax": 91159,
    "lat": 65.5322,
    "lng": 25.5674,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ii",
    "area": "Jakkukylä",
    "postalCode": 91210,
    "postalCodeMin": 91210,
    "postalCodeMax": 91219,
    "lat": 65.3125,
    "lng": 25.3829,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ii",
    "area": "Kuivaniemi",
    "postalCode": 95100,
    "postalCodeMin": 95100,
    "postalCodeMax": 95109,
    "lat": 65.6043,
    "lng": 25.2074,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ii",
    "area": "Kuivaniemi kk",
    "postalCode": 95110,
    "postalCodeMin": 95110,
    "postalCodeMax": 95119,
    "lat": 65.5863,
    "lng": 25.1971,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ii",
    "area": "Hyryoja",
    "postalCode": 95130,
    "postalCodeMin": 95130,
    "postalCodeMax": 95139,
    "lat": 65.6222,
    "lng": 25.6104,
    "radiusKm": 7.3
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ii",
    "area": "Oijärvi",
    "postalCode": 95160,
    "postalCodeMin": 95160,
    "postalCodeMax": 95169,
    "lat": 65.6366,
    "lng": 25.9731,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kalajoki",
    "area": "Himanka",
    "postalCode": 68100,
    "postalCodeMin": 68100,
    "postalCodeMax": 68109,
    "lat": 64.0615,
    "lng": 23.6542,
    "radiusKm": 4.0
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kalajoki",
    "area": "Hillilä",
    "postalCode": 68150,
    "postalCodeMin": 68150,
    "postalCodeMax": 68159,
    "lat": 64.0256,
    "lng": 23.7275,
    "radiusKm": 4.0
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kalajoki",
    "area": "Kalajoki",
    "postalCode": 85100,
    "postalCodeMin": 85100,
    "postalCodeMax": 85109,
    "lat": 64.2579,
    "lng": 23.9476,
    "radiusKm": 8.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kalajoki",
    "area": "Metsä",
    "postalCode": 85120,
    "postalCodeMin": 85120,
    "postalCodeMax": 85129,
    "lat": 64.2924,
    "lng": 24.2218,
    "radiusKm": 12.0
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kalajoki",
    "area": "Tynkä",
    "postalCode": 85140,
    "postalCodeMin": 85140,
    "postalCodeMax": 85149,
    "lat": 64.2036,
    "lng": 24.0351,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kalajoki",
    "area": "Typpö",
    "postalCode": 85150,
    "postalCodeMin": 85150,
    "postalCodeMax": 85159,
    "lat": 64.1242,
    "lng": 24.1512,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kalajoki",
    "area": "Rautio",
    "postalCode": 85160,
    "postalCodeMin": 85160,
    "postalCodeMax": 85169,
    "lat": 64.0744,
    "lng": 24.206,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kalajoki",
    "area": "Rahja",
    "postalCode": 85180,
    "postalCodeMin": 85180,
    "postalCodeMax": 85189,
    "lat": 64.1973,
    "lng": 23.7378,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kempele",
    "area": "Kempele",
    "postalCode": 90440,
    "postalCodeMin": 90440,
    "postalCodeMax": 90449,
    "lat": 64.9129,
    "lng": 25.5035,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kempele",
    "area": "Kempele",
    "postalCode": 90450,
    "postalCodeMin": 90450,
    "postalCodeMax": 90459,
    "lat": 64.8921,
    "lng": 25.5834,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kuusamo",
    "area": "Kuusamo",
    "postalCode": 93600,
    "postalCodeMin": 93600,
    "postalCodeMax": 93609,
    "lat": 65.9666,
    "lng": 29.1807,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kuusamo",
    "area": "Kuusamo",
    "postalCode": 93700,
    "postalCodeMin": 93700,
    "postalCodeMax": 93709,
    "lat": 65.764,
    "lng": 29.5826,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kuusamo",
    "area": "Kuusamo",
    "postalCode": 93800,
    "postalCodeMin": 93800,
    "postalCodeMax": 93809,
    "lat": 66.0618,
    "lng": 29.4171,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kuusamo",
    "area": "Rukatunturi",
    "postalCode": 93830,
    "postalCodeMin": 93830,
    "postalCodeMax": 93839,
    "lat": 66.1659,
    "lng": 29.1265,
    "radiusKm": 2.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kuusamo",
    "area": "Kuusamo",
    "postalCode": 93900,
    "postalCodeMin": 93900,
    "postalCodeMax": 93909,
    "lat": 66.3393,
    "lng": 29.0917,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kärsämäki",
    "area": "Kärsämäki",
    "postalCode": 86710,
    "postalCodeMin": 86710,
    "postalCodeMax": 86719,
    "lat": 63.9786,
    "lng": 25.7587,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Kärsämäki",
    "area": "Venetpalo",
    "postalCode": 86790,
    "postalCodeMin": 86790,
    "postalCodeMax": 86799,
    "lat": 63.8723,
    "lng": 25.8031,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Liminka",
    "area": "Liminka",
    "postalCode": 91900,
    "postalCodeMin": 91900,
    "postalCodeMax": 91909,
    "lat": 64.8098,
    "lng": 25.4153,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Liminka",
    "area": "Tupos",
    "postalCode": 91910,
    "postalCodeMin": 91910,
    "postalCodeMax": 91919,
    "lat": 64.8642,
    "lng": 25.4906,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Liminka",
    "area": "Ala-Temmes",
    "postalCode": 91930,
    "postalCodeMin": 91930,
    "postalCodeMax": 91939,
    "lat": 64.7729,
    "lng": 25.5467,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Lumijoki",
    "area": "Lumijoki",
    "postalCode": 91980,
    "postalCodeMin": 91980,
    "postalCodeMax": 91989,
    "lat": 64.8373,
    "lng": 25.1865,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Merijärvi",
    "area": "Merijärvi",
    "postalCode": 86220,
    "postalCodeMin": 86220,
    "postalCodeMax": 86229,
    "lat": 64.2972,
    "lng": 24.4465,
    "radiusKm": 9.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Merijärvi",
    "area": "Ylipää",
    "postalCode": 86230,
    "postalCodeMin": 86230,
    "postalCodeMax": 86239,
    "lat": 64.3321,
    "lng": 24.5606,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Merijärvi",
    "area": "Pyhänkoski",
    "postalCode": 86240,
    "postalCodeMin": 86240,
    "postalCodeMax": 86249,
    "lat": 64.3513,
    "lng": 24.4219,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Muhos",
    "area": "Jokirinne",
    "postalCode": 91410,
    "postalCodeMin": 91410,
    "postalCodeMax": 91419,
    "lat": 64.882,
    "lng": 25.8693,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Muhos",
    "area": "Leppiniemi",
    "postalCode": 91430,
    "postalCodeMin": 91430,
    "postalCodeMax": 91439,
    "lat": 64.8438,
    "lng": 26.0424,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Muhos",
    "area": "Muhos",
    "postalCode": 91500,
    "postalCodeMin": 91500,
    "postalCodeMax": 91509,
    "lat": 64.8075,
    "lng": 25.9943,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Muhos",
    "area": "Rova",
    "postalCode": 91510,
    "postalCodeMin": 91510,
    "postalCodeMax": 91519,
    "lat": 64.8677,
    "lng": 25.8591,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Muhos",
    "area": "Kylmälänkylä",
    "postalCode": 91560,
    "postalCodeMin": 91560,
    "postalCodeMax": 91569,
    "lat": 64.5693,
    "lng": 26.2949,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Nivala",
    "area": "Nivala",
    "postalCode": 85500,
    "postalCodeMin": 85500,
    "postalCodeMax": 85509,
    "lat": 63.9284,
    "lng": 24.9642,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Nivala",
    "area": "Mönkö",
    "postalCode": 85540,
    "postalCodeMin": 85540,
    "postalCodeMax": 85549,
    "lat": 63.9603,
    "lng": 24.7786,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Nivala",
    "area": "Ainastalo",
    "postalCode": 85560,
    "postalCodeMin": 85560,
    "postalCodeMax": 85569,
    "lat": 63.8502,
    "lng": 24.9907,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Nivala",
    "area": "Karvoskylä",
    "postalCode": 85580,
    "postalCodeMin": 85580,
    "postalCodeMax": 85589,
    "lat": 63.8508,
    "lng": 25.1493,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Nivala",
    "area": "Sarja",
    "postalCode": 85620,
    "postalCodeMin": 85620,
    "postalCodeMax": 85629,
    "lat": 64.0121,
    "lng": 25.0751,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Nivala",
    "area": "Sarjanahde",
    "postalCode": 85630,
    "postalCodeMin": 85630,
    "postalCodeMax": 85639,
    "lat": 63.9327,
    "lng": 25.0409,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Nivala",
    "area": "Maliskylä",
    "postalCode": 85640,
    "postalCodeMin": 85640,
    "postalCodeMax": 85649,
    "lat": 63.9516,
    "lng": 25.1586,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Nivala",
    "area": "Ruuskankylä",
    "postalCode": 85660,
    "postalCodeMin": 85660,
    "postalCodeMax": 85669,
    "lat": 63.9541,
    "lng": 25.2606,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulainen",
    "area": "Petäjäskoski",
    "postalCode": 86210,
    "postalCodeMin": 86210,
    "postalCodeMax": 86219,
    "lat": 64.2589,
    "lng": 24.5929,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulainen",
    "area": "Oulainen",
    "postalCode": 86300,
    "postalCodeMin": 86300,
    "postalCodeMax": 86309,
    "lat": 64.2676,
    "lng": 24.8159,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulainen",
    "area": "Kilpua",
    "postalCode": 86350,
    "postalCodeMin": 86350,
    "postalCodeMax": 86359,
    "lat": 64.3479,
    "lng": 24.9646,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulainen",
    "area": "Matkaniva",
    "postalCode": 86510,
    "postalCodeMin": 86510,
    "postalCodeMax": 86519,
    "lat": 64.2412,
    "lng": 25.0029,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulainen",
    "area": "Annonen",
    "postalCode": 86530,
    "postalCodeMin": 86530,
    "postalCodeMax": 86539,
    "lat": 64.2151,
    "lng": 25.0627,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Keskusta",
    "postalCode": 90100,
    "postalCodeMin": 90100,
    "postalCodeMax": 90109,
    "lat": 65.0123,
    "lng": 25.475,
    "radiusKm": 5.0
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Heinäpää",
    "postalCode": 90120,
    "postalCodeMin": 90120,
    "postalCodeMax": 90129,
    "lat": 65.0048,
    "lng": 25.4598,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Intiö, Myllytulli, Raksila",
    "postalCode": 90130,
    "postalCodeMin": 90130,
    "postalCodeMax": 90139,
    "lat": 65.0109,
    "lng": 25.4917,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Karjasilta",
    "postalCode": 90140,
    "postalCodeMin": 90140,
    "postalCodeMax": 90149,
    "lat": 64.9988,
    "lng": 25.4908,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Höyhtyä, Lintula, Mäntylä, Nokela",
    "postalCode": 90150,
    "postalCodeMin": 90150,
    "postalCodeMax": 90159,
    "lat": 64.9884,
    "lng": 25.5004,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kontinkangas",
    "postalCode": 90220,
    "postalCodeMin": 90220,
    "postalCodeMax": 90229,
    "lat": 65.004,
    "lng": 25.5229,
    "radiusKm": 20.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Oulunsuu, Värttö",
    "postalCode": 90230,
    "postalCodeMin": 90230,
    "postalCodeMax": 90239,
    "lat": 65.0088,
    "lng": 25.5279,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Maikkula",
    "postalCode": 90240,
    "postalCodeMin": 90240,
    "postalCodeMax": 90249,
    "lat": 64.9817,
    "lng": 25.5711,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kaukovainio, Hiironen",
    "postalCode": 90250,
    "postalCodeMin": 90250,
    "postalCodeMax": 90259,
    "lat": 64.9847,
    "lng": 25.5173,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Madekoski",
    "postalCode": 90310,
    "postalCodeMin": 90310,
    "postalCodeMax": 90319,
    "lat": 64.9547,
    "lng": 25.6655,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Nuottasaari",
    "postalCode": 90400,
    "postalCodeMin": 90400,
    "postalCodeMax": 90409,
    "lat": 65.0032,
    "lng": 25.4399,
    "radiusKm": 20.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kiviniemi",
    "postalCode": 90410,
    "postalCodeMin": 90410,
    "postalCodeMax": 90419,
    "lat": 64.9741,
    "lng": 25.5027,
    "radiusKm": 18.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kaakkuri, Metsokangas",
    "postalCode": 90420,
    "postalCodeMin": 90420,
    "postalCodeMax": 90429,
    "lat": 64.9693,
    "lng": 25.5284,
    "radiusKm": 20.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Oulunsalo",
    "postalCode": 90460,
    "postalCodeMin": 90460,
    "postalCodeMax": 90469,
    "lat": 64.9347,
    "lng": 25.414,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Varjakka",
    "postalCode": 90470,
    "postalCodeMin": 90470,
    "postalCodeMax": 90479,
    "lat": 64.9847,
    "lng": 25.3331,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Tuira",
    "postalCode": 90500,
    "postalCodeMin": 90500,
    "postalCodeMax": 90509,
    "lat": 65.026,
    "lng": 25.4708,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Hietasaari",
    "postalCode": 90510,
    "postalCodeMin": 90510,
    "postalCodeMax": 90519,
    "lat": 65.0215,
    "lng": 25.4325,
    "radiusKm": 20.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Toppila, Taskila",
    "postalCode": 90520,
    "postalCodeMin": 90520,
    "postalCodeMax": 90529,
    "lat": 65.0527,
    "lng": 25.431,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Alppila, Välivainio",
    "postalCode": 90530,
    "postalCodeMin": 90530,
    "postalCodeMax": 90539,
    "lat": 65.0332,
    "lng": 25.4733,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kuivasjärvi, Ritaharju",
    "postalCode": 90540,
    "postalCodeMin": 90540,
    "postalCodeMax": 90549,
    "lat": 65.0673,
    "lng": 25.467,
    "radiusKm": 9.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Puolivälinkangas, Pyykösjärvi",
    "postalCode": 90550,
    "postalCodeMin": 90550,
    "postalCodeMax": 90559,
    "lat": 65.0416,
    "lng": 25.4855,
    "radiusKm": 20.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Koskela",
    "postalCode": 90560,
    "postalCodeMin": 90560,
    "postalCodeMax": 90569,
    "lat": 65.0477,
    "lng": 25.448,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kaijonharju, Linnanmaa",
    "postalCode": 90570,
    "postalCodeMin": 90570,
    "postalCodeMax": 90579,
    "lat": 65.0599,
    "lng": 25.4807,
    "radiusKm": 9.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Rajakylä",
    "postalCode": 90580,
    "postalCodeMin": 90580,
    "postalCodeMax": 90589,
    "lat": 65.0655,
    "lng": 25.4213,
    "radiusKm": 15.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Teknologiakylä",
    "postalCode": 90590,
    "postalCodeMin": 90590,
    "postalCodeMax": 90599,
    "lat": 65.0591,
    "lng": 25.4491,
    "radiusKm": 8.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Postikeskus",
    "postalCode": 90600,
    "postalCodeMin": 90600,
    "postalCodeMax": 90609,
    "lat": 65.0411,
    "lng": 25.5389,
    "radiusKm": 6.0
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Rusko",
    "postalCode": 90620,
    "postalCodeMin": 90620,
    "postalCodeMax": 90629,
    "lat": 65.0484,
    "lng": 25.5381,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Korvensuora",
    "postalCode": 90630,
    "postalCodeMin": 90630,
    "postalCodeMax": 90639,
    "lat": 65.0385,
    "lng": 25.5768,
    "radiusKm": 20.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Myllyoja",
    "postalCode": 90650,
    "postalCodeMin": 90650,
    "postalCodeMax": 90659,
    "lat": 65.0195,
    "lng": 25.5514,
    "radiusKm": 13.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Sanginsuu",
    "postalCode": 90660,
    "postalCodeMin": 90660,
    "postalCodeMax": 90669,
    "lat": 64.9621,
    "lng": 25.6789,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Hiukkavaara",
    "postalCode": 90670,
    "postalCodeMin": 90670,
    "postalCodeMax": 90679,
    "lat": 65.0155,
    "lng": 25.5757,
    "radiusKm": 22.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Pateniemi",
    "postalCode": 90800,
    "postalCodeMin": 90800,
    "postalCodeMax": 90809,
    "lat": 65.0793,
    "lng": 25.409,
    "radiusKm": 18.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kiviniemi",
    "postalCode": 90810,
    "postalCodeMin": 90810,
    "postalCodeMax": 90819,
    "lat": 65.1165,
    "lng": 25.333,
    "radiusKm": 18.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kello",
    "postalCode": 90820,
    "postalCodeMin": 90820,
    "postalCodeMax": 90829,
    "lat": 65.1286,
    "lng": 25.3567,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Haukipudas",
    "postalCode": 90830,
    "postalCodeMin": 90830,
    "postalCodeMax": 90839,
    "lat": 65.1763,
    "lng": 25.3532,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Haukipudas",
    "postalCode": 90840,
    "postalCodeMin": 90840,
    "postalCodeMax": 90849,
    "lat": 65.2012,
    "lng": 25.5341,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Martinniemi",
    "postalCode": 90850,
    "postalCodeMin": 90850,
    "postalCodeMax": 90859,
    "lat": 65.2107,
    "lng": 25.316,
    "radiusKm": 18.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Halosenniemi",
    "postalCode": 90860,
    "postalCodeMin": 90860,
    "postalCodeMax": 90869,
    "lat": 65.2456,
    "lng": 25.3316,
    "radiusKm": 18.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kiiminki",
    "postalCode": 90900,
    "postalCodeMin": 90900,
    "postalCodeMax": 90909,
    "lat": 65.1281,
    "lng": 25.7757,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Kontio",
    "postalCode": 90910,
    "postalCodeMin": 90910,
    "postalCodeMax": 90919,
    "lat": 65.1349,
    "lng": 25.6263,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Jääli",
    "postalCode": 90940,
    "postalCodeMin": 90940,
    "postalCodeMax": 90949,
    "lat": 65.0983,
    "lng": 25.7118,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Yli-Ii",
    "postalCode": 91200,
    "postalCodeMin": 91200,
    "postalCodeMax": 91209,
    "lat": 65.371,
    "lng": 25.8346,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Tannila",
    "postalCode": 91240,
    "postalCodeMin": 91240,
    "postalCodeMax": 91249,
    "lat": 65.4863,
    "lng": 25.9832,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Pahkakoski",
    "postalCode": 91260,
    "postalCodeMin": 91260,
    "postalCodeMax": 91269,
    "lat": 65.3608,
    "lng": 26.0433,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Ylikiiminki",
    "postalCode": 91300,
    "postalCodeMin": 91300,
    "postalCodeMax": 91309,
    "lat": 65.0286,
    "lng": 26.1467,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Oulu",
    "area": "Arkala",
    "postalCode": 91310,
    "postalCodeMin": 91310,
    "postalCodeMax": 91319,
    "lat": 65.1835,
    "lng": 26.1395,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Pudasjärvi",
    "postalCode": 93100,
    "postalCodeMin": 93100,
    "postalCodeMax": 93109,
    "lat": 65.3619,
    "lng": 26.9859,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Kipinä",
    "postalCode": 93140,
    "postalCodeMin": 93140,
    "postalCodeMax": 93149,
    "lat": 65.2797,
    "lng": 26.548,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Hetejärvi",
    "postalCode": 93160,
    "postalCodeMin": 93160,
    "postalCodeMax": 93169,
    "lat": 65.1839,
    "lng": 26.735,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Yli-Kollaja",
    "postalCode": 93170,
    "postalCodeMin": 93170,
    "postalCodeMax": 93179,
    "lat": 65.4211,
    "lng": 26.7642,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Ikosenniemi",
    "postalCode": 93180,
    "postalCodeMin": 93180,
    "postalCodeMax": 93189,
    "lat": 65.5265,
    "lng": 26.5687,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Ala-Siurua",
    "postalCode": 93187,
    "postalCodeMin": 93180,
    "postalCodeMax": 93189,
    "lat": 65.5081,
    "lng": 26.3306,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Yli-Siurua",
    "postalCode": 93190,
    "postalCodeMin": 93190,
    "postalCodeMax": 93199,
    "lat": 65.6,
    "lng": 26.6103,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Kokkokylä",
    "postalCode": 93195,
    "postalCodeMin": 93190,
    "postalCodeMax": 93199,
    "lat": 65.7003,
    "lng": 26.673,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Livo",
    "postalCode": 93220,
    "postalCodeMin": 93220,
    "postalCodeMax": 93229,
    "lat": 65.3619,
    "lng": 26.9859,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Pärjänsuo",
    "postalCode": 93225,
    "postalCodeMin": 93220,
    "postalCodeMax": 93229,
    "lat": 65.3619,
    "lng": 26.9859,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Rytinki",
    "postalCode": 93240,
    "postalCodeMin": 93240,
    "postalCodeMax": 93249,
    "lat": 65.692,
    "lng": 27.331,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Sarajärvi",
    "postalCode": 93250,
    "postalCodeMin": 93250,
    "postalCodeMax": 93259,
    "lat": 65.7975,
    "lng": 27.336,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Sotkajärvi",
    "postalCode": 93270,
    "postalCodeMin": 93270,
    "postalCodeMax": 93279,
    "lat": 65.3417,
    "lng": 27.2997,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Iinattijärvi",
    "postalCode": 93277,
    "postalCodeMin": 93270,
    "postalCodeMax": 93279,
    "lat": 65.4829,
    "lng": 27.5067,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Syöte",
    "postalCode": 93280,
    "postalCodeMin": 93280,
    "postalCodeMax": 93289,
    "lat": 65.3619,
    "lng": 26.9859,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Pintamo",
    "postalCode": 93290,
    "postalCodeMin": 93290,
    "postalCodeMax": 93299,
    "lat": 65.4521,
    "lng": 27.6559,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Jaurakkajärvi",
    "postalCode": 93350,
    "postalCodeMin": 93350,
    "postalCodeMax": 93359,
    "lat": 65.1744,
    "lng": 27.6496,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pudasjärvi",
    "area": "Puhoskylä",
    "postalCode": 93390,
    "postalCodeMin": 93390,
    "postalCodeMax": 93399,
    "lat": 65.277,
    "lng": 27.8522,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjoki",
    "area": "Pyhäjoki",
    "postalCode": 86100,
    "postalCodeMin": 86100,
    "postalCodeMax": 86109,
    "lat": 64.4651,
    "lng": 24.2625,
    "radiusKm": 8.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjoki",
    "area": "Parhalahti",
    "postalCode": 86110,
    "postalCodeMin": 86110,
    "postalCodeMax": 86119,
    "lat": 64.4946,
    "lng": 24.3214,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjoki",
    "area": "Pirttikoski",
    "postalCode": 86160,
    "postalCodeMin": 86160,
    "postalCodeMax": 86169,
    "lat": 64.4118,
    "lng": 24.3103,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjoki",
    "area": "Yppäri",
    "postalCode": 86170,
    "postalCodeMin": 86170,
    "postalCodeMax": 86179,
    "lat": 64.4062,
    "lng": 24.1004,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjärvi",
    "area": "Pyhäsalmi",
    "postalCode": 86800,
    "postalCodeMin": 86800,
    "postalCodeMax": 86809,
    "lat": 63.6812,
    "lng": 25.9815,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjärvi",
    "area": "Pyhäjärvi",
    "postalCode": 86810,
    "postalCodeMin": 86810,
    "postalCodeMax": 86819,
    "lat": 63.6412,
    "lng": 25.9788,
    "radiusKm": 9.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjärvi",
    "area": "Hiidenniemi",
    "postalCode": 86850,
    "postalCodeMin": 86850,
    "postalCodeMax": 86859,
    "lat": 63.5388,
    "lng": 25.8134,
    "radiusKm": 8.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjärvi",
    "area": "Vesikoski",
    "postalCode": 86870,
    "postalCodeMin": 86870,
    "postalCodeMax": 86879,
    "lat": 63.8151,
    "lng": 26.0509,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjärvi",
    "area": "Pyhäkumpu",
    "postalCode": 86900,
    "postalCodeMin": 86900,
    "postalCodeMax": 86909,
    "lat": 63.6796,
    "lng": 26.0596,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäjärvi",
    "area": "Väliaho",
    "postalCode": 86980,
    "postalCodeMin": 86980,
    "postalCodeMax": 86989,
    "lat": 63.4931,
    "lng": 26.1542,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäntä",
    "area": "Tavastkenkä",
    "postalCode": 92910,
    "postalCodeMin": 92910,
    "postalCodeMax": 92919,
    "lat": 64.1736,
    "lng": 26.4284,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäntä",
    "area": "Ahokylä",
    "postalCode": 92920,
    "postalCodeMin": 92920,
    "postalCodeMax": 92929,
    "lat": 63.9967,
    "lng": 26.5412,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Pyhäntä",
    "area": "Pyhäntä",
    "postalCode": 92930,
    "postalCodeMin": 92930,
    "postalCodeMax": 92939,
    "lat": 64.0971,
    "lng": 26.3305,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Ilveskorpi",
    "postalCode": 86360,
    "postalCodeMin": 86360,
    "postalCodeMax": 86369,
    "lat": 64.378,
    "lng": 25.0194,
    "radiusKm": 12.0
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Vihanti",
    "postalCode": 86400,
    "postalCodeMin": 86400,
    "postalCodeMax": 86409,
    "lat": 64.4861,
    "lng": 24.9918,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Lampinsaari",
    "postalCode": 86440,
    "postalCodeMin": 86440,
    "postalCodeMax": 86449,
    "lat": 64.4106,
    "lng": 25.1308,
    "radiusKm": 9.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Alpua",
    "postalCode": 86460,
    "postalCodeMin": 86460,
    "postalCodeMax": 86469,
    "lat": 64.4233,
    "lng": 25.2232,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Lumimetsä",
    "postalCode": 86470,
    "postalCodeMin": 86470,
    "postalCodeMax": 86479,
    "lat": 64.3611,
    "lng": 25.2417,
    "radiusKm": 12.0
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Raahe",
    "postalCode": 92100,
    "postalCodeMin": 92100,
    "postalCodeMax": 92109,
    "lat": 64.6723,
    "lng": 24.4542,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Raahe",
    "postalCode": 92120,
    "postalCodeMin": 92120,
    "postalCodeMax": 92129,
    "lat": 64.6747,
    "lng": 24.5026,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Raahe",
    "postalCode": 92130,
    "postalCodeMin": 92130,
    "postalCodeMax": 92139,
    "lat": 64.6945,
    "lng": 24.5078,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Pattijoki",
    "postalCode": 92140,
    "postalCodeMin": 92140,
    "postalCodeMax": 92149,
    "lat": 64.6926,
    "lng": 24.5746,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Raahe",
    "postalCode": 92150,
    "postalCodeMin": 92150,
    "postalCodeMax": 92159,
    "lat": 64.6683,
    "lng": 24.4768,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Saloinen",
    "postalCode": 92160,
    "postalCodeMin": 92160,
    "postalCodeMax": 92169,
    "lat": 64.6507,
    "lng": 24.4562,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Lapaluoto",
    "postalCode": 92180,
    "postalCodeMin": 92180,
    "postalCodeMax": 92189,
    "lat": 64.6677,
    "lng": 24.419,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Arkkukari",
    "postalCode": 92210,
    "postalCodeMin": 92210,
    "postalCodeMax": 92219,
    "lat": 64.61,
    "lng": 24.4146,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Piehinki",
    "postalCode": 92220,
    "postalCodeMin": 92220,
    "postalCodeMax": 92229,
    "lat": 64.5722,
    "lng": 24.3952,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Mattilanperä",
    "postalCode": 92230,
    "postalCodeMin": 92230,
    "postalCodeMax": 92239,
    "lat": 64.5862,
    "lng": 24.6039,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Lasikangas",
    "postalCode": 92240,
    "postalCodeMin": 92240,
    "postalCodeMax": 92249,
    "lat": 64.6307,
    "lng": 24.6723,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Raahe",
    "area": "Kopsa",
    "postalCode": 92260,
    "postalCodeMin": 92260,
    "postalCodeMax": 92269,
    "lat": 64.5796,
    "lng": 24.7105,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Reisjärvi",
    "area": "Reisjärvi",
    "postalCode": 85900,
    "postalCodeMin": 85900,
    "postalCodeMax": 85909,
    "lat": 63.6045,
    "lng": 24.9389,
    "radiusKm": 9.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Reisjärvi",
    "area": "Kangaskylä",
    "postalCode": 85930,
    "postalCodeMin": 85930,
    "postalCodeMax": 85939,
    "lat": 63.6654,
    "lng": 24.8349,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Reisjärvi",
    "area": "Räisälänmäki",
    "postalCode": 85940,
    "postalCodeMin": 85940,
    "postalCodeMax": 85949,
    "lat": 63.6351,
    "lng": 25.0477,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Reisjärvi",
    "area": "Köyhänperä",
    "postalCode": 85980,
    "postalCodeMin": 85980,
    "postalCodeMax": 85989,
    "lat": 63.5971,
    "lng": 25.0924,
    "radiusKm": 8.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Sievi",
    "area": "Sievi as",
    "postalCode": 85310,
    "postalCodeMin": 85310,
    "postalCodeMax": 85319,
    "lat": 63.9645,
    "lng": 24.2192,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Sievi",
    "area": "Markkula",
    "postalCode": 85320,
    "postalCodeMin": 85320,
    "postalCodeMax": 85329,
    "lat": 63.941,
    "lng": 24.3513,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Sievi",
    "area": "Jyrinki",
    "postalCode": 85340,
    "postalCodeMin": 85340,
    "postalCodeMax": 85349,
    "lat": 63.9215,
    "lng": 24.4369,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Sievi",
    "area": "Sievi",
    "postalCode": 85410,
    "postalCodeMin": 85410,
    "postalCodeMax": 85419,
    "lat": 63.906,
    "lng": 24.5145,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Sievi",
    "area": "Koivisto",
    "postalCode": 85430,
    "postalCodeMin": 85430,
    "postalCodeMax": 85439,
    "lat": 63.9144,
    "lng": 24.6394,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Sievi",
    "area": "Joenkylä",
    "postalCode": 85450,
    "postalCodeMin": 85450,
    "postalCodeMax": 85459,
    "lat": 63.906,
    "lng": 24.5145,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Sievi",
    "area": "Kiiskilampi",
    "postalCode": 85470,
    "postalCodeMin": 85470,
    "postalCodeMax": 85479,
    "lat": 63.8003,
    "lng": 24.665,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikajoki",
    "area": "Kopsa",
    "postalCode": 92260,
    "postalCodeMin": 92260,
    "postalCodeMax": 92269,
    "lat": 64.5796,
    "lng": 24.7105,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikajoki",
    "area": "Siikajoki",
    "postalCode": 92320,
    "postalCodeMin": 92320,
    "postalCodeMax": 92329,
    "lat": 64.8329,
    "lng": 24.7449,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikajoki",
    "area": "Karinkanta",
    "postalCode": 92330,
    "postalCodeMin": 92330,
    "postalCodeMax": 92339,
    "lat": 64.865,
    "lng": 24.9433,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikajoki",
    "area": "Revonlahti",
    "postalCode": 92350,
    "postalCodeMin": 92350,
    "postalCodeMax": 92359,
    "lat": 64.6645,
    "lng": 25.1024,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikajoki",
    "area": "Ruukki",
    "postalCode": 92400,
    "postalCodeMin": 92400,
    "postalCodeMax": 92409,
    "lat": 64.6643,
    "lng": 25.0994,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikajoki",
    "area": "Paavola",
    "postalCode": 92430,
    "postalCodeMin": 92430,
    "postalCodeMax": 92439,
    "lat": 64.6082,
    "lng": 25.2059,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikajoki",
    "area": "Saarikoski",
    "postalCode": 92440,
    "postalCodeMin": 92440,
    "postalCodeMax": 92449,
    "lat": 64.6172,
    "lng": 25.4311,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikajoki",
    "area": "Luohua",
    "postalCode": 92450,
    "postalCodeMin": 92450,
    "postalCodeMax": 92459,
    "lat": 64.5494,
    "lng": 25.2757,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikajoki",
    "area": "Tuomioja",
    "postalCode": 92470,
    "postalCodeMin": 92470,
    "postalCodeMax": 92479,
    "lat": 64.6074,
    "lng": 25.03,
    "radiusKm": 7.3
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikalatva",
    "area": "Rantsila",
    "postalCode": 92500,
    "postalCodeMin": 92500,
    "postalCodeMax": 92509,
    "lat": 64.5061,
    "lng": 25.6503,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikalatva",
    "area": "Sipola",
    "postalCode": 92520,
    "postalCodeMin": 92520,
    "postalCodeMax": 92529,
    "lat": 64.4113,
    "lng": 25.9013,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikalatva",
    "area": "Mankila",
    "postalCode": 92530,
    "postalCodeMin": 92530,
    "postalCodeMax": 92539,
    "lat": 64.5814,
    "lng": 25.4987,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikalatva",
    "area": "Pulkkila",
    "postalCode": 92600,
    "postalCodeMin": 92600,
    "postalCodeMax": 92609,
    "lat": 64.2685,
    "lng": 25.8668,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikalatva",
    "area": "Vorna",
    "postalCode": 92610,
    "postalCodeMin": 92610,
    "postalCodeMax": 92619,
    "lat": 64.342,
    "lng": 25.9605,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikalatva",
    "area": "Piippola",
    "postalCode": 92620,
    "postalCodeMin": 92620,
    "postalCodeMax": 92629,
    "lat": 64.1775,
    "lng": 25.9659,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikalatva",
    "area": "Leskelä",
    "postalCode": 92640,
    "postalCodeMin": 92640,
    "postalCodeMax": 92649,
    "lat": 64.1789,
    "lng": 25.8036,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikalatva",
    "area": "Laakkola",
    "postalCode": 92650,
    "postalCodeMin": 92650,
    "postalCodeMax": 92659,
    "lat": 64.237,
    "lng": 25.7503,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Siikalatva",
    "area": "Kestilä",
    "postalCode": 92700,
    "postalCodeMin": 92700,
    "postalCodeMax": 92709,
    "lat": 64.3505,
    "lng": 26.2757,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Taivalkoski",
    "area": "Taivalkoski",
    "postalCode": 93400,
    "postalCodeMin": 93400,
    "postalCodeMax": 93409,
    "lat": 65.575,
    "lng": 28.2434,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Taivalkoski",
    "area": "Jurmu",
    "postalCode": 93420,
    "postalCodeMin": 93420,
    "postalCodeMax": 93429,
    "lat": 65.5211,
    "lng": 27.9553,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Taivalkoski",
    "area": "Loukusa",
    "postalCode": 93440,
    "postalCodeMin": 93440,
    "postalCodeMax": 93449,
    "lat": 65.7295,
    "lng": 27.9569,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Taivalkoski",
    "area": "Inget",
    "postalCode": 93470,
    "postalCodeMin": 93470,
    "postalCodeMax": 93479,
    "lat": 65.575,
    "lng": 28.2434,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Taivalkoski",
    "area": "Tyrövaara",
    "postalCode": 93540,
    "postalCodeMin": 93540,
    "postalCodeMax": 93549,
    "lat": 65.4848,
    "lng": 28.7583,
    "radiusKm": 12.3
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Taivalkoski",
    "area": "Vanhala",
    "postalCode": 93590,
    "postalCodeMin": 93590,
    "postalCodeMax": 93599,
    "lat": 65.575,
    "lng": 28.2434,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Tyrnävä",
    "area": "Tyrnävä",
    "postalCode": 91800,
    "postalCodeMin": 91800,
    "postalCodeMax": 91809,
    "lat": 64.7638,
    "lng": 25.653,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Tyrnävä",
    "area": "Temmes",
    "postalCode": 91950,
    "postalCodeMin": 91950,
    "postalCodeMax": 91959,
    "lat": 64.6667,
    "lng": 25.6,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Utajärvi",
    "area": "Utajärvi",
    "postalCode": 91600,
    "postalCodeMin": 91600,
    "postalCodeMax": 91609,
    "lat": 64.7624,
    "lng": 26.4206,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Utajärvi",
    "area": "Sanginkylä",
    "postalCode": 91620,
    "postalCodeMin": 91620,
    "postalCodeMax": 91629,
    "lat": 64.8494,
    "lng": 26.7011,
    "radiusKm": 8.4
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Utajärvi",
    "area": "Juorkuna",
    "postalCode": 91630,
    "postalCodeMin": 91630,
    "postalCodeMax": 91639,
    "lat": 64.955,
    "lng": 26.9784,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Utajärvi",
    "area": "Särkijärvi",
    "postalCode": 91640,
    "postalCodeMin": 91640,
    "postalCodeMax": 91649,
    "lat": 64.9264,
    "lng": 27.1957,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Utajärvi",
    "area": "Ahmas",
    "postalCode": 91660,
    "postalCodeMin": 91660,
    "postalCodeMax": 91669,
    "lat": 64.6282,
    "lng": 26.4065,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Utajärvi",
    "area": "Rokua",
    "postalCode": 91670,
    "postalCodeMin": 91670,
    "postalCodeMax": 91679,
    "lat": 64.5631,
    "lng": 26.5117,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Manamansalo",
    "postalCode": 88340,
    "postalCodeMin": 88340,
    "postalCodeMax": 88349,
    "lat": 64.3854,
    "lng": 27.1166,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Vaala",
    "postalCode": 91700,
    "postalCodeMin": 91700,
    "postalCodeMax": 91709,
    "lat": 64.5599,
    "lng": 26.8409,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Jylhämä",
    "postalCode": 91710,
    "postalCodeMin": 91710,
    "postalCodeMax": 91719,
    "lat": 64.5761,
    "lng": 26.7596,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Oterma",
    "postalCode": 91720,
    "postalCodeMin": 91720,
    "postalCodeMax": 91729,
    "lat": 64.5599,
    "lng": 26.8409,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Kankari",
    "postalCode": 91730,
    "postalCodeMin": 91730,
    "postalCodeMax": 91739,
    "lat": 64.558,
    "lng": 27.0153,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Jaalanka",
    "postalCode": 91740,
    "postalCodeMin": 91740,
    "postalCodeMax": 91749,
    "lat": 64.5565,
    "lng": 27.1643,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Liminpuro",
    "postalCode": 91750,
    "postalCodeMin": 91750,
    "postalCodeMax": 91759,
    "lat": 64.535,
    "lng": 27.2793,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Säräisniemi",
    "postalCode": 91760,
    "postalCodeMin": 91760,
    "postalCodeMax": 91769,
    "lat": 64.4451,
    "lng": 26.7841,
    "radiusKm": 10.1
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Neittävä",
    "postalCode": 91780,
    "postalCodeMin": 91780,
    "postalCodeMax": 91789,
    "lat": 64.5067,
    "lng": 26.6634,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Nuojua",
    "postalCode": 91790,
    "postalCodeMin": 91790,
    "postalCodeMax": 91799,
    "lat": 64.5724,
    "lng": 26.6634,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Pelsonsuo",
    "postalCode": 92810,
    "postalCodeMin": 92810,
    "postalCodeMax": 92819,
    "lat": 64.5,
    "lng": 26.4167,
    "radiusKm": 11.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Vaala",
    "area": "Veneheitto",
    "postalCode": 92830,
    "postalCodeMin": 92830,
    "postalCodeMax": 92839,
    "lat": 64.4432,
    "lng": 26.5272,
    "radiusKm": 5.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ylivieska",
    "area": "Ylivieska",
    "postalCode": 84100,
    "postalCodeMin": 84100,
    "postalCodeMax": 84109,
    "lat": 64.0723,
    "lng": 24.5336,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ylivieska",
    "area": "Tuomiperä",
    "postalCode": 84460,
    "postalCodeMin": 84460,
    "postalCodeMax": 84469,
    "lat": 64.1289,
    "lng": 24.74,
    "radiusKm": 8.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ylivieska",
    "area": "Vähäkangas",
    "postalCode": 84540,
    "postalCodeMin": 84540,
    "postalCodeMax": 84549,
    "lat": 64.0645,
    "lng": 24.6805,
    "radiusKm": 9.6
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ylivieska",
    "area": "Kantokylä",
    "postalCode": 84650,
    "postalCodeMin": 84650,
    "postalCodeMax": 84659,
    "lat": 64.0749,
    "lng": 24.8331,
    "radiusKm": 7.2
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ylivieska",
    "area": "Isokoski",
    "postalCode": 84770,
    "postalCodeMin": 84770,
    "postalCodeMax": 84779,
    "lat": 64.0165,
    "lng": 24.7919,
    "radiusKm": 4.8
  },
  {
    "region": "Pohjois-Pohjanmaa",
    "city": "Ylivieska",
    "area": "Raudaskylä",
    "postalCode": 84880,
    "postalCodeMin": 84880,
    "postalCodeMax": 84889,
    "lat": 64.0033,
    "lng": 24.7464,
    "radiusKm": 7.2
  },
  {
    "region": "Kainuu",
    "city": "Hyrynsalmi",
    "area": "Hyrynsalmi",
    "postalCode": 89400,
    "postalCodeMin": 89400,
    "postalCodeMax": 89409,
    "lat": 64.6791,
    "lng": 28.484,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Hyrynsalmi",
    "area": "Hoikka",
    "postalCode": 89430,
    "postalCodeMin": 89430,
    "postalCodeMax": 89439,
    "lat": 64.7285,
    "lng": 28.618,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Hyrynsalmi",
    "area": "Moisiovaara",
    "postalCode": 89540,
    "postalCodeMin": 89540,
    "postalCodeMax": 89549,
    "lat": 64.5967,
    "lng": 29.1194,
    "radiusKm": 11.6
  },
  {
    "region": "Kainuu",
    "city": "Hyrynsalmi",
    "area": "Karhuvaara",
    "postalCode": 89560,
    "postalCodeMin": 89560,
    "postalCodeMax": 89569,
    "lat": 64.5251,
    "lng": 29.0224,
    "radiusKm": 11.6
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87100,
    "postalCodeMin": 87100,
    "postalCodeMax": 87109,
    "lat": 64.2209,
    "lng": 27.7278,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87150,
    "postalCodeMin": 87150,
    "postalCodeMax": 87159,
    "lat": 64.2232,
    "lng": 27.7053,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87200,
    "postalCodeMin": 87200,
    "postalCodeMax": 87209,
    "lat": 64.2333,
    "lng": 27.7304,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87250,
    "postalCodeMin": 87250,
    "postalCodeMax": 87259,
    "lat": 64.248,
    "lng": 27.7997,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87300,
    "postalCodeMin": 87300,
    "postalCodeMax": 87309,
    "lat": 64.2092,
    "lng": 27.7298,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87400,
    "postalCodeMin": 87400,
    "postalCodeMax": 87409,
    "lat": 64.2168,
    "lng": 27.7789,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87500,
    "postalCodeMin": 87500,
    "postalCodeMax": 87509,
    "lat": 64.2013,
    "lng": 27.8073,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87700,
    "postalCodeMin": 87700,
    "postalCodeMax": 87709,
    "lat": 64.2175,
    "lng": 27.6802,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87800,
    "postalCodeMin": 87800,
    "postalCodeMax": 87809,
    "lat": 64.1662,
    "lng": 27.3808,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Nakertaja",
    "postalCode": 87830,
    "postalCodeMin": 87830,
    "postalCodeMax": 87839,
    "lat": 64.2491,
    "lng": 27.6951,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Paltaniemi",
    "postalCode": 87850,
    "postalCodeMin": 87850,
    "postalCodeMax": 87859,
    "lat": 64.293,
    "lng": 27.6585,
    "radiusKm": 9.5
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kajaani",
    "postalCode": 87900,
    "postalCodeMin": 87900,
    "postalCodeMax": 87909,
    "lat": 64.0662,
    "lng": 27.5847,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Linnantaus",
    "postalCode": 87910,
    "postalCodeMin": 87910,
    "postalCodeMax": 87919,
    "lat": 64.2365,
    "lng": 27.7465,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Salmijärvi",
    "postalCode": 87930,
    "postalCodeMin": 87930,
    "postalCodeMax": 87939,
    "lat": 64.2911,
    "lng": 27.855,
    "radiusKm": 10.6
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Kuluntalahti",
    "postalCode": 87950,
    "postalCodeMin": 87950,
    "postalCodeMax": 87959,
    "lat": 64.2725,
    "lng": 27.8926,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Jormua",
    "postalCode": 87970,
    "postalCodeMin": 87970,
    "postalCodeMax": 87979,
    "lat": 64.2985,
    "lng": 28.0092,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Otanmäki",
    "postalCode": 88200,
    "postalCodeMin": 88200,
    "postalCodeMax": 88209,
    "lat": 64.1106,
    "lng": 27.1068,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kajaani",
    "area": "Vuolijoki",
    "postalCode": 88270,
    "postalCodeMin": 88270,
    "postalCodeMax": 88279,
    "lat": 64.1824,
    "lng": 27.0052,
    "radiusKm": 9.5
  },
  {
    "region": "Kainuu",
    "city": "Kuhmo",
    "area": "Ylä-Vieksi",
    "postalCode": 88730,
    "postalCodeMin": 88730,
    "postalCodeMax": 88739,
    "lat": 64.314,
    "lng": 29.107,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kuhmo",
    "area": "Härmänkylä",
    "postalCode": 88740,
    "postalCodeMin": 88740,
    "postalCodeMax": 88749,
    "lat": 64.4409,
    "lng": 29.0642,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Kuhmo",
    "area": "Iivantiira",
    "postalCode": 88760,
    "postalCodeMin": 88760,
    "postalCodeMax": 88769,
    "lat": 64.4563,
    "lng": 29.5278,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kuhmo",
    "area": "Katerma",
    "postalCode": 88820,
    "postalCodeMin": 88820,
    "postalCodeMax": 88829,
    "lat": 64.1009,
    "lng": 29.0281,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kuhmo",
    "area": "Kuhmo",
    "postalCode": 88900,
    "postalCodeMin": 88900,
    "postalCodeMax": 88909,
    "lat": 64.1287,
    "lng": 29.5203,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kuhmo",
    "area": "Lentiira",
    "postalCode": 88930,
    "postalCodeMin": 88930,
    "postalCodeMax": 88939,
    "lat": 64.3887,
    "lng": 29.837,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Kuhmo",
    "area": "Kuumu",
    "postalCode": 88940,
    "postalCodeMin": 88940,
    "postalCodeMax": 88949,
    "lat": 64.5627,
    "lng": 29.6999,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Paltamo",
    "area": "Paltamo",
    "postalCode": 88300,
    "postalCodeMin": 88300,
    "postalCodeMax": 88309,
    "lat": 64.403,
    "lng": 27.8381,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Paltamo",
    "area": "Melalahti",
    "postalCode": 88310,
    "postalCodeMin": 88310,
    "postalCodeMax": 88319,
    "lat": 64.4079,
    "lng": 27.6752,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Paltamo",
    "area": "Kivesjärvi",
    "postalCode": 88350,
    "postalCodeMin": 88350,
    "postalCodeMax": 88359,
    "lat": 64.4668,
    "lng": 27.476,
    "radiusKm": 10.6
  },
  {
    "region": "Kainuu",
    "city": "Paltamo",
    "area": "Mieslahti",
    "postalCode": 88380,
    "postalCodeMin": 88380,
    "postalCodeMax": 88389,
    "lat": 64.3898,
    "lng": 27.9878,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Paltamo",
    "area": "Kontiomäki",
    "postalCode": 88470,
    "postalCodeMin": 88470,
    "postalCodeMax": 88479,
    "lat": 64.3377,
    "lng": 28.1102,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Puolanka",
    "area": "Törmänmäki",
    "postalCode": 89110,
    "postalCodeMin": 89110,
    "postalCodeMax": 89119,
    "lat": 64.5662,
    "lng": 27.7333,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Puolanka",
    "area": "Kotila",
    "postalCode": 89140,
    "postalCodeMin": 89140,
    "postalCodeMax": 89149,
    "lat": 64.6599,
    "lng": 27.9107,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Puolanka",
    "area": "Puolanka",
    "postalCode": 89200,
    "postalCodeMin": 89200,
    "postalCodeMax": 89209,
    "lat": 64.8675,
    "lng": 27.6752,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Puolanka",
    "area": "Puokiovaara",
    "postalCode": 89210,
    "postalCodeMin": 89210,
    "postalCodeMax": 89219,
    "lat": 64.75,
    "lng": 27.3167,
    "radiusKm": 11.6
  },
  {
    "region": "Kainuu",
    "city": "Puolanka",
    "area": "Joukokylä",
    "postalCode": 89320,
    "postalCodeMin": 89320,
    "postalCodeMax": 89329,
    "lat": 65.041,
    "lng": 27.9986,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Puolanka",
    "area": "Suolijärvi",
    "postalCode": 89330,
    "postalCodeMin": 89330,
    "postalCodeMax": 89339,
    "lat": 65.1451,
    "lng": 28.0662,
    "radiusKm": 10.6
  },
  {
    "region": "Kainuu",
    "city": "Ristijärvi",
    "area": "Ristijärvi",
    "postalCode": 88400,
    "postalCodeMin": 88400,
    "postalCodeMax": 88409,
    "lat": 64.5101,
    "lng": 28.209,
    "radiusKm": 10.6
  },
  {
    "region": "Kainuu",
    "city": "Ristijärvi",
    "area": "Jokikylä",
    "postalCode": 88440,
    "postalCodeMin": 88440,
    "postalCodeMax": 88449,
    "lat": 64.553,
    "lng": 28.3166,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Ristijärvi",
    "area": "Hiisijärvi",
    "postalCode": 88460,
    "postalCodeMin": 88460,
    "postalCodeMax": 88469,
    "lat": 64.3646,
    "lng": 28.6035,
    "radiusKm": 10.6
  },
  {
    "region": "Kainuu",
    "city": "Sotkamo",
    "area": "Tuhkakylä",
    "postalCode": 88120,
    "postalCodeMin": 88120,
    "postalCodeMax": 88129,
    "lat": 64.0466,
    "lng": 28.1077,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Sotkamo",
    "area": "Pohjavaara",
    "postalCode": 88490,
    "postalCodeMin": 88490,
    "postalCodeMax": 88499,
    "lat": 64.2408,
    "lng": 28.0778,
    "radiusKm": 11.6
  },
  {
    "region": "Kainuu",
    "city": "Sotkamo",
    "area": "Paakki",
    "postalCode": 88530,
    "postalCodeMin": 88530,
    "postalCodeMax": 88539,
    "lat": 64.2928,
    "lng": 28.2123,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Sotkamo",
    "area": "Sotkamo",
    "postalCode": 88600,
    "postalCodeMin": 88600,
    "postalCodeMax": 88609,
    "lat": 64.1307,
    "lng": 28.3905,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Sotkamo",
    "area": "Vuokatti",
    "postalCode": 88610,
    "postalCodeMin": 88610,
    "postalCodeMax": 88619,
    "lat": 64.1458,
    "lng": 28.269,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Sotkamo",
    "area": "Korholanmäki",
    "postalCode": 88620,
    "postalCodeMin": 88620,
    "postalCodeMax": 88629,
    "lat": 64.0878,
    "lng": 28.1107,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Sotkamo",
    "area": "Ontojoki",
    "postalCode": 88640,
    "postalCodeMin": 88640,
    "postalCodeMax": 88649,
    "lat": 64.0877,
    "lng": 28.8737,
    "radiusKm": 9.5
  },
  {
    "region": "Kainuu",
    "city": "Sotkamo",
    "area": "Juurikkalahti",
    "postalCode": 88670,
    "postalCodeMin": 88670,
    "postalCodeMax": 88679,
    "lat": 64.0533,
    "lng": 28.3108,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Sotkamo",
    "area": "Maanselkä",
    "postalCode": 88690,
    "postalCodeMin": 88690,
    "postalCodeMax": 88699,
    "lat": 63.8718,
    "lng": 28.4604,
    "radiusKm": 11.6
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Sakara",
    "postalCode": 89440,
    "postalCodeMin": 89440,
    "postalCodeMax": 89449,
    "lat": 64.774,
    "lng": 28.7582,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Ämmänsaari",
    "postalCode": 89600,
    "postalCodeMin": 89600,
    "postalCodeMax": 89609,
    "lat": 64.8841,
    "lng": 28.9117,
    "radiusKm": 10.6
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Jumaliskylä",
    "postalCode": 89610,
    "postalCodeMin": 89610,
    "postalCodeMax": 89619,
    "lat": 64.7103,
    "lng": 29.2062,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Pesiökylä",
    "postalCode": 89640,
    "postalCodeMin": 89640,
    "postalCodeMax": 89649,
    "lat": 64.9286,
    "lng": 28.5659,
    "radiusKm": 7.9
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Takalo",
    "postalCode": 89660,
    "postalCodeMin": 89660,
    "postalCodeMax": 89669,
    "lat": 65.0548,
    "lng": 28.6,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Näljänkä",
    "postalCode": 89670,
    "postalCodeMin": 89670,
    "postalCodeMax": 89679,
    "lat": 65.2276,
    "lng": 28.4159,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Vaaranniva",
    "postalCode": 89680,
    "postalCodeMin": 89680,
    "postalCodeMax": 89689,
    "lat": 65.1619,
    "lng": 28.3772,
    "radiusKm": 11.6
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Ahjola",
    "postalCode": 89730,
    "postalCodeMin": 89730,
    "postalCodeMax": 89739,
    "lat": 65.1909,
    "lng": 28.8845,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Kianta",
    "postalCode": 89740,
    "postalCodeMin": 89740,
    "postalCodeMax": 89749,
    "lat": 65.1923,
    "lng": 29.1252,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Piispajärvi",
    "postalCode": 89760,
    "postalCodeMin": 89760,
    "postalCodeMax": 89769,
    "lat": 65.2971,
    "lng": 29.074,
    "radiusKm": 10.6
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Peranka",
    "postalCode": 89770,
    "postalCodeMin": 89770,
    "postalCodeMax": 89779,
    "lat": 65.393,
    "lng": 29.0306,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Kaikkonen",
    "postalCode": 89780,
    "postalCodeMin": 89780,
    "postalCodeMax": 89789,
    "lat": 65.3285,
    "lng": 28.7258,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Suomussalmi kk",
    "postalCode": 89800,
    "postalCodeMin": 89800,
    "postalCodeMax": 89809,
    "lat": 64.9018,
    "lng": 29.0052,
    "radiusKm": 10.6
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Ala-Vuokki",
    "postalCode": 89830,
    "postalCodeMin": 89830,
    "postalCodeMax": 89839,
    "lat": 64.7473,
    "lng": 29.4409,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Yli-Vuokki",
    "postalCode": 89840,
    "postalCodeMin": 89840,
    "postalCodeMax": 89849,
    "lat": 64.6667,
    "lng": 29.8,
    "radiusKm": 5.3
  },
  {
    "region": "Kainuu",
    "city": "Suomussalmi",
    "area": "Ruhtinansalmi",
    "postalCode": 89920,
    "postalCodeMin": 89920,
    "postalCodeMax": 89929,
    "lat": 65.2314,
    "lng": 29.4651,
    "radiusKm": 5.3
  },
  {
    "region": "Lappi",
    "city": "Enontekiö",
    "area": "Hetta",
    "postalCode": 99400,
    "postalCodeMin": 99400,
    "postalCodeMax": 99409,
    "lat": 68.384,
    "lng": 23.6336,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Enontekiö",
    "area": "Vuontisjärvi",
    "postalCode": 99410,
    "postalCodeMin": 99410,
    "postalCodeMax": 99419,
    "lat": 68.4353,
    "lng": 23.988,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Enontekiö",
    "area": "Peltovuoma",
    "postalCode": 99420,
    "postalCodeMin": 99420,
    "postalCodeMax": 99429,
    "lat": 68.3844,
    "lng": 24.2003,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Enontekiö",
    "area": "Nunnanen",
    "postalCode": 99430,
    "postalCodeMin": 99430,
    "postalCodeMax": 99439,
    "lat": 68.3986,
    "lng": 24.4985,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Enontekiö",
    "area": "Leppäjärvi",
    "postalCode": 99440,
    "postalCodeMin": 99440,
    "postalCodeMax": 99449,
    "lat": 68.5065,
    "lng": 23.3108,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Enontekiö",
    "area": "Palojoensuu",
    "postalCode": 99450,
    "postalCodeMin": 99450,
    "postalCodeMax": 99459,
    "lat": 68.2842,
    "lng": 23.0812,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Enontekiö",
    "area": "Kuttanen",
    "postalCode": 99460,
    "postalCodeMin": 99460,
    "postalCodeMax": 99469,
    "lat": 68.3868,
    "lng": 22.8427,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Enontekiö",
    "area": "Karesuvanto",
    "postalCode": 99470,
    "postalCodeMin": 99470,
    "postalCodeMax": 99479,
    "lat": 68.449,
    "lng": 22.4838,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Enontekiö",
    "area": "Kilpisjärvi",
    "postalCode": 99490,
    "postalCodeMin": 99490,
    "postalCodeMax": 99499,
    "lat": 69.0443,
    "lng": 20.8033,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Inari",
    "area": "Ivalo",
    "postalCode": 99800,
    "postalCodeMin": 99800,
    "postalCodeMax": 99809,
    "lat": 68.6576,
    "lng": 27.5397,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Inari",
    "area": "Saariselkä",
    "postalCode": 99830,
    "postalCodeMin": 99830,
    "postalCodeMax": 99839,
    "lat": 68.4197,
    "lng": 27.41,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Inari",
    "area": "Nellim",
    "postalCode": 99860,
    "postalCodeMin": 99860,
    "postalCodeMax": 99869,
    "lat": 68.8455,
    "lng": 28.315,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Inari",
    "area": "Inari",
    "postalCode": 99870,
    "postalCodeMin": 99870,
    "postalCodeMax": 99879,
    "lat": 69.0834,
    "lng": 26.3687,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Inari",
    "area": "Lemmenjoki",
    "postalCode": 99885,
    "postalCodeMin": 99880,
    "postalCodeMax": 99889,
    "lat": 68.7543,
    "lng": 26.225,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Inari",
    "area": "Kaamanen",
    "postalCode": 99910,
    "postalCodeMin": 99910,
    "postalCodeMax": 99919,
    "lat": 69.104,
    "lng": 27.1946,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Inari",
    "area": "Sevettijärvi",
    "postalCode": 99930,
    "postalCodeMin": 99930,
    "postalCodeMax": 99939,
    "lat": 69.5055,
    "lng": 28.5916,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Inari",
    "area": "Näätämö",
    "postalCode": 99940,
    "postalCodeMin": 99940,
    "postalCodeMax": 99949,
    "lat": 69.6706,
    "lng": 29.1234,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemi",
    "area": "Kemi",
    "postalCode": 94100,
    "postalCodeMin": 94100,
    "postalCodeMax": 94109,
    "lat": 65.7375,
    "lng": 24.564,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemi",
    "area": "Kemi",
    "postalCode": 94200,
    "postalCodeMin": 94200,
    "postalCodeMax": 94209,
    "lat": 65.7648,
    "lng": 24.544,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemi",
    "area": "Kemi",
    "postalCode": 94300,
    "postalCodeMin": 94300,
    "postalCodeMax": 94309,
    "lat": 65.7639,
    "lng": 24.4932,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemi",
    "area": "Kemi",
    "postalCode": 94600,
    "postalCodeMin": 94600,
    "postalCodeMax": 94609,
    "lat": 65.7567,
    "lng": 24.5911,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemi",
    "area": "Kemi",
    "postalCode": 94700,
    "postalCodeMin": 94700,
    "postalCodeMax": 94709,
    "lat": 65.7341,
    "lng": 24.6488,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemi",
    "area": "Kemi",
    "postalCode": 94720,
    "postalCodeMin": 94720,
    "postalCodeMax": 94729,
    "lat": 65.7199,
    "lng": 24.5923,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemi",
    "area": "Veitsiluoto",
    "postalCode": 94800,
    "postalCodeMin": 94800,
    "postalCodeMax": 94809,
    "lat": 65.6916,
    "lng": 24.623,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemi",
    "area": "Hepola",
    "postalCode": 94830,
    "postalCodeMin": 94830,
    "postalCodeMax": 94839,
    "lat": 65.6836,
    "lng": 24.6674,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemi",
    "area": "Ajos",
    "postalCode": 94900,
    "postalCodeMin": 94900,
    "postalCodeMax": 94909,
    "lat": 65.6759,
    "lng": 24.5808,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Raajärvi",
    "postalCode": 97590,
    "postalCodeMin": 97590,
    "postalCodeMax": 97599,
    "lat": 66.5594,
    "lng": 26.9069,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Juujärvi",
    "postalCode": 97645,
    "postalCodeMin": 97640,
    "postalCodeMax": 97649,
    "lat": 66.3923,
    "lng": 27.3067,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Kemijärvi",
    "postalCode": 98100,
    "postalCodeMin": 98100,
    "postalCodeMax": 98109,
    "lat": 66.7136,
    "lng": 27.4292,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Kemijärvi",
    "postalCode": 98120,
    "postalCodeMin": 98120,
    "postalCodeMax": 98129,
    "lat": 66.723,
    "lng": 27.3853,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Luusua",
    "postalCode": 98230,
    "postalCodeMin": 98230,
    "postalCodeMax": 98239,
    "lat": 66.4845,
    "lng": 27.2972,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Kemijärvi",
    "postalCode": 98310,
    "postalCodeMin": 98310,
    "postalCodeMax": 98319,
    "lat": 66.7602,
    "lng": 27.344,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Tapionniemi",
    "postalCode": 98350,
    "postalCodeMin": 98350,
    "postalCodeMax": 98359,
    "lat": 66.9032,
    "lng": 27.4456,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Vuostimo",
    "postalCode": 98360,
    "postalCodeMin": 98360,
    "postalCodeMax": 98369,
    "lat": 66.9711,
    "lng": 27.5205,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Isokylä",
    "postalCode": 98400,
    "postalCodeMin": 98400,
    "postalCodeMax": 98409,
    "lat": 66.6951,
    "lng": 27.5582,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Ryti-Lehtola",
    "postalCode": 98420,
    "postalCodeMin": 98420,
    "postalCodeMax": 98429,
    "lat": 66.5349,
    "lng": 27.7085,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Kallaanvaara",
    "postalCode": 98440,
    "postalCodeMin": 98440,
    "postalCodeMax": 98449,
    "lat": 66.7138,
    "lng": 27.5238,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Kostamo",
    "postalCode": 98450,
    "postalCodeMin": 98450,
    "postalCodeMax": 98459,
    "lat": 66.7851,
    "lng": 27.4629,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Joutsijärvi",
    "postalCode": 98710,
    "postalCodeMin": 98710,
    "postalCodeMax": 98719,
    "lat": 66.685,
    "lng": 27.9778,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kemijärvi",
    "area": "Suomutunturi",
    "postalCode": 98720,
    "postalCodeMin": 98720,
    "postalCodeMax": 98729,
    "lat": 66.55,
    "lng": 28.0167,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Keminmaa",
    "area": "Laurila",
    "postalCode": 94400,
    "postalCodeMin": 94400,
    "postalCodeMax": 94409,
    "lat": 65.8013,
    "lng": 24.545,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Keminmaa",
    "area": "Keminmaa",
    "postalCode": 94450,
    "postalCodeMin": 94450,
    "postalCodeMax": 94459,
    "lat": 65.7874,
    "lng": 24.4862,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Keminmaa",
    "area": "Lautiosaari",
    "postalCode": 94500,
    "postalCodeMin": 94500,
    "postalCodeMax": 94509,
    "lat": 65.7989,
    "lng": 24.5795,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Keminmaa",
    "area": "Liedakkala",
    "postalCode": 95310,
    "postalCodeMin": 95310,
    "postalCodeMax": 95319,
    "lat": 65.8547,
    "lng": 24.5851,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Keminmaa",
    "area": "Törmä",
    "postalCode": 95315,
    "postalCodeMin": 95310,
    "postalCodeMax": 95319,
    "lat": 65.8991,
    "lng": 24.6744,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Keminmaa",
    "area": "Maula",
    "postalCode": 95365,
    "postalCodeMin": 95360,
    "postalCodeMax": 95369,
    "lat": 65.8968,
    "lng": 24.7298,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Keminmaa",
    "area": "Itäkoski",
    "postalCode": 95370,
    "postalCodeMin": 95370,
    "postalCodeMax": 95379,
    "lat": 65.9353,
    "lng": 24.718,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Alakylä",
    "postalCode": 97470,
    "postalCodeMin": 97470,
    "postalCodeMax": 97479,
    "lat": 67.3529,
    "lng": 24.8856,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Kittilä",
    "postalCode": 99100,
    "postalCodeMin": 99100,
    "postalCodeMax": 99109,
    "lat": 67.6538,
    "lng": 24.5739,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Kaukonen",
    "postalCode": 99110,
    "postalCodeMin": 99110,
    "postalCodeMax": 99119,
    "lat": 67.4811,
    "lng": 24.9023,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Kallo",
    "postalCode": 99120,
    "postalCodeMin": 99120,
    "postalCodeMax": 99129,
    "lat": 67.4221,
    "lng": 24.5158,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Sirkka",
    "postalCode": 99130,
    "postalCodeMin": 99130,
    "postalCodeMax": 99139,
    "lat": 67.8051,
    "lng": 24.8007,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Köngäs",
    "postalCode": 99140,
    "postalCodeMin": 99140,
    "postalCodeMax": 99149,
    "lat": 67.8732,
    "lng": 24.8522,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Tepasto",
    "postalCode": 99150,
    "postalCodeMin": 99150,
    "postalCodeMax": 99159,
    "lat": 68.0039,
    "lng": 24.691,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Lompolo",
    "postalCode": 99160,
    "postalCodeMin": 99160,
    "postalCodeMax": 99169,
    "lat": 68.0921,
    "lng": 24.8209,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Pulju",
    "postalCode": 99170,
    "postalCodeMin": 99170,
    "postalCodeMax": 99179,
    "lat": 68.2305,
    "lng": 24.8291,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Rautusjärvi",
    "postalCode": 99180,
    "postalCodeMin": 99180,
    "postalCodeMax": 99189,
    "lat": 67.8729,
    "lng": 24.9539,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Hanhimaa",
    "postalCode": 99190,
    "postalCodeMin": 99190,
    "postalCodeMax": 99199,
    "lat": 67.9266,
    "lng": 25.0458,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Pokka",
    "postalCode": 99195,
    "postalCodeMin": 99190,
    "postalCodeMax": 99199,
    "lat": 68.1587,
    "lng": 25.7713,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Jeesiöjärvi",
    "postalCode": 99230,
    "postalCodeMin": 99230,
    "postalCodeMax": 99239,
    "lat": 67.7173,
    "lng": 25.417,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Kuivasalmi",
    "postalCode": 99240,
    "postalCodeMin": 99240,
    "postalCodeMax": 99249,
    "lat": 67.7927,
    "lng": 25.2596,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Kiistala",
    "postalCode": 99250,
    "postalCodeMin": 99250,
    "postalCodeMax": 99259,
    "lat": 67.8627,
    "lng": 25.3444,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Hormakumpu",
    "postalCode": 99270,
    "postalCodeMin": 99270,
    "postalCodeMax": 99279,
    "lat": 67.6134,
    "lng": 25.2011,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Tepsa",
    "postalCode": 99280,
    "postalCodeMin": 99280,
    "postalCodeMax": 99289,
    "lat": 67.561,
    "lng": 25.6809,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Kelontekemä",
    "postalCode": 99290,
    "postalCodeMin": 99290,
    "postalCodeMax": 99299,
    "lat": 67.5074,
    "lng": 25.6168,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kittilä",
    "area": "Raattama",
    "postalCode": 99340,
    "postalCodeMin": 99340,
    "postalCodeMax": 99349,
    "lat": 68.1386,
    "lng": 24.2215,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Sieppijärvi",
    "postalCode": 95800,
    "postalCodeMin": 95800,
    "postalCodeMax": 95809,
    "lat": 67.1486,
    "lng": 23.9856,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Vaattojärvi",
    "postalCode": 95830,
    "postalCodeMin": 95830,
    "postalCodeMax": 95839,
    "lat": 67.2183,
    "lng": 24.1434,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Venejärvenkylä",
    "postalCode": 95840,
    "postalCodeMin": 95840,
    "postalCodeMax": 95849,
    "lat": 67.299,
    "lng": 24.2404,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Ruokojärvi",
    "postalCode": 95850,
    "postalCodeMin": 95850,
    "postalCodeMax": 95859,
    "lat": 67.1667,
    "lng": 24.45,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Pasmajärvi",
    "postalCode": 95860,
    "postalCodeMin": 95860,
    "postalCodeMax": 95869,
    "lat": 67.1003,
    "lng": 24.3804,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Kolari",
    "postalCode": 95900,
    "postalCodeMin": 95900,
    "postalCodeMax": 95909,
    "lat": 67.3319,
    "lng": 23.7893,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Saaripudas",
    "postalCode": 95920,
    "postalCodeMin": 95920,
    "postalCodeMax": 95929,
    "lat": 67.3875,
    "lng": 23.7531,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Äkäsjoensuu",
    "postalCode": 95930,
    "postalCodeMin": 95930,
    "postalCodeMax": 95939,
    "lat": 67.4506,
    "lng": 23.7018,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Äkäslompolo",
    "postalCode": 95970,
    "postalCodeMin": 95970,
    "postalCodeMax": 95979,
    "lat": 67.6039,
    "lng": 24.1567,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Ylläsjärvi",
    "postalCode": 95980,
    "postalCodeMin": 95980,
    "postalCodeMax": 95989,
    "lat": 67.5264,
    "lng": 24.3046,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Kurtakko",
    "postalCode": 95990,
    "postalCodeMin": 95990,
    "postalCodeMax": 95999,
    "lat": 67.4041,
    "lng": 24.1712,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Kolari",
    "area": "Taapajärvi",
    "postalCode": 97430,
    "postalCodeMin": 97430,
    "postalCodeMax": 97439,
    "lat": 67.14,
    "lng": 24.6697,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Muonio",
    "area": "Tapojärvi",
    "postalCode": 95940,
    "postalCodeMin": 95940,
    "postalCodeMax": 95949,
    "lat": 67.5333,
    "lng": 23.6273,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Muonio",
    "area": "Kihlanki",
    "postalCode": 95950,
    "postalCodeMin": 95950,
    "postalCodeMax": 95959,
    "lat": 67.5954,
    "lng": 23.5501,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Muonio",
    "area": "Muonio",
    "postalCode": 99300,
    "postalCodeMin": 99300,
    "postalCodeMax": 99309,
    "lat": 67.8965,
    "lng": 23.8425,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Muonio",
    "area": "Yli-Muonio",
    "postalCode": 99310,
    "postalCodeMin": 99310,
    "postalCodeMax": 99319,
    "lat": 68.0244,
    "lng": 23.5029,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Muonio",
    "area": "Kätkäsuvanto",
    "postalCode": 99320,
    "postalCodeMin": 99320,
    "postalCodeMax": 99329,
    "lat": 68.1147,
    "lng": 23.3413,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Muonio",
    "area": "Pallastunturi",
    "postalCode": 99330,
    "postalCodeMin": 99330,
    "postalCodeMax": 99339,
    "lat": 68.0757,
    "lng": 24.0603,
    "radiusKm": 25.2
  },
  {
    "region": "Lappi",
    "city": "Muonio",
    "area": "Kangosjärvi",
    "postalCode": 99360,
    "postalCodeMin": 99360,
    "postalCodeMax": 99369,
    "lat": 67.8171,
    "lng": 23.6814,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Pelkosenniemi",
    "area": "Pelkosenniemi",
    "postalCode": 98500,
    "postalCodeMin": 98500,
    "postalCodeMax": 98509,
    "lat": 67.1084,
    "lng": 27.5146,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Pelkosenniemi",
    "area": "Saunavaara",
    "postalCode": 98510,
    "postalCodeMin": 98510,
    "postalCodeMax": 98519,
    "lat": 67.0586,
    "lng": 27.5247,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Pelkosenniemi",
    "area": "Pyhätunturi",
    "postalCode": 98530,
    "postalCodeMin": 98530,
    "postalCodeMax": 98539,
    "lat": 67.0139,
    "lng": 27.1494,
    "radiusKm": 25.2
  },
  {
    "region": "Lappi",
    "city": "Pelkosenniemi",
    "area": "Suvanto",
    "postalCode": 98550,
    "postalCodeMin": 98550,
    "postalCodeMax": 98559,
    "lat": 67.1526,
    "lng": 27.2682,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Pelkosenniemi",
    "area": "Kairala",
    "postalCode": 98560,
    "postalCodeMin": 98560,
    "postalCodeMax": 98569,
    "lat": 67.1952,
    "lng": 27.4416,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Pelkosenniemi",
    "area": "Aapajärvi",
    "postalCode": 98570,
    "postalCodeMin": 98570,
    "postalCodeMax": 98579,
    "lat": 67.2555,
    "lng": 27.2835,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Pelkosenniemi",
    "area": "Luiro",
    "postalCode": 98580,
    "postalCodeMin": 98580,
    "postalCodeMax": 98589,
    "lat": 67.2189,
    "lng": 27.5469,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Juoksenki",
    "postalCode": 95640,
    "postalCodeMin": 95640,
    "postalCodeMax": 95649,
    "lat": 66.5632,
    "lng": 23.867,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Turtola",
    "postalCode": 95645,
    "postalCodeMin": 95640,
    "postalCodeMax": 95649,
    "lat": 66.6463,
    "lng": 23.8814,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Pello",
    "postalCode": 95700,
    "postalCodeMin": 95700,
    "postalCodeMax": 95709,
    "lat": 66.7762,
    "lng": 23.9662,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Naamijoki",
    "postalCode": 95710,
    "postalCodeMin": 95710,
    "postalCodeMax": 95719,
    "lat": 66.9429,
    "lng": 23.9082,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Jarhoinen",
    "postalCode": 95720,
    "postalCodeMin": 95720,
    "postalCodeMax": 95729,
    "lat": 66.9629,
    "lng": 23.8327,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Orajärvi",
    "postalCode": 95750,
    "postalCodeMin": 95750,
    "postalCodeMax": 95759,
    "lat": 66.902,
    "lng": 24.0893,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Konttajärvi",
    "postalCode": 95760,
    "postalCodeMin": 95760,
    "postalCodeMax": 95769,
    "lat": 66.8375,
    "lng": 24.3972,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Lankojärvi",
    "postalCode": 95770,
    "postalCodeMin": 95770,
    "postalCodeMax": 95779,
    "lat": 66.7364,
    "lng": 24.3618,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Sirkkakoski",
    "postalCode": 95780,
    "postalCodeMin": 95780,
    "postalCodeMax": 95789,
    "lat": 66.6888,
    "lng": 24.4004,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Lampsijärvi",
    "postalCode": 95790,
    "postalCodeMin": 95790,
    "postalCodeMax": 95799,
    "lat": 66.7014,
    "lng": 24.5187,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Rattosjärvi",
    "postalCode": 97330,
    "postalCodeMin": 97330,
    "postalCodeMax": 97339,
    "lat": 66.8322,
    "lng": 24.8657,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Pello",
    "area": "Ruuhivaara",
    "postalCode": 97335,
    "postalCodeMin": 97330,
    "postalCodeMax": 97339,
    "lat": 66.7738,
    "lng": 23.9648,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Suorsa",
    "postalCode": 97810,
    "postalCodeMin": 97810,
    "postalCodeMax": 97819,
    "lat": 66.303,
    "lng": 27.3079,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Pernu",
    "postalCode": 97815,
    "postalCodeMin": 97810,
    "postalCodeMax": 97819,
    "lat": 66.1876,
    "lng": 27.5939,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Perä-Posio",
    "postalCode": 97820,
    "postalCodeMin": 97820,
    "postalCodeMax": 97829,
    "lat": 66.1846,
    "lng": 27.89,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Lehtiniemi",
    "postalCode": 97840,
    "postalCodeMin": 97840,
    "postalCodeMax": 97849,
    "lat": 66.2477,
    "lng": 27.9508,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Ristilä",
    "postalCode": 97850,
    "postalCodeMin": 97850,
    "postalCodeMax": 97859,
    "lat": 66.2913,
    "lng": 28.0347,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Jumisko",
    "postalCode": 97870,
    "postalCodeMin": 97870,
    "postalCodeMax": 97879,
    "lat": 66.3622,
    "lng": 28.1277,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Nolimo",
    "postalCode": 97880,
    "postalCodeMin": 97880,
    "postalCodeMax": 97889,
    "lat": 66.3942,
    "lng": 28.1288,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Karjalaisenniemi",
    "postalCode": 97890,
    "postalCodeMin": 97890,
    "postalCodeMax": 97899,
    "lat": 66.2388,
    "lng": 28.2249,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Mourujärvi",
    "postalCode": 97895,
    "postalCodeMin": 97890,
    "postalCodeMax": 97899,
    "lat": 66.3711,
    "lng": 28.4205,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Posio",
    "postalCode": 97900,
    "postalCodeMin": 97900,
    "postalCodeMax": 97909,
    "lat": 66.1106,
    "lng": 28.1674,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Suonnankylä",
    "postalCode": 97920,
    "postalCodeMin": 97920,
    "postalCodeMax": 97929,
    "lat": 66.1328,
    "lng": 28.4786,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Tolva",
    "postalCode": 97925,
    "postalCodeMin": 97920,
    "postalCodeMax": 97929,
    "lat": 66.2158,
    "lng": 28.7116,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Lohiranta",
    "postalCode": 97940,
    "postalCodeMin": 97940,
    "postalCodeMax": 97949,
    "lat": 66.0485,
    "lng": 28.6266,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Säikkä",
    "postalCode": 97950,
    "postalCodeMin": 97950,
    "postalCodeMax": 97959,
    "lat": 65.9848,
    "lng": 28.1814,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Kuloharju",
    "postalCode": 97960,
    "postalCodeMin": 97960,
    "postalCodeMax": 97969,
    "lat": 65.9071,
    "lng": 28.1425,
    "radiusKm": 7.6
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Kynsilä",
    "postalCode": 97965,
    "postalCodeMin": 97960,
    "postalCodeMax": 97969,
    "lat": 65.8861,
    "lng": 28.3594,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Sirniö",
    "postalCode": 97970,
    "postalCodeMin": 97970,
    "postalCodeMax": 97979,
    "lat": 65.8527,
    "lng": 28.1604,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Anetjärvi",
    "postalCode": 97980,
    "postalCodeMin": 97980,
    "postalCodeMax": 97989,
    "lat": 65.9197,
    "lng": 27.9522,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Posio",
    "area": "Maaninkavaara",
    "postalCode": 98780,
    "postalCodeMin": 98780,
    "postalCodeMax": 98789,
    "lat": 66.443,
    "lng": 28.4915,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Ranua",
    "area": "Pohjasperä",
    "postalCode": 97665,
    "postalCodeMin": 97660,
    "postalCodeMax": 97669,
    "lat": 66.2126,
    "lng": 26.9012,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Ranua",
    "area": "Ranua",
    "postalCode": 97700,
    "postalCodeMin": 97700,
    "postalCodeMax": 97709,
    "lat": 65.9295,
    "lng": 26.5159,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ranua",
    "area": "Raiskio",
    "postalCode": 97715,
    "postalCodeMin": 97710,
    "postalCodeMax": 97719,
    "lat": 65.9985,
    "lng": 26.2102,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ranua",
    "area": "Yli-Simo",
    "postalCode": 97720,
    "postalCodeMin": 97720,
    "postalCodeMax": 97729,
    "lat": 66.1265,
    "lng": 26.2975,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ranua",
    "area": "Saariharju",
    "postalCode": 97760,
    "postalCodeMin": 97760,
    "postalCodeMax": 97769,
    "lat": 65.9165,
    "lng": 27.1415,
    "radiusKm": 7.6
  },
  {
    "region": "Lappi",
    "city": "Ranua",
    "area": "Impiö",
    "postalCode": 97765,
    "postalCodeMin": 97760,
    "postalCodeMax": 97769,
    "lat": 65.9679,
    "lng": 27.2148,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ranua",
    "area": "Kuukasjärvi",
    "postalCode": 97780,
    "postalCodeMin": 97780,
    "postalCodeMax": 97789,
    "lat": 65.806,
    "lng": 26.9369,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Ranua",
    "area": "Kelankylä",
    "postalCode": 97785,
    "postalCodeMin": 97780,
    "postalCodeMax": 97789,
    "lat": 65.7523,
    "lng": 27.0317,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96100,
    "postalCodeMin": 96100,
    "postalCodeMax": 96109,
    "lat": 66.5711,
    "lng": 25.6084,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96190,
    "postalCodeMin": 96190,
    "postalCodeMax": 96199,
    "lat": 66.5344,
    "lng": 25.6347,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96200,
    "postalCodeMin": 96200,
    "postalCodeMax": 96209,
    "lat": 66.5103,
    "lng": 25.726,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96300,
    "postalCodeMin": 96300,
    "postalCodeMax": 96309,
    "lat": 66.4846,
    "lng": 25.6809,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96320,
    "postalCodeMin": 96320,
    "postalCodeMax": 96329,
    "lat": 66.4906,
    "lng": 25.6554,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96400,
    "postalCodeMin": 96400,
    "postalCodeMax": 96409,
    "lat": 66.4451,
    "lng": 25.7406,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96440,
    "postalCodeMin": 96440,
    "postalCodeMax": 96449,
    "lat": 66.4873,
    "lng": 25.8163,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96460,
    "postalCodeMin": 96460,
    "postalCodeMax": 96469,
    "lat": 66.4727,
    "lng": 25.7844,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96500,
    "postalCodeMin": 96500,
    "postalCodeMax": 96509,
    "lat": 66.5139,
    "lng": 25.66,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96600,
    "postalCodeMin": 96600,
    "postalCodeMax": 96609,
    "lat": 66.4788,
    "lng": 25.9491,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96700,
    "postalCodeMin": 96700,
    "postalCodeMax": 96709,
    "lat": 66.4791,
    "lng": 25.5474,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96800,
    "postalCodeMin": 96800,
    "postalCodeMax": 96809,
    "lat": 66.5274,
    "lng": 25.6926,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Saarenkylä",
    "postalCode": 96900,
    "postalCodeMin": 96900,
    "postalCodeMax": 96909,
    "lat": 66.5153,
    "lng": 25.7851,
    "radiusKm": 31.5
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96910,
    "postalCodeMin": 96910,
    "postalCodeMax": 96919,
    "lat": 66.5376,
    "lng": 25.7807,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Napapiiri Rovaniemi",
    "postalCode": 96930,
    "postalCodeMin": 96930,
    "postalCodeMax": 96939,
    "lat": 66.544,
    "lng": 25.8443,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rovaniemi",
    "postalCode": 96960,
    "postalCodeMin": 96960,
    "postalCodeMax": 96969,
    "lat": 66.5525,
    "lng": 25.7966,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Rautionsaari",
    "postalCode": 97110,
    "postalCodeMin": 97110,
    "postalCodeMax": 97119,
    "lat": 66.4255,
    "lng": 25.4761,
    "radiusKm": 42.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Hirvas",
    "postalCode": 97130,
    "postalCodeMin": 97130,
    "postalCodeMax": 97139,
    "lat": 66.4198,
    "lng": 25.4138,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Muurola",
    "postalCode": 97140,
    "postalCodeMin": 97140,
    "postalCodeMax": 97149,
    "lat": 66.3786,
    "lng": 25.3792,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Totonvaara",
    "postalCode": 97145,
    "postalCodeMin": 97140,
    "postalCodeMax": 97149,
    "lat": 66.3762,
    "lng": 25.3684,
    "radiusKm": 46.2
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Petäjäinen",
    "postalCode": 97160,
    "postalCodeMin": 97160,
    "postalCodeMax": 97169,
    "lat": 66.2734,
    "lng": 25.3282,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Jaatila",
    "postalCode": 97170,
    "postalCodeMin": 97170,
    "postalCodeMax": 97179,
    "lat": 66.2476,
    "lng": 25.342,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Sinettä",
    "postalCode": 97220,
    "postalCodeMin": 97220,
    "postalCodeMax": 97229,
    "lat": 66.6483,
    "lng": 25.4632,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Sonka",
    "postalCode": 97240,
    "postalCodeMin": 97240,
    "postalCodeMax": 97249,
    "lat": 66.6314,
    "lng": 25.2481,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Tapio",
    "postalCode": 97280,
    "postalCodeMin": 97280,
    "postalCodeMax": 97289,
    "lat": 66.7073,
    "lng": 25.4521,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Marraskoski",
    "postalCode": 97290,
    "postalCodeMin": 97290,
    "postalCodeMax": 97299,
    "lat": 66.7896,
    "lng": 25.42,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Patokoski",
    "postalCode": 97310,
    "postalCodeMin": 97310,
    "postalCodeMax": 97319,
    "lat": 66.8607,
    "lng": 25.4644,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Marrasjärvi",
    "postalCode": 97320,
    "postalCodeMin": 97320,
    "postalCodeMax": 97329,
    "lat": 66.8998,
    "lng": 25.122,
    "radiusKm": 42.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Meltaus",
    "postalCode": 97340,
    "postalCodeMin": 97340,
    "postalCodeMax": 97349,
    "lat": 66.9065,
    "lng": 25.3706,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Lohiniva",
    "postalCode": 97420,
    "postalCodeMin": 97420,
    "postalCodeMax": 97429,
    "lat": 67.1657,
    "lng": 24.9555,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Vikajärvi",
    "postalCode": 97510,
    "postalCodeMin": 97510,
    "postalCodeMax": 97519,
    "lat": 66.6215,
    "lng": 26.194,
    "radiusKm": 42.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Nampa",
    "postalCode": 97520,
    "postalCodeMin": 97520,
    "postalCodeMax": 97529,
    "lat": 66.7287,
    "lng": 26.2802,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Yli-Nampa",
    "postalCode": 97530,
    "postalCodeMin": 97530,
    "postalCodeMax": 97539,
    "lat": 66.7896,
    "lng": 26.2499,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Tiainen",
    "postalCode": 97540,
    "postalCodeMin": 97540,
    "postalCodeMax": 97549,
    "lat": 66.9044,
    "lng": 26.2037,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Misi",
    "postalCode": 97580,
    "postalCodeMin": 97580,
    "postalCodeMax": 97589,
    "lat": 66.6181,
    "lng": 26.6863,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Oikarainen",
    "postalCode": 97610,
    "postalCodeMin": 97610,
    "postalCodeMax": 97619,
    "lat": 66.4554,
    "lng": 26.0877,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Tennirova",
    "postalCode": 97615,
    "postalCodeMin": 97610,
    "postalCodeMax": 97619,
    "lat": 66.4244,
    "lng": 26.43,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Viiri",
    "postalCode": 97620,
    "postalCodeMin": 97620,
    "postalCodeMax": 97629,
    "lat": 66.3903,
    "lng": 26.5664,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Vanttauskoski",
    "postalCode": 97625,
    "postalCodeMin": 97620,
    "postalCodeMax": 97629,
    "lat": 66.3776,
    "lng": 26.6816,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Pekkala",
    "postalCode": 97630,
    "postalCodeMin": 97630,
    "postalCodeMax": 97639,
    "lat": 66.3408,
    "lng": 26.881,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Juuniemi",
    "postalCode": 97635,
    "postalCodeMin": 97630,
    "postalCodeMax": 97639,
    "lat": 66.359,
    "lng": 27.0632,
    "radiusKm": 37.8
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Juotas",
    "postalCode": 97650,
    "postalCodeMin": 97650,
    "postalCodeMax": 97659,
    "lat": 66.3245,
    "lng": 26.9449,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Autti",
    "postalCode": 97655,
    "postalCodeMin": 97650,
    "postalCodeMax": 97659,
    "lat": 66.3165,
    "lng": 27.0981,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Kivitaipale",
    "postalCode": 97670,
    "postalCodeMin": 97670,
    "postalCodeMax": 97679,
    "lat": 66.3252,
    "lng": 25.9293,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Narkaus",
    "postalCode": 97675,
    "postalCodeMin": 97670,
    "postalCodeMax": 97679,
    "lat": 66.2766,
    "lng": 26.1149,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Saari-Kämä",
    "postalCode": 97680,
    "postalCodeMin": 97680,
    "postalCodeMax": 97689,
    "lat": 66.1945,
    "lng": 26.2218,
    "radiusKm": 42.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Siika-Kämä",
    "postalCode": 97685,
    "postalCodeMin": 97680,
    "postalCodeMax": 97689,
    "lat": 66.2253,
    "lng": 26.49,
    "radiusKm": 21.0
  },
  {
    "region": "Lappi",
    "city": "Rovaniemi",
    "area": "Sulaoja",
    "postalCode": 97690,
    "postalCodeMin": 97690,
    "postalCodeMax": 97699,
    "lat": 66.2108,
    "lng": 25.8485,
    "radiusKm": 27.3
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Kursu",
    "postalCode": 98600,
    "postalCodeMin": 98600,
    "postalCodeMax": 98609,
    "lat": 66.7645,
    "lng": 28.1352,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Pahkakumpu",
    "postalCode": 98620,
    "postalCodeMin": 98620,
    "postalCodeMax": 98629,
    "lat": 66.9331,
    "lng": 28.0089,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Ahvenselkä",
    "postalCode": 98630,
    "postalCodeMin": 98630,
    "postalCodeMax": 98639,
    "lat": 66.99,
    "lng": 28.0982,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Salmivaara",
    "postalCode": 98660,
    "postalCodeMin": 98660,
    "postalCodeMax": 98669,
    "lat": 66.8178,
    "lng": 28.4113,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Hirvasvaara",
    "postalCode": 98760,
    "postalCodeMin": 98760,
    "postalCodeMax": 98769,
    "lat": 66.5445,
    "lng": 28.5931,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Aholanvaara",
    "postalCode": 98770,
    "postalCodeMin": 98770,
    "postalCodeMax": 98779,
    "lat": 66.5341,
    "lng": 28.7041,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Paloperä",
    "postalCode": 98790,
    "postalCodeMin": 98790,
    "postalCodeMax": 98799,
    "lat": 66.4525,
    "lng": 28.1693,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Salla",
    "postalCode": 98900,
    "postalCodeMin": 98900,
    "postalCodeMax": 98909,
    "lat": 66.8327,
    "lng": 28.6701,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Kelloselkä",
    "postalCode": 98920,
    "postalCodeMin": 98920,
    "postalCodeMax": 98929,
    "lat": 66.9331,
    "lng": 28.8958,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Kotalankylä",
    "postalCode": 98930,
    "postalCodeMin": 98930,
    "postalCodeMax": 98939,
    "lat": 67.0172,
    "lng": 29.0121,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Saija",
    "postalCode": 98950,
    "postalCodeMin": 98950,
    "postalCodeMax": 98959,
    "lat": 67.0936,
    "lng": 28.8277,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Naruska",
    "postalCode": 98960,
    "postalCodeMin": 98960,
    "postalCodeMax": 98969,
    "lat": 67.1365,
    "lng": 29.1617,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Onkamojärvi",
    "postalCode": 98970,
    "postalCodeMin": 98970,
    "postalCodeMax": 98979,
    "lat": 66.7667,
    "lng": 29.0667,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Kallunki",
    "postalCode": 98980,
    "postalCodeMin": 98980,
    "postalCodeMax": 98989,
    "lat": 66.651,
    "lng": 28.9452,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Salla",
    "area": "Hautajärvi",
    "postalCode": 98995,
    "postalCodeMin": 98990,
    "postalCodeMax": 98999,
    "lat": 66.5127,
    "lng": 29.0318,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Savukoski",
    "area": "Savukoski",
    "postalCode": 98800,
    "postalCodeMin": 98800,
    "postalCodeMax": 98809,
    "lat": 67.2924,
    "lng": 28.1585,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Savukoski",
    "area": "Lunkkaus",
    "postalCode": 98810,
    "postalCodeMin": 98810,
    "postalCodeMax": 98819,
    "lat": 67.2558,
    "lng": 27.8964,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Savukoski",
    "area": "Värriö",
    "postalCode": 98820,
    "postalCodeMin": 98820,
    "postalCodeMax": 98829,
    "lat": 67.4675,
    "lng": 27.9906,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Savukoski",
    "area": "Martti",
    "postalCode": 98830,
    "postalCodeMin": 98830,
    "postalCodeMax": 98839,
    "lat": 67.474,
    "lng": 28.3571,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Savukoski",
    "area": "Ruuvaoja",
    "postalCode": 98840,
    "postalCodeMin": 98840,
    "postalCodeMax": 98849,
    "lat": 67.6553,
    "lng": 28.7193,
    "radiusKm": 10.9
  },
  {
    "region": "Lappi",
    "city": "Savukoski",
    "area": "Kuosku",
    "postalCode": 98850,
    "postalCodeMin": 98850,
    "postalCodeMax": 98859,
    "lat": 67.2343,
    "lng": 28.4026,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Savukoski",
    "area": "Tanhua",
    "postalCode": 99640,
    "postalCodeMin": 99640,
    "postalCodeMax": 99649,
    "lat": 67.5276,
    "lng": 27.5388,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Simo",
    "area": "Simo",
    "postalCode": 95200,
    "postalCodeMin": 95200,
    "postalCodeMax": 95209,
    "lat": 65.6614,
    "lng": 25.058,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Simo",
    "area": "Filpus",
    "postalCode": 95210,
    "postalCodeMin": 95210,
    "postalCodeMax": 95219,
    "lat": 65.6479,
    "lng": 24.9984,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Simo",
    "area": "Simoniemi",
    "postalCode": 95220,
    "postalCodeMin": 95220,
    "postalCodeMax": 95229,
    "lat": 65.6548,
    "lng": 24.9087,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Simo",
    "area": "Viantie",
    "postalCode": 95225,
    "postalCodeMin": 95220,
    "postalCodeMax": 95229,
    "lat": 65.7596,
    "lng": 24.98,
    "radiusKm": 5.0
  },
  {
    "region": "Lappi",
    "city": "Simo",
    "area": "Maksniemi",
    "postalCode": 95230,
    "postalCodeMin": 95230,
    "postalCodeMax": 95239,
    "lat": 65.6773,
    "lng": 24.782,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Simo",
    "area": "Alaniemi",
    "postalCode": 95255,
    "postalCodeMin": 95250,
    "postalCodeMax": 95259,
    "lat": 65.8447,
    "lng": 25.3307,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Simo",
    "area": "Tainionjoki",
    "postalCode": 95260,
    "postalCodeMin": 95260,
    "postalCodeMax": 95269,
    "lat": 65.992,
    "lng": 25.4756,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Simo",
    "area": "Ylikärppä",
    "postalCode": 95270,
    "postalCodeMin": 95270,
    "postalCodeMax": 95279,
    "lat": 65.8093,
    "lng": 25.6686,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Unarin-Luusua",
    "postalCode": 97370,
    "postalCodeMin": 97370,
    "postalCodeMax": 97379,
    "lat": 67.1449,
    "lng": 25.7264,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Kukasranta",
    "postalCode": 97380,
    "postalCodeMin": 97380,
    "postalCodeMax": 97389,
    "lat": 67.416,
    "lng": 26.589,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Kierinki",
    "postalCode": 97390,
    "postalCodeMin": 97390,
    "postalCodeMax": 97399,
    "lat": 67.2692,
    "lng": 25.5311,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Raudanjoki",
    "postalCode": 99510,
    "postalCodeMin": 99510,
    "postalCodeMax": 99519,
    "lat": 67.0204,
    "lng": 26.4213,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Seipäjärvi",
    "postalCode": 99520,
    "postalCodeMin": 99520,
    "postalCodeMax": 99529,
    "lat": 67.1603,
    "lng": 26.2191,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Vuojärvi",
    "postalCode": 99530,
    "postalCodeMin": 99530,
    "postalCodeMax": 99539,
    "lat": 67.0862,
    "lng": 26.6118,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Torvinen",
    "postalCode": 99540,
    "postalCodeMin": 99540,
    "postalCodeMax": 99549,
    "lat": 67.1995,
    "lng": 26.6449,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Aska",
    "postalCode": 99550,
    "postalCodeMin": 99550,
    "postalCodeMax": 99559,
    "lat": 67.2967,
    "lng": 26.6879,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Luosto",
    "postalCode": 99555,
    "postalCodeMin": 99550,
    "postalCodeMax": 99559,
    "lat": 67.1541,
    "lng": 26.9156,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Orakylä",
    "postalCode": 99560,
    "postalCodeMin": 99560,
    "postalCodeMax": 99569,
    "lat": 67.3749,
    "lng": 26.8625,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Sodankylä",
    "postalCode": 99600,
    "postalCodeMin": 99600,
    "postalCodeMax": 99609,
    "lat": 67.416,
    "lng": 26.589,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Siurunmaa",
    "postalCode": 99610,
    "postalCodeMin": 99610,
    "postalCodeMax": 99619,
    "lat": 67.4541,
    "lng": 26.8503,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Kelujärvi",
    "postalCode": 99620,
    "postalCodeMin": 99620,
    "postalCodeMax": 99629,
    "lat": 67.4655,
    "lng": 27.0345,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Lokka",
    "postalCode": 99645,
    "postalCodeMin": 99640,
    "postalCodeMax": 99649,
    "lat": 67.8212,
    "lng": 27.7399,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Sattanen",
    "postalCode": 99650,
    "postalCodeMin": 99650,
    "postalCodeMax": 99659,
    "lat": 67.5083,
    "lng": 26.6171,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Sattasvaara",
    "postalCode": 99655,
    "postalCodeMin": 99650,
    "postalCodeMax": 99659,
    "lat": 67.6167,
    "lng": 26.3333,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Kersilö",
    "postalCode": 99660,
    "postalCodeMin": 99660,
    "postalCodeMax": 99669,
    "lat": 67.5765,
    "lng": 26.7381,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Moskuvaara",
    "postalCode": 99665,
    "postalCodeMin": 99660,
    "postalCodeMax": 99669,
    "lat": 67.5977,
    "lng": 26.9394,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Petkula",
    "postalCode": 99670,
    "postalCodeMin": 99670,
    "postalCodeMax": 99679,
    "lat": 67.6786,
    "lng": 26.7695,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Vuotso",
    "postalCode": 99690,
    "postalCodeMin": 99690,
    "postalCodeMax": 99699,
    "lat": 68.1023,
    "lng": 27.12,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Tankavaara",
    "postalCode": 99695,
    "postalCodeMin": 99690,
    "postalCodeMax": 99699,
    "lat": 68.1802,
    "lng": 27.1006,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Vaalajärvi",
    "postalCode": 99710,
    "postalCodeMin": 99710,
    "postalCodeMax": 99719,
    "lat": 67.4295,
    "lng": 26.1354,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Riipi",
    "postalCode": 99720,
    "postalCodeMin": 99720,
    "postalCodeMax": 99729,
    "lat": 67.3394,
    "lng": 26.0396,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Syväjärvi",
    "postalCode": 99740,
    "postalCodeMin": 99740,
    "postalCodeMax": 99749,
    "lat": 67.2793,
    "lng": 25.9188,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Sassali",
    "postalCode": 99750,
    "postalCodeMin": 99750,
    "postalCodeMax": 99759,
    "lat": 67.2656,
    "lng": 25.8229,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Uimaniemi",
    "postalCode": 99760,
    "postalCodeMin": 99760,
    "postalCodeMax": 99769,
    "lat": 67.1869,
    "lng": 25.7211,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Sodankylä",
    "area": "Jeesiö",
    "postalCode": 99770,
    "postalCodeMin": 99770,
    "postalCodeMax": 99779,
    "lat": 67.509,
    "lng": 26.0377,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tervola",
    "area": "Tervola",
    "postalCode": 95300,
    "postalCodeMin": 95300,
    "postalCodeMax": 95309,
    "lat": 66.0805,
    "lng": 24.8109,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tervola",
    "area": "Paakkola",
    "postalCode": 95325,
    "postalCodeMin": 95320,
    "postalCodeMax": 95329,
    "lat": 66.0017,
    "lng": 24.7107,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tervola",
    "area": "Kaisajoki",
    "postalCode": 95330,
    "postalCodeMin": 95330,
    "postalCodeMax": 95339,
    "lat": 66.0834,
    "lng": 24.6671,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Tervola",
    "area": "Loue",
    "postalCode": 95340,
    "postalCodeMin": 95340,
    "postalCodeMax": 95349,
    "lat": 66.1435,
    "lng": 24.9609,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tervola",
    "area": "Peura",
    "postalCode": 95350,
    "postalCodeMin": 95350,
    "postalCodeMax": 95359,
    "lat": 66.1524,
    "lng": 25.1215,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tervola",
    "area": "Koivu",
    "postalCode": 95355,
    "postalCodeMin": 95350,
    "postalCodeMax": 95359,
    "lat": 66.1692,
    "lng": 25.2116,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tervola",
    "area": "Yli-Paakkola",
    "postalCode": 95375,
    "postalCodeMin": 95370,
    "postalCodeMax": 95379,
    "lat": 66.0033,
    "lng": 24.7337,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Kaakamo",
    "postalCode": 94430,
    "postalCodeMin": 94430,
    "postalCodeMax": 94439,
    "lat": 65.8001,
    "lng": 24.4422,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Ruottala",
    "postalCode": 94460,
    "postalCodeMin": 94460,
    "postalCodeMax": 94469,
    "lat": 65.8552,
    "lng": 24.5069,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Tornio",
    "postalCode": 95400,
    "postalCodeMin": 95400,
    "postalCodeMax": 95409,
    "lat": 65.8496,
    "lng": 24.1458,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Kiviranta",
    "postalCode": 95410,
    "postalCodeMin": 95410,
    "postalCodeMax": 95419,
    "lat": 65.857,
    "lng": 24.1684,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Tornio",
    "postalCode": 95420,
    "postalCodeMin": 95420,
    "postalCodeMax": 95429,
    "lat": 65.8392,
    "lng": 24.1795,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Tornio",
    "postalCode": 95430,
    "postalCodeMin": 95430,
    "postalCodeMax": 95439,
    "lat": 65.8595,
    "lng": 24.1435,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Kyläjoki",
    "postalCode": 95440,
    "postalCodeMin": 95440,
    "postalCodeMax": 95449,
    "lat": 65.8308,
    "lng": 24.2873,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Kokkokangas",
    "postalCode": 95450,
    "postalCodeMin": 95450,
    "postalCodeMax": 95459,
    "lat": 65.8035,
    "lng": 24.165,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Tornio",
    "postalCode": 95460,
    "postalCodeMin": 95460,
    "postalCodeMax": 95469,
    "lat": 65.8473,
    "lng": 24.152,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Pirkkiö",
    "postalCode": 95470,
    "postalCodeMin": 95470,
    "postalCodeMax": 95479,
    "lat": 65.8148,
    "lng": 24.2003,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Tornio",
    "postalCode": 95490,
    "postalCodeMin": 95490,
    "postalCodeMax": 95499,
    "lat": 65.7639,
    "lng": 24.1741,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Vojakkala",
    "postalCode": 95500,
    "postalCodeMin": 95500,
    "postalCodeMax": 95509,
    "lat": 65.914,
    "lng": 24.1345,
    "radiusKm": 10.9
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Kukkola",
    "postalCode": 95520,
    "postalCodeMin": 95520,
    "postalCodeMax": 95529,
    "lat": 65.977,
    "lng": 24.0701,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Karunki",
    "postalCode": 95530,
    "postalCodeMin": 95530,
    "postalCodeMax": 95539,
    "lat": 66.0348,
    "lng": 24.0192,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Korpikylä",
    "postalCode": 95540,
    "postalCodeMin": 95540,
    "postalCodeMax": 95549,
    "lat": 66.1352,
    "lng": 23.9391,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Aapajoki",
    "postalCode": 95560,
    "postalCodeMin": 95560,
    "postalCodeMax": 95569,
    "lat": 66.0153,
    "lng": 24.1121,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Tornio",
    "area": "Arpela",
    "postalCode": 95590,
    "postalCodeMin": 95590,
    "postalCodeMax": 95599,
    "lat": 66.0183,
    "lng": 24.3867,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Utsjoki",
    "area": "Karigasniemi",
    "postalCode": 99950,
    "postalCodeMin": 99950,
    "postalCodeMax": 99959,
    "lat": 69.3975,
    "lng": 25.8557,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Utsjoki",
    "area": "Nuvvus",
    "postalCode": 99970,
    "postalCodeMin": 99970,
    "postalCodeMax": 99979,
    "lat": 69.7866,
    "lng": 26.2274,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Utsjoki",
    "area": "Utsjoki",
    "postalCode": 99980,
    "postalCodeMin": 99980,
    "postalCodeMax": 99989,
    "lat": 69.909,
    "lng": 27.0285,
    "radiusKm": 15.1
  },
  {
    "region": "Lappi",
    "city": "Utsjoki",
    "area": "Nuorgam",
    "postalCode": 99990,
    "postalCodeMin": 99990,
    "postalCodeMax": 99999,
    "lat": 70.0821,
    "lng": 27.8718,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Ylitornio",
    "postalCode": 95600,
    "postalCodeMin": 95600,
    "postalCodeMax": 95609,
    "lat": 66.3193,
    "lng": 23.671,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Kainuunkylä",
    "postalCode": 95610,
    "postalCodeMin": 95610,
    "postalCodeMax": 95619,
    "lat": 66.2281,
    "lng": 23.7604,
    "radiusKm": 12.6
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Pekanpää",
    "postalCode": 95615,
    "postalCodeMin": 95610,
    "postalCodeMax": 95619,
    "lat": 66.1871,
    "lng": 23.8145,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Aavasaksa",
    "postalCode": 95620,
    "postalCodeMin": 95620,
    "postalCodeMax": 95629,
    "lat": 66.4,
    "lng": 23.7333,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Kuivakangas",
    "postalCode": 95630,
    "postalCodeMin": 95630,
    "postalCodeMax": 95639,
    "lat": 66.4245,
    "lng": 23.6595,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Kaulinranta",
    "postalCode": 95635,
    "postalCodeMin": 95630,
    "postalCodeMax": 95639,
    "lat": 66.4572,
    "lng": 23.6808,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Etelä-Portimojärvi",
    "postalCode": 95655,
    "postalCodeMin": 95650,
    "postalCodeMax": 95659,
    "lat": 66.3719,
    "lng": 23.8802,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Kantomaanpää",
    "postalCode": 95660,
    "postalCodeMin": 95660,
    "postalCodeMax": 95669,
    "lat": 66.432,
    "lng": 24.0738,
    "radiusKm": 18.5
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Pessalompolo",
    "postalCode": 95670,
    "postalCodeMin": 95670,
    "postalCodeMax": 95679,
    "lat": 66.5071,
    "lng": 24.4069,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Meltosjärvi",
    "postalCode": 95675,
    "postalCodeMin": 95670,
    "postalCodeMax": 95679,
    "lat": 66.5349,
    "lng": 24.6198,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Lohijärvi",
    "postalCode": 95680,
    "postalCodeMin": 95680,
    "postalCodeMax": 95689,
    "lat": 66.4487,
    "lng": 24.3694,
    "radiusKm": 16.8
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Mellakoski",
    "postalCode": 95690,
    "postalCodeMin": 95690,
    "postalCodeMax": 95699,
    "lat": 66.3983,
    "lng": 24.4401,
    "radiusKm": 8.4
  },
  {
    "region": "Lappi",
    "city": "Ylitornio",
    "area": "Raanujärvi",
    "postalCode": 97250,
    "postalCodeMin": 97250,
    "postalCodeMax": 97259,
    "lat": 66.6462,
    "lng": 24.7283,
    "radiusKm": 16.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Brändö",
    "area": "Lappo",
    "postalCode": 22840,
    "postalCodeMin": 22840,
    "postalCodeMax": 22849,
    "lat": 60.3167,
    "lng": 20.9833,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Brändö",
    "area": "Torsholma",
    "postalCode": 22910,
    "postalCodeMin": 22910,
    "postalCodeMax": 22919,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Brändö",
    "area": "Brändö",
    "postalCode": 22920,
    "postalCodeMin": 22920,
    "postalCodeMax": 22929,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Brändö",
    "area": "Fiskö",
    "postalCode": 22930,
    "postalCodeMin": 22930,
    "postalCodeMax": 22939,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Brändö",
    "area": "Åva",
    "postalCode": 22940,
    "postalCodeMin": 22940,
    "postalCodeMax": 22949,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Brändö",
    "area": "Jurmo",
    "postalCode": 22950,
    "postalCodeMin": 22950,
    "postalCodeMax": 22959,
    "lat": 60.5269,
    "lng": 21.076,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Eckerö",
    "area": "Eckerö",
    "postalCode": 22270,
    "postalCodeMin": 22270,
    "postalCodeMax": 22279,
    "lat": 60.2232,
    "lng": 19.5595,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Finström",
    "area": "Emkarby",
    "postalCode": 22220,
    "postalCodeMin": 22220,
    "postalCodeMax": 22229,
    "lat": 60.2112,
    "lng": 19.8859,
    "radiusKm": 2.7
  },
  {
    "region": "Ahvenanmaa",
    "city": "Finström",
    "area": "Pålsböle",
    "postalCode": 22310,
    "postalCodeMin": 22310,
    "postalCodeMax": 22319,
    "lat": 60.2657,
    "lng": 19.9317,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Finström",
    "area": "Tjudö",
    "postalCode": 22330,
    "postalCodeMin": 22330,
    "postalCodeMax": 22339,
    "lat": 60.3324,
    "lng": 19.9496,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Finström",
    "area": "Godby",
    "postalCode": 22410,
    "postalCodeMin": 22410,
    "postalCodeMax": 22419,
    "lat": 60.2299,
    "lng": 19.988,
    "radiusKm": 2.7
  },
  {
    "region": "Ahvenanmaa",
    "city": "Föglö",
    "area": "Föglö",
    "postalCode": 22710,
    "postalCodeMin": 22710,
    "postalCodeMax": 22719,
    "lat": 60.0146,
    "lng": 20.4139,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Geta (kunta)",
    "area": "Geta",
    "postalCode": 22340,
    "postalCodeMin": 22340,
    "postalCodeMax": 22349,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Hammarland",
    "area": "Hammarland",
    "postalCode": 22240,
    "postalCodeMin": 22240,
    "postalCodeMax": 22249,
    "lat": 60.2164,
    "lng": 19.7402,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Jomala",
    "area": "Gottby",
    "postalCode": 22130,
    "postalCodeMin": 22130,
    "postalCodeMax": 22139,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 2.7
  },
  {
    "region": "Ahvenanmaa",
    "city": "Jomala",
    "area": "Mariehamn",
    "postalCode": 22140,
    "postalCodeMin": 22140,
    "postalCodeMax": 22149,
    "lat": 60.12,
    "lng": 20.0087,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Jomala",
    "area": "Jomala",
    "postalCode": 22150,
    "postalCodeMin": 22150,
    "postalCodeMax": 22159,
    "lat": 60.1522,
    "lng": 19.9486,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Kumlinge",
    "area": "Seglinge",
    "postalCode": 22810,
    "postalCodeMin": 22810,
    "postalCodeMax": 22819,
    "lat": 60.2049,
    "lng": 20.6959,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Kumlinge",
    "area": "Kumlinge",
    "postalCode": 22820,
    "postalCodeMin": 22820,
    "postalCodeMax": 22829,
    "lat": 60.2588,
    "lng": 20.778,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Kumlinge",
    "area": "Enklinge",
    "postalCode": 22830,
    "postalCodeMin": 22830,
    "postalCodeMax": 22839,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Kökar",
    "area": "Kökar",
    "postalCode": 22730,
    "postalCodeMin": 22730,
    "postalCodeMax": 22739,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Lemland",
    "area": "Lemland",
    "postalCode": 22610,
    "postalCodeMin": 22610,
    "postalCodeMax": 22619,
    "lat": 60.0689,
    "lng": 20.0864,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Lumparland",
    "area": "Lumparland",
    "postalCode": 22630,
    "postalCodeMin": 22630,
    "postalCodeMax": 22639,
    "lat": 60.1152,
    "lng": 20.262,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Maarianhamina",
    "area": "Mariehamn",
    "postalCode": 22100,
    "postalCodeMin": 22100,
    "postalCodeMax": 22109,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Maarianhamina",
    "area": "Mariehamn",
    "postalCode": 22110,
    "postalCodeMin": 22110,
    "postalCodeMax": 22119,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Maarianhamina",
    "area": "Mariehamn",
    "postalCode": 22120,
    "postalCodeMin": 22120,
    "postalCodeMax": 22129,
    "lat": 60.1351,
    "lng": 19.9125,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Maarianhamina",
    "area": "Mariehamn",
    "postalCode": 22160,
    "postalCodeMin": 22160,
    "postalCodeMax": 22169,
    "lat": 60.0971,
    "lng": 19.9348,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Saltvik",
    "area": "Ödkarby",
    "postalCode": 22320,
    "postalCodeMin": 22320,
    "postalCodeMax": 22329,
    "lat": 60.3091,
    "lng": 19.98,
    "radiusKm": 2.7
  },
  {
    "region": "Ahvenanmaa",
    "city": "Saltvik",
    "area": "Saltvik",
    "postalCode": 22430,
    "postalCodeMin": 22430,
    "postalCodeMax": 22439,
    "lat": 60.2755,
    "lng": 20.0619,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Sottunga",
    "area": "Sottunga",
    "postalCode": 22720,
    "postalCodeMin": 22720,
    "postalCodeMax": 22729,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Sund",
    "area": "Kastelholm",
    "postalCode": 22520,
    "postalCodeMin": 22520,
    "postalCodeMax": 22529,
    "lat": 60.2382,
    "lng": 20.0833,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Sund",
    "area": "Sund",
    "postalCode": 22530,
    "postalCodeMin": 22530,
    "postalCodeMax": 22539,
    "lat": 60.2183,
    "lng": 20.1903,
    "radiusKm": 1.8
  },
  {
    "region": "Ahvenanmaa",
    "city": "Vårdö",
    "area": "Vårdö",
    "postalCode": 22550,
    "postalCodeMin": 22550,
    "postalCodeMax": 22559,
    "lat": 61.9241,
    "lng": 25.7482,
    "radiusKm": 1.8
  }
]